import * as i0 from '@angular/core';
import { InjectionToken, PLATFORM_ID, EventEmitter, Injectable, Inject, Component, Input, Optional, ElementRef, TemplateRef, ContentChild, Output, ViewChild, HostListener, ContentChildren, Pipe, Directive, HostBinding, ViewEncapsulation, QueryList, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i6 from '@angular/forms';
import { NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpErrorResponse, HttpRequest, HttpParams, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i1$2 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as i1$3 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i4 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownConfig, NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import * as i6$1 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import * as i2$1 from '@angular/platform-browser';
import { BrowserModule } from '@angular/platform-browser';
import * as i1$5 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { Subject, throwError, interval, BehaviorSubject, of, Observable, defer, forkJoin, timer, concat, range } from 'rxjs';
import { filter, pluck, startWith, distinctUntilChanged, tap, catchError, take, switchMap, map, shareReplay, finalize, mapTo, reduce, timeout, concatMap, share, first } from 'rxjs/operators';
import moment from 'moment';
import 'moment-timezone';
import * as i3 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i1$4 from '@angular/cdk/a11y';
import { FocusKeyManager, A11yModule } from '@angular/cdk/a11y';
import { faChevronUp, faChevronDown, faArrowsAltV, faInfoCircle, faAngleDown, faBars, faCalendarAlt, faCaretLeft, faCheck, faChevronLeft, faExclamationTriangle, faGlobeAmericas, faQuestionCircle, faRandom, faSignOutAlt, faSortDown, faSortUp, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import * as i3$1 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { faArrowDown, faArrowUp, faCopy, faTimes as faTimes$1 } from '@fortawesome/pro-light-svg-icons';
import * as i3$2 from '@angular/material/tabs';
import { MatTab, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import * as i4$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i5 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i1$6 from '@pearsonvue/vue-network-library';
import { RouterTestingModule } from '@angular/router/testing';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { HttpClientTestingModule } from '@angular/common/http/testing';

/**
 * Represents the encoded token contained within the VUE OAuth token.
 *
 * TODO: Rename to `IdToken` or `VueIdToken`
 */
const _c0 = ["*"];
function VueAuthorizedRoleComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function VueValidationMessageComponent_Conditional_0_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵelement(1, "fa-icon", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", error_r1, " ");
  }
}
function VueValidationMessageComponent_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueValidationMessageComponent_Conditional_0_For_2_Conditional_1_Template, 3, 1, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(error_r1 ? 1 : -1);
  }
}
function VueValidationMessageComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵrepeaterCreate(1, VueValidationMessageComponent_Conditional_0_For_2_Template, 2, 1, "span", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.listOfErrors());
  }
}
const _c1 = ["inputElement"];
const _c2 = ["labelFragment"];
const _c3 = a0 => ({
  "has-error": a0
});
function VueControlGroupComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.getInputElementName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getDisplayText(), " ");
  }
}
function VueControlGroupComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.labelFragment)("ngTemplateOutletContext", ctx_r0.getCustomLabelContext());
  }
}
function VueControlGroupComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Required");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.getInputElementName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getSrLabelTranslation(), " ");
  }
}
function VueControlGroupComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "vue-validation-message", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.control)("formError", ctx_r0.formError)("isSingleFieldLevelErrorEnabled", ctx_r0.isSingleFieldLevelErrorEnabled);
  }
}
function VueCookiePolicyComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 2)(5, "a", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 4);
    i0.ɵɵlistener("click", function VueCookiePolicyComponent_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hideCookiePolicyBar());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.message);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.privacyLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.learnMore);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.understand);
  }
}
function VueFooterComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("href", ctx_r0.getDvsaProvideFeedbackUrlTranslation(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getDvsaProvideFeedbackTranslation(), " ");
  }
}
const _c4 = [[["", "customInnerText", ""]]];
const _c5 = ["[customInnerText]"];
const _c6 = () => [];
function VueFormButtonsComponent_Conditional_2_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 2)(4, "li", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li")(7, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_2_Conditional_1_Conditional_1_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li")(10, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_2_Conditional_1_Conditional_1_Template_a_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryCancelClick());
    });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placement", ctx_r1.getPrimaryConfirmPlacement());
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.primaryDropdownId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r1.primaryDropdownId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.primaryConfirmId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(11, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.primaryCancelId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(12, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryCancelTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_2_Conditional_1_Conditional_1_Template, 12, 13, "div", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isPrimaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_2_Conditional_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.primaryId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryButtonTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_2_Conditional_2_Conditional_1_Template, 2, 2, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isPrimaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_2_Conditional_1_Template, 2, 1, "span")(2, VueFormButtonsComponent_Conditional_2_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isPrimaryConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isPrimaryConfirmStyleDesired() ? 2 : -1);
  }
}
function VueFormButtonsComponent_Conditional_3_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 2)(4, "li", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li")(7, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_3_Conditional_1_Conditional_1_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li")(10, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_3_Conditional_1_Conditional_1_Template_a_click_10_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultCancelClick());
    });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placement", ctx_r1.getSecondaryConfirmPlacement());
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("btn btn-default ", ctx_r1.getDefaultPosition(), " vue-form-default-btn");
    i0.ɵɵpropertyInterpolate("id", ctx_r1.defaultDropdownId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r1.defaultDropdownId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.defaultConfirmId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(14, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.defaultCancelId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(15, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultCancelTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_3_Conditional_1_Conditional_1_Template, 12, 16, "div", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isDefaultHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_3_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_3_Conditional_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("btn btn-default ", ctx_r1.getDefaultPosition(), " vue-form-default-btn");
    i0.ɵɵpropertyInterpolate("id", ctx_r1.defaultId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultButtonTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_3_Conditional_2_Conditional_1_Template, 2, 5, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isDefaultHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_3_Conditional_1_Template, 2, 1, "span")(2, VueFormButtonsComponent_Conditional_3_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isDefaultConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isDefaultConfirmStyleDesired() ? 2 : -1);
  }
}
function VueFormButtonsComponent_Conditional_4_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 2)(4, "li", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li")(7, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_4_Conditional_1_Conditional_1_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.tertiaryConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li")(10, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_4_Conditional_1_Conditional_1_Template_a_click_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.tertiaryCancelClick());
    });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placement", ctx_r1.getTertiaryConfirmPlacement());
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.tertiaryDropdownId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTertiaryButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r1.tertiaryDropdownId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTertiaryConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.tertiaryConfirmId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(11, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTertiaryConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.tertiaryCancelId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(12, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTertiaryCancelTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_4_Conditional_1_Conditional_1_Template, 12, 13, "div", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isTertiaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_4_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_4_Conditional_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.tertiaryButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.tertiaryId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTertiaryButtonTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_4_Conditional_2_Conditional_1_Template, 2, 2, "button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isTertiaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_4_Conditional_1_Template, 2, 1, "span")(2, VueFormButtonsComponent_Conditional_4_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isTertiaryConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isTertiaryConfirmStyleDesired() ? 2 : -1);
  }
}
function VueFormButtonsComponent_Conditional_5_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 2)(4, "li", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li")(7, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_5_Conditional_1_Conditional_1_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li")(10, "a", 4);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_5_Conditional_1_Conditional_1_Template_a_click_10_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryCancelClick());
    });
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placement", ctx_r1.getDefaultConfirmPlacement());
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.secondaryDropdownId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r1.secondaryDropdownId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.secondaryConfirmId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(11, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryConfirmTranslation(), "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.secondaryCancelId);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(12, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryCancelTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_5_Conditional_1_Conditional_1_Template, 12, 13, "div", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isSecondaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_5_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function VueFormButtonsComponent_Conditional_5_Conditional_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.secondaryId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryButtonTranslation(), " ");
  }
}
function VueFormButtonsComponent_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_5_Conditional_2_Conditional_1_Template, 2, 2, "button", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isSecondaryHidden() ? 1 : -1);
  }
}
function VueFormButtonsComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueFormButtonsComponent_Conditional_5_Conditional_1_Template, 2, 1, "span")(2, VueFormButtonsComponent_Conditional_5_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSecondaryConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isSecondaryConfirmStyleDesired() ? 2 : -1);
  }
}
function VueLocaleSelectComponent_Conditional_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("lang", ctx_r1.getLanguageCode(item_r3.code));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.name);
  }
}
function VueLocaleSelectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "fa-icon", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "ng-select", 4, 0);
    i0.ɵɵlistener("change", function VueLocaleSelectComponent_Conditional_0_Template_ng_select_change_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLocaleChanged($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function VueLocaleSelectComponent_Conditional_0_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedLocale, $event) || (ctx_r1.selectedLocale = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(5, VueLocaleSelectComponent_Conditional_0_ng_template_5_Template, 2, 2, "ng-template", 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("clearable", false)("items", ctx_r1.locales)("searchable", false);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedLocale);
    i0.ɵɵattribute("aria-label", ctx_r1.getLocaleAriaLabelTranslation());
  }
}
function VueLoginHeaderComponent_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-select-locale", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("localeSelectAriaLabel", ctx_r0.localeSelectAriaLabel)("i18nBundle", ctx_r0.i18nBundle)("localeSelectAriaLabelKey", ctx_r0.localeSelectAriaLabelKey);
  }
}
function VueLoginHeaderComponent_Conditional_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function VueLoginHeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 0)(1, "div", 1)(2, "div", 2)(3, "div")(4, "div", 3);
    i0.ɵɵtext(5, "Pearson");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 4);
    i0.ɵɵtext(7, "Always Learning");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, VueLoginHeaderComponent_Conditional_0_Conditional_8_Template, 1, 3, "vue-select-locale", 5)(9, VueLoginHeaderComponent_Conditional_0_Conditional_9_Template, 2, 0, "div");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.getBrandingClientCode());
    i0.ɵɵadvance(8);
    i0.ɵɵconditional(!ctx_r0.hideLocaleSelect ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.transclude ? 9 : -1);
  }
}
const _c7 = ["content"];
function VueModalComponent_ng_template_0_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function VueModalComponent_ng_template_0_Conditional_0_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const d_r2 = i0.ɵɵnextContext(2).dismiss;
      return i0.ɵɵresetView(d_r2());
    });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵtext(4, "\xD7");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r2.getCloseLabel());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.getCloseLabel());
  }
}
function VueModalComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VueModalComponent_ng_template_0_Conditional_0_Conditional_3_Template, 5, 2, "button", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getHeaderLabel(), "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showCloseButton === "true" ? 3 : -1);
  }
}
function VueModalComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VueModalComponent_ng_template_0_Conditional_0_Template, 4, 2, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.showHeader() ? 0 : -1);
  }
}
const _c8 = a0 => ({
  "select-error": a0
});
function VueMultiSelectComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵlistener("click", function VueMultiSelectComponent_For_9_Template_span_click_3_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clearItem(item_r3));
    });
    i0.ɵɵtext(4, "\xA0\xD7");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r3[ctx_r3.bindLabel]);
  }
}
function VueMultiSelectComponent_ng_template_13_Template(rf, ctx) {}
function VueMultiSelectComponent_Conditional_14_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "fa-icon", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r3.getMinEntriesErrorTranslation(), " ");
  }
}
function VueMultiSelectComponent_Conditional_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "fa-icon", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r3.getMaxEntriesErrorTranslation(), " ");
  }
}
function VueMultiSelectComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, VueMultiSelectComponent_Conditional_14_Conditional_1_Template, 3, 1, "span", 12)(2, VueMultiSelectComponent_Conditional_14_Conditional_2_Template, 3, 1, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isMinEntriesError() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isMaxEntriesError() ? 2 : -1);
  }
}
function VuePageNotificationComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function VuePageNotificationComponent_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.button2Click());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getButton2Translation(), " ");
  }
}
function VueNavigationLogoComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "img", 2);
    i0.ɵɵlistener("error", function VueNavigationLogoComponent_Conditional_0_Template_img_error_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hideLogo());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.logoPath, i0.ɵɵsanitizeUrl);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 2)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "li")(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.selectedMenu.client.clientName, ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.subMenu.translatedSubMenuName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.application.translatedName);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.application.translatedName);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.client.clientName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.application.translatedName);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.userApplication);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 5)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedMenu.application.translatedName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.customHeaderDetail);
  }
}
function VueNavigationBreadCrumbComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3)(1, "li")(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.customHeaderDetail);
  }
}
const _c9 = () => ["fas", "random"];
function VueNavigationStdRightTopMenuComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 11);
    i0.ɵɵlistener("click", function VueNavigationStdRightTopMenuComponent_Conditional_2_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.launchCustomMenu($event));
    });
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", ctx_r1.translation["label.CustomMenuName"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(3, _c9));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.translation["label.CustomMenuName"]);
  }
}
function VueNavigationStdRightTopMenuComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵlistener("click", function VueNavigationStdRightTopMenuComponent_Conditional_14_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.callLaunchAccountMaintenance($event));
    });
    i0.ɵɵelement(1, "fa-icon", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.translation["label.Account"], " ");
  }
}
function VueNavigationMenuItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "fa-icon", 1);
    i0.ɵɵelementEnd();
  }
}
const _c10 = ["navigationStdRightTopMenu"];
function VueNavigationComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header", 1)(1, "div", 3)(2, "button", 4);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵlistener("click", function VueNavigationComponent_Conditional_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSideMenu());
    });
    i0.ɵɵelement(5, "fa-icon", 5);
    i0.ɵɵelementStart(6, "span", 6);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(10, "vue-navigation-logo", 7)(11, "vue-navigation-bread-crumb", 8)(12, "vue-navigation-std-right-top-menu", 9, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", !ctx_r1.showMenuButton);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 15, i0.ɵɵpipeBind2(3, 12, "pageTitle.menu", "PortalBase")))("aria-expanded", ctx_r1.showSideMenu);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 20, i0.ɵɵpipeBind2(8, 17, "pageTitle.menu", "PortalBase")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("imagePath", ctx_r1.imagePath);
    i0.ɵɵadvance();
    i0.ɵɵproperty("menu", ctx_r1.selectedMenu)("customHeaderDetail", ctx_r1.customHeaderDetail);
    i0.ɵɵadvance();
    i0.ɵɵproperty("helpURL", ctx_r1.helpURL)("customMenuURL", ctx_r1.customMenuURL)("showAccountMaint", ctx_r1.showAccountMaint)("accountMaintLink", ctx_r1.accountMaintLink)("translation", ctx_r1.translation);
  }
}
function VueNavigationComponent_Conditional_1_Conditional_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 15);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_2_For_3_Template_vue_navigation_menu_item_selected_0_listener() {
      const appObject_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callSelectApplication(appObject_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const appObject_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", appObject_r4.translatedName);
    i0.ɵɵattribute("aria-selected", ctx_r1.isAppCurrentlySelected(appObject_r4));
  }
}
function VueNavigationComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(2, VueNavigationComponent_Conditional_1_Conditional_2_For_3_Template, 1, 2, "vue-navigation-menu-item", 14, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(4, "sortBy");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.translation["label.Applications"]);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind2(4, 1, ctx_r1.clientsAndApplications, "translatedName"));
  }
}
function VueNavigationComponent_Conditional_1_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 18);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_3_Conditional_2_Template_vue_navigation_menu_item_selected_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callBackToMenu("backToApplications"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isBackButton", true)("label", ctx_r1.translation["label.BackToApplications"]);
  }
}
function VueNavigationComponent_Conditional_1_Conditional_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 15);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_3_For_4_Template_vue_navigation_menu_item_selected_0_listener() {
      const clientObject_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callSelectClient(clientObject_r7));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const clientObject_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", clientObject_r7.clientName);
    i0.ɵɵattribute("aria-selected", ctx_r1.isClientCurrentlySelected(clientObject_r7));
  }
}
function VueNavigationComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, VueNavigationComponent_Conditional_1_Conditional_3_Conditional_2_Template, 1, 2, "vue-navigation-menu-item", 17);
    i0.ɵɵrepeaterCreate(3, VueNavigationComponent_Conditional_1_Conditional_3_For_4_Template, 1, 2, "vue-navigation-menu-item", 14, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(5, "sortBy");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.translation["label.Clients"]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.userHasMultipleApplications() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind2(5, 2, ctx_r1.clientList, "clientName"));
  }
}
function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 18);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_2_Template_vue_navigation_menu_item_selected_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callBackToMenu("backToClients"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isBackButton", true)("label", ctx_r1.translation["label.BackToClients"]);
  }
}
function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 18);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_3_Template_vue_navigation_menu_item_selected_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callBackToMenu("backToApplications"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isBackButton", true)("label", ctx_r1.translation["label.BackToApplications"]);
  }
}
function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 18);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_4_Conditional_4_Template_vue_navigation_menu_item_selected_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callBackToMenu("backToPrevSubMenu"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isBackButton", true)("label", ctx_r1.translation["PrevSubMenuTitle"]);
  }
}
function VueNavigationComponent_Conditional_1_Conditional_4_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-navigation-menu-item", 15);
    i0.ɵɵlistener("selected", function VueNavigationComponent_Conditional_1_Conditional_4_For_6_Template_vue_navigation_menu_item_selected_0_listener() {
      const submenuObject_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.callSelectSubMenu(submenuObject_r12));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const submenuObject_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", submenuObject_r12.translatedSubMenuName);
    i0.ɵɵattribute("aria-selected", ctx_r1.isSubMenuCurrentlySelected(submenuObject_r12));
  }
}
function VueNavigationComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, VueNavigationComponent_Conditional_1_Conditional_4_Conditional_2_Template, 1, 2, "vue-navigation-menu-item", 17)(3, VueNavigationComponent_Conditional_1_Conditional_4_Conditional_3_Template, 1, 2, "vue-navigation-menu-item", 17)(4, VueNavigationComponent_Conditional_1_Conditional_4_Conditional_4_Template, 1, 2, "vue-navigation-menu-item", 17);
    i0.ɵɵrepeaterCreate(5, VueNavigationComponent_Conditional_1_Conditional_4_For_6_Template, 1, 2, "vue-navigation-menu-item", 14, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.translation["SubMenuTitle"]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showBackToClients() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showBackToApplications() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showBackToPreviousSubMenu() ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.displaySubMenu.subMenuList);
  }
}
function VueNavigationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 2)(1, "vue-navigation-menu", 10);
    i0.ɵɵtemplate(2, VueNavigationComponent_Conditional_1_Conditional_2_Template, 5, 4)(3, VueNavigationComponent_Conditional_1_Conditional_3_Template, 6, 5)(4, VueNavigationComponent_Conditional_1_Conditional_4_Template, 7, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11)(6, "div", 12);
    i0.ɵɵtext(7, "Pearson");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showApplicationSideMenu() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showClientSideMenu() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showSubMenu ? 4 : -1);
  }
}
function VuePageHeaderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previousPageButtonClick());
    });
    i0.ɵɵelement(1, "fa-icon", 8);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.getPreviousPageButtonTranslation());
  }
}
function VuePageHeaderComponent_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 10);
  }
}
function VuePageHeaderComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, VuePageHeaderComponent_Conditional_9_Conditional_1_Template, 1, 0, "fa-icon", 10);
    i0.ɵɵelementStart(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.descriptiveTextHasWarning ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getDescriptiveTextTranslation());
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 11)(2, "button", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13)(5, "p", 14);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 15);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_1_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 16);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultCancelClick());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultButtonTranslation(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultCancelTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 17);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.defaultButtonClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getDefaultButtonTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_1_Template, 11, 4, "span")(2, VuePageHeaderComponent_Conditional_10_Conditional_1_Conditional_2_Template, 3, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isDefaultConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isDefaultConfirmStyleDesired() ? 2 : -1);
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 11)(2, "button", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19)(5, "p", 14);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 20);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_1_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 21);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryCancelClick());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryButtonTranslation(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryCancelTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 22);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.secondaryButtonClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getSecondaryButtonTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_1_Template, 11, 4, "span")(2, VuePageHeaderComponent_Conditional_10_Conditional_2_Conditional_2_Template, 3, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSecondaryConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isSecondaryConfirmStyleDesired() ? 2 : -1);
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "button", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25)(4, "p", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 26);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryConfirmClick());
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 27);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_1_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryCancelClick());
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryButtonTranslation(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryConfirmHeaderTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryConfirmTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryCancelTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.primaryButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getPrimaryButtonTranslation(), " ");
  }
}
function VuePageHeaderComponent_Conditional_10_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_1_Template, 10, 4, "div", 11)(2, VuePageHeaderComponent_Conditional_10_Conditional_3_Conditional_2_Template, 2, 1, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isPrimaryConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isPrimaryConfirmStyleDesired() ? 2 : -1);
  }
}
function VuePageHeaderComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, VuePageHeaderComponent_Conditional_10_Conditional_1_Template, 3, 2, "span")(2, VuePageHeaderComponent_Conditional_10_Conditional_2_Template, 3, 2, "span")(3, VuePageHeaderComponent_Conditional_10_Conditional_3_Template, 3, 2, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isDefaultButtonDesiredAndAuthorized() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSecondaryButtonDesiredAndAuthorized() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isPrimaryButtonDesiredAndAuthorized() ? 3 : -1);
  }
}
const _c11 = a0 => [a0];
function VuePageRowsComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function VuePageRowsComponent_For_9_Template_button_click_0_listener() {
      const size_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changePageSize(size_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const size_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", size_r2, " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleSection());
    });
    i0.ɵɵelement(1, "fa-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r1.getCollapseAriaLabelTranslation(ctx_r1.expanded));
    i0.ɵɵattribute("aria-controls", "panel-content" + ctx_r1.idSuffix)("aria-expanded", ctx_r1.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", !ctx_r1.expanded ? ctx_r1.chevronDown : ctx_r1.chevronUp);
  }
}
function VuePanelComponent_Conditional_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTitleTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VuePanelComponent_Conditional_2_Conditional_2_Conditional_0_Template, 2, 1, "h2", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.isTitleDesired() ? 0 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTitleTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VuePanelComponent_Conditional_2_Conditional_3_Conditional_0_Template, 2, 1, "h1", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.isTitleDesired() ? 0 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 10)(2, "button", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵelement(5, "p", 13);
    i0.ɵɵpipe(6, "vuehtmlsafe");
    i0.ɵɵelementStart(7, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_1_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.action1ConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.action1CancelClick());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isAction1Hidden())("container", ctx_r1.dropDownAppend);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dropdownBasic1", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction1ButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "dropdownBasic1" + ctx_r1.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(6, 13, ctx_r1.getAction1ConfirmHeaderTranslation()), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "confirm-true", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction1ConfirmTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "confirm-false", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction1CancelTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 15);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.action1ButtonClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "action1Btn", ctx_r1.idSuffix, "");
    i0.ɵɵproperty("hidden", ctx_r1.isAction1Hidden());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction1ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_1_Template, 11, 15, "span")(2, VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Conditional_2_Template, 3, 4, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction1ConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isAction1ConfirmStyleDesired() ? 2 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 10)(2, "button", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵelement(5, "p", 13);
    i0.ɵɵpipe(6, "vuehtmlsafe");
    i0.ɵɵelementStart(7, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_1_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action2ConfirmClick());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action2CancelClick());
    });
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isAction2Hidden())("container", ctx_r1.dropDownAppend);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dropdownBasic2", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction2ButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "dropdownBasic2" + ctx_r1.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(6, 13, ctx_r1.getAction2ConfirmHeaderTranslation()), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "confirm-true", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction2ConfirmTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "confirm-false", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction2CancelTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 15);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action2ButtonClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "action2Btn", ctx_r1.idSuffix, "");
    i0.ɵɵproperty("hidden", ctx_r1.isAction2Hidden());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction2ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_1_Template, 11, 15, "span")(2, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Conditional_2_Template, 3, 4, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction2ConfirmStyleDesired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isAction2ConfirmStyleDesired() ? 2 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action4ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action4Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction4ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action5ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action5Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction5ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action6ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action6Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction6ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 16)(2, "button", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 12)(6, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.action3ButtonClick());
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_8_Template, 2, 3, "button", 18)(9, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_9_Template, 2, 3, "button", 18)(10, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Conditional_10_Template, 2, 3, "button", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isAction1Hidden())("container", ctx_r1.dropDownAppend);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dropdownBasic3", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getMoreButtonTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-labelledby", "dropdownBasic3" + ctx_r1.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "action3Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction3ButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction4ButtonDesiredAndAuthorized() ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction5ButtonDesiredAndAuthorized() ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction6ButtonDesiredAndAuthorized() ? 10 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_1_Template, 3, 2, "span")(2, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Conditional_2_Template, 11, 12, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction2ButtonDesiredAndAuthorized() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction3ButtonDesiredAndAuthorized() ? 2 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action3ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action3Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction3ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action4ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action4Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction4ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action5ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action5Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction5ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.action6ButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "action6Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction6ButtonTranslation(), " ");
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 16)(2, "button", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 12)(6, "button", 14);
    i0.ɵɵlistener("click", function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.action2ButtonClick());
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_8_Template, 2, 3, "button", 18)(9, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_9_Template, 2, 3, "button", 18)(10, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_10_Template, 2, 3, "button", 18)(11, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Conditional_11_Template, 2, 3, "button", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", ctx_r1.isAction1Hidden())("container", ctx_r1.dropDownAppend);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dropdownBasic4", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getMoreButtonTranslation(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-labelledby", "dropdownBasic4" + ctx_r1.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "action2Btn", ctx_r1.idSuffix, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getAction2ButtonTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction3ButtonDesiredAndAuthorized() ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction4ButtonDesiredAndAuthorized() ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction5ButtonDesiredAndAuthorized() ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction6ButtonDesiredAndAuthorized() ? 11 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Conditional_1_Template, 12, 13, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction2ButtonDesiredAndAuthorized() ? 1 : -1);
  }
}
function VuePanelComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_4_Conditional_1_Template, 3, 2, "span")(2, VuePanelComponent_Conditional_2_Conditional_4_Conditional_2_Template, 3, 2, "span")(3, VuePanelComponent_Conditional_2_Conditional_4_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAction1ButtonDesiredAndAuthorized() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isTwoPrimaryButtonsDesired() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isTwoPrimaryButtonsDesired() ? 3 : -1);
  }
}
function VuePanelComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, VuePanelComponent_Conditional_2_Conditional_1_Template, 2, 4, "button", 5)(2, VuePanelComponent_Conditional_2_Conditional_2_Template, 1, 1)(3, VuePanelComponent_Conditional_2_Conditional_3_Template, 1, 1)(4, VuePanelComponent_Conditional_2_Conditional_4_Template, 4, 3, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("subpanel-header ", ctx_r1.getBorderClass(), "");
    i0.ɵɵproperty("ngClass", ctx_r1.toggle && !ctx_r1.expanded && "content-collapsed");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.toggle ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isTitleH1Tag() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isTitleH1Tag() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.action1Visible ? 4 : -1);
  }
}
function VuePanelComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "panel-content", ctx_r1.idSuffix, "");
  }
}
function VueProgressBarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngb-progressbar", 1);
  }
}
function VueProgressBarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-bar", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("mode", ctx_r0.type)("value", ctx_r0.progress);
    i0.ɵɵattribute("aria-label", ctx_r0.name);
  }
}
function VueReadOnlyFormComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3)(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.getTranslatedName(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r1.getTranslatedValue());
  }
}
function VueSearchComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getLabelTranslation(), " ");
  }
}
function VueSearchComponent_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_1_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleAdvanced());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "fa-icon", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getSearchOptionsLabelTranslation());
  }
}
function VueSearchComponent_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_1_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearSearchButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getClearLabelTranslation());
  }
}
function VueSearchComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 2);
    i0.ɵɵtemplate(2, VueSearchComponent_Conditional_1_Conditional_2_Template, 2, 1, "label", 3);
    i0.ɵɵelementStart(3, "div", 4)(4, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function VueSearchComponent_Conditional_1_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.genericSearchField, $event) || (ctx_r1.genericSearchField = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function VueSearchComponent_Conditional_1_Template_input_ngModelChange_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.genericSearchChange());
    })("keyup", function VueSearchComponent_Conditional_1_Template_input_keyup_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkBasicSearchKey($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 6)(6, "button", 7);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.basicSearchButtonClick());
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VueSearchComponent_Conditional_1_Conditional_8_Template, 4, 1, "button", 8)(9, VueSearchComponent_Conditional_1_Conditional_9_Template, 2, 1, "button", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 10)(11, "span", 11);
    i0.ɵɵelement(12, "fa-icon", 12);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(14, "div", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.getBasicErrorClass());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isLabelSpecified() ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.genericSearchField);
    i0.ɵɵproperty("placeholder", ctx_r1.getPlaceHolderTranslation());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r1.isShowAdvanced());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getSearchLabelTranslation());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAdvancedSearch() ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showClearSearch && !ctx_r1.isShowAdvanced() ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.showBasicSearchError);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.basicSearchError, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.isAdvancedSearch());
  }
}
function VueSearchComponent_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_2_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleContent());
    });
    i0.ɵɵelement(1, "fa-icon", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r1.getSearchOptionsLabelTranslation());
    i0.ɵɵattribute("aria-expanded", !ctx_r1.collapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", !ctx_r1.collapsed ? ctx_r1.chevronUp : ctx_r1.chevronDown);
  }
}
function VueSearchComponent_Conditional_2_Conditional_11_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 15);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_2_Conditional_11_Conditional_11_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearSearchButtonClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getClearLabelTranslation());
  }
}
function VueSearchComponent_Conditional_2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 26)(2, "button", 27);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_2_Conditional_11_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearAdvancedError());
    });
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵtext(4, "\xD7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 29);
    i0.ɵɵtext(6, "Close");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "span", 30);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵprojection(9);
    i0.ɵɵelementStart(10, "div", 31);
    i0.ɵɵtemplate(11, VueSearchComponent_Conditional_2_Conditional_11_Conditional_11_Template, 3, 1, "span");
    i0.ɵɵelementStart(12, "button", 32);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_2_Conditional_11_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.advancedSearchButtonClick());
    });
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.showAdvancedSearchError);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.advancedSearchError);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showClearSearch ? 11 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getSearchLabelTranslation());
  }
}
function VueSearchComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div")(2, "div", 16)(3, "div", 17)(4, "div", 18);
    i0.ɵɵtemplate(5, VueSearchComponent_Conditional_2_Conditional_5_Template, 2, 3, "button", 19);
    i0.ɵɵelementStart(6, "span", 20);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 21)(9, "a", 22);
    i0.ɵɵlistener("click", function VueSearchComponent_Conditional_2_Template_a_click_9_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeAdvanced());
    });
    i0.ɵɵelement(10, "fa-icon", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(11, VueSearchComponent_Conditional_2_Conditional_11_Template, 14, 4, "div", 23);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.isShowAdvanced());
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("advanced-search-container ", ctx_r1.getWidthClass(), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.collapsed && "collapsed");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.toggle ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getSearchOptionsTitleLabelTranslation());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r1.isStandaloneSearch())("routerLink", i0.ɵɵpureFunction0(10, _c6));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.toggle || !ctx_r1.collapsed ? 11 : -1);
  }
}
function VueServerMessagesComponent_For_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", message_r1.messageText, " ");
  }
}
function VueServerMessagesComponent_For_1_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", message_r1.messageText, i0.ɵɵsanitizeHtml);
  }
}
function VueServerMessagesComponent_For_1_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵlistener("click", function VueServerMessagesComponent_For_1_Conditional_3_Conditional_3_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ɵ$index_1_r3 = i0.ɵɵnextContext(2).$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clickMessage(ɵ$index_1_r3, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", message_r1.messageText, i0.ɵɵsanitizeHtml);
  }
}
function VueServerMessagesComponent_For_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, VueServerMessagesComponent_For_1_Conditional_3_Conditional_1_Template, 2, 1, "span", 6)(2, VueServerMessagesComponent_For_1_Conditional_3_Conditional_2_Template, 1, 1, "span", 7)(3, VueServerMessagesComponent_For_1_Conditional_3_Conditional_3_Template, 1, 1, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.isClickable(message_r1) && !ctx_r3.isRenderInHtml(message_r1) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.isClickable(message_r1) && ctx_r3.isRenderInHtml(message_r1) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isClickable(message_r1) ? 3 : -1);
  }
}
function VueServerMessagesComponent_For_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", message_r1.messageText, " ");
  }
}
function VueServerMessagesComponent_For_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", message_r1.messageText, i0.ɵɵsanitizeHtml);
  }
}
function VueServerMessagesComponent_For_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 10);
    i0.ɵɵlistener("click", function VueServerMessagesComponent_For_1_Conditional_6_Template_span_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ɵ$index_1_r3 = i0.ɵɵnextContext().$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clickMessage(ɵ$index_1_r3, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", message_r1.messageText, i0.ɵɵsanitizeHtml);
  }
}
function VueServerMessagesComponent_For_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function VueServerMessagesComponent_For_1_Conditional_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ɵ$index_1_r3 = i0.ɵɵnextContext().$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clearMessage(ɵ$index_1_r3));
    });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2, "\xD7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.dismissLabel ? ctx_r3.dismissLabel : i0.ɵɵpipeBind1(6, 4, i0.ɵɵpipeBind2(5, 1, ctx_r3.dismissLabelKey, ctx_r3.i18nBundle)), " ");
  }
}
function VueServerMessagesComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 0);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵtemplate(3, VueServerMessagesComponent_For_1_Conditional_3_Template, 4, 3, "div", 1)(4, VueServerMessagesComponent_For_1_Conditional_4_Template, 2, 1, "span", 2)(5, VueServerMessagesComponent_For_1_Conditional_5_Template, 1, 1, "span", 3)(6, VueServerMessagesComponent_For_1_Conditional_6_Template, 2, 1, "div", 4)(7, VueServerMessagesComponent_For_1_Conditional_7_Template, 7, 6, "button", 5);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const message_r1 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r3.getMessageClass(message_r1) + " alert")("tabindex", ctx_r3.isDismissible(message_r1) ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r3.isDismissible(message_r1) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isDismissible(message_r1) && !ctx_r3.isClickable(message_r1) && !ctx_r3.isRenderInHtml(message_r1) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isDismissible(message_r1) && !ctx_r3.isClickable(message_r1) && ctx_r3.isRenderInHtml(message_r1) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isDismissible(message_r1) && ctx_r3.isClickable(message_r1) ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.isDismissible(message_r1) ? 7 : -1);
  }
}
function VueSortComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 0);
    i0.ɵɵelementEnd();
  }
}
function VueSortComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 1);
    i0.ɵɵelementEnd();
  }
}
const _c12 = ["confirmDialog"];
function VueTableActionsComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5, 1);
    i0.ɵɵlistener("click", function VueTableActionsComponent_For_1_Template_button_click_0_listener() {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const currentButton_r3 = i0.ɵɵreference(1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.buttonClick(button_r2, currentButton_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵproperty("id", button_r2.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", button_r2.label, " ");
  }
}
function VueTableActionsComponent_Conditional_2_For_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function VueTableActionsComponent_Conditional_2_For_9_Template_button_click_0_listener() {
      const button_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      i0.ɵɵnextContext();
      const moreButton_r7 = i0.ɵɵreference(2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.buttonClick(button_r6, moreButton_r7));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r6 = ctx.$implicit;
    i0.ɵɵproperty("id", button_r6.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", button_r6.label, " ");
  }
}
function VueTableActionsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "button", 6, 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelement(6, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵrepeaterCreate(8, VueTableActionsComponent_Conditional_2_For_9_Template, 2, 2, "button", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placement", ctx_r3.isRTL ? "bottom-left" : "bottom-right");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "table-action-buttons-moreButton-" + ctx_r3.idSuffix);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, i0.ɵɵpipeBind2(4, 4, "button.more", ctx_r3.i18nBundle)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-labelledby", "moreButton" + ctx_r3.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.moreButtons);
  }
}
function VueTableActionsComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 12);
    i0.ɵɵpipe(1, "vuehtmlsafe");
  }
  if (rf & 2) {
    const data_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, data_r9.confirmHeaderLabel), i0.ɵɵsanitizeHtml);
  }
}
function VueTableActionsComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, VueTableActionsComponent_ng_template_3_Conditional_1_Template, 2, 3, "p", 12);
    i0.ɵɵelementStart(2, "button", 13);
    i0.ɵɵlistener("keydown.arrowdown", function VueTableActionsComponent_ng_template_3_Template_button_keydown_arrowdown_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.target.nextElementSibling.focus());
    })("keydown.arrowup", function VueTableActionsComponent_ng_template_3_Template_button_keydown_arrowup_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.target.nextElementSibling.focus());
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 13);
    i0.ɵɵlistener("keydown.arrowdown", function VueTableActionsComponent_ng_template_3_Template_button_keydown_arrowdown_4_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.target.previousElementSibling.focus());
    })("keydown.arrowup", function VueTableActionsComponent_ng_template_3_Template_button_keydown_arrowup_4_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.target.previousElementSibling.focus());
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const data_r9 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(data_r9.confirmHeaderLabel ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "table-action-buttons-confirm-true-" + ctx_r3.idSuffix)("mat-dialog-close", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", data_r9.confirmLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "table-action-buttons-confirm-false-" + ctx_r3.idSuffix)("mat-dialog-close", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", data_r9.cancelLabel, " ");
  }
}
const _c13 = ["vue-table-filter", ""];
function VueTableFilterComponent_Conditional_0_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function VueTableFilterComponent_Conditional_0_For_1_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const filterInput_r3 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(filterInput_r3.fieldValue, $event) || (filterInput_r3.fieldValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("input", function VueTableFilterComponent_Conditional_0_For_1_Conditional_1_Template_input_input_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.applyFilter());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filterInput_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", filterInput_r3.fieldName)("id", filterInput_r3.inputId + ctx_r3.idSuffix);
    i0.ɵɵtwoWayProperty("ngModel", filterInput_r3.fieldValue);
    i0.ɵɵattribute("aria-label", filterInput_r3.ariaLabel);
  }
}
function VueTableFilterComponent_Conditional_0_For_1_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectOption_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", selectOption_r6.ngValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(selectOption_r6.optionLabel);
  }
}
function VueTableFilterComponent_Conditional_0_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function VueTableFilterComponent_Conditional_0_For_1_Conditional_2_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const filterInput_r3 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(filterInput_r3.fieldValue, $event) || (filterInput_r3.fieldValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function VueTableFilterComponent_Conditional_0_For_1_Conditional_2_Template_select_change_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.applyFilter());
    });
    i0.ɵɵrepeaterCreate(1, VueTableFilterComponent_Conditional_0_For_1_Conditional_2_For_2_Template, 2, 2, "option", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filterInput_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", filterInput_r3.fieldName)("id", filterInput_r3.inputId + ctx_r3.idSuffix);
    i0.ɵɵtwoWayProperty("ngModel", filterInput_r3.fieldValue);
    i0.ɵɵattribute("aria-label", filterInput_r3.ariaLabel);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(filterInput_r3.selectOptions);
  }
}
function VueTableFilterComponent_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, VueTableFilterComponent_Conditional_0_For_1_Conditional_1_Template, 1, 4, "input", 1)(2, VueTableFilterComponent_Conditional_0_For_1_Conditional_2_Template, 3, 4, "select", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filterInput_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.isFilterInputDropdown(filterInput_r3) ? 1 : 2);
  }
}
function VueTableFilterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵrepeaterCreate(0, VueTableFilterComponent_Conditional_0_For_1_Template, 3, 1, "td", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(2, "td")(3, "button", 0);
    i0.ɵɵlistener("click", function VueTableFilterComponent_Conditional_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clearFilter());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.filterInputs);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", "filter-clear-id" + ctx_r3.idSuffix);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, i0.ɵɵpipeBind2(5, 2, "button.clearFilter", "PortalBase")), " ");
  }
}
function VueTimeoutDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵlistener("click", function VueTimeoutDialogComponent_Conditional_0_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.extendSession());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "p");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 4);
    i0.ɵɵlistener("click", function VueTimeoutDialogComponent_Conditional_0_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.extendSession());
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.timeoutMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.extendSessionText);
  }
}
const _c14 = a0 => ({
  "validation-disabled": a0
});
function VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rule_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.classFail);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", rule_r1.label, " ");
  }
}
function VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rule_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c14, rule_r1.valid));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", rule_r1.label, " ");
  }
}
function VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rule_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.classSuccess);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", rule_r1.label, " ");
  }
}
function VueInlineValidationMessageComponent_Conditional_0_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_1_Template, 3, 3, "span", 1)(2, VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_2_Template, 2, 4, "span", 2)(3, VueInlineValidationMessageComponent_Conditional_0_For_4_Conditional_3_Template, 3, 3, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rule_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(rule_r1.class === ctx_r1.classFail ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(rule_r1.class === ctx_r1.classDisabled || rule_r1.class === ctx_r1.classNone ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(rule_r1.class === ctx_r1.classSuccess ? 3 : -1);
  }
}
function VueInlineValidationMessageComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "ul");
    i0.ɵɵrepeaterCreate(3, VueInlineValidationMessageComponent_Conditional_0_For_4_Template, 4, 3, "li", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ruleHelpLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.validationRules.rules);
  }
}
const _c15 = ["passwordResetForm"];
const _c16 = ["inlineValidatorRequired"];
const _c17 = ["inlineValidatorMatch"];
function VuePasswordStrengthInputComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-control-group", 7)(1, "input", 18, 3);
    i0.ɵɵlistener("paste", function VuePasswordStrengthInputComponent_Conditional_2_Template_input_paste_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.noPaste($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function VuePasswordStrengthInputComponent_Conditional_2_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.passwordInput.oldPassword, $event) || (ctx_r2.passwordInput.oldPassword = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vue-validation-message", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const oldPasswordField_r4 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", oldPasswordField_r4)("excludeValidationMessage", true)("formError", ctx_r2.formError)("widthClass", ctx_r2.inputWidthClass)("i18nBundle", ctx_r2.i18nBundle)("label", ctx_r2.oldPasswordLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("vueAutofocus", ctx_r2.autofocus);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.passwordInput.oldPassword);
    i0.ɵɵproperty("vueMaxLength", ctx_r2.maxPasswordLength);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", oldPasswordField_r4)("formError", ctx_r2.formError)("i18nBundle", ctx_r2.i18nBundle)("isSingleFieldLevelErrorEnabled", true);
  }
}
function VuePasswordStrengthInputComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-validation-message", 10);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const newPasswordField_r5 = i0.ɵɵreference(7);
    i0.ɵɵproperty("control", newPasswordField_r5)("formError", ctx_r2.formError)("i18nBundle", ctx_r2.i18nBundle)("isSingleFieldLevelErrorEnabled", true);
  }
}
function VuePasswordStrengthInputComponent_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵelement(1, "fa-icon", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.passwordContainsUsernameLabel, " ");
  }
}
function VuePasswordStrengthInputComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, VuePasswordStrengthInputComponent_Conditional_9_Conditional_1_Template, 3, 1, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.passwordContainsUsername ? 1 : -1);
  }
}
function VuePasswordStrengthInputComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-inline-validation-message", 13, 4);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const newPasswordField_r5 = i0.ɵɵreference(7);
    i0.ɵɵproperty("control", newPasswordField_r5)("i18nBundle", ctx_r2.i18nBundle)("validationRules", ctx_r2.validationRequiredRules)("ruleHelpLabel", ctx_r2.requiredRuleLabel);
  }
}
function VuePasswordStrengthInputComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-inline-validation-message", 15, 5);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const newPasswordField_r5 = i0.ɵɵreference(7);
    i0.ɵɵproperty("control", newPasswordField_r5)("i18nBundle", ctx_r2.i18nBundle)("validationRules", ctx_r2.validationOptionalRules)("ruleHelpLabel", ctx_r2.optionalRuleLabel);
  }
}
function VuePasswordStrengthInputComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-validation-message", 10);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const confirmPasswordField_r6 = i0.ɵɵreference(18);
    i0.ɵɵproperty("control", confirmPasswordField_r6)("formError", ctx_r2.formError)("i18nBundle", ctx_r2.i18nBundle)("isSingleFieldLevelErrorEnabled", true);
  }
}
function VuePasswordStrengthInputComponent_Conditional_20_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵelement(1, "fa-icon", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.passwordNotMatchLabel, " ");
  }
}
function VuePasswordStrengthInputComponent_Conditional_20_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelement(1, "fa-icon", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.passwordsMatchLabel, " ");
  }
}
function VuePasswordStrengthInputComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, VuePasswordStrengthInputComponent_Conditional_20_Conditional_1_Template, 3, 1, "span", 20)(2, VuePasswordStrengthInputComponent_Conditional_20_Conditional_2_Template, 3, 1, "span", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.passwordsMatch ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.passwordsMatch ? 2 : -1);
  }
}
function VueDragDropComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 3)(2, "div", 4);
    i0.ɵɵelement(3, "fa-icon", 5);
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("itemData", item_r1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", ctx_r2.faArrowsAltV);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ɵ$index_3_r2 + 1, ". ", item_r1.label, "");
  }
}
const _c18 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
const _c19 = () => ["fal", "arrow-down"];
const _c20 = () => ["fal", "arrow-up"];
const _c21 = () => ["fal", "copy"];
const _c22 = () => ["fal", "times"];
function VueMultipartComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "header" + ctx_r0.identifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getLabelTranslation());
  }
}
function VueMultipartComponent_For_2_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 11);
  }
}
function VueMultipartComponent_For_2_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext().$index;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ɵ$index_7_r4 + 1, ". ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 19);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.down(ɵ$index_7_r4));
    });
    i0.ɵɵelement(2, "fa-icon", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "itemDownButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", ctx_r0.getMoveAriaLabelTranslation("down"));
    i0.ɵɵattribute("aria-label", ctx_r0.getMoveAriaLabelTranslation("down"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(4, _c19));
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 19);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.down(ɵ$index_7_r4));
    });
    i0.ɵɵelement(2, "fa-icon", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 19);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.up(ɵ$index_7_r4));
    });
    i0.ɵɵelement(4, "fa-icon", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "itemDown_Button" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", ctx_r0.getMoveAriaLabelTranslation("down"));
    i0.ɵɵattribute("aria-label", ctx_r0.getMoveAriaLabelTranslation("down"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(8, _c19));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "itemUp_Button" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", ctx_r0.getMoveAriaLabelTranslation("up"));
    i0.ɵɵattribute("aria-label", ctx_r0.getMoveAriaLabelTranslation("up"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(9, _c20));
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 19);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.up(ɵ$index_7_r4));
    });
    i0.ɵɵelement(2, "fa-icon", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "itemUpButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", ctx_r0.getMoveAriaLabelTranslation("up"));
    i0.ɵɵattribute("aria-label", ctx_r0.getMoveAriaLabelTranslation("up"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(4, _c20));
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_1_Template, 3, 5, "span")(2, VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_2_Template, 5, 10, "span")(3, VueMultipartComponent_For_2_Conditional_13_Conditional_2_Conditional_3_Template, 3, 5, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_7_r4 === 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_7_r4 > 0 && ɵ$index_7_r4 < ctx_r0.itemsData.length - 1 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_7_r4 > 0 && ɵ$index_7_r4 === ctx_r0.itemsData.length - 1 ? 3 : -1);
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.emitActionButtonEvent(ɵ$index_7_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "actionBtn" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵattribute("aria-label", ctx_r0.getActionButtonTranslation());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getActionButtonTranslation(), " ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 20);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(1, _c21));
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getCopyAriaLabelTranslation(), " ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.copy(ɵ$index_7_r4));
    });
    i0.ɵɵtemplate(1, VueMultipartComponent_For_2_Conditional_13_Conditional_4_Conditional_1_Template, 1, 2, "fa-icon", 20)(2, VueMultipartComponent_For_2_Conditional_13_Conditional_4_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "itemCopyButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", !ctx_r0.useCopyText ? ctx_r0.getCopyAriaLabelTranslation() : "");
    i0.ɵɵattribute("aria-label", ctx_r0.getCopyAriaLabelTranslation());
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.useCopyText ? 1 : 2);
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 20);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(1, _c22));
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getRemoveAriaLabelTranslation(), " ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(3).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "confirmHeader" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getDeleteConfirmationLabelTranslation(), " ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 18)(1, "button", 23);
    i0.ɵɵtemplate(2, VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_2_Template, 1, 2, "fa-icon", 20)(3, VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 24);
    i0.ɵɵtemplate(5, VueMultipartComponent_For_2_Conditional_13_Conditional_5_Conditional_5_Template, 2, 2, "p", 25);
    i0.ɵɵelementStart(6, "button", 26);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Conditional_13_Conditional_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r10);
      const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.remove(ɵ$index_7_r4));
    });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 27);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ɵ$index_7_r4 = i0.ɵɵnextContext(2).$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "itemRemoveButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", !ctx_r0.useRemoveText ? ctx_r0.getRemoveAriaLabelTranslation() : "");
    i0.ɵɵattribute("aria-label", ctx_r0.getRemoveAriaLabelTranslation());
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.useRemoveText ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", "itemRemoveButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getDeleteConfirmationLabelTranslation() ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "confirmTrue" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵattribute("aria-label", ctx_r0.getConfirmationLabelTranslation());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getConfirmationLabelTranslation(), " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "confirmFalse" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵattribute("aria-label", ctx_r0.getCancelLabelTranslation());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getCancelLabelTranslation(), " ");
  }
}
function VueMultipartComponent_For_2_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 15);
    i0.ɵɵtemplate(2, VueMultipartComponent_For_2_Conditional_13_Conditional_2_Template, 4, 3, "span")(3, VueMultipartComponent_For_2_Conditional_13_Conditional_3_Template, 2, 3, "button", 16)(4, VueMultipartComponent_For_2_Conditional_13_Conditional_4_Template, 3, 4, "button", 17)(5, VueMultipartComponent_For_2_Conditional_13_Conditional_5_Template, 10, 12, "span", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.sortable ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.enableActionButton ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.enableCopyButton ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.enableRemoveButton ? 5 : -1);
  }
}
function VueMultipartComponent_For_2_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function VueMultipartComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "button", 7);
    i0.ɵɵlistener("click", function VueMultipartComponent_For_2_Template_button_click_5_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      return i0.ɵɵresetView(item_r3.collapsed = !item_r3.collapsed);
    });
    i0.ɵɵelement(6, "fa-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 9)(8, "div", 10);
    i0.ɵɵtemplate(9, VueMultipartComponent_For_2_Conditional_9_Template, 1, 0, "fa-icon", 11)(10, VueMultipartComponent_For_2_Conditional_10_Template, 2, 1, "b");
    i0.ɵɵelementStart(11, "b");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, VueMultipartComponent_For_2_Conditional_13_Template, 6, 4, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 13);
    i0.ɵɵtemplate(15, VueMultipartComponent_For_2_ng_container_15_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ɵ$index_7_r4 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", item_r3.collapsed ? "subpanel-header no-border" : "subpanel-header");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", "itemCollapseButton" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("title", ctx_r0.getCollapseAriaLabelTranslation(item_r3.collapsed))("ngClass", !item_r3.collapsed ? "rotate" : "");
    i0.ɵɵattribute("aria-label", ctx_r0.getCollapseAriaLabelTranslation(item_r3.collapsed));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("id", "itemLabel" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("ngClass", item_r3.hasError ? "panel-has-error subpanel-title" : "subpanel-title");
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r3.hasWarning ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.enableMultipartNumbering ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getCounterLabelTranslation(ɵ$index_7_r4));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r3.readonly ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "content" + ɵ$index_7_r4 + "-" + ctx_r0.identifier);
    i0.ɵɵproperty("hidden", item_r3.collapsed);
    i0.ɵɵattribute("aria-hidden", item_r3.collapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(16, _c18, item_r3, ɵ$index_7_r4));
  }
}
function VueMultipartComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function VueMultipartComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.add());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "itemAddButton" + "-" + ctx_r0.identifier);
    i0.ɵɵattribute("aria-label", ctx_r0.getAddButtonTranslation());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getAddButtonTranslation());
  }
}
function VueToggleSectionComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "content", ctx_r0.idSuffix, "");
  }
}
const _c23 = ["loginForm"];
const _c24 = ["verifyForm"];
function VueAuthenticationComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "vue-panel", 30);
    i0.ɵɵelement(2, "span", 31);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.welcomeTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.welcomeMessage, i0.ɵɵsanitizeHtml);
  }
}
function VueAuthenticationComponent_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngb-alert", 32);
    i0.ɵɵlistener("close", function VueAuthenticationComponent_Conditional_3_Conditional_4_Template_ngb_alert_close_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeInfoMessage());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dismissible", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.infoMessage, " ");
  }
}
function VueAuthenticationComponent_Conditional_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngb-alert", 15);
    i0.ɵɵelement(1, "span", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dismissible", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.errorMessage, i0.ɵɵsanitizeHtml);
  }
}
function VueAuthenticationComponent_Conditional_3_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-control-group", 21)(1, "input", 33, 3);
    i0.ɵɵtwoWayListener("ngModelChange", function VueAuthenticationComponent_Conditional_3_Conditional_16_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.credentials.siteId, $event) || (ctx_r1.credentials.siteId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const siteId_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", siteId_r5)("formError", ctx_r1.formError);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.credentials.siteId);
  }
}
function VueAuthenticationComponent_Conditional_3_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-forgot-credentials", 34);
    i0.ɵɵlistener("resetPasswordClicked", function VueAuthenticationComponent_Conditional_3_Conditional_19_Template_vue_forgot_credentials_resetPasswordClicked_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.resetPasswordClicked());
    });
    i0.ɵɵelementEnd();
  }
}
function VueAuthenticationComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, VueAuthenticationComponent_Conditional_3_Conditional_1_Template, 3, 2, "div", 11);
    i0.ɵɵelementStart(2, "div", 12)(3, "vue-panel", 13);
    i0.ɵɵtemplate(4, VueAuthenticationComponent_Conditional_3_Conditional_4_Template, 2, 2, "ngb-alert", 14)(5, VueAuthenticationComponent_Conditional_3_Conditional_5_Template, 2, 2, "ngb-alert", 15);
    i0.ɵɵelementStart(6, "form", 16, 0)(8, "vue-control-group", 17)(9, "input", 18, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function VueAuthenticationComponent_Conditional_3_Template_input_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.credentials.username, $event) || (ctx_r1.credentials.username = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "vue-control-group", 19)(13, "input", 20, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function VueAuthenticationComponent_Conditional_3_Template_input_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.credentials.password, $event) || (ctx_r1.credentials.password = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, VueAuthenticationComponent_Conditional_3_Conditional_16_Template, 4, 3, "vue-control-group", 21);
    i0.ɵɵelementStart(17, "div")(18, "div", 22);
    i0.ɵɵtemplate(19, VueAuthenticationComponent_Conditional_3_Conditional_19_Template, 1, 0, "vue-forgot-credentials");
    i0.ɵɵelementStart(20, "button", 23);
    i0.ɵɵlistener("click", function VueAuthenticationComponent_Conditional_3_Template_button_click_20_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.login());
    });
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(22, "div", 24);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 25)(25, "p");
    i0.ɵɵelement(26, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "ul", 27)(28, "li")(29, "a", 28);
    i0.ɵɵlistener("click", function VueAuthenticationComponent_Conditional_3_Template_a_click_29_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doResetAccount());
    });
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "li")(32, "a", 29);
    i0.ɵɵlistener("click", function VueAuthenticationComponent_Conditional_3_Template_a_click_32_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelResetAccount());
    });
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const username_r7 = i0.ɵɵreference(11);
    const password_r8 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.displayInformationPanel ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("titleKey", ctx_r1.titleKey);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.infoMessage ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.errorMessage && !ctx_r1.hideErrorMessage ? 5 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", username_r7)("formError", ctx_r1.formError);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.credentials.username);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", password_r8)("formError", ctx_r1.formError);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.credentials.password);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isSiteIdRequired ? 16 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.displayForgotCredentials ? 19 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.loginButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.browserInformationMessage, " ");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", ctx_r1.showResetAccountDropdown ? "block" : "none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.resetAccountConfirmationText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(21, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.resetAccountYes, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(22, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.resetAccountNo, " ");
  }
}
function VueAuthenticationComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 7)(2, "vue-panel", 35)(3, "form", 36, 4)(5, "vue-control-group", 37)(6, "input", 38, 5);
    i0.ɵɵtwoWayListener("ngModelChange", function VueAuthenticationComponent_Conditional_4_Template_input_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.verificationCode, $event) || (ctx_r1.verificationCode = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup.enter", function VueAuthenticationComponent_Conditional_4_Template_input_keyup_enter_6_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doVerify());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "vue-form-buttons", 39);
    i0.ɵɵlistener("secondaryButtonClicked", function VueAuthenticationComponent_Conditional_4_Template_vue_form_buttons_secondaryButtonClicked_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelVerify());
    })("defaultButtonClicked", function VueAuthenticationComponent_Conditional_4_Template_vue_form_buttons_defaultButtonClicked_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.requestVerificationCode());
    })("primaryButtonClicked", function VueAuthenticationComponent_Conditional_4_Template_vue_form_buttons_primaryButtonClicked_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doVerify());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const verificationCodeInput_r10 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("control", verificationCodeInput_r10)("formError", ctx_r1.formError);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.verificationCode);
  }
}
function VueLoadingIndicatorComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.loading);
  }
}
function VueLoadingIndicatorComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, VueLoadingIndicatorComponent_Conditional_1_Conditional_1_Template, 2, 1, "p");
    i0.ɵɵelementStart(2, "p", 4, 0);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5)(6, "p", 6);
    i0.ɵɵtext(7, "...");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const content_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!content_r2.innerHTML.trim() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !content_r2.innerHTML.trim());
  }
}
function VueLoadingIndicatorComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function VuePleaseSelectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vue-server-messages", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("messages", ctx_r0.messages);
  }
}
function VueTabComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵelement(1, "fa-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r0.toolTipMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.infoCircle);
  }
}
function VueTabComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, VueTabComponent_ng_template_1_Conditional_2_Template, 2, 2, "span", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-tab-label-content-has-error", ctx_r0.vueTabHasError);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.toolTipMessage ? 2 : -1);
  }
}
const _c25 = a0 => ({
  "check-error": a0
});
function VueCheckboxComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mat-checkbox", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function VueCheckboxComponent_For_7_Template_mat_checkbox_ngModelChange_1_listener($event) {
      const option_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      i0.ɵɵtwoWayBindingSet(option_r2.checked, $event) || (option_r2.checked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function VueCheckboxComponent_For_7_Template_mat_checkbox_change_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onToggle());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", option_r2.checked);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", option_r2.label, " ");
  }
}
function VueCheckboxComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 5);
    i0.ɵɵelement(2, "fa-icon", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.error, " ");
  }
}
const _c26 = ["initiatePasswordResetForm"];
function VueForgotPasswordComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vue-control-group", 12);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "input", 13, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function VueForgotPasswordComponent_Conditional_21_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.inputSiteID, $event) || (ctx_r2.inputSiteID = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const siteID_r4 = i0.ɵɵreference(6);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(3, 8, i0.ɵɵpipeBind2(2, 5, "field.SiteID", "PortalBase")))("control", siteID_r4)("i18nBundle", ctx_r2.i18nBundle)("formError", ctx_r2.formError);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.inputSiteID);
  }
}
const _c27 = ["passwordInputContainer"];
const _c28 = ["*", [["", "vueStepPendingContent", ""]], [["", "vueStepActiveContent", ""]], [["", "vueStepCompleteContent", ""]]];
const _c29 = ["*", "[vueStepPendingContent]", "[vueStepActiveContent]", "[vueStepCompleteContent]"];
function VueStepComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function VueStepComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function VueStepComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
const _c30 = ["securityQuestionsForm"];
function VueSecurityQuestionsComponent_For_3_Conditional_0_For_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const question_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", question_r4.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", question_r4.text, " ");
  }
}
function VueSecurityQuestionsComponent_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-control-group", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "select", 6, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function VueSecurityQuestionsComponent_For_3_Conditional_0_Template_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ɵ$index_3_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.internalSelectedQuestions[ɵ$index_3_r2], $event) || (ctx_r2.internalSelectedQuestions[ɵ$index_3_r2] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(6, "option", 7);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(10, VueSecurityQuestionsComponent_For_3_Conditional_0_For_11_Template, 2, 2, "option", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const questionDropdownInput_r5 = i0.ɵɵreference(5);
    const ctx_r5 = i0.ɵɵnextContext();
    const group_r7 = ctx_r5.$implicit;
    const ɵ$index_3_r2 = ctx_r5.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 14, i0.ɵɵpipeBind3(1, 10, "label.default.question", ctx_r2.i18nBundle, i0.ɵɵpureFunction1(21, _c11, ɵ$index_3_r2 + 1))))("control", questionDropdownInput_r5)("formError", ctx_r2.formError);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("vueAutofocus", ɵ$index_3_r2 === 0 && ctx_r2.isEdit)("name", "questionDropdownInput" + ɵ$index_3_r2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.internalSelectedQuestions[ɵ$index_3_r2]);
    i0.ɵɵproperty("id", "questionDropdownInput" + ɵ$index_3_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngValue", undefined)("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 19, i0.ɵɵpipeBind2(8, 16, "field.common.SelectOne", ctx_r2.i18nBundle)));
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(group_r7);
  }
}
function VueSecurityQuestionsComponent_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10)(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const group_r7 = ctx_r5.$implicit;
    const ɵ$index_3_r2 = ctx_r5.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind3(3, 2, "label.default.question", ctx_r2.i18nBundle, i0.ɵɵpureFunction1(8, _c11, ɵ$index_3_r2 + 1))), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(group_r7[0].text);
  }
}
function VueSecurityQuestionsComponent_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10)(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, i0.ɵɵpipeBind2(3, 2, "label.default.securityQuestionAnswer", ctx_r2.i18nBundle)), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 10, i0.ɵɵpipeBind2(8, 7, "securityQuestionsTab.answerText", ctx_r2.i18nBundle)));
  }
}
function VueSecurityQuestionsComponent_For_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-control-group", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "input", 11, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function VueSecurityQuestionsComponent_For_3_Conditional_3_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ɵ$index_3_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.answers[ɵ$index_3_r2], $event) || (ctx_r2.answers[ɵ$index_3_r2] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const securityQuestionInput_r9 = i0.ɵɵreference(5);
    const ɵ$index_3_r2 = i0.ɵɵnextContext().$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 10, i0.ɵɵpipeBind2(1, 7, "label.default.securityQuestionAnswer", ctx_r2.i18nBundle)))("control", securityQuestionInput_r9)("formError", ctx_r2.formError);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("vueAutofocus", ɵ$index_3_r2 === 0 && ctx_r2.isAnswer)("name", "securityQuestionInput" + ɵ$index_3_r2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.answers[ɵ$index_3_r2]);
    i0.ɵɵproperty("id", "securityQuestionInput" + ɵ$index_3_r2);
  }
}
function VueSecurityQuestionsComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VueSecurityQuestionsComponent_For_3_Conditional_0_Template, 12, 23, "vue-control-group", 4)(1, VueSecurityQuestionsComponent_For_3_Conditional_1_Template, 8, 10, "div", 5)(2, VueSecurityQuestionsComponent_For_3_Conditional_2_Template, 10, 12, "div", 5)(3, VueSecurityQuestionsComponent_For_3_Conditional_3_Template, 6, 12, "vue-control-group", 4);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.isEdit ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isView || ctx_r2.isAnswer ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.isView ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.isView ? 3 : -1);
  }
}
function VueFirstTimeLoginComponent_Conditional_7_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function VueFirstTimeLoginComponent_Conditional_7_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.editQuestions());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind2(2, 1, "button.Edit", ctx_r2.i18nBundle)), " ");
  }
}
function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-form-buttons", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("primaryButtonClicked", function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_0_Template_vue_form_buttons_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.securityQuestionSubmit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind2(1, 1, "label.next", ctx_r2.i18nBundle)));
  }
}
function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-form-buttons", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵlistener("primaryButtonClicked", function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_1_Template_vue_form_buttons_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.securityQuestionSubmit());
    })("defaultButtonClicked", function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_1_Template_vue_form_buttons_defaultButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.cancelQuestionEdit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind2(1, 2, "label.save", ctx_r2.i18nBundle)))("defaultLabel", i0.ɵɵpipeBind1(4, 10, i0.ɵɵpipeBind2(3, 7, "label.cancel", ctx_r2.i18nBundle)));
  }
}
function VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_0_Template, 3, 6, "vue-form-buttons", 17)(1, VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Conditional_1_Template, 5, 12, "vue-form-buttons", 18);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.questionsFirstEdit ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.questionsFirstEdit ? 1 : -1);
  }
}
function VueFirstTimeLoginComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "vue-stepper", 6)(4, "vue-step", 7);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtemplate(8, VueFirstTimeLoginComponent_Conditional_7_Conditional_8_Template, 4, 6, "button", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "vue-security-questions", 10);
    i0.ɵɵlistener("answered", function VueFirstTimeLoginComponent_Conditional_7_Template_vue_security_questions_answered_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.questionsAnswered($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, VueFirstTimeLoginComponent_Conditional_7_Conditional_10_Template, 2, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "vue-step", 7);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementContainerStart(14, 11);
    i0.ɵɵelementStart(15, "p", 12);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵpipe(18, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 13);
    i0.ɵɵelement(20, "vue-password-strength-input", 14, 0);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵpipe(23, "async");
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵpipe(25, "async");
    i0.ɵɵelementStart(26, "vue-form-buttons", 15);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵpipe(28, "async");
    i0.ɵɵlistener("primaryButtonClicked", function VueFirstTimeLoginComponent_Conditional_7_Template_vue_form_buttons_primaryButtonClicked_26_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.savePassword());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("activeStepIndex", ctx_r2.stepIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(6, 21, i0.ɵɵpipeBind2(5, 18, "label.securityQuestions", ctx_r2.i18nBundle)));
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r2.questionEditMode === "view" ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("mode", ctx_r2.questionEditMode)("questionPromptGroups", ctx_r2.questionPromptGroups)("formError", ctx_r2.formError)("selectedQuestions", ctx_r2.selectedQuestions)("i18nBundle", ctx_r2.i18nBundle);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.questionEditMode === "edit" ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(13, 26, i0.ɵɵpipeBind2(12, 23, "firstTimeLogin.group2Heading", ctx_r2.i18nBundle)));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 31, i0.ɵɵpipeBind2(17, 28, "firstTimeLogin.section2.emptyStateMessage", ctx_r2.i18nBundle)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("newPasswordLabel", i0.ɵɵpipeBind1(23, 36, i0.ɵɵpipeBind2(22, 33, "passwordTab.newPassword", ctx_r2.i18nBundle)))("confirmPasswordLabel", i0.ɵɵpipeBind1(25, 41, i0.ɵɵpipeBind2(24, 38, "passwordTab.reEnterNewPassword", ctx_r2.i18nBundle)))("validationRequiredRules", ctx_r2.requiredRules)("hasOldPassword", false)("formError", ctx_r2.formError)("autofocus", true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(28, 46, i0.ɵɵpipeBind2(27, 43, "label.submit", ctx_r2.i18nBundle)));
  }
}
const _c31 = ["verifyUserForm"];
function VueChangePasswordComponent_Conditional_8_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vue-form-buttons", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("primaryButtonClicked", function VueChangePasswordComponent_Conditional_8_Conditional_5_Conditional_2_Template_vue_form_buttons_primaryButtonClicked_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.verifyQuestionAnswers());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind2(1, 1, "button.Verify", ctx_r1.i18nBundle)));
  }
}
function VueChangePasswordComponent_Conditional_8_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "vue-security-questions", 9);
    i0.ɵɵlistener("answered", function VueChangePasswordComponent_Conditional_8_Conditional_5_Template_vue_security_questions_answered_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAnswer($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, VueChangePasswordComponent_Conditional_8_Conditional_5_Conditional_2_Template, 3, 6, "vue-form-buttons", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("mode", ctx_r1.securityQuestionMode)("questionPromptGroups", ctx_r1.questionPromptGroup)("formError", ctx_r1.formError);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.activeStepIndex == 0 ? 2 : -1);
  }
}
function VueChangePasswordComponent_Conditional_8_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind2(2, 1, "changePassword.section2.emptyStateMessage", ctx_r1.i18nBundle)), " ");
  }
}
function VueChangePasswordComponent_Conditional_8_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vue-password-strength-input", 12, 0);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "vue-form-buttons", 11);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵlistener("primaryButtonClicked", function VueChangePasswordComponent_Conditional_8_Conditional_10_Template_vue_form_buttons_primaryButtonClicked_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changePassword());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("newPasswordLabel", i0.ɵɵpipeBind1(4, 10, i0.ɵɵpipeBind2(3, 7, "passwordTab.newPassword", ctx_r1.i18nBundle)))("confirmPasswordLabel", i0.ɵɵpipeBind1(6, 15, i0.ɵɵpipeBind2(5, 12, "passwordTab.reEnterNewPassword", ctx_r1.i18nBundle)))("validationRequiredRules", ctx_r1.requiredRules)("hasOldPassword", false)("formError", ctx_r1.formError)("autofocus", true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(9, 20, i0.ɵɵpipeBind2(8, 17, "label.submit", ctx_r1.i18nBundle)));
  }
}
function VueChangePasswordComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "vue-stepper", 6)(2, "vue-step", 7);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, VueChangePasswordComponent_Conditional_8_Conditional_5_Template, 3, 4, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "vue-step", 7);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, VueChangePasswordComponent_Conditional_8_Conditional_9_Template, 4, 6, "div", 8)(10, VueChangePasswordComponent_Conditional_8_Conditional_10_Template, 10, 22, "div");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("activeStepIndex", ctx_r1.activeStepIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(4, 9, i0.ɵɵpipeBind2(3, 6, "groupHeader.answerSecurityQuestions", ctx_r1.i18nBundle)));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.validLink ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(8, 14, i0.ɵɵpipeBind2(7, 11, "changePassword.group2Heading", ctx_r1.i18nBundle)));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.activeStepIndex != 1 ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.activeStepIndex == 1 ? 10 : -1);
  }
}
function VuePortalLocaleSelectorComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const locale_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", locale_r1);
    i0.ɵɵattribute("lang", locale_r1.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", locale_r1.name, " ");
  }
}
class IDToken {}

/**
 * This class represents the OAuth token obtained from CAS.
 *
 * TODO: rename to `VueOauthToken`
 */
class VueOAuthToken {
  /**
   * Token constructor.
   */
  constructor() {
    this.idToken = new IDToken();
  }
}
class VueApplication {
  constructor(jsonObj) {
    for (const prop of Object.keys(jsonObj)) {
      this[prop] = jsonObj[prop];
    }
    // Remove this later, when Navigator is moved to angular 6 or more.
    this.convertOldFormatToNew();
  }
  // Remove this later, when Navigator is moved to angular 6 or more.
  convertOldFormatToNew() {
    if (this.navigationMenu) {
      this.applicationMenuOptions = this.navigationMenu;
      this.navigationMenu = null;
    }
  }
  // Function used to identify the generic submenu for all the clients.
  getGenericSubMenuList() {
    if (!this.applicationMenuOptions || this.applicationMenuOptions.length < 1) {
      return null;
    }
    for (let j = 0; j < this.applicationMenuOptions[0].clientSubMenuList.length; j++) {
      const clientSubMenu = this.applicationMenuOptions[0].clientSubMenuList[j];
      if (!clientSubMenu.clientId) {
        return clientSubMenu;
      }
    }
    return null;
  }
  // Function used to identify the client specific submenu for a client.
  getClientSpecificSubMenuList(clientId) {
    if (!this.applicationMenuOptions || this.applicationMenuOptions.length < 1) {
      return null;
    }
    for (let j = 0; j < this.applicationMenuOptions[0].clientSubMenuList.length; j++) {
      const clientSubMenu = this.applicationMenuOptions[0].clientSubMenuList[j];
      if (clientSubMenu.clientId && clientSubMenu.clientId === clientId) {
        return clientSubMenu;
      }
    }
    return null;
  }
  isApplicationCurrentlySelected() {
    return this.currentlySelected;
  }
  doesMenuExists() {
    if (this.applicationMenuOptions) {
      if (this.applicationMenuOptions.length > 0) {
        return true;
      }
    }
    return false;
  }
}
class VueClient {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(jsonObj) {
    for (const prop of Object.keys(jsonObj)) {
      this[prop] = jsonObj[prop];
    }
  }
  isClientCurrentlySelected() {
    return this.currentlySelected;
  }
}

/**
 *  Authorization status .
 * <ul>
 *     <li>SUCCESS - user has all authorization to acess.</li>
 *     <li>FAILED_AUTH_APPLICAION - user is not authorized to access the application.</li>
 *     <li>FAILED_AUTH_ROLE - user don't have the required role to peroforme the action.</li>
 *     <li>FAILED_AUTH_ROLE - user is not blongs to the client.</li>
 * </ul>
 */
var VueAuthorizationStatus = /*#__PURE__*/function (VueAuthorizationStatus) {
  VueAuthorizationStatus["SUCCESS"] = "authorization_success";
  VueAuthorizationStatus["FAILED_AUTH_APPLICAION"] = "authorization_failed_application";
  VueAuthorizationStatus["FAILED_AUTH_ROLE"] = "authorization_failed_role";
  VueAuthorizationStatus["FAILED_AUTH_CLIENT"] = "authorization_failed_client";
  return VueAuthorizationStatus;
}(VueAuthorizationStatus || {});
/* eslint-disable @typescript-eslint/no-explicit-any */
/* Create a new injection token for injecting the window into a component. */
const WINDOW = new InjectionToken('WindowToken');
/* Define abstract class for obtaining reference to the global window object. */
class WindowRef {
  get nativeWindow() {
    throw new Error('Not implemented.');
  }
}
/* Define class that implements the abstract class and returns the native window object. */
class BrowserWindowRef extends WindowRef {
  get nativeWindow() {
    return window;
  }
}
/* Create an factory function that returns the native window object. */
function windowFactory(browserWindowRef, platformId) {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return {};
}
/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserWindowProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef
};
/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider = {
  deps: [WindowRef, PLATFORM_ID],
  provide: WINDOW,
  useFactory: windowFactory
};
/* Create an array of providers. */
const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];

/* eslint-disable valid-jsdoc */
/**
 * This class provides a number of defaults that are used by framework services.
 * Methods should be overridden by each app as necessary.
 */
let VueAppDefaultsService = /*#__PURE__*/(() => {
  class VueAppDefaultsService {
    constructor() {
      /**
       * Event emitted when localization status is toggled.
       */
      this.localizationEnabledChanges = new EventEmitter();
      /**
       * Whether localization is enabled. False by default.
       */
      this.localizationEnabled = false;
    }
    /**
     * Some portals have an account maintenance function that sits on the right hand side (above logout).
     * This would be turned on with a parameter to the navigation controller. You would point to your route
     * that defines the starting page to do account maintenance. The reason this configuration value is
     * present is this 'whitelists' this route so that the standard authentication check bypasses it
     * since every user gets this capability if so determined by the portal.
     */
    getAccountMaintenanceRoute() {
      return 'account/maintenance';
    }
    /**
     * Cookie Name to store selected locale. This will be set by the app.
     * Defaults to null for backwards compatibility.
     */
    getLocaleCookieName() {
      return null;
    }
    /**
     * This should be set to the rest root for the application's proxy (such as Azure APIM).  In most cases this defaults
     * to env.js setting that changes per environment.  In development mode, this can be used to point at a local generic
     * proxy.
     */
    getApplicationRESTRoot() {
      return '';
    }
    /**
     * If a portal has endpoints over and above core ones they should be added here.
     * These are strings that will be turned into regex expressions.
     */
    getApplicationsUnAuthenticatedURLList() {
      return [];
    }
    /**
     * Return the app name.
     *
     * @returns the app name.
     */
    getAppName() {
      return '';
    }
    /**
     * Can be used by applications to define a default XLIFF bundle for the app.
     */
    getDefaultAppBundle() {
      return '';
    }
    /**
     * Help can be specified in a variety of places (see Help documentation in Confluence).
     * This value is the fallback when there is no context help for an application.
     * Usually this would give generic portal help.
     */
    getDefaultHelpURL() {
      return 'help/RAHelp.html';
    }
    /**
     * Used to hard-code locale for an application (e.g. locale: 'ja-JP'). If set, then the
     * value of appDefaults.i18n.localizationEnabled is ignored and assumed 'false'.
     */
    getDefaultLocale() {
      return null;
    }
    /**
     * get all the locales supported by a application
     */
    getAppLocales() {
      return null;
    }
    /**
     * If provided then the cas calls made from the JS go through this. The fallback is the portalRestRoot.
     */
    getCASRESTRoot() {
      return '';
    }
    /**
     * Default Timezone for an application (e.g. timeZone: 'America/Chicago').
     */
    getDefaultTimeZone() {
      return null;
    }
    /**
     * The path to the client logos.
     */
    getDefaultLogoImagePath() {
      return 'vendor/vue/assets/images/';
    }
    /**
     * The default page title to use for portal if the translated title is missing from
     * the i18n bundle or if there was a problem accessing retrieving translation from Translation Service.
     */
    getDefaultPageTitle() {
      return 'RA Portal';
    }
    /**
     * If you are using the field validation directive (most are), this is the bundle that contains all the generic
     * field validations. For example if you are no overriding any error messages and want to use the standard messages,
     * you add this: `<vue-validation-message />`. However, the directive still needs to know which bundle to find those
     * default messages. See Connect for example. If you want to override the default message, you must specify the
     * bundle and key like `<vue-validation-message i18n-bundle="portal" required="error.SampleOverride" />`
     */
    getFieldErrorMessageBundle() {
      return 'PortalBase';
    }
    /**
     * The inactivity timeout in minutes used to override the default value in Idle Service. If no user activity
     * is detected for this period (no REST calls are made and no changes to URL occur), then the user will be
     * presented with a popup containing a timeout warning and a button that the user can click to extend their session.
     */
    getInactivityTimeout() {
      return 14;
    }
    /**
     * The default is 60 seconds. Override this if you want to customize the timer counter.
     */
    getExtendSessionTimeout() {
      return 60;
    }
    /**
     * Normally false but used to turn on debugging for inactivity timeout.
     */
    getInactivityTimeoutLogging() {
      return false;
    }
    /**
     * If a portal does not use OAuth, override this to false.
     */
    getIsOAuthEnabled() {
      return true;
    }
    /**
     * Whether or not to use the REST root for XLIFF retrieval. Override to `false` if you want to use a custom
     * URL.
     *
     * Note: you will also need to override `getXliffBaseURL()`
     */
    getIsRestRootUsedForXliff() {
      return true;
    }
    /**
     * If set to `true`, localization will be enabled for the application which would enable features like
     * locale auto-detection, presenting user with a way to change locale, etc.
     */
    getLocalizationEnabled() {
      return this.localizationEnabled;
    }
    /**
     * When true there will be a confirm box on your portal's login page.
     */
    getLoginDisplayResetAccountConfirmation() {
      return false;
    }
    /**
     * When true there will be a "I forgot username/password" link on your portal's login page.
     */
    displayForgotCredentials() {
      return true;
    }
    /**
     * When true there will be a "I forgot password" link on your portal's login page.
     */
    getLoginDisplayResetPasswordLink() {
      return true;
    }
    /**
     * When true there will be a "I forgot user name" link on your portal's login page.
     */
    getLoginDisplayResetUserNameLink() {
      return false;
    }
    /**
     * When true there will be an information panel on the left of the screen,
     * and the login component will be moved to the right.
     */
    getLoginDisplayInformationPanel() {
      return true;
    }
    /**
     * When true there will be an title bar displayed in login, By default the login component
     * will show tile bar but applications can ovrride this behaviour.
     */
    getLoginDisplayTitleBar() {
      return true;
    }
    /**
     * This is the realm the users of the application will need to be assigned to in order to log in.
     * This value will become part of the username value passed to CAS when logging in.
     * Some examples would be: `PATRON`, `TESTCENTER`, `EMPLOYEE`.
     */
    getLoginRealm() {
      return 'PATRON';
    }
    /**
     * When true, the login page will add a Site ID field and this will be used to pass to login REST service.
     */
    getLoginSiteIDRequired() {
      return false;
    }
    /**
     * When true, the entire authentication process will ensure that user is set up with 2 factor authentication.
     */
    getLoginUseTwoFactor() {
      return false;
    }
    /**
     * Get navigation override menu
     */
    getNavigationOverrideMenu() {
      return '';
    }
    /**
     * This is the bundle XLIFF name that should be used to get the menu translations and the additional labels that exist
     * on the menu. It is also used for some common message keys where a portal specific override is needed.
     */
    getPortalMessageBundle() {
      return 'portal';
    }
    /**
     * In most cases this is empty string and the rest root default will be from wherever the JavaScript was served from.
     * However in development mode, this can be used to point at a local generic proxy.
     */
    getPortalRESTRoot() {
      return '';
    }
    /**
     * A list of routes that can be accessed without being authenticated.
     */
    getUnAuthenticatedWhiteList() {
      return ['externalLogout'];
    }
    /**
     * If the XLIFF Hosting Type is 'cloudfront', we need to specify the base URL to the bundle.<br />
     * This will be used to construct the final bundle url, which will look like:
     * `<xliffBaseURL>/<countryCode>/<languageCode>/<bundleName>.json`
     */
    getXliffBaseURL() {
      return '';
    }
    /**
     * The XLIFF hosting type.<br /?
     * Values:
     * <ul>
     *     <li>`default`: the usual way that XLIFF bundles are fetched from services.</li>
     *     <li>`cdn`: stored on a CDN, such as Cloud Front.</li>
     * </ul>
     */
    getXliffHostingType() {
      return 'default';
    }
    /**
     * Toggle localization on/off. This is used to show the locale dropdown on the login page header. Causes
     * `localizationEnabledChange` event to be emitted.
     *
     * @param localizationEnabled whether or not to enable localization.
     */
    setLocalizationEnabled(localizationEnabled) {
      this.localizationEnabled = localizationEnabled;
      this.localizationEnabledChanges.emit(this.localizationEnabled);
    }
    /**
    * This method returns default route for a application
    * the framework will redirect after successful authentication
    * @returns  returns default route for a application if the vlaue
    *           is blank then automatic navigation will be disabled.
    */
    getAuthenticatedDefaultState() {
      return 'pleaseSelect';
    }
    /**
     * This method returns true if application is of type portal
     */
    isPortalApplication() {
      return true;
    }
    /**
     * This method returns true if application wants to display the  PasswordExpired error message in
     * vue-authentication componenet.
     */
    displayPasswordExpiredErrorMessage() {
      return false;
    }
    /**
     * This method returns true if we are excluding application from navigation menu when failure to retrieval
     * submenu occurs. Displaying message will need to be implemented in future.
     */
    enableSubmenuMessage() {
      return false;
    }
    static {
      this.ɵfac = function VueAppDefaultsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAppDefaultsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueAppDefaultsService,
        factory: VueAppDefaultsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueAppDefaultsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any, valid-jsdoc */
/**
 * This class makes is a facade over the session storage and cookie functionality
 * TODO: needs hydrate and cookie methods from sessionCookieService.js
 */
let VueSessionCookieService = /*#__PURE__*/(() => {
  class VueSessionCookieService {
    constructor(vueAppDefaultsService, vueWindow) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueWindow = vueWindow;
      this.defaultPrefix = 'VUE';
      this.cookiePathDomain = 'path=/; domain=pearsonvue.com';
      this.cookiePathDomainLocal = 'path=/; domain=';
      this.changes = new Subject();
    }
    getPrefix(namespace) {
      // TODO: == null is bad practice, fix and evaluate side effects
      /* eslint-disable-next-line no-eq-null */
      if (namespace == null) {
        return `${this.defaultPrefix}-`;
      }
      if (namespace) {
        return `${namespace}-`;
      }
      return '';
    }
    getAttribute(key, namespace) {
      // TODO: == null is bad practice, fix and evaluate side effects
      /* eslint-disable-next-line no-eq-null */
      if (key == null) {
        return null;
      }
      return sessionStorage.getItem(this.getPrefix(namespace) + key);
    }
    setAttribute(key, value, namespace) {
      if (key !== null && value !== null) {
        sessionStorage.setItem(this.getPrefix(namespace) + key, value);
        this.changes.next({
          key: this.getPrefix(namespace) + key,
          value: value
        });
      }
    }
    /**
     * Removes an item from session storage.
     * @param key the name of the session key with out the prefix.
     * @param [namespace=VUE] the namespace part of the session key. example : 'MPV'.
     * The default will be 'VUE' if no value is provided.
     */
    removeAttribute(key, namespace) {
      if (key !== null) {
        sessionStorage.removeItem(this.getPrefix(namespace) + key);
        this.changes.next({
          key: this.getPrefix(namespace) + key,
          value: null
        });
      }
    }
    /**
     * Watches session variables to see when its set, removed.
     * Will not respond to removeAllAttributes
     * @param key the name of the session key with out the prefix.
     * @param [namespace=VUE] the namespace part of the session key. example : 'MPV'.
     * @returns Observable<string>
     */
    watchAttribute(key, namespace) {
      const watchKey = this.getPrefix(namespace) + key;
      return this.changes.pipe(filter(v => v.key === watchKey), pluck('value'), startWith(this.getAttribute(key, namespace)), distinctUntilChanged());
    }
    /**
     * Removes all items from session storage
     */
    removeAllAttributes() {
      Object.keys(sessionStorage).forEach(key => {
        this.changes.next({
          key: key,
          value: null
        });
      });
      sessionStorage.clear();
    }
    removeCookie(name, namespace) {
      const domain = this.getCookiePathDomain();
      const cookieName = `${this.getPrefix(namespace)}${name}`;
      this.vueWindow.document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${domain}`;
    }
    getCookie(cname, namespace) {
      const prefix = this.getPrefix(namespace);
      const name = `${prefix}${cname}=`;
      const ca = this.vueWindow.document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
    getCookiePathDomain() {
      if (this.vueWindow.document.domain === 'localhost') {
        return this.cookiePathDomainLocal;
      }
      return this.cookiePathDomain;
    }
    getDate() {
      const minutes = 2;
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      return date;
    }
    setCookie(key, value, options) {
      let prefix;
      let pathDomain;
      const cookieSettings = {
        domain: 'pearsonvue.com',
        expires: this.getDate(),
        /* eslint-disable-next-line no-undefined */
        namespace: undefined,
        path: '/'
      };
      if (options instanceof Object) {
        if (options.namespace !== null) {
          cookieSettings.namespace = options.namespace;
        }
        if (options.expires !== null) {
          cookieSettings.expires = options.expires;
        }
        if (options.path !== null) {
          cookieSettings.path = options.path;
        }
        if (options.domain !== null) {
          cookieSettings.domain = options.domain;
        }
        prefix = this.getPrefix(cookieSettings.namespace);
        pathDomain = `path=${cookieSettings.path}; domain=${cookieSettings.domain};`;
      } else {
        prefix = this.getPrefix(options);
        pathDomain = this.getCookiePathDomain();
      }
      // TODO: I want to reevaluate this. The incorrect uses of `!=` to compare to null created buggy code here.
      const expires = cookieSettings && cookieSettings.expires ? `expires=${cookieSettings.expires.toUTCString()}` : null;
      this.vueWindow.document.cookie = `${prefix}${key}=${value}; ${expires ? expires + ';' : ''}; ${pathDomain}`;
    }
    /**
     * Copies cookie values to session storage. All cookies prefixed with 'NAV-' will be copied.
     * @param otherNamespaces copy over other cookies prefixed with a different namespace. example ['MPV']
     */
    hydrateSessionFromCookieValues(otherNamespaces) {
      this.hydrateSessionFromExplicitCookies(this.defaultPrefix);
      if (otherNamespaces) {
        otherNamespaces.forEach(namespace => {
          this.hydrateSessionFromExplicitCookies(namespace);
        });
      }
    }
    hydrateSessionFromExplicitCookies(namespace) {
      const prefix = this.getPrefix(namespace);
      const ca = this.vueWindow.document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        const cookieVal = ca[i].trim();
        if (cookieVal.indexOf(prefix) === 0) {
          // only split on the first '=' character
          const splitIndex = cookieVal.indexOf('=');
          const name = cookieVal.slice(0, splitIndex);
          const value = cookieVal.slice(splitIndex + 1);
          this.setAttribute(name, value, '');
          if (this.getAttribute(name, '') === value) {
            // clear the cookie
            this.removeCookie(name, '');
          }
        }
      }
    }
    /**
     * Copies session storage values to cookies. All session storage keys prefixed with 'NAV-' will be copied.
     * @param otherNamespaces copy over other session storage values prefixed with a different namespace. example ['MPV']
     */
    hydrateCookiesFromSession(otherNamespaces, omittedValues) {
      this.hydrateCookiesFromExplicitSession(this.defaultPrefix, omittedValues);
      if (otherNamespaces) {
        otherNamespaces.forEach(namespace => {
          this.hydrateCookiesFromExplicitSession(namespace, null);
        });
      }
      // add origin for giri:
      if (!this.getAttribute('restBaseURL')) {
        let origin = this.vueWindow.location.origin;
        if (!origin) {
          origin = `${this.vueWindow.location.protocol}//${this.vueWindow.location.hostname}`;
          if (this.vueWindow.location.port) {
            origin = `${origin}:${this.vueWindow.location.port}`;
          }
        }
        this.setCookie('restBaseURL', `${origin}/${this.vueAppDefaultsService.getPortalRESTRoot()}`, null);
      }
    }
    hydrateCookiesFromExplicitSession(namespace, omittedValues) {
      const prefix = `${namespace}-`;
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        let ignore = false;
        if (omittedValues) {
          for (let j = 0; j < omittedValues.length; j++) {
            const currentValue = prefix + omittedValues[j];
            if (key === currentValue) {
              ignore = true;
              break;
            }
          }
        }
        if (key.indexOf(prefix) === 0 && !ignore) {
          this.setCookie(key, sessionStorage.getItem(key), '');
        }
      }
    }
    isHydrateSessionFromCookiesNeeded() {
      const ssRefreshExp = this.getAttribute('refreshExp', 'VUE');
      const cookieRefreshExp = this.getCookie('refreshExp', null);
      if (cookieRefreshExp) {
        return !ssRefreshExp || ssRefreshExp <= cookieRefreshExp;
      }
      return false;
    }
    static {
      this.ɵfac = function VueSessionCookieService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueSessionCookieService)(i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(WINDOW));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueSessionCookieService,
        factory: VueSessionCookieService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueSessionCookieService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
let VueNavigationService = /*#__PURE__*/(() => {
  class VueNavigationService {
    constructor() {
      this.accountMaintSelected = new Subject();
      this.authenticationChange = new Subject();
      this.clientCode = new Subject();
      this.customMenuSelected = new Subject();
      this.externalNavigationContextChange = new Subject();
      this.logoff = new Subject();
      this.menuState = new Subject();
      this.menuSelected = new Subject();
      this.unauthenticatedAccess = new Subject();
      this.applicationId = new Subject();
    }
    /**
     * Used to select an application outside
     * of nav component.
     * @param id number
     */
    selectApplication(id) {
      this.applicationId.next(id);
    }
    /**
     * Used to listen to application changes outside
     * nav component so that nav component can react to
     * them
     * @returns observable<string>
     */
    getSelectedApplication() {
      return this.applicationId.asObservable();
    }
    getMenuState() {
      return this.menuState;
    }
    changeCurrentMenuStateOpen() {
      this.menuState.next('menu-open');
    }
    changeCurrentMenuStateClosed() {
      this.menuState.next('menu-closed');
    }
    getMenuSelected() {
      return this.menuSelected;
    }
    changeCurrentMenuSelectedState(state) {
      this.menuSelected.next(state);
    }
    getLogoffState() {
      return this.logoff;
    }
    changeLogoffState(state) {
      this.logoff.next(state);
    }
    getAccountMaintSelected() {
      return this.accountMaintSelected;
    }
    getCustomMenuSelected() {
      return this.customMenuSelected;
    }
    changeAccountMaintSelected(state) {
      this.accountMaintSelected.next(state);
    }
    changeCustomMenuSelected(state) {
      this.customMenuSelected.next(state);
    }
    isAuthenticationChanged() {
      return this.authenticationChange;
    }
    authenticationChanged(authChange) {
      this.authenticationChange.next(authChange);
    }
    getClientCode() {
      return this.clientCode;
    }
    changeClientCode(clientCode) {
      this.clientCode.next(clientCode);
    }
    getExternalNavigationContextChanged() {
      return this.externalNavigationContextChange;
    }
    externalNavigationContextChanged(application, client) {
      const context = {};
      context.application = application;
      context.client = client;
      this.externalNavigationContextChange.next(context);
    }
    getUnauthenticatedAccess() {
      return this.unauthenticatedAccess;
    }
    unAuthenticatedAccessChanged(authChange) {
      this.unauthenticatedAccess.next(authChange);
    }
    static {
      this.ɵfac = function VueNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueNavigationService,
        factory: VueNavigationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any */
/**
 This class makes is all about a user's session and study of the OAuth token.

 TODO: checkAuthorizationAndSetContext, validateOAuthToken
 */
let VueUserSessionService = /*#__PURE__*/(() => {
  class VueUserSessionService {
    constructor(sessionCookieService, vueAppDefaultsService, vueNavigationService, http) {
      this.sessionCookieService = sessionCookieService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueNavigationService = vueNavigationService;
      this.http = http;
      this.clientsAndApplications = [];
      this.menuTranslations = {};
      this.clientsAndApplicationsChange = new Subject();
      // var pendingTokenRefresh;
      this.sessionAuthenticationChange = new Subject();
      this.transientRouteAndStateInfo = {};
    }
    create(newOAuthToken) {
      this.oAuthToken = new VueOAuthToken();
      this.oAuthToken.encodedToken = newOAuthToken.encodedToken;
      this.oAuthToken.refreshToken = newOAuthToken.refreshToken;
      this.oAuthToken.idToken.exp = newOAuthToken.idToken.exp;
      this.oAuthToken.idToken.refreshExp = newOAuthToken.idToken.refreshExp;
      this.oAuthToken.idToken.sub = newOAuthToken.idToken.sub;
      this.oAuthToken.idToken.username = newOAuthToken.idToken.username;
      this.oAuthToken.idToken.name = newOAuthToken.idToken.name;
      this.oAuthToken.idToken.realmDetail = newOAuthToken.idToken.realmDetail;
      this.oAuthToken.idToken.realm = newOAuthToken.idToken.realm;
      this.sessionCookieService.setAttribute('encodedToken', this.oAuthToken.encodedToken);
      this.sessionCookieService.setAttribute('refreshToken', this.oAuthToken.refreshToken);
      this.sessionCookieService.setAttribute('exp', this.oAuthToken.idToken.exp);
      this.sessionCookieService.setAttribute('refreshExp', this.oAuthToken.idToken.refreshExp);
      this.sessionCookieService.setAttribute('appUserId', this.oAuthToken.idToken.sub);
      this.sessionCookieService.setAttribute('username', this.oAuthToken.idToken.username);
      this.sessionCookieService.setAttribute('name', this.oAuthToken.idToken.name);
      this.sessionCookieService.setAttribute('realmDetail', JSON.stringify(this.oAuthToken.idToken.realmDetail));
      this.sessionCookieService.setAttribute('realm', this.oAuthToken.idToken.realm);
      this.changeSessionAuthenticationChangeState(true);
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    preCheckAuthorizationAndSetContext(route, state) {
      // some preconditions to force programmers to do the right thing!
      const authData = route.data.authData;
      if (!authData) {
        // this forces authorizations to be defined on each route by programmer
        /* eslint-disable-next-line no-console */
        console.error('You have not defined authData on your route!');
        this.setHelpContext('');
        return false;
      }
      if (!authData.authorizedRoles) {
        // this forces authorizations to be defined correctly on each route by programmer :-)
        /* eslint-disable-next-line no-console */
        console.error('You have not defined authData.authorizedRoles on your route.');
        this.setHelpContext('');
        return false;
      }
      if (this.vueAppDefaultsService.isPortalApplication() && !authData.menuEntryURI && authData.authorizedRoles[0] !== '*all') {
        // if the programmer did not say *all, menuEntryURI needs to be defined.
        /* eslint-disable-next-line no-console */
        console.error('You have not defined authData.menuEntryURI on your route.');
        this.setHelpContext('');
        return false;
      }
      return true;
    }
    /* eslint-disable-next-line complexity, @typescript-eslint/no-unused-vars */
    checkAuthorizationAndSetContext(route, state) {
      let authorized = false;
      const appList = this.getClientsAndApplications();
      // one last piece of prep
      if (!this.clientsAndApplications || this.clientsAndApplications.length === 0) {
        this.clientsAndApplications = appList;
      }
      if (!this.menuTranslations || Object.keys(this.menuTranslations).length === 0) {
        this.menuTranslations = this.getMenuTranslations();
      }
      const isAPortalApplication = this.vueAppDefaultsService.isPortalApplication();
      // get the menu from the menu definition (might be null if going to account maintenance, for example)
      let vueApplication = null;
      let client = null;
      let authorizationAppID;
      if (isAPortalApplication) {
        if (route.queryParams) {
          authorizationAppID = route.queryParams.appId;
        }
      } else {
        authorizationAppID = route.data.authData.appId;
      }
      // check for single app
      for (let i = 0; i < this.clientsAndApplications.length; i++) {
        const clientsAndApplication = this.clientsAndApplications[i];
        if (isAPortalApplication) {
          if (clientsAndApplication.defaultURI.split('?')[0].indexOf(route.data.authData.menuEntryURI) !== -1) {
            if (clientsAndApplication.externalAppLauncher && clientsAndApplication.id.toString() !== authorizationAppID.toString()) {
              /* eslint-disable-next-line no-continue */
              continue;
            }
            vueApplication = new VueApplication(clientsAndApplication);
            break;
          }
        } else if (authorizationAppID && clientsAndApplication.id === authorizationAppID) {
          vueApplication = new VueApplication(clientsAndApplication);
          break;
        }
      }
      if (!vueApplication) {
        /* eslint-disable-next-line no-console */
        console.error('You have not chosen a valid application/menu.');
        this.setHelpContext('');
        this.authorizationStatusChanged(VueAuthorizationStatus.FAILED_AUTH_APPLICAION, route, state);
        return false;
      }
      // get the client ID from the URL (could be null for apps that have no client)
      const authClientID = route.params.clientID;
      const authClientCode = route.params.clientCode;
      // Step 1: check client if necessary
      if (vueApplication && (authClientID || authClientCode)) {
        // if this is a known menu item and the client is filled, make sure user has that client!
        const clientsUserAuthorizedFor = vueApplication.clients;
        for (let y = 0; y < clientsUserAuthorizedFor.length; y++) {
          const authClient = clientsUserAuthorizedFor[y];
          if (authClientID) {
            if (authClient.clientId.toString() === authClientID) {
              // cool, in list
              client = new VueClient(authClient);
              break;
            }
            /* eslint-disable-next-line max-len */
          } else if (authClientCode && authClient.code.toString().toLowerCase() === authClientCode.toLowerCase()) {
            // cool, in list
            client = new VueClient(authClient);
            break;
          }
        }
        if (!client) {
          // user trying to get access to a client not on their list, disallow always
          this.setHelpContext('');
          this.authorizationStatusChanged(VueAuthorizationStatus.FAILED_AUTH_CLIENT, route, state);
          return false;
        }
      } else if (authClientID) {
        // this would be really weird.  There is a client on the route but where
        // they are going is not in their menu, disallow for now until we get a valid
        // use case.
        this.setHelpContext('');
        this.authorizationStatusChanged(VueAuthorizationStatus.FAILED_AUTH_CLIENT, route, state);
        return false;
      }
      // Step 2: check role
      if (route.data.authData.authorizedRoles[0] !== '*all') {
        let routeAuthorizedRoles = null;
        if (!Array.isArray(route.data.authData.authorizedRoles)) {
          routeAuthorizedRoles = [route.data.authData.authorizedRoles];
        } else {
          routeAuthorizedRoles = route.data.authData.authorizedRoles;
        }
        // Now see if at least one of the menuEntry roles matches the route roles.
        const menuEntryRoles = vueApplication.applicationRoles;
        for (let j = 0; j < menuEntryRoles.length; j++) {
          if (routeAuthorizedRoles.indexOf(menuEntryRoles[j].name) !== -1) {
            authorized = true;
            break;
          }
        }
      } else {
        authorized = true;
      }
      if (authorized) {
        // Whew, user is authorized.  set the help context and, if necessary, signal
        // to the navigation directive to update its context and branding
        // if the toState has no specific role requirement and has no associated menuEntry, no need to set context
        if (route.data.authData.authorizedRoles[0] === '*all' && !vueApplication) {
          return true;
        }
        this.setHelpContext(route.data.helpURL);
        if (this.getSelectedApplication()) {
          const previousMenuEntry = this.getSelectedApplication();
          if (previousMenuEntry.name !== vueApplication.name) {
            // new menu item, signal
            this.vueNavigationService.externalNavigationContextChanged(vueApplication, client);
          }
        } else if (vueApplication) {
          // no previous selected item, signal
          this.vueNavigationService.externalNavigationContextChanged(vueApplication, client);
        }
        if (this.getSelectedClient()) {
          const previousClient = this.getSelectedClient();
          if (!client || previousClient.clientId !== client.clientId) {
            // new client, signal
            this.vueNavigationService.externalNavigationContextChanged(vueApplication, client);
          }
        } else if (client) {
          // no previous selected client, signal
          this.vueNavigationService.externalNavigationContextChanged(vueApplication, client);
        }
        this.authorizationStatusChanged(VueAuthorizationStatus.SUCCESS, route, state);
        return true;
      }
      this.setHelpContext('');
      this.authorizationStatusChanged(VueAuthorizationStatus.FAILED_AUTH_ROLE, route, state);
      return false;
    }
    /**
     * This method can be overridden by child class
     * to do some processing depending upon the authorization status
     *
     * @param authorizationStatus  Authorization Status enum
     * @param route                Router instace
     * @param state                Router state
     */
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars, max-len , @typescript-eslint/no-empty-function */
    authorizationStatusChanged(authStatus, route, state) {}
    destroy() {
      // Call the logout endpoint of restServiceURL to remove authToken in Cookies.
      this.http.post(this.getRestServiceURL('/rest/portal/logout', ''), {}).subscribe();
      this.oAuthToken = null;
      this.clientsAndApplications = [];
      // menuTranslations = {};
      // we want to keep the portal logout URL (in case user hits back button)
      const portalLogoutURL = this.getPortalLogoutURL();
      this.sessionCookieService.removeAllAttributes();
      this.sessionCookieService.removeCookie('idToken', '');
      this.clearTransientRouteAndStateInfo();
      // now reset it if it was there before.
      if (portalLogoutURL) {
        this.setPortalLogoutURL(portalLogoutURL);
      }
      this.changeSessionAuthenticationChangeState(false);
    }
    reestablishFromSessionStorage() {
      this.oAuthToken = new VueOAuthToken();
      if (this.sessionCookieService.getAttribute('encodedToken') !== null) {
        this.oAuthToken.encodedToken = this.sessionCookieService.getAttribute('encodedToken');
      }
      if (this.sessionCookieService.getAttribute('refreshToken') !== null) {
        this.oAuthToken.refreshToken = this.sessionCookieService.getAttribute('refreshToken');
      }
      if (this.sessionCookieService.getAttribute('exp') !== null) {
        this.oAuthToken.idToken.exp = this.sessionCookieService.getAttribute('exp');
      }
      if (this.sessionCookieService.getAttribute('refreshExp') !== null) {
        this.oAuthToken.idToken.refreshExp = this.sessionCookieService.getAttribute('refreshExp');
      }
      if (this.sessionCookieService.getAttribute('appUserId') !== null) {
        this.oAuthToken.idToken.sub = this.sessionCookieService.getAttribute('appUserId');
      }
      if (this.sessionCookieService.getAttribute('username') !== null) {
        this.oAuthToken.idToken.username = this.sessionCookieService.getAttribute('username');
      }
      if (this.sessionCookieService.getAttribute('name') !== null) {
        this.oAuthToken.idToken.name = this.sessionCookieService.getAttribute('name');
      }
      if (this.sessionCookieService.getAttribute('realmDetail') !== null) {
        this.oAuthToken.idToken.realmDetail = JSON.parse(this.sessionCookieService.getAttribute('realmDetail'));
      }
      if (this.isUserAuthenticated()) {
        this.changeSessionAuthenticationChangeState(true);
      }
    }
    // TODO: == null is bad practice, fix and evaluate side effects
    isUserAuthenticated() {
      /* eslint-disable-next-line no-eq-null */
      if (this.oAuthToken == null || this.oAuthToken.encodedToken === null) {
        this.reestablishFromSessionStorage();
      }
      /* eslint-disable-next-line no-eq-null */
      if (this.oAuthToken == null) {
        return false;
      }
      /* eslint-disable-next-line no-eq-null */
      if (this.oAuthToken.encodedToken == null) {
        return false;
      }
      return true;
    }
    isOAuthTokenDefined() {
      return this.oAuthToken !== null && Boolean(this.oAuthToken.encodedToken);
    }
    isOAuthTokenCurrent() {
      /* eslint-disable-next-line no-undefined */
      if (this.oAuthToken.encodedToken === undefined) {
        this.reestablishFromSessionStorage();
      }
      /* eslint-disable-next-line no-undefined */
      if (this.oAuthToken.encodedToken !== undefined) {
        const currentDate = new Date();
        const tokenExpireTimeStamp = parseInt(this.oAuthToken.idToken.exp, 10);
        if (!this.oAuthToken.idToken.exp || isNaN(tokenExpireTimeStamp)) {
          return false;
        }
        // We subtract 10 seconds from tokenExpireTimeStamp to prevent a scenario where the token is so
        // close to expiring that a subsequent REST call (either from our portal or an external application)
        // will find it already expired and will fail.
        const tokenExpireDate = new Date(tokenExpireTimeStamp - 10000);
        if (tokenExpireDate < currentDate) {
          return false;
        }
        return true;
      }
      return false;
    }
    refreshAuthToken() {
      const url = this.getRestServiceURL('/rest/login/refreshToken', '');
      return this.http.post(
      // 'http://localhost:8090/RAFrontEnd/rest/login/refreshToken',
      url, {
        refreshToken: this.getRefreshToken()
      }, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.getEncodedToken()}`,
          'Content-Type': 'application/json'
        })
      }).pipe(/* eslint-disable-next-line consistent-return */
      tap(data => {
        if (Array.isArray(data.body)) {
          this.create(data.body[0]);
          return data.body[0];
        }
      }), catchError(ignored => {
        return throwError('error in refresh token');
      }));
    }
    /**
     * Get full rest service path.  This is duplicated from javascript utility service to avoid circular dependency
     * @param relativePath - portion of the path following the rest root
     * @param restRootOverride - rest root to override the rest root defined in Session Storage or appDefaults
     * @returns endpoint path
     */
    getRestServiceURL(relativePath, restRootOverride) {
      // Use the restRootOverride if it's set, otherwise try to get the portal rest url from session, finally use
      // the constant value.
      let portalRestUrl = restRootOverride || this.getPortalBaseRESTURL() || this.vueAppDefaultsService.getPortalRESTRoot();
      const startsWithSlash = portalRestUrl.indexOf('/') === 0;
      portalRestUrl = portalRestUrl.slice(-1) === '/' ? portalRestUrl.slice(0, -1) : portalRestUrl;
      const startsWithProtocol = new RegExp('^https?://').test(portalRestUrl);
      let url = !startsWithProtocol && !startsWithSlash ? '/' : '';
      url += portalRestUrl + relativePath;
      return url;
    }
    getEncodedToken() {
      return this.oAuthToken.encodedToken;
    }
    getOAuthToken() {
      return this.oAuthToken;
    }
    getRefreshToken() {
      return this.oAuthToken.refreshToken;
    }
    getRealmDetail() {
      return this.oAuthToken.idToken.realmDetail;
    }
    getUserFullName() {
      const name = this.sessionCookieService.getAttribute('name');
      if (!name) {
        return 'Undefined!';
      }
      return name;
    }
    getUserLanguage() {
      // no ability to switch language yet
      return 'en';
    }
    getPortalBaseRESTURL() {
      return this.sessionCookieService.getAttribute('restBaseURL');
    }
    setPortalBaseRESTURL(URL) {
      this.sessionCookieService.setAttribute('restBaseURL', URL);
    }
    getPortalLogoutURL() {
      return this.sessionCookieService.getAttribute('logoutURL');
    }
    setPortalLogoutURL(URL) {
      this.sessionCookieService.setAttribute('logoutURL', URL);
    }
    /**
     * Returns true if user has at least one of the roles passed in as param
     * @param requiredRoles: comma-delimited list of roles
     * @returns true or false
     */
    userHasOneRole(requiredRoles) {
      let userAuthorized = false;
      if (!this.getSelectedApplication() && requiredRoles.length > 0) {
        return false;
      }
      // loop through the roles which this user has
      const requiredRoleListLength = requiredRoles.length;
      const userAssignedRolesLength = this.getSelectedApplication().applicationRoles.length;
      for (let i = 0; i < userAssignedRolesLength; i++) {
        // for each role the user has, compare to the list of roles which should be authorized for this item
        const userAssignedRole = this.getSelectedApplication().applicationRoles[i].name.trim();
        for (let j = 0; j < requiredRoleListLength; j++) {
          if (requiredRoles[j].trim() === userAssignedRole) {
            userAuthorized = true;
            break;
          }
        }
        // we have already found a match, no need to keep looking...
        if (userAuthorized) {
          break;
        }
      }
      return userAuthorized;
    }
    // These methods are mandatory to work with menuing directive.
    getClientsAndApplications() {
      const temp = this.sessionCookieService.getAttribute('clientsAndApplications');
      this.clientsAndApplications = JSON.parse(temp);
      return this.clientsAndApplications;
    }
    /**
     * Applications are excluded when:
     * - SubmenuRetrievalSuccess is false
     *
     * @returns Applications that are excluded from the clientsAndApplications array
     */
    getExcludedApplications() {
      const temp = this.sessionCookieService.getAttribute('excludedApplications');
      return JSON.parse(temp);
    }
    setMenuTranslations(translationJSON) {
      this.sessionCookieService.setAttribute('menuTranslations', JSON.stringify(translationJSON));
    }
    getMenuTranslations() {
      const temp = this.sessionCookieService.getAttribute('menuTranslations');
      this.menuTranslations = JSON.parse(temp);
      return this.menuTranslations;
    }
    setClientsAndApplications(clientsAndApplicationJSON) {
      this.clientsAndApplications = clientsAndApplicationJSON;
      this.sessionCookieService.setAttribute('clientsAndApplications', JSON.stringify(clientsAndApplicationJSON));
      this.changeClientsAndApplicationsChangeState(true);
    }
    removeClientsAndApplications() {
      this.sessionCookieService.removeAttribute('clientsAndApplications');
      this.clientsAndApplications = [];
      this.changeClientsAndApplicationsChangeState(true);
    }
    setExcludedApplications(excludedApplicationsJSON) {
      this.clientsAndApplications = excludedApplicationsJSON;
      this.sessionCookieService.setAttribute('excludedApplications', JSON.stringify(excludedApplicationsJSON));
    }
    removeExcludedApplications() {
      this.sessionCookieService.removeAttribute('excludedApplications');
    }
    getNavigationHistory() {
      const navigationHistory = this.sessionCookieService.getAttribute('navigationHistory');
      if (!navigationHistory) {
        return null;
      }
      return JSON.parse(navigationHistory);
    }
    setNavigationHistory(navigationJSON) {
      this.sessionCookieService.setAttribute('navigationHistory', JSON.stringify(navigationJSON));
    }
    getSelectedApplication() {
      const selectedApplication = this.sessionCookieService.getAttribute('selectedApplication');
      let app = JSON.parse(selectedApplication);
      /**
       * We check to see that the selected application
       * matches the selected application id (this can occur
       * between apps) and will attempt to correct.
       *
       * (this is matched parity with angular-js-commons)
       */
      const selectedAppId = this.getSelectedApplicationId();
      if (!app || app.id !== selectedAppId) {
        const apps = this.getClientsAndApplications();
        const _app = apps ? apps.find(app => app.id === selectedAppId) : null;
        if (_app) {
          app = _app;
          this.setSelectedApplication(app);
        }
      }
      return app;
    }
    setSelectedApplication(applicationJSON) {
      this.sessionCookieService.setAttribute('selectedApplication', JSON.stringify(applicationJSON));
    }
    removeSelectedApplication() {
      this.sessionCookieService.removeAttribute('selectedApplication');
    }
    getSelectedApplicationId() {
      const selectedApplicationId = this.sessionCookieService.getAttribute('selectedApplicationId');
      if (selectedApplicationId !== null) {
        // && !isNaN(selectedApplicationId)
        return parseInt(selectedApplicationId, 10);
      }
      return null;
    }
    setSelectedApplicationId(selectedApplicationId) {
      this.sessionCookieService.setAttribute('selectedApplicationId', selectedApplicationId);
    }
    removeSelectedApplicationId() {
      this.sessionCookieService.removeAttribute('selectedApplicationId');
    }
    getSelectedUserApplication() {
      const selectedUserApplication = this.sessionCookieService.getAttribute('selectedUserApplication');
      return JSON.parse(selectedUserApplication);
    }
    setSelectedUserApplication(applicationJSON) {
      this.sessionCookieService.setAttribute('selectedUserApplication', JSON.stringify(applicationJSON));
    }
    removeSelectedUserApplication() {
      this.sessionCookieService.removeAttribute('selectedUserApplication');
    }
    setClientId(clientId) {
      this.sessionCookieService.setAttribute('clientId', clientId);
    }
    getClientId() {
      return this.sessionCookieService.getAttribute('clientId');
    }
    removeClientId() {
      this.sessionCookieService.removeAttribute('clientId');
    }
    getSelectedClient() {
      const client = this.sessionCookieService.getAttribute('client');
      return JSON.parse(client);
    }
    setSelectedClient(clientJSON) {
      this.sessionCookieService.setAttribute('client', JSON.stringify(clientJSON));
    }
    removeSelectedClient() {
      this.sessionCookieService.removeAttribute('client');
    }
    getSelectedSubmenu() {
      const subMenu = this.sessionCookieService.getAttribute('subMenu');
      return JSON.parse(subMenu);
    }
    setSelectedSubmenu(subMenuJSON) {
      this.sessionCookieService.setAttribute('subMenu', JSON.stringify(subMenuJSON));
    }
    setDisplaySubmenu(subMenuJSON) {
      this.sessionCookieService.setAttribute('displaySubMenu', JSON.stringify(subMenuJSON));
    }
    getDisplaySubmenu() {
      const menu = this.sessionCookieService.getAttribute('displaySubMenu');
      return JSON.parse(menu);
    }
    removeSelectedSubmenu() {
      this.sessionCookieService.removeAttribute('subMenu');
    }
    setHelpContext(helpURL) {
      /* eslint-disable-next-line no-undefined */
      if (helpURL === undefined) {
        this.sessionCookieService.removeAttribute('helpContext');
      } else {
        this.sessionCookieService.setAttribute('helpContext', helpURL);
      }
    }
    getHelpContext() {
      const url = this.sessionCookieService.getAttribute('helpContext');
      return url;
    }
    getLogoutURL() {
      return this.sessionCookieService.getAttribute('logoutURL');
    }
    getTimeoutURL() {
      return this.sessionCookieService.getAttribute('timeoutURL');
    }
    getAccountMaintenanceURL() {
      return this.sessionCookieService.getAttribute('accountMaintLink');
    }
    setAccountMaintenanceURL(URL) {
      this.sessionCookieService.setAttribute('accountMaintLink', URL);
    }
    getBrandingClientCode() {
      return this.sessionCookieService.getAttribute('brandingClientCode');
    }
    setBrandingClientCode(brandingClientCode) {
      this.sessionCookieService.setAttribute('brandingClientCode', brandingClientCode);
    }
    removeBrandingClientCode() {
      this.sessionCookieService.removeAttribute('brandingClientCode');
    }
    getSessionAuthenticationChange() {
      return this.sessionAuthenticationChange;
    }
    changeSessionAuthenticationChangeState(state) {
      this.sessionAuthenticationChange.next(state);
    }
    getClientsAndApplicationsChange() {
      return this.clientsAndApplicationsChange;
    }
    changeClientsAndApplicationsChangeState(state) {
      this.clientsAndApplicationsChange.next(state);
    }
    setTransientRouteAndStateInfo(route, state) {
      this.transientRouteAndStateInfo.route = route;
      this.transientRouteAndStateInfo.state = state;
    }
    getTransientRouteAndStateInfo() {
      return this.transientRouteAndStateInfo;
    }
    clearTransientRouteAndStateInfo() {
      this.transientRouteAndStateInfo = {};
    }
    static {
      this.ɵfac = function VueUserSessionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueUserSessionService)(i0.ɵɵinject(VueSessionCookieService), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueNavigationService), i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueUserSessionService,
        factory: VueUserSessionService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueUserSessionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This class is the implementation of timing out / logging off the user if there is no activity
for a period of time.  There is a thirty second timer that is subscribed to such that it
compares the current time against the last activity + configurable timeout period.  If that is
greater, it turns off the 30 second timer and starts a 1 minute timer as well as shows a time out
dialog.  If the user does not extend session during that 1 minute, the timer is stopped and user
is logged off.

What updates the activity?  Effectively any time the route changes (captured in VueAuthorityChecker) or
a rest calls is made (captured in VueOAuthInterceptor)
*/
let VueTimeoutService = /*#__PURE__*/(() => {
  class VueTimeoutService {
    constructor(vueAppDefaultsService, vueUserSessionService) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueUserSessionService = vueUserSessionService;
      this.showTimeoutDialog = new Subject();
      this.extendTimerSubject = new Subject();
      this.timedOutSubject = new Subject();
      // Create an Observable that runs every thirty seconds
      this.thirtySecondCounter = interval(30000);
      this.oneSecondCounter = interval(1000);
      this.defaultTimer = this.vueAppDefaultsService.getExtendSessionTimeout();
      this.extendSessionTimer = this.defaultTimer;
    }
    startIdleTimer() {
      if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
        /* eslint-disable-next-line no-console */
        console.log(`started timer for ${this.vueAppDefaultsService.getInactivityTimeout()} minute timeout`);
      }
      this.changeShowTimeoutDialog(false);
      this.changeTimedOutState(false);
      if (this.thirtySecondListener) {
        this.thirtySecondListener.unsubscribe();
      }
      // Subscribe to begin publishing values
      this.lastActivity = Date.now();
      this.thirtySecondListener = this.thirtySecondCounter.subscribe(ignored => this.checkActivityTime());
    }
    stopIdleTimer() {
      // unsubscribe
      if (this.thirtySecondListener) {
        this.thirtySecondListener.unsubscribe();
      }
      if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
        /* eslint-disable-next-line no-console */
        console.log('Stopped timer');
      }
    }
    updateActivityTime() {
      this.lastActivity = Date.now();
      if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
        /* eslint-disable-next-line no-console */
        console.log('Just updated activity time');
      }
      // Check if an action was taken within 5 minutes of token expiry, if so, attempt to refresh the token
      // so that users don't get bombarded by extend timers when they are actually active
      if (this.vueAppDefaultsService.getIsOAuthEnabled()) {
        const currentDate = new Date();
        const oAuthToken = this.vueUserSessionService.getOAuthToken();
        if (oAuthToken) {
          const tokenExpireTimeStamp = parseInt(oAuthToken.idToken.exp, 10);
          const tokenExpireDate = new Date(tokenExpireTimeStamp - 10000);
          const timeDiff = Math.abs(tokenExpireDate.getTime() - currentDate.getTime());
          if (tokenExpireDate >= currentDate && timeDiff < 300000) {
            this.extendSession();
          }
        }
      }
    }
    checkActivityTime() {
      if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
        /* eslint-disable-next-line no-console */
        console.log('checking activity time');
      }
      const lastActivityPlusTimeout = this.lastActivity + this.vueAppDefaultsService.getInactivityTimeout() * 60 * 1000;
      const currentTime = Date.now();
      if (lastActivityPlusTimeout > currentTime) {
        // validateOAuthToken();  // TODO why was this here?
      } else {
        if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
          /* eslint-disable-next-line no-console */
          console.log('Timing out. Showing dialog');
        }
        this.thirtySecondListener.unsubscribe();
        this.changeShowTimeoutDialog(true);
        this.oneSecondListener = this.oneSecondCounter.subscribe(ignored => this.checkExtendTime());
      }
    }
    checkExtendTime() {
      this.extendSessionTimer--;
      this.extendTimerSubject.next(this.extendSessionTimer);
      if (this.extendSessionTimer <= 0) {
        this.performSessionTimeout();
      }
    }
    performSessionTimeout() {
      if (this.vueAppDefaultsService.getInactivityTimeoutLogging()) {
        /* eslint-disable-next-line no-console */
        console.log('times up!');
      }
      if (this.oneSecondListener) {
        this.oneSecondListener.unsubscribe();
      }
      this.showTimeoutDialog.next(false);
      this.extendSessionTimer = this.defaultTimer;
      this.changeTimedOutState(true);
    }
    extendSession() {
      // unsubscribe
      this.vueUserSessionService.refreshAuthToken().subscribe(ignored => {
        if (this.oneSecondListener) {
          this.oneSecondListener.unsubscribe();
        }
        this.extendSessionTimer = this.defaultTimer;
        this.extendTimerSubject.next(this.extendSessionTimer);
        this.startIdleTimer();
      }, ignored => {
        this.performSessionTimeout();
      });
    }
    getShowTimeoutDialog() {
      return this.showTimeoutDialog;
    }
    changeShowTimeoutDialog(state) {
      this.showTimeoutDialog.next(state);
    }
    getTimedOutState() {
      return this.timedOutSubject;
    }
    getExtendTimer() {
      return this.extendTimerSubject;
    }
    changeTimedOutState(state) {
      this.timedOutSubject.next(state);
    }
    static {
      this.ɵfac = function VueTimeoutService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTimeoutService)(i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueUserSessionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueTimeoutService,
        factory: VueTimeoutService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueTimeoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any, max-len */
/* eslint-enable max-len */
let VueOauthInterceptor = /*#__PURE__*/(() => {
  class VueOauthInterceptor {
    constructor(vueUserSessionService, vueAppDefaultsService, vueTimeoutService) {
      this.vueUserSessionService = vueUserSessionService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueTimeoutService = vueTimeoutService;
      this.isRefreshingToken = false;
      this.tokenSubject = new BehaviorSubject(null);
    }
    intercept(request, next) {
      // If it's a refresh token call, we go ahead and call handleRefreshToken. It should be called
      // before updateActivityTime. if not, would cause an infinite loop.
      if (request.url.indexOf('refreshToken') > -1) {
        return this.handleRefreshToken(request, next);
      }
      // Some endpoints are unauthenticated and don't need token added or current
      if (this.isRequestToUnauthenticatedEndpoint(request)) {
        return next.handle(request);
      }
      // Notify timeout service that user is not idle.
      this.vueTimeoutService.updateActivityTime();
      if (!this.vueAppDefaultsService.getIsOAuthEnabled()) {
        return next.handle(request);
      }
      // We only deal with rest requests.
      // Anything that does not have "rest" and "api/v*/" in the URL ignore
      if (request.url.indexOf('rest') === -1 && !/(\/api\/v.*\/)/i.test(request.url)) {
        return next.handle(request);
      }
      // TODO xliff calls are special. They need to be unsecured or we could not translate the login page.
      // but if the user is authenticated (has a selected application), then the xliff calls can
      // if (config.url.indexOf("xliffs") > -1 && !UserSession.getSelectedApplication()) {
      //    return config;
      // }
      if (request.url.indexOf('xliffs') > -1) {
        return next.handle(request);
      }
      if (this.vueUserSessionService.isOAuthTokenCurrent()) {
        return next.handle(this.addToken(request, this.vueUserSessionService.getEncodedToken())).pipe(catchError(error => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case 401:
                // if unauthorized, attempt to refresh to token to see if we can re-authorized them
                return this.handleRefreshToken(request, next);
              default:
                return throwError(error);
            }
          } else {
            return throwError(error);
          }
        }));
      }
      // if token is not current, attempt to re-authorize them
      return this.handleRefreshToken(request, next);
    }
    handleRefreshToken(req, next) {
      if (!this.isRefreshingToken) {
        this.isRefreshingToken = true;
        // NOTE: So, this is kind of annoying. Angular's Interceptor doesn't want
        // any service to have HttpClient as a dependency, also it wants an HttpEvent<any> returned, not a Subscription
        // so, we have to create the refresh token request here instead of using vueUseSessionService.refreshAuthToken()
        const refreshRequest = new HttpRequest('POST', `${this.vueUserSessionService.getPortalBaseRESTURL()}/rest/login/refreshToken`, {
          refreshToken: this.vueUserSessionService.getRefreshToken()
        }, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${this.vueUserSessionService.getEncodedToken()}`,
            'Content-Type': 'application/json'
          })
        });
        // Reset here so that the following requests wait until the token
        // comes back from the refreshToken call.
        this.tokenSubject.next(null);
        return next.handle(refreshRequest).pipe(/* eslint-disable-next-line consistent-return */
        tap(data => {
          // data is of type HttpResponse, but typescript wants data to be type HttpEvent
          // bypassing typescript typing by specifically marking data as <any>
          if (Array.isArray(data.body)) {
            this.vueUserSessionService.create(data.body[0]);
            this.isRefreshingToken = false;
            this.tokenSubject.next(data.body[0].encodedToken);
            return next.handle(this.addToken(req, data.body[0].encodedToken));
          }
        }), catchError(ignored => {
          this.isRefreshingToken = false;
          return throwError('error in refreshing token');
        }));
      }
      // TODO: != null is bad practice, fix and evaluate side effects
      return this.tokenSubject.pipe(/* eslint-disable-next-line no-eq-null */
      filter(token => token != null), take(1), switchMap(token => {
        return next.handle(this.addToken(req, token));
      }));
    }
    // add auth token to request
    addToken(req, token) {
      return req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    isRequestToUnauthenticatedEndpoint(request) {
      let unAuthenticatedHttpURLList = ['/login/refreshToken', '/portal/login', '/portal/2factor', '/twofactor/verificationCodes', '/atlas/locales', '/portal/localeSettings', '/connect/localeSettings', '/portal/logout', '/portal/newRelicConfig'];
      const appsUnAuthenticatedURLList = this.vueAppDefaultsService.getApplicationsUnAuthenticatedURLList();
      if (appsUnAuthenticatedURLList && appsUnAuthenticatedURLList.length) {
        unAuthenticatedHttpURLList = unAuthenticatedHttpURLList.concat(appsUnAuthenticatedURLList);
      }
      for (const entry of unAuthenticatedHttpURLList) {
        const result = new RegExp(entry + '$').test(request.url);
        if (result) {
          return true;
        }
      }
      return false;
    }
    static {
      this.ɵfac = function VueOauthInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueOauthInterceptor)(i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueTimeoutService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueOauthInterceptor,
        factory: VueOauthInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueOauthInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component wraps content that you want role secured. An example usage is:
 *
 *
 ```
 <vue-authorized-role [roles]="['foo', 'admin']">
 This is seen only by folks with a 'foo' or 'admin' role.
 </vue-authorized-role>
 ```
 */
let VueAuthorizedRoleComponent = /*#__PURE__*/(() => {
  class VueAuthorizedRoleComponent {
    /**
     * Component constructor.
     *
     * @param vueUserSessionService service keeping track of user session data.
     */
    constructor(vueUserSessionService) {
      this.vueUserSessionService = vueUserSessionService;
    }
    /**
     * This method will test for roles passed as input.<br/>
     * If no roles are passed, it defaults false.<br/>
     * Next it will take the array of roles and ask user session service if the user has at least one of the roles.
     *
     * @returns whether the user is authorized to see the content.
     */
    isUserAuthorized() {
      if (this.roles) {
        return this.vueUserSessionService.userHasOneRole(this.roles);
      }
      return false;
    }
    static {
      this.ɵfac = function VueAuthorizedRoleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAuthorizedRoleComponent)(i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueAuthorizedRoleComponent,
        selectors: [["vue-authorized-role"]],
        inputs: {
          roles: "roles"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        template: function VueAuthorizedRoleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, VueAuthorizedRoleComponent_Conditional_0_Template, 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isUserAuthorized() ? 0 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueAuthorizedRoleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 This service is part of the infrastructure to support checking for unsaved changes when navigating away from a
 maintenance page.
 <br/><br/>
 Here is the process:<br/>
 a) On a maintenance route, the programmer adds a deactivate guard known as VueConfirmLoseChanges.
    This guard will ask the component if it can navigate away. The programmer provides this method by implementing
    VueCanComponentDeactivate.<br/>
 b) If it cannot (meaning the component indicates it has unsaved changes), the guard will save the route the user is
    attempting to go to on this service.  It will then tell this service to display the dialog.<br/>
 c) The VueConfirmLoseChangeDialog is listening to this subject and will display itself when told.<br/>
 d) If the user presses 'stay', the dialog is closed.  If the user presses 'leave', it will tell this service
    to route the user to where they wanted to go and this service will tell the dialog to close itself.
 */
let VueConfirmLoseChangesService = /*#__PURE__*/(() => {
  class VueConfirmLoseChangesService {
    constructor(router) {
      this.router = router;
      this.showConfirm = new Subject();
      this.overrideGuard = false;
      this.leavePageConfirmed = new Subject();
    }
    setNextRoute(nextRoute) {
      this.nextRouteUponConfirm = nextRoute;
    }
    setShowConfirm() {
      this.changeShowConfirm(true);
    }
    stayOnPage() {
      this.changeShowConfirm(false);
      this.leavePageConfirmed.next(false);
    }
    leavePage() {
      this.overrideGuard = true;
      this.changeShowConfirm(false);
      this.currentComponent = null;
      if (this.nextRouteUponConfirm && this.nextRouteUponConfirm.url) {
        this.router.navigate([this.nextRouteUponConfirm.url]);
      }
      this.leavePageConfirmed.next(true);
    }
    getOverrideGuard() {
      return this.overrideGuard;
    }
    setOverrideGuardOn() {
      this.overrideGuard = true;
    }
    setOverrideGuardOff() {
      this.overrideGuard = false;
    }
    getShowConfirm() {
      return this.showConfirm;
    }
    changeShowConfirm(state) {
      this.showConfirm.next(state);
    }
    getLeavePageConfirmed() {
      return this.leavePageConfirmed;
    }
    changeLeavePageConfirmed(state) {
      this.leavePageConfirmed.next(state);
    }
    setCurrentComponent(component) {
      this.currentComponent = component;
    }
    menuNavigationCheck() {
      if (this.overrideGuard) {
        return true;
      }
      if (this.currentComponent && this.currentComponent.canDeactivate) {
        if (!this.currentComponent.canDeactivate()) {
          // set this to show confirm lose changes dialog box.
          this.setShowConfirm();
          return false;
        }
      }
      return true;
    }
    static {
      this.ɵfac = function VueConfirmLoseChangesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueConfirmLoseChangesService)(i0.ɵɵinject(i1$1.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueConfirmLoseChangesService,
        factory: VueConfirmLoseChangesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueConfirmLoseChangesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable valid-jsdoc */
/**
 This service should contain generic javascript routines that we find we are doing over and over again.
 */
let VueJavascriptUtilityService = /*#__PURE__*/(() => {
  class VueJavascriptUtilityService {
    constructor(vueAppDefaultsService, vueUserSessionService, /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    vueWindow) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueWindow = vueWindow;
    }
    /**
     This method takes HTML formatting in Xliff and replaces the escaped HTML with non-escaped.
     */
    replaceEscapedHTML(source) {
      let output = source.replace(/&lt;/g, '<');
      output = output.replace(/&gt;/g, '>');
      return output;
    }
    /**
     * Get full rest service path
     * @param relativePath - portion of the path following the rest root
     * @param restRootOverride - rest root to override the rest root defined in Session Storage or appDefaults
     * @returns endpoint path
     */
    getRestServiceURL(relativePath, restRootOverride) {
      // Use the restRootOverride if it's set, otherwise try to get the portal rest url from session,
      // finally use the constant value.
      let portalRestUrl = restRootOverride || this.vueUserSessionService.getPortalBaseRESTURL() || this.vueAppDefaultsService.getPortalRESTRoot();
      portalRestUrl = portalRestUrl.slice(-1) === '/' ? portalRestUrl.slice(0, -1) : portalRestUrl;
      const portalStartsWithSlash = portalRestUrl.startsWith('/');
      const startsWithHttp = portalRestUrl.startsWith('http');
      const prefix = !startsWithHttp && !portalStartsWithSlash ? '/' : '';
      const path = !relativePath || relativePath.startsWith('/') ? relativePath : '/' + relativePath;
      const url = prefix + portalRestUrl + path;
      return url;
    }
    /**
     * Returns true if the provided url is on the current browser location domain
     * @param url
     * @returns true or false
     */
    isCurrentDomain(url) {
      return url.toLowerCase().startsWith(this.vueWindow.location.origin.toLowerCase());
    }
    /**
     * Returns true if provided url is within the current app
     * e.g. Will return true if user is currently in the Navigator app and
     *      testURL is https://navigator.pearsonvue.com/Navigator/foo
     * @deprecated
     * Use isCurrentDomain
     * @param testURL absolute url
     * @returns true or false
     */
    isURLInCurrentApp(testURL) {
      const currentURL = this.vueWindow.location.href;
      // get base of test url, excluding state and query params
      return this.getURLOrigin(testURL).toLowerCase() === this.getURLOrigin(currentURL).toLowerCase();
    }
    /**
     * Returns the app root URL
     * For example, if URL is https://navigator.pearsonvue.com/Navigator/index.html#authenticate/login
     * it will return https://navigator.pearsonvue.com/Navigator
     * @deprecated
     * Used only by isCurrentDomain which is deprecated.
     * @param url
     * @returns root of current web app
     */
    getURLOrigin(url) {
      const urlArray = url.split('/');
      return `${urlArray[0]}//${urlArray[2]}/${urlArray[3]}`;
    }
    /**
     * Return the part of an absolute url that can be navigated to within an angular app.
     * If you have `http://myDomain.com/path/to/something` and you want to use angular routing,
     * this will return `/path/to/something` so you can use `router.navigateByUrl('/path/to/something')`
     * This assumes you have already checked that your are in the same angular
     * app so the route will work.
     * @param url string;
     */
    getNavigatePathFromUrl(url) {
      // This condition is to maintain backward compatibility with angularJS apps
      if (url.includes('#')) {
        return url.split('#')[1];
      }
      return '/' + (url.split('//')[1] || url).split('/').slice(1).join('/');
    }
    /**
     * The method checks if a string is null , undefined and blank(only spaces)
     * @param str
     */
    isBlank(str) {
      return !str || /^\s*$/.test(str);
    }
    static {
      this.ɵfac = function VueJavascriptUtilityService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueJavascriptUtilityService)(i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(WINDOW));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueJavascriptUtilityService,
        factory: VueJavascriptUtilityService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueJavascriptUtilityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class works in conjunction with the vue-loading-indicator. As rest calls are made through either
 * VueHttpClientService or VueHttpPaginationClientService, the counter is incremented. As they finish it is decremented.
 * The VueLoadingIndicator is listening to a subject on this service so it knows when to show or hide itself.
 */
let VueLoadingService = /*#__PURE__*/(() => {
  class VueLoadingService {
    constructor() {
      this.restState = new Subject();
      this.restCounter = 0;
    }
    incrementCounter() {
      this.restCounter++;
      this.changeCurrentRestState(true);
    }
    decrementCounter() {
      this.restCounter--;
      if (this.restCounter <= 0) {
        this.changeCurrentRestState(false);
      }
    }
    getRestState() {
      return this.restState;
    }
    changeCurrentRestState(state) {
      this.restState.next(state);
    }
    static {
      this.ɵfac = function VueLoadingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLoadingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueLoadingService,
        factory: VueLoadingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueLoadingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/member-ordering */
/**
 * These the date formats most commonly returned from our services.
 * This is important because safari,firefox (and soon chrome) need
 * you to tell them about the type of date your feeding the new Date().
 * If we find other apps have very commons parsing formats we
 * should set this up as an injection token declared in the consuming
 * app module.
 */
const defaultParseFormats = [moment.ISO_8601, 'MM/DD/YYYY HH:mm:ss.SSS', 'MM/DD/YYYY'];
/**
 * @deprecated
 * This class works holds onto a user's locale and is used primarily to fetch the right
 * translations and provide date formatting.
 *
 * Using localized dates in your application.
 *
 * The app utilizes MomentJS and its locale files. To have dates formatted in the locale
 * you must instal the languages you indent to support in your app.
 *
 * Example: Add the following to your app.module.ts if you wish
 * to support arabic and chinese.
 * import 'moment/locale/ar';
 * import 'moment/locale/zh-cn';
 *
 * If you just want to be able to see UK date time format to
 * your users outside of the US, then just install
 *
 * import 'moment/locale/en-gb';
 *
 * In your app you should also import `MatMomentDateModule` and use that
 * in conjunction with Material Date picker. This will automatically pick up
 * your localizations for display and input. The method from this library
 * #dateInputFormat can be used to give the end user the correct placeholder
 * prompt for how their date should be entered.
 *
 */
// https://github.com/angular/angular/issues/20351#issuecomment-344009887
/** @dynamic */
let VueLocaleService = /*#__PURE__*/(() => {
  class VueLocaleService {
    /**
     * returns value of the current locale
     */
    get locale() {
      return this.locale$.value;
    }
    /**
     * sets current locale
     * @param val string ex 'en-us'
     */
    set locale(val) {
      this.locale$.next(val);
    }
    /**
     * returns the locale as an observable.
     */
    get localeObs() {
      return this.locale$.asObservable();
    }
    /* eslint-enable max-len, no-inline-comments */
    /**
     *
     * @param vueSessionCookieService CookieService
     * @param vueAppDefaultsService Defaults Service
     * @param vueWindow Window
     * @param dateAdapter DateAdapter, optional only if the consuming app is using material date picker.
     */
    constructor(vueSessionCookieService, vueAppDefaultsService, vueWindow, dateAdapter) {
      this.vueSessionCookieService = vueSessionCookieService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueWindow = vueWindow;
      this.dateAdapter = dateAdapter;
      /**
       * Cookie name that stores the current locale. Overridden by default services
       */
      this.defaultLocaleCookieName = 'VUE_LOCALE';
      /**
       * Store the currently selected locale in a behavior subject.
       */
      this.locale$ = new BehaviorSubject('en-us');
      /**
       * Moment Library
       */
      this.moment = moment;
      /**
       * Selected Locale used by locale selector
       */
      this.selectedLocale = null;
      /**
       * Supported locales to use by locale selector
       */
      this.supportedLocales = null;
      /**
       * Subject for the locale selector selection changed
       */
      this.selectedLocaleChanged = new Subject();
      /**
       * Observable for the supported locales
       */
      this.supportedLocalesChanged = new Subject();
      /**
       * Localized date formats
       */
      /* eslint-disable max-len, no-inline-comments */
      this.localizedDateFormats = {
        dayOfWeekFull: 'dddd',
        // Monday
        dayOfWeekMin: 'dd',
        // Monday
        dayOfWeekShort: 'ddd',
        // Mon
        fullDate: 'LLLL',
        // Monday, 3 August 2015 12:12     // sample String is for en-gb locale
        fullDateNoTime: 'LLLL',
        // Monday, 3 August 2015     // sample String is for en-gb locale. Time removed later in locale.service.js.
        longDate: 'LLL',
        // 3 August 2015 12:12              // sample String is for en-gb locale
        mediumDate: 'LL',
        // 3 August 2015                   // sample String is for en-gb locale
        mediumDateSmallMonth: 'll',
        // 3 Aug 2015            // sample String is for en-gb locale.
        mediumTime: 'LTS',
        // 13:10:55                       // sample String is for en-gb locale 24 hour format for en-gb
        shortDate: 'L',
        // 03/08/2015                        // sample String is for en-gb locale
        shortTime: 'LT' // 13:10                             // sample String is for en-gb locale 24 hour format for en-gb
      };
      this.setLocale(this.getLocaleFromCookie(), false);
    }
    /**
     * Sets cookie name based on vueAppDefaultService setting. If not defined
     * by the app will fallback for backwards compatibility.
     * @returns string
     */
    getPortalCookieLocaleName() {
      return this.vueAppDefaultsService.getLocaleCookieName() || this.convertHostNameToCookieName(this.defaultLocaleCookieName);
    }
    /**
     *
     * Uses the hostname to provide a custom default cookie name
     *
     * @param defaultCookieName string
     * @returns string
     */
    convertHostNameToCookieName(defaultCookieName) {
      return `${defaultCookieName}_${this.vueWindow.location.hostname.toUpperCase()}`;
    }
    /**
     *
     * Gets cookie name from defaults or overrides provided
     *
     * @returns string
     */
    getLocaleFromCookie() {
      const cookieName = this.getPortalCookieLocaleName();
      let cookie = this.vueSessionCookieService.getCookie(cookieName, '');
      if (!cookie) {
        cookie = this.vueSessionCookieService.getCookie(this.defaultLocaleCookieName, '');
      }
      if (!cookie) {
        cookie = this.vueAppDefaultsService.getDefaultLocale();
      }
      if (!cookie) {
        cookie = 'en-us';
      }
      return this.normalizeLocale(cookie);
    }
    /**
     * Saves local to cookie
     * @param locale string 'en-us'
     */
    saveLocaleToCookie(locale) {
      const cookieName = this.getPortalCookieLocaleName();
      const expires = new Date();
      expires.setDate(expires.getDate() + 5);
      this.vueSessionCookieService.setCookie(cookieName, locale, {
        domain: this.vueWindow.location.hostname === 'localhost' ? 'localhost' : 'pearsonvue.com',
        expires: expires,
        namespace: '',
        path: '/'
      });
    }
    /**
     * This method converts the string date to input timezone
     * @param dateToConvert string
     * @param toTimezone string
     * @returns date in input timezone , if date in-valid it returns String - 'Invalid date'
     */
    convertDateToTimezone(dateToConvert, toTimezone) {
      if (!dateToConvert) {
        return '';
      } else if (isNaN(Date.parse(dateToConvert)) === true) {
        return 'Invalid date';
      } else if (toTimezone) {
        return this.moment.tz(this.moment.utc(dateToConvert), toTimezone).format();
      }
      return '';
    }
    /**
     * converts a Date to s specified timezone
     * @param dateToConvert string | number
     * @param toTimezone string
     * @returns Moment
     */
    convertDateToTimezoneWithoutFormat(dateToConvert, toTimezone) {
      if (!dateToConvert) {
        return null;
      }
      if (!toTimezone) {
        return this.moment.utc(new Date(dateToConvert));
      }
      // only when you call format, the zone in the timezone gets applied to change the datetime, _d.
      return this.moment.tz(this.moment.utc(dateToConvert), toTimezone);
    }
    /**
     * This method converts the string date to moment obj based on input timezone and input format.
     * @param dateToConvert string
     * @param toTimezone, if TimeZone is not specified then it converts to GMT+0000.
     * @param format string
     * @param defaultTimeZone string, undefined if not specified
     * @returns date in input timezone and format , if date in-valid it returns null.
     */
    convertDateToTimezoneWithSpecificFormat(dateToConvert, toTimezone, format, defaultTimeZone) {
      if (!this.checkValidDateStr(dateToConvert)) {
        return 'No or Invalid Date';
      }
      const dateFormat = format ? format : this.moment.defaultFormatUtc;
      if (toTimezone) {
        return this.moment.tz(dateToConvert, dateFormat, toTimezone);
      } else if (defaultTimeZone) {
        return this.moment.tz(dateToConvert, dateFormat, defaultTimeZone);
      }
      return this.moment.tz(dateToConvert, dateFormat);
    }
    /**
     * Validate if the date string is a valid date.
     * @param dateStr string
     * @returns boolean
     */
    checkValidDateStr(dateStr) {
      if (!dateStr) {
        return false;
      }
      if (isNaN(Date.parse(dateStr))) {
        return false;
      }
      return true;
    }
    /**
     * @deprecated use dateFormatLocale for parsing compatibility
     * This method - formats the date if format is passed else return ISO String
     * formatting string is declared as a constant in localizedDateFilterConstantsMoment
     * Use it only when you need to format date in browser timezone.
     * @param dateToFormat MomentInput
     * @param toFormat string
     * @returns formatted date
     */
    convertToFormat(dateToFormat, toFormat) {
      if (!dateToFormat) {
        return null;
      }
      if (!toFormat) {
        return this.moment(dateToFormat).toISOString();
      }
      return this.moment(dateToFormat).format(this.localizedDateFormats[toFormat]);
    }
    /**
     *
     * @param value value to be formatted
     * @param parseFormat If value is a string, then a default format will be applied if this
     * is missing.
     * @returns a Moment object.
     */
    parseDate(value, parseFormat = defaultParseFormats) {
      if (this.moment.isMoment(value)) {
        return value;
      }
      if (typeof value === 'string') {
        return this.moment(value, parseFormat, true);
      }
      return this.moment(value);
    }
    /**
     * @param value This is a utility function that can be used to simply format
     * that dates back to our default parsing format 'MM/DD/YYYY HH:mm:ss.SSS'.
     * If another format is desired, you should use dateFormatLocale
     * @returns string
     */
    unParseDate(value) {
      return this.parseDate(value).format('MM/DD/YYYY HH:mm:ss.SSS');
    }
    /**
     * This will format the date using the parsing method which has a default parsing method for
     * strings 'MM/DD/YYYY HH:mm:ss.SSS'. Non string values are unaffected.
     * Only use as an injected service, otherwise locale information will
     * be lost.
     * @param value MomentInput
     * @param toFormat localizedDateFormats or MomentJS format
     * @param parseFormat 'MM/DD/YYYY HH:mm:ss.SSS'
     * @returns string
     */
    dateFormatLocale(value, toFormat, parseFormat) {
      return this.parseDate(value, parseFormat).format(this.localizedDateFormats[toFormat] || toFormat);
    }
    /**
     * Returns the days of the week for the locale
     * @param useLocaleFirstDow: should the return order the
     * based on the locale
     * @returns dates as array ['Su', 'Mo', 'Tu' ...]
     */
    weekdaysMin(useLocaleFirstDow) {
      return this.moment.weekdaysMin(useLocaleFirstDow);
    }
    /**
     * Returns the days of the week for the locale
     * @param useLocaleFirstDow: should the return order the
     * based on the locale
     * @returns dates as array ['Sun', 'Mon', 'Tue' ...]
     */
    weekdaysShort(useLocaleFirstDow) {
      return this.moment.weekdaysShort(useLocaleFirstDow);
    }
    /**
     * Returns the days of the week for the locale
     * @param useLocaleFirstDow: should the return order the
     * based on the locale
     * @returns dates as array ['Sunday', 'Monday', 'Tuesday' ...]
     */
    weekdays(useLocaleFirstDow) {
      return this.moment.weekdays(useLocaleFirstDow);
    }
    /**
     * A reverse look up for day of week. Helpful when
     * get index of week day in other languages
     * @param minShortOrLongWeekday ex: 'Mo'
     * @returns number;
     */
    weekDaysParse(minShortOrLongWeekday) {
      return this.moment.localeData().weekdaysParse(minShortOrLongWeekday, null, null);
    }
    /**
     * Returns the months of the year for the locale
     * @returns dates as array ['January', 'February', 'March' ...]
     */
    months() {
      return this.moment.months();
    }
    /**
     * Returns the months of the year for the locale
     * @returns dates as array ['Jan', 'Feb', 'Mar' ...]
     */
    monthsShort() {
      return this.moment.monthsShort();
    }
    /**
     * Returns the format that should be used when entering dates into date picker
     * @returns string mm/dd/yyyy
     */
    dateInputFormat() {
      return this.moment.localeData().longDateFormat('L');
    }
    /**
     * This method - formats the date
     * formatting string is declared as a constant in localizedDateFilterConstantsMoment
     * Use it only when you need to format date in UTC timezone.
     * @param dateToFormat MomentInput
     * @param toFormat string
     * @returns formatted date
     */
    convertToUTCAndFormat(dateToFormat, toFormat) {
      if (!dateToFormat) {
        return null;
      }
      return this.moment(dateToFormat).utc().format(this.localizedDateFormats[toFormat]);
    }
    /**
     * This method - formats the date if format is passed else return ISO String
     * formatting string is declared as a constant in localizedDateFilterConstantsMoment.
     * This methods hardcodes format for VTS legacy purposes.
     * Use it only when you need to format date in UTC timezone.
     * @param dateToFormat MomentInput
     * @returns formatted date
     */
    convertToUTCAndFormatLegacyVTS(dateToFormat) {
      if (!dateToFormat) {
        return null;
      }
      return this.moment(dateToFormat).utc().format('DD MMMM YYYY');
    }
    /**
     * This method - formats the date given a format and timezone.
     * @param dateToFormat MomentInput
     * @param timeZone timezone
     * @param toFormat format of returned date
     * @returns formatted date converted to time zone
     */
    convertToFormatWithTimeZone(dateToFormat, timeZone, toFormat) {
      if (dateToFormat && timeZone && toFormat) {
        if (toFormat === 'fullDateNoTime') {
          return this.moment.tz(dateToFormat, timeZone).format('dddd, MMMM D, YYYY');
        }
        return this.moment.tz(dateToFormat, timeZone).format(this.localizedDateFormats[toFormat]);
      }
      return dateToFormat;
    }
    /**
     * Parses locale (ex: 'en-us') returns the language portion
     * @returns string 'en'
     */
    findLanguageFromLocale() {
      return this.localeStringToArray(this.locale)[0];
    }
    /**
    * Parses locale (ex: 'en-us') returns the country portion
    * @returns string 'us'
    */
    findCountryCodeFromLocale() {
      return this.localeStringToArray(this.locale)[1] || '';
    }
    /**
     * Splits locale on '-'
     * @param locale : string
     * @returns array ['en','us']
     */
    localeStringToArray(locale) {
      return this.normalizeLocale(locale).split('-');
    }
    /**
     * If locale is `en_US` will return `en-us`
     * @param key string
     * @returns string 'en-us'
     */
    normalizeLocale(key) {
      return key ? key.trim().toLowerCase().replace('_', '-') : key;
    }
    /**
     * Updates current locale and sets cookie
     * @param newLocale locale string 'en-us'
     * @param saveToCookie Should it save the cookie
     */
    setLocale(newLocale, saveToCookie) {
      if (!newLocale) {
        return;
      }
      this.locale = this.normalizeLocale(newLocale);
      if (this.locale) {
        /**
         * If the user has chosen `English` and browser is `US`
         * then set moment to `en-us``.
         *
         * Otherwise we attempt the chosen locale, defaulting
         * to `en-gb` and `en-us` depending on what the locals
         * the consuming app has installed.
         *
         * If the consuming app has installed NO additional
         * languages moment will automatically just use
         * `en-us`.
         *
         * The purpose of this is to default to `en-gb` (if installed)
         * when the user is not in the United States and their
         * corresponding language is also not installed.
         */
        const navLocale = this.normalizeLocale(navigator.language);
        /* eslint-disable-next-line */
        let dateLocale; // string | string[];
        if (navLocale === 'en-us' && this.locale === 'en-us') {
          // if user is in `us` and browser is set to `us` the use `us`
          dateLocale = 'en-us';
        } else {
          // try chosen locale, then try `en-us` (if installed),
          // otherwise default to `en-us`
          dateLocale = [this.locale, 'en-gb', 'en-us'];
        }
        this.moment.locale(dateLocale);
        // Consuming app may not be using date adapter.
        if (this.dateAdapter) {
          this.dateAdapter.setLocale(dateLocale);
        }
        if (saveToCookie) {
          this.saveLocaleToCookie(this.locale);
        }
      }
    }
    /**
     * used for testing
     * @param timezone string
     */
    setTimeZone(timezone) {
      this.moment.tz.setDefault(timezone);
    }
    /**
     * Updated the selected locale: Locale, and saves the code to current
     * locale and cookie.
     * @param arg Locale
     */
    setSelectedLocale(arg) {
      this.selectedLocale = arg;
      this.setLocale(arg.code, true);
      this.selectedLocaleChanged.next(this.selectedLocale);
    }
    /**
     * Returns selected locale
     * @returns Locale
     */
    getSelectedLocale() {
      return this.selectedLocale;
    }
    /**
     * Loads supported locales
     * @param locales All supported locales in array of Locale object
     */
    loadSupportedLocales(locales) {
      const localesObservable = this.fetchSupportedLocales(locales);
      if (localesObservable !== null) {
        localesObservable.subscribe(localRef => {
          this.setSupportedLocales(localRef);
        });
      }
    }
    /**
     * looks for supported locales inside app defaults first, otherwise makes
     * api call
     * @param locales Array of locales to return as observable array
     * @returns Observable<Locale[]>
     */
    fetchSupportedLocales(locales) {
      return of(locales);
    }
    /**
     * returns supported local
     * @returns Local[]
     */
    getSupportedLocales() {
      return this.supportedLocales;
    }
    /**
     * Sets the supported locales
     * @param locales Locale[]
     */
    setSupportedLocales(locales) {
      this.supportedLocales = locales;
      this.supportedLocalesChanged.next(this.supportedLocales);
    }
    /**
     * Returns supportedLocalesChanged
     * Dev Note:  This seems unneeded since supportedLocalesChanged is public - Randall Meeker  11/5/21
     * @returns Observable<Locale[]>
     */
    getSupportedLocalesChanged() {
      return this.supportedLocalesChanged;
    }
    static {
      this.ɵfac = function VueLocaleService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLocaleService)(i0.ɵɵinject(VueSessionCookieService), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i3.DateAdapter, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueLocaleService,
        factory: VueLocaleService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueLocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any, valid-jsdoc */
/**
 * Translation service, used to fetch translation bundles and provide the translation key values.
 *
 * **TODO**:
 * <ul>
 *     <li>Remove all instances of the `any` type and define interfaces instead.</li>
 * </ul>
 */
let VueTranslationService = /*#__PURE__*/(() => {
  class VueTranslationService {
    /**
     * Constructor bringing in all service dependencies.
     *
     * @param http
     * @param vueAppDefaultsService
     * @param vueJavascriptUtilityService
     * @param vueLoadingService
     * @param vueLocaleService
     * @param vueUserSessionService
     */
    constructor(http, vueAppDefaultsService, vueJavascriptUtilityService, vueLoadingService, vueLocaleService, vueUserSessionService) {
      this.http = http;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueLoadingService = vueLoadingService;
      this.vueLocaleService = vueLocaleService;
      this.vueUserSessionService = vueUserSessionService;
      /**
       * Portal bundle name.
       */
      this.portalBundle = 'portal';
      /**
       * Portal Base bundle name.
       */
      this.portalBaseBundle = 'PortalBase';
      /**
       * Stores the observables. One observable per bundle rest call.
       */
      this.observableList = {};
      this.appBundleChange = new Subject();
      /**
       * Locally cached bundles
       */
      this.bundles = {};
    }
    /**
     * Sets the locally cached bundle
     * @param bundleName Name of bundle
     * @param translations the bundle to be saved
     */
    setBundle(bundleName, translations) {
      this.bundles[(bundleName || '').toLowerCase()] = translations;
    }
    /**
     * Retrieves the locally cached bundle
     * @param bundleName Name of bundle
     * @returns bundle
     */
    getBundle(bundleName) {
      return this.bundles[(bundleName || '').toLowerCase()];
    }
    /**
     * Get the translation for a given key in a given bundle.
     *
     * @param bundle the bundle containing the translated key.
     * @param key the key to translate.
     * @param params optional translation parameters.
     */
    /* eslint-disable-next-line consistent-return */
    getTranslation(bundle, key, params) {
      if (!this.getBundle(bundle)) {
        /*
         * If the bundle is not loaded upon first translation, go get it.
         * NOTE: this should rarely happen if you have route resolves set properly.
         */
        this.getTranslationBundle(bundle, this.vueAppDefaultsService.getPortalRESTRoot()).subscribe(() => this.getTranslationFromBundle(bundle, key, params));
      } else {
        return this.getTranslationFromBundle(bundle, key, params);
      }
    }
    /**
     * Get the translation for a given key in a given bundle.
     * If no bundle found get bundle and then message.
     * We are returning observable so user can subscribe to message when we need to get bundle.
     *
     * @param bundle the bundle containing the translated key.
     * @param key the key to translate.
     * @param params optional translation parameters.
     *
     * @returns An Observable of the translated message
     */
    getTranslationAsObservable(bundle, key, params) {
      if (this.getBundle(bundle)) {
        return new Observable(stub => {
          // observable execution, mark complete
          stub.next(this.getTranslationFromBundle(bundle, key, params));
          stub.complete();
        });
      }
      /*
       * If the bundle is not loaded upon first translation, go get it.
       * NOTE: this should rarely happen if you have route resolves set properly.
       * This will happen if translations are needed in app component
       */
      return this.getTranslationBundle(bundle, this.vueAppDefaultsService.getPortalRESTRoot()).pipe(take(1), map(ignored => this.getTranslationFromBundle(bundle, key, params)));
    }
    /**
     * Gets a translation bundle by name, either from cache or from an external location.
     *
     * @param bundle the bundle to fetch.
     * @param restRoot the rest root (todo: currently unused as param)
     */
    getTranslationBundle(bundle = '', ignored) {
      if (this.getBundle(bundle)) {
        // already fetched bundle
        return new Observable(stub => {
          // observable execution, mark complete
          stub.next();
          stub.complete();
        });
      } else if (this.observableList[bundle.toLowerCase()]) {
        // If the observable is already created for the rest call.
        return this.observableList[bundle.toLowerCase()];
      }
      const url = this.getRestURL(bundle);
      const httpHeaders = new HttpHeaders().set('Accept-Language', '*');
      const options = {
        headers: httpHeaders
      };
      this.observableList[bundle.toLowerCase()] = defer(() => {
        this.vueLoadingService.incrementCounter();
        return this.http.get(url, options);
      }).pipe(tap({
        error: () => this.handleBundleFetchError(),
        next: results => this.handleBundleFetchSuccess(bundle, results)
      }), shareReplay());
      return this.observableList[bundle.toLowerCase()];
    }
    /**
     * Gets the translation of a given key from the defined bundle.
     *
     * @param bundle the bundle containing the key.
     * @param key the translation key.
     * @param params optional parameters for the translation.
     */
    /* eslint-disable-next-line complexity */
    getTranslationFromBundle(bundle, key, params) {
      let originalKey = key;
      // Return empty string when translation key is undefined rather than error
      if (!key) {
        return '';
      }
      const selectedApplication = this.vueUserSessionService.getSelectedApplication();
      const selectedClient = this.vueUserSessionService.getSelectedClient();
      // In some legacy cases, VTS services still append the client code for the
      // current context to the error code being returned. In order to accurately
      // find the appropriate XLIFF key, we should start by removing the client code
      // from the error key we are searching for.
      if (selectedClient && key.substring(key.lastIndexOf('.') + 1, key.length) === selectedClient.code) {
        originalKey = key.substring(0, key.lastIndexOf('.'));
      }
      // Retrieve the current client context if one exists, and tack on to the key.
      let keyWithClientCode = '';
      if (selectedClient) {
        keyWithClientCode = `${originalKey}.${this.vueUserSessionService.getSelectedClient().code}`;
      }
      // Data set-up, the translation to return and the bundle to search.
      let translation;
      // If we have an application context, and that application has an XLIFF bundle,
      // then search that bundle for application-specific overrides first.
      if (selectedApplication && selectedApplication.bundleName && this.getBundle(selectedApplication.bundleName) && selectedApplication.bundleName !== bundle) {
        // If the user has a client selected, look for a client-specific override in this bundle.
        if (keyWithClientCode) {
          translation = this.getBundle(selectedApplication.bundleName)[`${bundle}.${keyWithClientCode}`];
        }
        // If the user doesn't have a client selected, or there was no client-specific override found.
        if (!keyWithClientCode || !translation) {
          translation = this.getBundle(selectedApplication.bundleName)[`${bundle}.${originalKey}`];
        }
      }
      // Search the bundle provided if it exists (and an application-specific wasn't already used).
      if (!translation && this.getBundle(bundle)) {
        // If the user has a client selected, look for a client-specific override in this bundle.
        if (keyWithClientCode) {
          translation = this.getBundle(bundle)[keyWithClientCode];
        }
        // If the user doesn't have a client selected, or there was no client-specific override found.
        if (!keyWithClientCode || !translation) {
          translation = this.getBundle(bundle)[originalKey];
        }
      }
      // No more variations of the key to check for, so now we can proceed...
      if (!translation) {
        // If bundle does not exist or bundle.key doesn't exist, return error message
        if (!this.getBundle(bundle)) {
          return `[@@ Message ${bundle}.${key} does not exist because bundle not defined!! @@]`;
        }
        if (!this.getBundle(bundle)[key]) {
          return `[@@ Message ${bundle}.${key} does not exist because term not defined!! @@]`;
        }
        // This hard-coded message is intended to make key name errors more obvious,
        // while still remaining "production-safe" (not offensive)
        return `[@@ Message ${bundle}.${key} does not exist!! @@]`;
      }
      if (params) {
        return this.replaceParams(translation, params);
      }
      return translation;
    }
    /**
     * Fetch the translation for a code returned from an API call.
     *
     * @param code the translation code provided by the server.
     */
    getTranslationFromServerCode(code) {
      if (code && code.code) {
        const serverCode = code.code;
        const parameters = code.parameters || [];
        const key = serverCode.indexOf('.') >= 0 ? serverCode.slice(serverCode.indexOf('.') + 1) : serverCode;
        const bundle = serverCode.indexOf('.') >= 0 ? serverCode.slice(0, serverCode.indexOf('.')) : null;
        return this.getTranslation(bundle, key, parameters);
      }
      return null;
    }
    /**
     * Get the translation of multiple keys.
     *
     * @param bundle the bundle containing the translations.
     * @param keys the keys to translate.
     * @returns Record
     */
    getTranslations(bundle, keys) {
      const messages = {};
      if (Array.isArray(keys)) {
        for (let i = 0, j = keys.length; i < j; i++) {
          messages[keys[i]] = this.getTranslation(bundle, keys[i]);
        }
      }
      return messages;
    }
    /**
     * Checks if the translations for a bundle have already been fetched.
     *
     * @param bundle bundle to check.
     */
    isBundleAvailable(bundle) {
      return Boolean(this.getBundle(bundle));
    }
    /**
     *  This method will load bundles suported by application, This method helps loading
     *  the bundles required by application when locale changes. This method is created to load
     *  bundles dynamically if locale changes.
     */
    loadTranslationBundles(bundles) {
      this.bundles = {};
      this.observableList = {};
      if (bundles.length > 0) {
        const bundlesObservables = [];
        for (const bundle of bundles) {
          bundlesObservables.push(this.getTranslationBundle(bundle, this.vueAppDefaultsService.getPortalRESTRoot()));
        }
        forkJoin(bundlesObservables).subscribe(() => {
          this.appBundleChange.next('bundlesLoadComplete');
        });
      }
    }
    /**
     * Gets the URL to use to fetch a given bundle.
     *
     * @param bundle the bundle to fetch.
     */
    getRestURL(bundle) {
      if (this.vueAppDefaultsService.getXliffHostingType() === 'cdn' && this.vueAppDefaultsService.getXliffBaseURL() !== '') {
        let cdnUrl = this.vueAppDefaultsService.getXliffBaseURL();
        cdnUrl = `${cdnUrl}/${this.vueLocaleService.findLanguageFromLocale()}`;
        if (this.vueLocaleService.findCountryCodeFromLocale()) {
          cdnUrl = `${cdnUrl}/${this.vueLocaleService.findCountryCodeFromLocale().toUpperCase()}`;
        }
        cdnUrl = `${cdnUrl}/${bundle}.json`;
        return cdnUrl;
      }
      const restRootOverride = this.vueAppDefaultsService.getIsRestRootUsedForXliff() ? '' : this.vueAppDefaultsService.getXliffBaseURL();
      let url = this.vueJavascriptUtilityService.getRestServiceURL('/rest/xliffs', restRootOverride);
      url = `${url}?language=${this.vueLocaleService.findLanguageFromLocale()}`;
      url = `${url}&countryCode=${this.vueLocaleService.findCountryCodeFromLocale()}`;
      url = `${url}&name=${bundle}`;
      return url;
    }
    /**
     * Handles successful HTTP calls when fetching a bundle.
     *
     * @param bundle the bundle that was fetched.
     * @param results the results of the HTTP call.
     */
    handleBundleFetchSuccess(bundle, results) {
      this.setBundle(bundle, results);
      this.vueLoadingService.decrementCounter();
    }
    /**
     * Handles HTTP errors that occurred when fetching a bundle.
     */
    handleBundleFetchError() {
      this.vueLoadingService.decrementCounter();
    }
    /**
     * Support parameter replacement and formatting of dates in the current locale in the translation.
     *
     * @param dateFormat the style in which to format the dates (e.g. `short`, `medium`, etc.)
     * @param date the value to format.
     */
    replaceDateParams(dateFormat, date) {
      let formattedDate = '';
      // Expected types: short, medium, long, and full
      // Undefined: processes no qualifier passed
      // Default: handles backwards compatibility with date formats
      switch (dateFormat) {
        /* eslint-disable-next-line no-undefined */
        case undefined:
          // This will be the default if nothing is passed.
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'longDate');
          break;
        case 'short':
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'shortDate');
          break;
        case 'medium':
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'mediumDate');
          break;
        case 'long':
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'longDate');
          break;
        case 'full':
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'fullDate');
          break;
        // This case is for when VTS returns a java format which is not handled correctly by MOMENT
        case 'dd MMMM yyyy':
          formattedDate = this.vueLocaleService.convertToUTCAndFormatLegacyVTS(date);
          break;
        default:
          formattedDate = this.vueLocaleService.convertToUTCAndFormat(date, 'fullDate');
          break;
      }
      return formattedDate;
    }
    /**
     * Replace parameters in a translated string.<br />
     * XLIFF format:
     * <ul>
     * <li>`Value {0}`: no formatting specified</li>
     * <li>`Value {0,number}`: formatted as a number</li>
     * <li>`Value {0,number,percent}`: formatted as a percentage, with a max of 2 decimals</li>
     * <li>`Value {0,number,currency}`: formatted as currency, with a max of 2 decimals</li>
     * <li>`Value {0,number,integer}`: formatted as a regular integer</li>
     * <li>`Value {0,date}`: formatted as default date</li>
     * <li>`Value {0,date,short}`: formatted as short date</li>
     * <li>`Value {0,date,medium}`: formatted as medium date</li>
     * <li>`Value {0,date,long}`: formatted as long date</li>
     * <li>`Value {0,date,full}`: formatted as full date</li>
     * <li>`Value {0,date,dd MMMM yyyy}`: VTS legacy</li>
     * </li>
     *
     * @param translation the translated message.
     * @param params the parameters to replace in the translation.
     */
    replaceParams(translation, params) {
      /* eslint-disable-next-line complexity */
      return translation.replace(/{(\d+),? ?[a-z]*?,? ?[a-zA-Z/\-\s]*?}/g, (match, number) => {
        let replacedParameter;
        if (params[number] !== null && typeof params[number] !== 'undefined') {
          // todo cleanup
          let paramValue = params[number];
          // parameter could be specified as a nested key, or as I18N content
          if (typeof paramValue === 'object') {
            // for now, we just grab the defaultContent value for I18N content
            if (paramValue.defaultContent) {
              paramValue = paramValue.defaultContent;
              // if this is a nested XLIFF message, we need to attempt to resolve it (this solution
              // assumes that the nested message(s) exists either in the same bundle as the parent
              // message - which is the case today - or that any additional bundles have already been pre-loaded)
            } else if (paramValue.messageKey && paramValue.systemDomain && this.getBundle(paramValue.systemDomain)) {
              paramValue = this.getTranslationFromBundle(paramValue.systemDomain, paramValue.messageKey, paramValue.parameters);
            } else {
              // something else entirely
              paramValue = `[Error resolving parameter: ${JSON.stringify(paramValue)}]`;
            }
          }
          // Define the format and format qualifier of the parameter.
          const paramFormat = match.replace(/[{} ]/g, '').split(',')[1];
          let paramFormatQualifier;
          // Handle dates
          if (paramFormat === 'date') {
            // Replace brackets, but not spaces.
            paramFormatQualifier = match.replace(/[{}]/g, '').split(',')[2];
            // If the parameter format qualifier exists, strip leading spaces.
            if (paramFormatQualifier) {
              paramFormatQualifier = paramFormatQualifier.replace(/^\s+|/, '');
            }
          } else {
            // Strip brackets and spaces.
            paramFormatQualifier = match.replace(/[{} ]/g, '').split(',')[2];
          }
          // If a format was specified for this parameter, then handle it as appropriate.
          switch (paramFormat) {
            case 'date':
              {
                replacedParameter = this.replaceDateParams(paramFormatQualifier, paramValue);
                break;
              }
            case 'number':
              // Verify that the parameter value is a number.
              if (parseFloat(paramValue)) {
                if (paramFormatQualifier) {
                  // expected types: integer, percent, currency
                  switch (paramFormatQualifier) {
                    case 'percent':
                      replacedParameter = (parseFloat(paramValue) * 100).toFixed(2);
                      replacedParameter = replacedParameter.split('.')[1] === '00' ? replacedParameter.split('.')[0] : replacedParameter;
                      replacedParameter = `${replacedParameter}%`;
                      break;
                    case 'currency':
                      replacedParameter = parseFloat(paramValue).toFixed(2);
                      replacedParameter = `$${replacedParameter}`;
                      break;
                    case 'integer':
                      // todo: what would cause `parseInt(paramValue, 10)` to return falsy?
                      replacedParameter = parseInt(paramValue, 10) ? parseInt(paramValue, 10) : match;
                      break;
                    default:
                      replacedParameter = parseFloat(paramValue);
                      break;
                  }
                } else {
                  replacedParameter = parseFloat(paramValue);
                }
              } else {
                replacedParameter = match;
              }
              break;
            default:
              replacedParameter = paramValue;
              break;
          }
        } else {
          replacedParameter = match;
        }
        return replacedParameter;
      });
    }
    static {
      this.ɵfac = function VueTranslationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTranslationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueLoadingService), i0.ɵɵinject(VueLocaleService), i0.ɵɵinject(VueUserSessionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueTranslationService,
        factory: VueTranslationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueTranslationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This UX dialog is part of the infrastructure to support checking for unsaved changes when navigating away from a
 * maintenance page.
 * <br/><br/>
 * Here is the process:
 * <ol>
 *   <li>
 *     On a maintenance route, the programmer adds a deactivate guard known as VueConfirmLoseChanges.
 *     This guard will ask the component if it can navigate away. The programmer provides this method
 *     by implementing VueCanComponentDeactivate.
 *   </li>
 *   <li>
 *     If it cannot (meaning the component indicates it has unsaved changes), the guard will save the route
 *     the user is attempting to go to on the VueConfirmLoseChangesService. The guard will then tell this
 *     service to display this dialog.
 *   </li>
 *   <li>
 *     This dialog is listening to this subject and will display itself when told.
 *   </li>
 *   <li>
 *     If the user presses 'stay', the dialog is closed. If the user presses 'leave', it will tell
 *     this service to route the user to where they wanted to go and this service will tell the dialog
 *     to close itself.
 *   </li>
 * </ol>
 */
let VueConfirmLoseChangesDialogComponent = /*#__PURE__*/(() => {
  class VueConfirmLoseChangesDialogComponent {
    /**
     * Component constructor.
     *
     * @param vueAppDefaultsService service used to fetch application-wide default attributes.
     * @param vueConfirmLoseChangesService service supporting lose changes dialog component.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(vueAppDefaultsService, vueConfirmLoseChangesService, vueTranslationService) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueConfirmLoseChangesService = vueConfirmLoseChangesService;
      this.vueTranslationService = vueTranslationService;
      /**
       * Default Translation key for the stayOnThispage button label.<br />
       * Only used if `i18nKey` is set.
       *
       */
      this.stayOnThisPageLabelKeyDefault = 'vue.core.dialogDirective.StayOnThisPage';
      /**
       * Default Translation key for the leaveThisPage button label.<br />
       * Only used if `i18nKey` is set.
       *
       */
      this.leaveThisPageLabelKeyDefault = 'vue.core.dialogDirective.LeaveThisPage';
      /**
       * Default Translation key for the dialogTitle text.<br />
       * Only used if `i18nKey` is set.
       *
       * Defaults to 'vue.core.dialogDirective.UnsavedChangesWarning'
       */
      this.dialogTitleKeyDefault = 'vue.core.dialogDirective.UnsavedChangesWarning';
      /**
       * Whether to show the dialog.
       */
      this.show = false;
      this.i18nBundle = this.i18nBundle ? this.i18nBundle : this.vueAppDefaultsService.getPortalMessageBundle();
    }
    /**
     * On component initialization, subscribe to the confirm lose changes service.
     */
    ngOnInit() {
      this.vueConfirmLoseChangesService.getShowConfirm().subscribe(state => {
        this.show = state;
      });
    }
    /**
     * Called when the user decides to leave the page.
     */
    leaveThisPage() {
      this.vueConfirmLoseChangesService.leavePage();
    }
    /**
     * Called when the user decides to stay on the page.
     */
    stayOnPage() {
      this.vueConfirmLoseChangesService.stayOnPage();
    }
    /**
     * Get the DialogTitle text label.
     *
     * @returns the DialogTitle text label.
     */
    getDialogTitleText() {
      if (this.dialogTitleText) {
        return this.dialogTitleText;
      } else if (this.i18nBundle && this.dialogTitleKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.dialogTitleKey);
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.dialogTitleKeyDefault);
    }
    /**
     * Get the LeavePage button label.
     *
     * @returns the LeavePage button label.
     */
    getLeavePageLabel() {
      if (this.i18nBundle && this.leaveThisPageLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.leaveThisPageLabelKey);
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.leaveThisPageLabelKeyDefault);
    }
    /**
     * Get the stayOnPage button label.
     *
     * @returns the stayOnPage button label.
     */
    getStayOnPageLabel() {
      if (this.i18nBundle && this.stayOnThisPageLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.stayOnThisPageLabelKey);
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.stayOnThisPageLabelKeyDefault);
    }
    static {
      this.ɵfac = function VueConfirmLoseChangesDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueConfirmLoseChangesDialogComponent)(i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueConfirmLoseChangesService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueConfirmLoseChangesDialogComponent,
        selectors: [["vue-confirm-lose-changes-dialog"]],
        inputs: {
          i18nBundle: "i18nBundle",
          stayOnThisPageLabelKey: "stayOnThisPageLabelKey",
          leaveThisPageLabelKey: "leaveThisPageLabelKey",
          dialogTitleKey: "dialogTitleKey",
          dialogTitleText: "dialogTitleText"
        },
        standalone: false,
        decls: 10,
        vars: 4,
        consts: [["id", "configDialog", 1, "session-timeout-container", 3, "hidden"], [1, "screen-overlay"], [1, "dashboard-message-wrapper"], [1, "dashboard-message-container"], [3, "innerHTML"], ["id", "stay", 1, "btn", "btn-default", "btn-sm", "session-extend", 3, "click"], ["id", "leave", 1, "btn", "btn-default", "btn-sm", "session-extend", 3, "click"]],
        template: function VueConfirmLoseChangesDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "p", 4);
            i0.ɵɵelementStart(5, "span")(6, "button", 5);
            i0.ɵɵlistener("click", function VueConfirmLoseChangesDialogComponent_Template_button_click_6_listener() {
              return ctx.stayOnPage();
            });
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 6);
            i0.ɵɵlistener("click", function VueConfirmLoseChangesDialogComponent_Template_button_click_8_listener() {
              return ctx.leaveThisPage();
            });
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", !ctx.show);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("innerHTML", ctx.getDialogTitleText(), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.getStayOnPageLabel(), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.getLeavePageLabel(), " ");
          }
        },
        styles: ["#leave[_ngcontent-%COMP%]{margin-left:2px}"]
      });
    }
  }
  return VueConfirmLoseChangesDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable valid-jsdoc */
/**
 * This component is included by default in the vue-control-group component. It will display field level errors.
 *
 * Usage:
 * ```
 <vue-validation-message i18nBundle="myBundle" [control]="control" [formError]="formError"></vue-validation-message>```
 *
 * You can override the following canned validation messages:
 * <ul>
 *     <li>Pattern match: by using attribute `pattern`</li>
 *     <li>Required field: by using attribute `required`</li>
 *     <li>Integer type: by using attribute `vueValidateInteger`</li>
 *     <li>Integer type: by using attribute `vueValidateAlphaNumeric`</li>
 *     <li>Integer type: by using attribute `vueValidateAlphaNumericCapva`</li>
 *     <li>Minimum length: by using attribute `minlength`</li>
 *     <li>Maximum length: by using attribute `vueValidateLength`</li>
 *     <li>Maximum value of integer: by using attribute `vueValidateMaxInteger`</li>
 *     <li>Minimum value of integer: by using attribute `vueValidateMinInteger`</li>
 * </ul>
 *
 * <b>Note</b>: You need to provide translation keys present in the `i18nBundle` provided.
 */
let VueValidationMessageComponent = /*#__PURE__*/(() => {
  class VueValidationMessageComponent {
    /**
     * Controller importing all necessary services
     * @param appDefaultsService
     * @param translationService
     * @param vueLocaleService
     */
    constructor(appDefaultsService, translationService) {
      this.appDefaultsService = appDefaultsService;
      this.translationService = translationService;
      /**
       * Flag - Whether to show multiple or most specific field level error message.
       */
      this.isSingleFieldLevelErrorEnabled = false;
      /**
       * The input control which shows the highest priority field level error when the input
       * 'isSingleFieldLevelErrorEnabled = true'.
       * default value: 'vueValidateAlphaNumeric'
       * Usage: <vue-validation-message ...[singleFieldLevelErrorPriority]="'vueValidateLength'"></vue-validation-message>
       */
      this.singleFieldLevelErrorPriority = 'vueValidateAlphaNumeric';
    }
    /**
     * Get the validation message for a given validation type.
     *
     * @param type the validation type.
     * @param params the message parameters.
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity */
    getMessage(type, params) {
      if (!this.i18nBundle) {
        this.i18nBundle = this.appDefaultsService.getFieldErrorMessageBundle();
      }
      if (!this.i18nOverrideBundle) {
        this.i18nOverrideBundle = this.appDefaultsService.getFieldErrorMessageBundle();
      }
      switch (type) {
        case 'minlength':
          {
            const param = [params.requiredLength];
            return this.minlength ? this.translationService.getTranslation(this.i18nBundle, this.minlength, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.MinLength', param);
          }
        case 'pattern':
          {
            const param = [params.requiredPattern];
            return this.pattern ? this.translationService.getTranslation(this.i18nBundle, this.pattern, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.RequiredPattern', param);
          }
        case 'required':
          {
            return this.required ? this.translationService.getTranslation(this.i18nBundle, this.required) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.Required');
          }
        case 'vueValidateInteger':
          {
            const param = [];
            return this.vueValidateInteger ? this.translationService.getTranslation(this.i18nBundle, this.vueValidateInteger, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.VueInteger', param);
          }
        case 'vueValidateAlphaNumeric':
          {
            const param = [];
            return this.vueValidateAlphaNumeric ? this.translationService.getTranslation(this.i18nBundle, this.vueValidateAlphaNumeric, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.VueValidateAlphaNumeric', param);
          }
        case 'vueValidateAlphaNumericCapva':
          {
            const param = [];
            return this.vueValidateAlphaNumericCapva ? this.translationService.getTranslation(this.i18nBundle, this.vueValidateAlphaNumericCapva, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.VueValidateAlphaNumericCapva', param);
          }
        case 'vueValidateLength':
          {
            const param = [params.maxLength];
            return this.vueValidateLength ? this.translationService.getTranslation(this.i18nBundle, this.vueValidateLength, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.MaxLength', param);
          }
        case 'vueValidateMaxInteger':
          {
            const param = [params.maxInteger];
            return this.vueMaxInteger ? this.translationService.getTranslation(this.i18nBundle, this.vueMaxInteger, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.VueMaxIntValue', param);
          }
        case 'vueValidateMinInteger':
          {
            const param = [params.minInteger];
            return this.vueMinInteger ? this.translationService.getTranslation(this.i18nBundle, this.vueMinInteger, param) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.VueMinIntValue', param);
          }
        case 'matDatepickerMin':
          {
            const formattedParam = [this.matDatepickerMinValue];
            return this.matDatepickerMin ? this.translationService.getTranslation(this.i18nBundle, this.matDatepickerMin, formattedParam) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.matDatepickerMin', formattedParam);
          }
        case 'matDatepickerMax':
          {
            const formattedParam = [this.matDatepickerMaxValue];
            return this.matDatepickerMax ? this.translationService.getTranslation(this.i18nBundle, this.matDatepickerMax, formattedParam) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.matDatepickerMax', formattedParam);
          }
        case 'matDatepickerParse':
          {
            const paramInvalid = [params.text];
            if (paramInvalid[0]) {
              return this.matDatepickerParse ? this.translationService.getTranslation(this.i18nBundle, this.matDatepickerParse, paramInvalid) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.matDatepickerParse', paramInvalid);
            }
            break;
          }
        case 'ngbDate':
          {
            const paramInvalid = [params.invalid];
            if (paramInvalid[0]) {
              return this.ngbDateInvalid ? this.translationService.getTranslation(this.i18nBundle, this.ngbDateInvalid, paramInvalid) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.ngbInvalid', paramInvalid);
            }
            const paramRequiredBefore = [params.requiredBefore];
            const formattedParam = [`${params.requiredBefore.month}/${params.requiredBefore.day}/${params.requiredBefore.year}`];
            if (paramRequiredBefore[0]) {
              return this.ngbDateRequiredBefore ? this.translationService.getTranslation(this.i18nBundle, this.ngbDateRequiredBefore, formattedParam) : this.translationService.getTranslation(this.i18nOverrideBundle, 'error.ngbDateRequiredBefore', formattedParam);
            }
            break;
          }
        case 'vueCustomValidation':
          {
            // we don't need to translate here. Leaving it to the user to translate at their end.
            // So that the user will have flexibility in adding extra params or formatted params to the message.
            return params;
          }
      }
      return null;
    }
    /**
     * Return the list of errors for this field.
     */
    listOfErrors() {
      return Object.keys(this.isSingleFieldLevelErrorEnabled ? this.getMostSpecificError() : this.control.errors).map(field => this.getMessage(field, this.control.errors[field]));
    }
    /**
     * Whether or not to show the validation error.
     */
    shouldShowErrors() {
      if (this.formError && this.formError.invalidFormSubmit && this.control.errors) {
        return true;
      }
      return this.control && this.control.errors && this.control.dirty;
    }
    /**
     * When there are more than one error messages, return the most specific error for this field.
     */
    getMostSpecificError() {
      const errors = this.control.errors;
      let keyname = '';
      let value = {};
      if (this.singleFieldLevelErrorPriority && this.singleFieldLevelErrorPriority in errors) {
        keyname = this.singleFieldLevelErrorPriority;
        value = errors[keyname];
        return {
          [keyname]: value
        };
      } else if (Object.keys(errors).length > 0) {
        keyname = Object.keys(errors)[0];
        value = errors[keyname];
        return {
          [keyname]: value
        };
      }
      return errors;
    }
    static {
      this.ɵfac = function VueValidationMessageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueValidationMessageComponent)(i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueValidationMessageComponent,
        selectors: [["vue-validation-message"]],
        inputs: {
          control: "control",
          isSingleFieldLevelErrorEnabled: "isSingleFieldLevelErrorEnabled",
          singleFieldLevelErrorPriority: "singleFieldLevelErrorPriority",
          formError: "formError",
          i18nBundle: "i18nBundle",
          i18nOverrideBundle: "i18nOverrideBundle",
          minlength: "minlength",
          pattern: "pattern",
          required: "required",
          vueMaxInteger: "vueMaxInteger",
          vueMinInteger: "vueMinInteger",
          vueValidateInteger: "vueValidateInteger",
          vueValidateLength: "vueValidateLength",
          ngbDateInvalid: "ngbDateInvalid",
          ngbDateRequiredBefore: "ngbDateRequiredBefore",
          matDatepickerMin: "matDatepickerMin",
          matDatepickerMinValue: "matDatepickerMinValue",
          matDatepickerMax: "matDatepickerMax",
          matDatepickerMaxValue: "matDatepickerMaxValue",
          matDatepickerParse: "matDatepickerParse",
          vueValidateAlphaNumeric: "vueValidateAlphaNumeric",
          vueValidateAlphaNumericCapva: "vueValidateAlphaNumericCapva",
          invalidDateFormat: "invalidDateFormat"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "help-inline", "validation-inline"], [1, "validation-fail"], ["icon", "times", 1, "fa", "fa-fw"]],
        template: function VueValidationMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueValidationMessageComponent_Conditional_0_Template, 3, 0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.shouldShowErrors() ? 0 : -1);
          }
        },
        dependencies: [i1$2.FaIconComponent],
        encapsulation: 2
      });
    }
  }
  return VueValidationMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/member-ordering, valid-jsdoc */
/**
 * This component wraps all our input fields. An example usage is:
 *
 * ```
   <vue-control-group labelKey="heroName" [control]="heroName" [formError]="formError">
      <input autocomplete="off"
             class="form-control"
             name="heroName"
             required
             #heroName="ngModel"
             #inputElement
             [(ngModel)]="hero.name">
   </vue-control-group>
 * ```
 *
 * If a custom label is needed, it can be specified as a template variable named `labelFragment`.
 * The properties `text` and `inputName` are provided in the context object.
 * ```
 * <vue-control-group labelKey="heroName" [control]="heroName" [formError]="formError">
 *   <ng-template let-text="text" let-inputName="inputName" #labelFragment>
 *     <label for="{{inputName}}" class="control-label custom-label">{{text}}</label>
 *   </ng-template>
 *   <input autocomplete="off"
 *          class="form-control"
 *          name="heroName"
 *          required
 *          #heroName="ngModel"
 *          #inputElement
 *          [(ngModel)]="hero.name">
 * </vue-control-group>
 * ```
 *
 * In general the component provides the following functionality:
 * <ul>
 *    <li>It will determine if the field it wraps is required or not and will add the required asterisk.</li>
 *    <li>If appropriate, it will translate the labels and turn them red when in error.</li>
 *    <li>It will add the appropriate accessibility tags.</li>
 *    <li>It will add the vue-validation-message component to display standard messages.</li>
 * </ul>
 *
 * TODO: there was functionality about adding a new class based on type of non-input type of field.
 * This still needs to be added if we need it but I did not see a problem without. Anyway
 * from investigation `this.inputElement.nativeElement.tagName` gives `select`, `textarea`, etc.
 * I could not see any visual difference in the UI to warrant it so maybe it is not necessary?
 */
let VueControlGroupComponent = /*#__PURE__*/(() => {
  class VueControlGroupComponent {
    /**
     * Constructs the component and imports all needed services.
     *
     * @param vueTranslationService
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * By default, this component will include the VueValidationMessage component. If you have a custom message and do not
       * want this included, pass true and specific this directive in your projected content instead.
       */
      this.excludeValidationMessage = false;
      /**
       * Flag - Whether to show multiple or most specific field level error message.
       */
      this.isSingleFieldLevelErrorEnabled = false;
      /**
       * This class takes a value of shorter, wider, widest to control width. By default you do not have to pass
       */
      this.widthClass = '';
    }
    /**
     * After the view is checked, check the focus.
     */
    ngAfterViewChecked() {
      this.checkFocus();
    }
    /**
     * Gets the name of the input element, if present, or 'NoInputElementFound' if not.
     */
    getInputElementName() {
      if (this.inputElement && this.inputElement.nativeElement) {
        if (this.inputElement.nativeElement.name) {
          return this.inputElement.nativeElement.name;
        }
        // Used by angular material components.
        if (this.inputElement.nativeElement.attributes && this.inputElement.nativeElement.attributes.getNamedItem('Name')) {
          return this.inputElement.nativeElement.attributes.getNamedItem('Name').nodeValue;
        }
      }
      return 'NoInputElementFound';
    }
    /**
     * Gets the label display text for non-screen reader context.
     */
    getDisplayText() {
      return `${this.getLabelTranslation()} ${this.getRequiredIndicator()}`;
    }
    /**
     * Gets the label translation, if present, or the hardcoded string.
     */
    getLabelTranslation() {
      if (this.label) {
        return this.label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.labelKey);
    }
    /**
     * This method uses will look at the field projected into its content to see if it us required.<br/>
     * Do NOT forget to mark your field with #inputElement
     */
    getRequiredIndicator() {
      if (this.inputElement && this.inputElement.nativeElement) {
        if (this.inputElement.nativeElement.required === true && !this.isAsteriskOptional) {
          return '*';
        } else if (this.inputElement.nativeElement.attributes && (this.inputElement.nativeElement.attributes.getNamedItem('Required') || this.inputElement.nativeElement.attributes.getNamedItem('vueRequired')) && !this.isAsteriskOptional) {
          // Used by angular material components.
          return '*';
        }
      }
      return '';
    }
    /**
     * Checks if input is of a type of 'select', and returns the appropriate style class.
     */
    getSelectTypeClass() {
      if (this.inputElement && this.inputElement.nativeElement) {
        const element = this.inputElement.nativeElement;
        return element.localName === 'select' ? 'custom-dropdown' : '';
      }
      return '';
    }
    /**
     * Gets the screen reader label translation, if present, or the hardcoded string.
     */
    getSrLabelTranslation() {
      if (this.srLabel) {
        return this.srLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.srLabelKey);
    }
    /**
     * Gets the width CSS class.
     */
    getWidthClass() {
      return this.widthClass;
    }
    /**
     * Checks whether we should include validation messages.
     */
    isIncludeValidationMessage() {
      return !this.excludeValidationMessage;
    }
    /**
     * This method returns true of the field is in error.
     */
    isInputFieldInError() {
      if (this.formError && this.formError.invalidFormSubmit && this.control.errors) {
        return true;
      }
      return Boolean(this.control && this.control.errors && this.control.dirty);
    }
    /**
     * Checks whether a label is specified.
     */
    isLabelSpecified() {
      return Boolean(this.label || this.labelKey);
    }
    /**
     * Checks whether a screen reader label is specified for assisted technologies.
     */
    isScreenReaderLabelSpecified() {
      return Boolean(this.srLabel || this.srLabelKey);
    }
    /**
     * Builds the context object for custom label templates.
     */
    getCustomLabelContext() {
      return {
        inputName: this.getInputElementName(),
        text: this.getDisplayText()
      };
    }
    /**
     * If this element has an error, place focus on it.
     */
    checkFocus() {
      if (this.formError && this.formError.fieldInError) {
        if (this.formError.fieldInError === this.getInputElementName()) {
          this.inputElement.nativeElement.focus();
          this.formError.fieldInError = '';
        }
      }
    }
    static {
      this.ɵfac = function VueControlGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueControlGroupComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueControlGroupComponent,
        selectors: [["vue-control-group"]],
        contentQueries: function VueControlGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c1, 7, ElementRef);
            i0.ɵɵcontentQuery(dirIndex, _c2, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelFragment = _t.first);
          }
        },
        inputs: {
          control: "control",
          excludeValidationMessage: "excludeValidationMessage",
          formError: "formError",
          i18nBundle: "i18nBundle",
          isSingleFieldLevelErrorEnabled: "isSingleFieldLevelErrorEnabled",
          label: "label",
          labelKey: "labelKey",
          srLabel: "srLabel",
          srLabelKey: "srLabelKey",
          widthClass: "widthClass",
          isAsteriskOptional: "isAsteriskOptional"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 7,
        vars: 11,
        consts: [[1, "form-group", 3, "ngClass"], [1, "control-label", 3, "for"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "sr-only", 3, "for"], [3, "control", "formError", "isSingleFieldLevelErrorEnabled"]],
        template: function VueControlGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, VueControlGroupComponent_Conditional_1_Template, 2, 2, "label", 1)(2, VueControlGroupComponent_Conditional_2_Template, 1, 2, "ng-container", 2)(3, VueControlGroupComponent_Conditional_3_Template, 4, 2, "label", 3);
            i0.ɵɵelementStart(4, "div");
            i0.ɵɵprojection(5);
            i0.ɵɵtemplate(6, VueControlGroupComponent_Conditional_6_Template, 2, 3, "span");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3, ctx.isInputFieldInError()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isLabelSpecified() && !ctx.labelFragment ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.labelFragment ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isScreenReaderLabelSpecified() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate2("input-container ", ctx.getWidthClass(), " ", ctx.getSelectTypeClass(), "");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isIncludeValidationMessage() ? 6 : -1);
          }
        },
        dependencies: [i2.NgClass, i2.NgTemplateOutlet, VueValidationMessageComponent],
        styles: [".error[_ngcontent-%COMP%]{color:red}"]
      });
    }
  }
  return VueControlGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 This component should be included in every project.  It simply displays a cookie policy if a cookie is not set.
 It allows the user to click on a button to accept.  This will place a cookie for that domain that then stops it
 from showing.

 ```
 <vue-login-header></vue-login-header>
 <vue-navigation></vue-navigation>
 <vue-cookie-policy></vue-cookie-policy>
 <div id="main-content" class="" vueMainContent>
   <vue-loading-indicator></vue-loading-indicator>
   <div class="app-wrapper">
     <div class="app-container">
       <router-outlet></router-outlet>
     </div>
   </div>
 </div>
 <vue-footer></vue-footer>```

 */
let VueCookiePolicyComponent = /*#__PURE__*/(() => {
  class VueCookiePolicyComponent {
    constructor(vueSessionCookieService, vueTranslationService, /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    vueWindow) {
      this.vueSessionCookieService = vueSessionCookieService;
      this.vueTranslationService = vueTranslationService;
      this.vueWindow = vueWindow;
      this.isCookieSet = false;
      this.acceptCookieClass = 'accept-cookie';
      this.policyCookieValue = 'active';
    }
    ngOnInit() {
      this.policyCookieName = `ctbar:${this.vueWindow.location.hostname}`;
      if (this.isPolicyCookieSet()) {
        this.hideCookiePolicyBar();
      } else {
        this.message = '';
        this.learnMore = '';
        this.understand = '';
        this.vueTranslationService.getTranslationBundle('PortalBase', null).subscribe(() => this.loadLiterals());
      }
    }
    /**
     * This is here because vue-cookie-policy is outside of <routerOutlet> and therefore does not respect route resolves.
     * In most cases this bundle is already fetched but the first time could be problematic.
     */
    loadLiterals() {
      this.message = this.vueTranslationService.getTranslation('PortalBase', 'vueCookiePolicy.message');
      this.learnMore = this.vueTranslationService.getTranslation('PortalBase', 'vueCookiePolicy.learnMore');
      this.understand = this.vueTranslationService.getTranslation('PortalBase', 'vueCookiePolicy.understandBtn');
      this.privacyLink = this.vueTranslationService.getTranslation('PortalBase', 'url.Privacy') + '#cookies-and-web-beacons';
      this.showCookiePolicyBar();
    }
    hideCookiePolicyBar() {
      this.setPolicyCookie();
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove(this.acceptCookieClass);
    }
    showCookiePolicyBar() {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add(this.acceptCookieClass);
    }
    getExpireDate() {
      const date = new Date();
      date.setMonth(date.getMonth() + 3);
      return date;
    }
    getDomain() {
      const host = this.vueWindow.location.hostname;
      return host === 'localhost' ? '' : host.split('.').slice(1).join('.');
    }
    setPolicyCookie() {
      this.vueSessionCookieService.setCookie(this.policyCookieName, this.policyCookieValue, {
        domain: this.getDomain(),
        expires: this.getExpireDate(),
        namespace: '',
        path: '/'
      });
      this.isCookieSet = true;
    }
    isPolicyCookieSet() {
      this.isCookieSet = this.vueSessionCookieService.getCookie(this.policyCookieName, '') === this.policyCookieValue;
      return this.isCookieSet;
    }
    static {
      this.ɵfac = function VueCookiePolicyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueCookiePolicyComponent)(i0.ɵɵdirectiveInject(VueSessionCookieService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(WINDOW));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueCookiePolicyComponent,
        selectors: [["vue-cookie-policy"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "cookie-policy-wrapper"], [1, "cookie-policy-container"], [1, "cookie-btns"], ["id", "learnMoreLink", "target", "_blank", 3, "href"], ["id", "acceptPolicy", 1, "btn", "btn-primary", "btn-xs", "cookie-understand", 3, "click"]],
        template: function VueCookiePolicyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueCookiePolicyComponent_Conditional_0_Template, 9, 4, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isCookieSet ? 0 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueCookiePolicyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component produces the standard VUE footer. Insert it in your application's app.component.html
 * (as shown below) and voila.
 *
 *  ```
 <div>
     <vue-navigation></vue-navigation>
     <div id="main-content" class="menu-open" vueMainContent>
         <div class="app-wrapper">
             <div class="app-container">
                  <router-outlet></router-outlet>
             </div>
         </div>
     </div>
     <vue-footer></vue-footer>
 </div>```
 */
let VueFooterComponent = /*#__PURE__*/(() => {
  class VueFooterComponent {
    /**
     * Component constructor.
     *
     * @param vueTranslationService service in charge of translating labels.
     * @param vueUserSessionService service keeping track of user session data.
     */
    constructor(vueTranslationService, vueUserSessionService) {
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      /**
       * If you want to pass custom footer message, Use this.
       */
      this.i18nBundle = 'PortalBase';
      /**
       * The key would you like translated. ()
       */
      this.footerMessageKey = 'footer.footerMessage';
      /**
       * The default Provide Feedback text for DVSA.
       */
      this.defaultDvsaProvideFeedback = 'Provide Feedback';
      /**
       * The default Provide Feedback URL for DVSA.
       */
      this.defaultDvsaProvideFeedbackUrl = 'https://www.pearsonvue.com/dvsa/feedback';
      /**
       * The default Terms URL, in case translations don't work.
       */
      this.defaultTermsUrl = 'https://www.pearsonvue.com/legal/appterms/';
      /**
       * The default Privacy text, in case translations don't work.
       */
      this.defaultPrivacy = 'Privacy';
      /**
       * The default Privacy URL, in case translations don't work.
       */
      this.defaultPrivacyUrl = 'https://www.pearsonvue.com/legal/appprivacy/';
      /**
       * The default Terms text, in case translations don't work.
       */
      this.defaultTerms = 'Terms';
      /**
       * Prefix used to find unusable translations.
       */
      this.untranslatedPrefix = '[@@';
    }
    /**
     * Checks whether the translations were fetched.
     *
     * @returns whether the translations are available.
     */
    areTranslationsAvailable() {
      return this.vueTranslationService.isBundleAvailable(this.i18nBundle);
    }
    /**
     * Get current year so copyright can be kept current without manual intervention.
     *
     * @returns the current year (format yyyy).
     */
    getCurrentYear() {
      return new Date().getFullYear();
    }
    /**
     * The default Footer Message text, in case translations don't work.
     * @returns: string
     */
    defaultFooterMessage() {
      return 'Copyright 1996-' + this.getCurrentYear() + ' Pearson Education Inc. or its affiliate(s). All rights reserved. pvuecopyright@pearson.com';
    }
    /**
     * Get the DVSA Provide Feedback link label translation.
     *
     * @todo get real translation rather than hard coded label.
     * @returns the provide feedback translation.
     */
    getDvsaProvideFeedbackTranslation() {
      return this.defaultDvsaProvideFeedback;
    }
    /**
     * Get the DVSA Provide Feedback URL translation.
     *
     * @todo get real translation rather than hard coded label.
     * @returns the provide feedback URL translation.
     */
    getDvsaProvideFeedbackUrlTranslation() {
      return this.defaultDvsaProvideFeedbackUrl;
    }
    /**
     * Get the Privacy link label translation.
     *
     * @returns the privacy translation.
     */
    getPrivacyTranslation() {
      if (!this.areTranslationsAvailable()) {
        return this.defaultPrivacy;
      }
      const translation = this.vueTranslationService.getTranslation(this.i18nBundle, 'button.Privacy');
      if (translation.startsWith(this.untranslatedPrefix)) {
        return this.defaultPrivacy;
      }
      return translation;
    }
    /**
     * Get the Privacy URL translation.
     *
     * @returns the Privacy URL.
     */
    getPrivacyUrlTranslation() {
      if (!this.areTranslationsAvailable()) {
        return this.defaultPrivacyUrl;
      }
      const translation = this.vueTranslationService.getTranslation(this.i18nBundle, 'url.Privacy');
      if (translation.startsWith(this.untranslatedPrefix)) {
        return this.defaultPrivacyUrl;
      }
      return translation;
    }
    /**
     * Get the Terms URL translation.
     *
     * @returns the Terms URL.
     */
    getTermsUrlTranslation() {
      if (!this.areTranslationsAvailable()) {
        return this.defaultTermsUrl;
      }
      const translation = this.vueTranslationService.getTranslation(this.i18nBundle, 'url.Terms');
      if (translation.startsWith(this.untranslatedPrefix)) {
        return this.defaultTermsUrl;
      }
      return translation;
    }
    /**
     * Get the Terms link label translation.
     *
     * @returns the terms translation.
     */
    getTermsTranslation() {
      if (!this.areTranslationsAvailable()) {
        return this.defaultTerms;
      }
      const translation = this.vueTranslationService.getTranslation(this.i18nBundle, 'button.Terms');
      if (translation.startsWith(this.untranslatedPrefix)) {
        return this.defaultTerms;
      }
      return translation;
    }
    /**
     * Checks whether the current client is DVSA.
     *
     * @returns whether DVSA is the current client.
     */
    isCurrentClientDvsa() {
      return this.getBrandingClientCode() === 'DSA';
    }
    /**
     * Get the Footer Message translation.
     *
     * @returns the Footer Message.
     */
    getFooterMessageTranslation() {
      if (this.footerMessage) {
        return this.footerMessage;
      }
      if (!this.footerMessageKey) {
        return this.defaultFooterMessage();
      }
      const translation = this.vueTranslationService.getTranslation(this.i18nBundle, this.footerMessageKey, [`${this.getCurrentYear()}`]);
      if (!translation || translation.startsWith(this.untranslatedPrefix)) {
        return this.defaultFooterMessage();
      }
      return translation;
    }
    /**
     * Get the branding code of the current client.
     *
     * @returns branding code.
     */
    getBrandingClientCode() {
      if (this.vueUserSessionService.getBrandingClientCode()) {
        return this.vueUserSessionService.getBrandingClientCode().toUpperCase();
      }
      return null;
    }
    static {
      this.ɵfac = function VueFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueFooterComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueFooterComponent,
        selectors: [["vue-footer"]],
        inputs: {
          i18nBundle: "i18nBundle",
          footerMessage: "footerMessage",
          footerMessageKey: "footerMessageKey"
        },
        standalone: false,
        decls: 12,
        vars: 7,
        consts: [["id", "footer-container", 3, "hidden"], [1, "app-container"], ["role", "contentinfo"], [1, "footer-content"], [1, "links"], ["id", "termsLink", "target", "_blank", 3, "href"], ["id", "privacyLink", "target", "_blank", 3, "href"], ["id", "dvsaProvideFeedbackLink", "target", "_blank", 3, "href"]],
        template: function VueFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "footer", 2)(3, "div", 3)(4, "p");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4)(7, "a", 5);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "a", 6);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, VueFooterComponent_Conditional_11_Template, 2, 2, "a", 7);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", !ctx.areTranslationsAvailable());
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.getFooterMessageTranslation(), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("href", ctx.getTermsUrlTranslation(), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.getTermsTranslation(), " ");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("href", ctx.getPrivacyUrlTranslation(), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.getPrivacyTranslation(), " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isCurrentClientDvsa() ? 11 : -1);
          }
        },
        styles: ["a[_ngcontent-%COMP%]{text-decoration:underline}"]
      });
    }
  }
  return VueFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable valid-jsdoc */
/**
 * This component provides action buttons for a given form.<br />
 * There are four possible buttons, and each can either be a typical button or a confirm-style button:
 * <ul>
 *     <li>Primary</li>
 *     <li>Secondary</li>
 *     <li>Tertiary</li>
 *     <li>Default</li>
 * </ul>
 *
 * TODO:
 * <ol>
 *     <li>Functionality to hide buttons based on users privileges.</li>
 * </ol>
 *
 * Example:
 * ```
 * <vue-panel>
 * 	   <vue-form-buttons
 * 	            i18nBundle="PortalBase"
 * 	            primaryLabelKey="primaryBtn"
 * 	            (primaryButtonClicked)="primaryClick($event)"
 * 	            secondaryLabelKey="secondaryBtn"
 * 	            (secondaryButtonClicked)="secondaryClick($event)"
 * 	            tertiaryLabel="Third"
 * 	            (tertiaryButtonClicked)="tertiaryClick($event)"
 * 	            defaultLabelKey="defaultBtn"
 * 	            (defaultButtonClicked)="defaultClick($event)">
 * 	   </vue-form-buttons>
 * </vue-panel>
 * ```
 */
let VueFormButtonsComponent = /*#__PURE__*/(() => {
  class VueFormButtonsComponent {
    /**
     * Default constructor.
     */
    constructor(vueTranslationService, vueUserSessionService) {
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      /**
       * The id for the primary button
       *
       * @default 'primaryBtn'
       */
      this.primaryId = 'primaryBtn';
      /**
       * The id for the primary dropdown
       *
       * @default 'dropdownBasic1'
       */
      this.primaryDropdownId = 'dropdownBasic1';
      /**
       * The id for the primary confirm button
       *
       * @default 'primary-confirm-true'
       */
      this.primaryConfirmId = 'primary-confirm-true';
      /**
       * The id for the primary cancel button
       *
       * @default 'primary-confirm-false'
       */
      this.primaryCancelId = 'primary-confirm-false';
      /**
       * The id for the default button
       *
       * @default 'defaultBtn'
       */
      this.defaultId = 'defaultBtn';
      /**
       * The id for the default dropdown
       *
       * @default 'dropdownBasic2'
       */
      this.defaultDropdownId = 'dropdownBasic2';
      /**
       * The id for the default confirm button
       *
       * @default 'default-confirm-true'
       */
      this.defaultConfirmId = 'default-confirm-true';
      /**
       * The id for the default cancel button
       *
       * @default 'default-confirm-false'
       */
      this.defaultCancelId = 'default-confirm-false';
      /**
       * The id for the secondary button
       *
       * @default 'secondaryBtn'
       */
      this.secondaryId = 'secondaryBtn';
      /**
       * The id for the secondary dropdown
       *
       * @default 'dropdownBasic3'
       */
      this.secondaryDropdownId = 'dropdownBasic3';
      /**
       * The id for the secondary confirm button
       *
       * @default 'secondary-confirm-true'
       */
      this.secondaryConfirmId = 'secondary-confirm-true';
      /**
       * The id for the secondary cancel button
       *
       * @default 'secondary-confirm-false'
       */
      this.secondaryCancelId = 'secondary-confirm-false';
      /**
       * The id for the tertiary button
       *
       * @default 'tertiaryBtn'
       */
      this.tertiaryId = 'tertiaryBtn';
      /**
       * The id for the tertiary dropdown
       *
       * @default 'dropdownBasic4'
       */
      this.tertiaryDropdownId = 'dropdownBasic4';
      /**
       * The id for the tertiary confirm button
       *
       * ! This is the same ID as secondary, which breaks web standards
       *
       * @default 'default-confirm-true'
       */
      this.tertiaryConfirmId = 'default-confirm-true';
      /**
       * The id for the tertiary cancel button
       *
       * ! This is the same ID as secondary, which breaks web standards
       *
       * @default 'default-confirm-false'
       */
      this.tertiaryCancelId = 'default-confirm-false';
      /**
       * Whether the button bar is standalone.
       * <ul>
       *     <li>true - not part of another panel, but floating on the page.</li>
       *     <li>false - part of a panel, but separated by a rule.</li>
       * </ul>
       */
      this.standalone = false;
      /**
       * Is the primary button visible?
       * Defaults to true.
       */
      this.primaryVisible = true;
      /**
       * Event emitted when the primary button is clicked.
       */
      this.primaryButtonClicked = new EventEmitter();
      /**
       * Event emitted when the primary button's cancel action is clicked.
       */
      this.primaryCancelClicked = new EventEmitter();
      /**
       * Event emitted when the primary button's confirm action is clicked.
       */
      this.primaryConfirmClicked = new EventEmitter();
      /**
       * Is the secondary button visible?
       * Defaults to true.
       */
      this.secondaryVisible = true;
      /**
       * Event emitted when the secondary button is clicked.
       */
      this.secondaryButtonClicked = new EventEmitter();
      /**
       * Event emitted when the secondary button's cancel action is clicked.
       */
      this.secondaryCancelClicked = new EventEmitter();
      /**
       * Event emitted when the secondary button's confirm action is clicked.
       */
      this.secondaryConfirmClicked = new EventEmitter();
      /**
       * Is the tertiary button visible?
       * Defaults to true.
       */
      this.tertiaryVisible = true;
      /**
       * Event emitted when the tertiary button is clicked.
       */
      this.tertiaryButtonClicked = new EventEmitter();
      /**
       * Event emitted when the tertiary button's cancel action is clicked.
       */
      this.tertiaryCancelClicked = new EventEmitter();
      /**
       * Event emitted when the tertiary button's confirm action is clicked.
       */
      this.tertiaryConfirmClicked = new EventEmitter();
      /**
       * The default button's position.
       * Defaults to 'btn-right'.
       * <ul>
       *     <li>'btn-left' - will be on the left of the panel.</li>
       *     <li>'btn-right' - will be on the right of the panel.</li>
       * </ul>
       */
      this.defaultPosition = 'btn-right';
      /**
       * Is the default button visible?
       * Defaults to true.
       */
      this.defaultVisible = true;
      /**
       * Event emitted when the default button is clicked.
       */
      this.defaultButtonClicked = new EventEmitter();
      /**
       * Event emitted when the default button's cancel action is clicked.
       */
      this.defaultCancelClicked = new EventEmitter();
      /**
       * Event emitted when the default button's confirm action is clicked.
       */
      this.defaultConfirmClicked = new EventEmitter();
      /**
       * The default placement of the confirm drop-down should be the default from NgbDropdown.
       */
      this.defaultConfirmPlacement = new NgbDropdownConfig().placement;
    }
    /**
     * Gets the CSS class based on whether the button bar is standalone or not.
     * Standalone means it is form buttons on a panel but not with other things.
     * If it has other things, we add a class that puts a horizontal rule.
     *
     * @returns the class to use depending on whether the buttons are standalone.
     */
    isStandalone() {
      return this.standalone ? '' : 'form-btn-section';
    }
    // ========== PRIMARY BUTTON METHODS
    /**
     * Gets the translated label for the primary button.<br />
     *
     * @returns the translated button label.
     */
    getPrimaryButtonTranslation() {
      if (this.primaryLabel) {
        return this.primaryLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryLabelKey);
    }
    /**
     * Gets the translated label for the primary button's cancel label.
     *
     * @returns the translated cancel label.
     */
    getPrimaryCancelTranslation() {
      if (this.primaryCancelLabel) {
        return this.primaryCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryCancelLabelKey);
    }
    /**
     * Gets the translated header for the primary button's confirmation drop-down.
     *
     * @returns the translated confirm header.
     */
    getPrimaryConfirmHeaderTranslation() {
      if (this.primaryConfirmHeaderLabel) {
        return this.primaryConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryConfirmHeaderLabelKey);
    }
    /**
     * Get the placement of the primary confirm button.
     *
     * @returns the placement of the primary confirm button.
     */
    getPrimaryConfirmPlacement() {
      return this.primaryConfirmPlacementOverride ? this.primaryConfirmPlacementOverride : this.defaultConfirmPlacement;
    }
    /**
     * Gets the translated header for the primary button's confirmation label.
     *
     * @returns the translated confirm label.
     */
    getPrimaryConfirmTranslation() {
      if (this.primaryConfirmLabel) {
        return this.primaryConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryConfirmLabelKey);
    }
    /**
     * Checks whether the primary button is desired and user is authorized.
     */
    isPrimaryButtonDesiredAndAuthorized() {
      if (this.primaryLabel || this.primaryLabelKey) {
        if (this.primaryRoles) {
          return this.vueUserSessionService.userHasOneRole(this.primaryRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the primary button should be a confirm button.
     */
    isPrimaryConfirmStyleDesired() {
      return Boolean(this.primaryConfirmHeaderLabelKey || this.primaryConfirmHeaderLabel);
    }
    /**
     * Checks whether the primary button should be hidden.
     */
    isPrimaryHidden() {
      return !this.primaryVisible;
    }
    /**
     * Function called when the primary button is clicked.
     * Emits a 'primaryButtonClicked' event.
     */
    primaryButtonClick() {
      this.primaryButtonClicked.emit();
    }
    /**
     * Function called when the primary button's cancel action is clicked.
     * Emits a 'primaryCancelClicked' event.
     */
    primaryCancelClick() {
      this.primaryCancelClicked.emit();
    }
    /**
     * Function called when the primary button's confirm action is clicked.
     * Emits a 'primaryConfirmClicked' event.
     */
    primaryConfirmClick() {
      this.primaryConfirmClicked.emit();
    }
    // ========== SECONDARY BUTTON METHODS
    /**
     * Gets the translated label for the secondary button.<br />
     *
     * @returns the translated button label.
     */
    getSecondaryButtonTranslation() {
      if (this.secondaryLabel) {
        return this.secondaryLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryLabelKey);
    }
    /**
     * Gets the translated label for the secondary button's cancel label.
     *
     * @returns the translated cancel label.
     */
    getSecondaryCancelTranslation() {
      if (this.secondaryCancelLabel) {
        return this.secondaryCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryCancelLabelKey);
    }
    /**
     * Gets the translated header for the secondary button's confirmation drop-down.
     *
     * @returns the translated confirm header.
     */
    getSecondaryConfirmHeaderTranslation() {
      if (this.secondaryConfirmHeaderLabel) {
        return this.secondaryConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryConfirmHeaderLabelKey);
    }
    /**
     * Get the placement of the secondary confirm button.
     *
     * @returns the placement of the secondary confirm button.
     */
    getSecondaryConfirmPlacement() {
      return this.secondaryConfirmPlacementOverride ? this.secondaryConfirmPlacementOverride : this.defaultConfirmPlacement;
    }
    /**
     * Gets the translated header for the secondary button's confirmation label.
     *
     * @returns the translated confirm label.
     */
    getSecondaryConfirmTranslation() {
      if (this.secondaryConfirmLabel) {
        return this.secondaryConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryConfirmLabelKey);
    }
    /**
     * Checks whether the secondary button is desired and user is authorized.
     */
    isSecondaryButtonDesiredAndAuthorized() {
      if (this.secondaryLabel || this.secondaryLabelKey) {
        if (this.secondaryRoles) {
          return this.vueUserSessionService.userHasOneRole(this.secondaryRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the secondary button should be a confirm button.
     */
    isSecondaryConfirmStyleDesired() {
      return Boolean(this.secondaryConfirmHeaderLabelKey || this.secondaryConfirmHeaderLabel);
    }
    /**
     * Checks whether the secondary button should be hidden.
     */
    isSecondaryHidden() {
      return !this.secondaryVisible;
    }
    /**
     * Function called when the secondary button is clicked.
     * Emits a 'secondaryButtonClicked' event.
     */
    secondaryButtonClick() {
      this.secondaryButtonClicked.emit();
    }
    /**
     * Function called when the secondary button's cancel action is clicked.
     * Emits a 'secondaryCancelClicked' event.
     */
    secondaryCancelClick() {
      this.secondaryCancelClicked.emit();
    }
    /**
     * Function called when the secondary button's confirm action is clicked.
     * Emits a 'secondaryConfirmClicked' event.
     */
    secondaryConfirmClick() {
      this.secondaryConfirmClicked.emit();
    }
    // ========== TERTIARY BUTTON METHODS
    /**
     * Gets the translated label for the tertiary button.<br />
     *
     * @returns the translated button label.
     */
    getTertiaryButtonTranslation() {
      if (this.tertiaryLabel) {
        return this.tertiaryLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.tertiaryLabelKey);
    }
    /**
     * Gets the translated label for the tertiary button's cancel label.
     *
     * @returns the translated cancel label.
     */
    getTertiaryCancelTranslation() {
      if (this.tertiaryCancelLabel) {
        return this.tertiaryCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.tertiaryCancelLabelKey);
    }
    /**
     * Gets the translated header for the tertiary button's confirmation drop-down.
     *
     * @returns the translated confirm header.
     */
    getTertiaryConfirmHeaderTranslation() {
      if (this.tertiaryConfirmHeaderLabel) {
        return this.tertiaryConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.tertiaryConfirmHeaderLabelKey);
    }
    /**
     * Get the placement of the tertiary confirm button.
     *
     * @returns the placement of the tertiary confirm button.
     */
    getTertiaryConfirmPlacement() {
      return this.tertiaryConfirmPlacementOverride ? this.tertiaryConfirmPlacementOverride : this.defaultConfirmPlacement;
    }
    /**
     * Gets the translated header for the tertiary button's confirmation label.
     *
     * @returns the translated confirm label.
     */
    getTertiaryConfirmTranslation() {
      if (this.tertiaryConfirmLabel) {
        return this.tertiaryConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.tertiaryConfirmLabelKey);
    }
    /**
     * Checks whether the tertiary button is desired and user is authorized.
     */
    isTertiaryButtonDesiredAndAuthorized() {
      if (this.tertiaryLabel || this.tertiaryLabelKey) {
        if (this.tertiaryRoles) {
          return this.vueUserSessionService.userHasOneRole(this.tertiaryRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the tertiary button should be a confirm button.
     */
    isTertiaryConfirmStyleDesired() {
      return Boolean(this.tertiaryConfirmHeaderLabelKey || this.tertiaryConfirmHeaderLabel);
    }
    /**
     * Checks whether the tertiary button should be hidden.
     */
    isTertiaryHidden() {
      return !this.tertiaryVisible;
    }
    /**
     * Function called when the tertiary button is clicked.
     * Emits a 'tertiaryButtonClicked' event.
     */
    tertiaryButtonClick() {
      this.tertiaryButtonClicked.emit();
    }
    /**
     * Function called when the tertiary button's cancel action is clicked.
     * Emits a 'tertiaryCancelClicked' event.
     */
    tertiaryCancelClick() {
      this.tertiaryCancelClicked.emit();
    }
    /**
     * Function called when the secondary button's confirm action is clicked.
     * Emits a 'secondaryConfirmClicked' event.
     */
    tertiaryConfirmClick() {
      this.tertiaryConfirmClicked.emit();
    }
    // ========== DEFAULT BUTTON METHODS
    /**
     * Function called when the default button is clicked.
     * Emits a 'defaultButtonClicked' event.
     */
    defaultButtonClick() {
      this.defaultButtonClicked.emit();
    }
    /**
     * Function called when the default button's cancel action is clicked.
     * Emits a 'defaultCancelClicked' event.
     */
    defaultCancelClick() {
      this.defaultCancelClicked.emit();
    }
    /**
     * Function called when the default button's confirm action is clicked.
     * Emits a 'defaultConfirmClicked' event.
     */
    defaultConfirmClick() {
      this.defaultConfirmClicked.emit();
    }
    /**
     * Gets the translated label for the default button.<br />
     *
     * @returns the translated button label.
     */
    getDefaultButtonTranslation() {
      if (this.defaultLabel) {
        return this.defaultLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultLabelKey);
    }
    /**
     * Gets the translated label for the default button's cancel label.
     *
     * @returns the translated cancel label.
     */
    getDefaultCancelTranslation() {
      if (this.defaultCancelLabel) {
        return this.defaultCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultCancelLabelKey);
    }
    /**
     * Gets the translated header for the default button's confirmation drop-down.
     *
     * @returns the translated confirm header.
     */
    getDefaultConfirmHeaderTranslation() {
      if (this.defaultConfirmHeaderLabel) {
        return this.defaultConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultConfirmHeaderLabelKey);
    }
    /**
     * Get the placement of the default confirm button.
     *
     * @returns the placement of the default confirm button.
     */
    getDefaultConfirmPlacement() {
      return this.defaultConfirmPlacementOverride ? this.defaultConfirmPlacementOverride : this.defaultConfirmPlacement;
    }
    /**
     * Gets the translated header for the default button's confirmation label.
     *
     * @returns the translated confirm label.
     */
    getDefaultConfirmTranslation() {
      if (this.defaultConfirmLabel) {
        return this.defaultConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultConfirmLabelKey);
    }
    /**
     * Gets the position of the default button.
     */
    getDefaultPosition() {
      return this.defaultPosition;
    }
    /**
     * Checks whether the default button is desired and user is authorized.
     */
    isDefaultButtonDesiredAndAuthorized() {
      if (this.defaultLabel || this.defaultLabelKey) {
        if (this.defaultRoles) {
          return this.vueUserSessionService.userHasOneRole(this.defaultRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the default button should be a confirm button.
     */
    isDefaultConfirmStyleDesired() {
      return Boolean(this.defaultConfirmHeaderLabelKey || this.defaultConfirmHeaderLabel);
    }
    /**
     * Checks whether the default button should be hidden.
     */
    isDefaultHidden() {
      return !this.defaultVisible;
    }
    static {
      this.ɵfac = function VueFormButtonsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueFormButtonsComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueFormButtonsComponent,
        selectors: [["vue-form-buttons"]],
        inputs: {
          primaryId: "primaryId",
          primaryDropdownId: "primaryDropdownId",
          primaryConfirmId: "primaryConfirmId",
          primaryCancelId: "primaryCancelId",
          defaultId: "defaultId",
          defaultDropdownId: "defaultDropdownId",
          defaultConfirmId: "defaultConfirmId",
          defaultCancelId: "defaultCancelId",
          secondaryId: "secondaryId",
          secondaryDropdownId: "secondaryDropdownId",
          secondaryConfirmId: "secondaryConfirmId",
          secondaryCancelId: "secondaryCancelId",
          tertiaryId: "tertiaryId",
          tertiaryDropdownId: "tertiaryDropdownId",
          tertiaryConfirmId: "tertiaryConfirmId",
          tertiaryCancelId: "tertiaryCancelId",
          i18nBundle: "i18nBundle",
          standalone: "standalone",
          primaryCancelLabel: "primaryCancelLabel",
          primaryCancelLabelKey: "primaryCancelLabelKey",
          primaryConfirmHeaderLabel: "primaryConfirmHeaderLabel",
          primaryConfirmHeaderLabelKey: "primaryConfirmHeaderLabelKey",
          primaryConfirmLabel: "primaryConfirmLabel",
          primaryConfirmLabelKey: "primaryConfirmLabelKey",
          primaryConfirmPlacementOverride: "primaryConfirmPlacementOverride",
          primaryLabel: "primaryLabel",
          primaryLabelKey: "primaryLabelKey",
          primaryVisible: "primaryVisible",
          primaryRoles: "primaryRoles",
          secondaryCancelLabel: "secondaryCancelLabel",
          secondaryCancelLabelKey: "secondaryCancelLabelKey",
          secondaryConfirmHeaderLabel: "secondaryConfirmHeaderLabel",
          secondaryConfirmHeaderLabelKey: "secondaryConfirmHeaderLabelKey",
          secondaryConfirmLabel: "secondaryConfirmLabel",
          secondaryConfirmLabelKey: "secondaryConfirmLabelKey",
          secondaryConfirmPlacementOverride: "secondaryConfirmPlacementOverride",
          secondaryLabel: "secondaryLabel",
          secondaryLabelKey: "secondaryLabelKey",
          secondaryVisible: "secondaryVisible",
          secondaryRoles: "secondaryRoles",
          tertiaryCancelLabel: "tertiaryCancelLabel",
          tertiaryCancelLabelKey: "tertiaryCancelLabelKey",
          tertiaryConfirmHeaderLabel: "tertiaryConfirmHeaderLabel",
          tertiaryConfirmHeaderLabelKey: "tertiaryConfirmHeaderLabelKey",
          tertiaryConfirmLabel: "tertiaryConfirmLabel",
          tertiaryConfirmLabelKey: "tertiaryConfirmLabelKey",
          tertiaryConfirmPlacementOverride: "tertiaryConfirmPlacementOverride",
          tertiaryLabel: "tertiaryLabel",
          tertiaryLabelKey: "tertiaryLabelKey",
          tertiaryVisible: "tertiaryVisible",
          tertiaryRoles: "tertiaryRoles",
          defaultCancelLabel: "defaultCancelLabel",
          defaultCancelLabelKey: "defaultCancelLabelKey",
          defaultConfirmHeaderLabel: "defaultConfirmHeaderLabel",
          defaultConfirmHeaderLabelKey: "defaultConfirmHeaderLabelKey",
          defaultConfirmLabel: "defaultConfirmLabel",
          defaultConfirmLabelKey: "defaultConfirmLabelKey",
          defaultConfirmPlacementOverride: "defaultConfirmPlacementOverride",
          defaultLabel: "defaultLabel",
          defaultLabelKey: "defaultLabelKey",
          defaultPosition: "defaultPosition",
          defaultVisible: "defaultVisible",
          defaultRoles: "defaultRoles"
        },
        outputs: {
          primaryButtonClicked: "primaryButtonClicked",
          primaryCancelClicked: "primaryCancelClicked",
          primaryConfirmClicked: "primaryConfirmClicked",
          secondaryButtonClicked: "secondaryButtonClicked",
          secondaryCancelClicked: "secondaryCancelClicked",
          secondaryConfirmClicked: "secondaryConfirmClicked",
          tertiaryButtonClicked: "tertiaryButtonClicked",
          tertiaryCancelClicked: "tertiaryCancelClicked",
          tertiaryConfirmClicked: "tertiaryConfirmClicked",
          defaultButtonClicked: "defaultButtonClicked",
          defaultCancelClicked: "defaultCancelClicked",
          defaultConfirmClicked: "defaultConfirmClicked"
        },
        standalone: false,
        ngContentSelectors: _c5,
        decls: 6,
        vars: 7,
        consts: [["ngbDropdown", "", 1, "confirm-dropdown", 3, "placement"], ["ngbDropdownToggle", "", 1, "btn", "btn-primary", "btn-right", 3, "id"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-left"], [1, "dropdown-header"], ["ngbDropdownItem", "", 3, "click", "id", "routerLink"], ["type", "button", 1, "btn", "btn-primary", "btn-right", 3, "id"], ["type", "button", 1, "btn", "btn-primary", "btn-right", 3, "click", "id"], ["ngbDropdownToggle", "", 3, "id"], ["type", "button", 3, "id", "class"], ["type", "button", 3, "click", "id"], ["ngbDropdownToggle", "", 1, "btn", "btn-default", "btn-right", "vue-form-default-btn", 3, "id"], ["type", "button", 1, "btn", "btn-default", "btn-right", "vue-form-default-btn", 3, "id"], ["type", "button", 1, "btn", "btn-default", "btn-right", "vue-form-default-btn", 3, "click", "id"], ["ngbDropdownToggle", "", 1, "btn", "btn-default", "btn-left", 3, "id"], ["type", "button", 1, "btn", "btn-default", "btn-left", 3, "id"], ["type", "button", 1, "btn", "btn-default", "btn-left", 3, "click", "id"]],
        template: function VueFormButtonsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, VueFormButtonsComponent_Conditional_2_Template, 3, 2, "span")(3, VueFormButtonsComponent_Conditional_3_Template, 3, 2, "span")(4, VueFormButtonsComponent_Conditional_4_Template, 3, 2, "span")(5, VueFormButtonsComponent_Conditional_5_Template, 3, 2, "span");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("btn-section ", ctx.isStandalone(), "");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isPrimaryButtonDesiredAndAuthorized() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDefaultButtonDesiredAndAuthorized() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isTertiaryButtonDesiredAndAuthorized() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isSecondaryButtonDesiredAndAuthorized() ? 5 : -1);
          }
        },
        dependencies: [i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i1$1.RouterLink],
        styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .show[_ngcontent-%COMP%] > .btn-primary.dropdown-toggle[_ngcontent-%COMP%]{background-color:#005a70;border-color:#1a4b6c;color:#fff}.btn-section[_ngcontent-%COMP%]   .vue-form-default-btn[_ngcontent-%COMP%]{margin-inline-end:5px}"]
      });
    }
  }
  return VueFormButtonsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This components provides a translated label.
 *
 * **Note**: This component does not have a non-translated version
 * as the user could just hard code on their page.
 *
 * Usage:
```
<vue-label i18nBundle="portal" labelKey="address.useBilling"></vue-label>
```
 */
let VueLabelComponent = /*#__PURE__*/(() => {
  class VueLabelComponent {
    /**
     * Component constructor.
     *
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
    }
    /**
     * On component initialization, get the label's translation.
     */
    ngOnInit() {
      this.translation = this.vueTranslationService.getTranslation(this.i18nBundle, this.labelKey);
    }
    static {
      this.ɵfac = function VueLabelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLabelComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLabelComponent,
        selectors: [["vue-label"]],
        inputs: {
          i18nBundle: "i18nBundle",
          labelKey: "labelKey"
        },
        standalone: false,
        decls: 2,
        vars: 1,
        template: function VueLabelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.translation);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A Locale is used to translate the application. It consists of a locale code, which
 * indicates which language and country to translate for. For example, `en-US` vs. `en-GB`
 * would be two different locales for english, but one would be for US english while the other
 * for British english.
 */
class Locale {
  /**
   * Locale constructor.
   *
   * @param code language code.
   * @param name human readable name of the language.
   */
  constructor(code, name) {
    this.code = code;
    this.name = name;
  }
}
let VueLocaleSelectComponent = /*#__PURE__*/(() => {
  class VueLocaleSelectComponent {
    /**
     * Builds the component.
     *
     * @param vueAppDefaultsService service used to fetch application-wide default attributes.
     * @param vueLocaleService service used to keep track of the current locale of the app.
     */
    constructor(vueAppDefaultsService, vueLocaleService, vueTranslationService) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueLocaleService = vueLocaleService;
      this.vueTranslationService = vueTranslationService;
      this.locales = [];
      this.selectedLocale = null;
      this.isLocalizationEnabled = this.vueAppDefaultsService.getLocalizationEnabled();
    }
    /**
     * On component initialization...
     */
    ngOnInit() {
      this.initializeLocales();
      this.localeEnabledSub = this.vueAppDefaultsService.localizationEnabledChanges.subscribe(isLocalizationEnabled => {
        this.isLocalizationEnabled = isLocalizationEnabled;
      });
      this.selectedLocaleChangedSub = this.vueLocaleService.selectedLocaleChanged.subscribe(value => {
        if (value.code !== this.selectedLocale) {
          this.selectedLocale = value.code;
        }
      });
    }
    ngOnDestroy() {
      this.localeEnabledSub.unsubscribe();
      this.selectedLocaleChangedSub.unsubscribe();
      this.supportedLocalesChangedSub.unsubscribe();
    }
    /**
     * @returns the proper translation for the aria label
     */
    getLocaleAriaLabelTranslation() {
      if (this.i18nBundle && this.localeSelectAriaLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.localeSelectAriaLabelKey);
      }
      return this.localeSelectAriaLabel;
    }
    onLocaleChanged(event) {
      if (event) {
        this.vueLocaleService.setSelectedLocale(event);
      } else {
        const locale = this.locales.find(arg => {
          return this.selectedLocale === arg.code;
        });
        if (locale) {
          this.vueLocaleService.setSelectedLocale(locale);
        }
      }
    }
    /**
     * @param code the code has language-code and country-code(ex: en-US, ja-JP)
     * @returns the language code (ex: en, ja)
     */
    getLanguageCode(code) {
      if (code) {
        return code.split('-')[0];
      }
      return 'en';
    }
    /**
     * Initializes supported locales, and listen for supported locales changes.
     */
    initializeLocales() {
      this.supportedLocalesChangedSub = this.vueLocaleService.supportedLocalesChanged.subscribe(value => {
        this.setLocales(value);
      });
      this.vueLocaleService.loadSupportedLocales(this.vueAppDefaultsService.getAppLocales());
    }
    retrieveDefaultLocale() {
      let locale = new Locale('', '');
      if (this.locales && this.locales.length > 0) {
        locale = this.locales[0];
      }
      return locale;
    }
    setLocales(locales) {
      this.locales = locales;
      const locale = this.vueLocaleService.getSelectedLocale();
      if (locale) {
        this.selectedLocale = locale.code;
      } else {
        this.defaultLocale = this.retrieveDefaultLocale();
        this.selectedLocale = this.defaultLocale.code;
        this.vueLocaleService.setSelectedLocale(this.defaultLocale);
      }
    }
    static {
      this.ɵfac = function VueLocaleSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLocaleSelectComponent)(i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueLocaleService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLocaleSelectComponent,
        selectors: [["vue-select-locale"]],
        viewQuery: function VueLocaleSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(NgSelectComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.select = _t.first);
          }
        },
        inputs: {
          localeSelectAriaLabel: "localeSelectAriaLabel",
          localeSelectAriaLabelKey: "localeSelectAriaLabelKey",
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["inputElement", ""], [1, "language-selector"], ["icon", "globe-americas", 1, "fa", "fa-fw"], [1, "custom-dropdown"], ["bindLabel", "name", "bindValue", "code", 3, "change", "ngModelChange", "clearable", "items", "searchable", "ngModel"], ["ng-option-tmp", ""]],
        template: function VueLocaleSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueLocaleSelectComponent_Conditional_0_Template, 6, 5, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isLocalizationEnabled ? 0 : -1);
          }
        },
        dependencies: [i6.NgControlStatus, i6.NgModel, i1$2.FaIconComponent, i6$1.NgSelectComponent, i6$1.NgOptionTemplateDirective],
        encapsulation: 2
      });
    }
  }
  return VueLocaleSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component should be included in every project as shown below. It will show itself on any page that the
 * user is not authenticated.
 *
 * Usage:
 ```
 <vue-login-header></vue-login-header>
 <vue-navigation></vue-navigation>
 <vue-cookie-policy></vue-cookie-policy>
 <div id="main-content" vueMainContent>
   <vue-loading-indicator></vue-loading-indicator>
   <div class="app-wrapper">
     <div class="app-container">
       <router-outlet></router-outlet>
     </div>
   </div>
 </div>
 <vue-footer></vue-footer>
 ```
 */
let VueLoginHeaderComponent = /*#__PURE__*/(() => {
  class VueLoginHeaderComponent {
    /**
     * Component constructor.
     *
     * @param vueUserSessionService service keeping track of user session data.
     */
    constructor(vueUserSessionService) {
      this.vueUserSessionService = vueUserSessionService;
      /**
       * Whether to show transcluded content.
       *
       * <b>NOTE</b>: Do not use unless specifically asked by the UX team.
       */
      this.transclude = false;
      /**
       * Whether or not to hide VueLocaleSelect component.
       *
       * <b>NOTE</b>: Do not use unless specifically asked by the UX team.
       */
      this.hideLocaleSelect = false;
      /**
       * the aria label for the locale selection dropdown
       */
      this.localeSelectAriaLabel = 'select language';
    }
    /**
     * Get the client code for branding purposes.
     *
     * @returns the client code.
     */
    getBrandingClientCode() {
      return this.vueUserSessionService.getBrandingClientCode();
    }
    /**
     * Checks whether the user is authenticated.
     *
     * @returns whether the user is authenticated.
     */
    isUserAuthenticated() {
      return this.vueUserSessionService.isUserAuthenticated();
    }
    static {
      this.ɵfac = function VueLoginHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLoginHeaderComponent)(i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLoginHeaderComponent,
        selectors: [["vue-login-header"]],
        inputs: {
          transclude: "transclude",
          hideLocaleSelect: "hideLocaleSelect",
          localeSelectAriaLabel: "localeSelectAriaLabel",
          localeSelectAriaLabelKey: "localeSelectAriaLabelKey",
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        consts: [[1, "pearson-header-neutral", "dashboard", "custom-brand-color", 3, "ngClass"], [1, "container"], [1, "flex-container"], [1, "pearson"], [1, "always-learning"], [3, "localeSelectAriaLabel", "i18nBundle", "localeSelectAriaLabelKey"]],
        template: function VueLoginHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, VueLoginHeaderComponent_Conditional_0_Template, 10, 3, "header", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isUserAuthenticated() ? 0 : -1);
          }
        },
        dependencies: [i2.NgClass, VueLocaleSelectComponent],
        styles: [".flex-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between}vue-select-locale[_ngcontent-%COMP%]{display:block}"]
      });
    }
  }
  return VueLoginHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component displays a modal on the screen.
 *
 * Example HTML:
 * ```
 <vue-modal #modal
            backgroundDismissal="false"
            closeButtonLabelKey="label.close"
            headerLabelKey="panelTitle"
            i18nBundle="PortalBase"
            showCloseButton="true">
    <... Content ...>
 </vue-modal>```
 *
 * In your component, import `VueModalComponent`:<br />
 * > ```import { VueModalComponent } from '@vue/vueframework';```
 *
 * Then, define the `@ViewChild` so that you have a reference to the modal:<br />
 * > ```@ViewChild('modal') public modal: VueModalComponent;```
 *
 * Finally, to open or close the modal:<br />
 * > `this.modal.open();`<br/>
 * > `this.modal.close();`
 *
 * You can also add `vue-form-buttons` inside of the `<vue-modal>` tags to provide form buttons on your modal.
 */
let VueModalComponent = /*#__PURE__*/(() => {
  class VueModalComponent {
    /**
     * Builds the modal component and import dependencies.
     *
     * @param modalService service used to open modal windows.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(modalService, vueTranslationService) {
      this.modalService = modalService;
      this.vueTranslationService = vueTranslationService;
      /**
       * Whether clicking the background will dismiss the modal.
       */
      this.backgroundDismissal = 'true';
      /**
       * Whether the modal should be centered on the page.
       */
      this.centered = 'true';
      /**
       * Label for the close button.
       *
       * Defaults to 'Close'
       */
      this.closeLabel = 'Close';
      /**
       * Translation key for the close button.<br />
       * Only used if `i18nLabel` is set.
       *
       * Defaults to 'label.close'
       */
      this.closeLabelKey = 'label.close';
      /**
       * Whether pressing the ESC key will dismiss the modal.
       */
      this.keyboardDismissal = 'true';
      /**
       * Whether to show the close button.
       *
       * **Warning**: If this is set to false, either `backgroundDismissal`
       * or `keyboardDismissal` should be set to `true`, otherwise there
       * will be no easy way to close the modal.
       */
      this.showCloseButton = 'true';
    }
    /**
     * Close the current modal.
     */
    close() {
      this.modalReference.close();
    }
    /**
     * Get the close button label.
     *
     * @returns the close button label.
     */
    getCloseLabel() {
      if (this.i18nBundle && this.closeLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.closeLabelKey);
      }
      return this.closeLabel;
    }
    /**
     * Get the header label.
     *
     * @returns the header label.
     */
    getHeaderLabel() {
      if (this.i18nBundle && this.headerLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.headerLabelKey);
      } else if (this.headerLabel) {
        return this.headerLabel;
      }
      return null;
    }
    /**
     * Open the modal with given options.
     */
    open() {
      const options = {
        backdrop: this.backgroundDismissal === 'true' ? true : 'static',
        centered: this.centered === 'true',
        keyboard: this.keyboardDismissal === 'true'
      };
      this.modalReference = this.modalService.open(this.content, options);
    }
    /**
     * Whether to show a header on the modal or not.
     *
     * @returns whether to show a header.
     */
    showHeader() {
      return this.getHeaderLabel() !== null;
    }
    static {
      this.ɵfac = function VueModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueModalComponent)(i0.ɵɵdirectiveInject(i4.NgbModal), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueModalComponent,
        selectors: [["vue-modal"]],
        viewQuery: function VueModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        inputs: {
          backgroundDismissal: "backgroundDismissal",
          centered: "centered",
          closeLabel: "closeLabel",
          closeLabelKey: "closeLabelKey",
          headerLabel: "headerLabel",
          headerLabelKey: "headerLabelKey",
          i18nBundle: "i18nBundle",
          keyboardDismissal: "keyboardDismissal",
          showCloseButton: "showCloseButton"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 2,
        vars: 0,
        consts: [["content", ""], [1, "modal-header"], [1, "modal-body"], ["type", "button", 1, "close"], ["type", "button", 1, "close", 3, "click"], [1, "modal-close", "align-middle"], ["aria-hidden", "true", 1, "align-middle"]],
        template: function VueModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, VueModalComponent_ng_template_0_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any, max-len */
/* eslint-enable max-len */
/**
This component is a wrapper around ng-select (https://github.com/ng-select/ng-select).  Example usage is:

```
<vue-multi-select name="animalSelect"
                  [items]="animals$1 | async"
                  [(selectedItems)]="selectedAnimals"
                  widthClass="shorter"
                  label="Selected one or multiple animals"
                  minEntries=1
                  minError="You need at least one animal"
                  [formError]="formError">
</vue-multi-select>```

ng-select's default behavior with respect to showing selected items is not very appealing.  They offer templates to
allow for UX customization but not in the area we needed it to look like our 1.x version.  Here is my dialog with
their team: https://github.com/ng-select/ng-select/issues/790

This field will validate when dirty like all other components.  However, when using this component you must check for
minEntries in your save method as it will NOT set the form's error flag.  See the example in the
vue-field-validation-component.

*/
let VueMultiSelectComponent = /*#__PURE__*/(() => {
  class VueMultiSelectComponent {
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
      Bind this value to the attribute that has the complete list
      */
      this.items = [];
      /**
      This bind this value to what object attribute you want to show in the list.  It defaults to .name
      */
      this.bindLabel = 'name';
      /**
      This class takes a value of shorter, wider, widest to control width.  By default you do not have to pass
      */
      this.widthClass = '';
      /**
      Specify a value > 0 if you want validation on min entries.  This will also put an asterisk
      next to your label.
      */
      this.minEntries = 0;
      /**
      Specify a value > 0 if you want validation on min entries.  This will also put an asterisk
      next to your label.
      */
      this.maxEntries = -1;
      /**
       Emits the changed items, so that parent component can have access to the changed items.
       */
      this.selectedItemsChange = new EventEmitter();
      this.isDirty = false;
    }
    ngOnInit() {
      this.translatePlaceHolderKey();
    }
    ngAfterViewChecked() {
      this.checkFocus();
    }
    checkFocus() {
      // TODO this needs followup.  Need to determine how to position focus
      /* if (this.formError && this.formError.fieldInError) {
         if (this.formError.fieldInError === this.inputElement.nativeElement.name) {
           this.inputElement.nativeElement.focus();
           this.formError.fieldInError = '';
         }
       }*/
    }
    clearItem(item) {
      this.isDirty = true;
      this.selectedItems = this.selectedItems.filter(x => x !== item);
      this.selectedItemsChange.emit(this.selectedItems);
    }
    getWidthClass() {
      return this.widthClass;
    }
    /* This method will translate (using VueTranslationService) or will return hardcoded string */
    getLabelTranslation() {
      if (this.label) {
        return this.label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.labelKey);
    }
    /* This method will translate (using VueTranslationService) or will return hardcoded string */
    getMinEntriesErrorTranslation() {
      if (this.minError) {
        return this.minError;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.minErrorKey);
    }
    /* This method will translate (using VueTranslationService) or will return hardcoded string */
    getMaxEntriesErrorTranslation() {
      if (this.maxError) {
        return this.maxError;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.maxErrorKey);
    }
    /* This method uses will look at the minEntries value to see if it us required.  */
    getRequiredIndicator() {
      return this.minEntries > 0 ? '*' : '';
    }
    isInputFieldInError() {
      if (!this.isDirty && !(this.formError && this.formError.invalidFormSubmit)) {
        return false;
      }
      if (this.isMinEntriesError()) {
        return true;
      }
      if (this.isMaxEntriesError()) {
        return true;
      }
      return false;
    }
    isMinEntriesError() {
      return this.minEntries > 0 && this.selectedItems.length < this.minEntries;
    }
    isMaxEntriesError() {
      if (this.maxEntries === -1) {
        return false;
      }
      return this.selectedItems.length > this.maxEntries;
    }
    setIsDirty() {
      this.isDirty = true;
      this.selectedItemsChange.emit(this.selectedItems);
    }
    translatePlaceHolderKey() {
      if (!this.placeholder && this.placeholderKey) {
        this.placeholder = this.vueTranslationService.getTranslation(this.i18nBundle, this.placeholderKey);
      }
    }
    static {
      this.ɵfac = function VueMultiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMultiSelectComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueMultiSelectComponent,
        selectors: [["vue-multi-select"]],
        contentQueries: function VueMultiSelectComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          name: "name",
          items: "items",
          selectedItems: "selectedItems",
          bindLabel: "bindLabel",
          formError: "formError",
          widthClass: "widthClass",
          i18nBundle: "i18nBundle",
          labelKey: "labelKey",
          label: "label",
          minErrorKey: "minErrorKey",
          minError: "minError",
          minEntries: "minEntries",
          maxErrorKey: "maxErrorKey",
          maxError: "maxError",
          maxEntries: "maxEntries",
          placeholder: "placeholder",
          placeholderKey: "placeholderKey",
          appendTo: "appendTo"
        },
        outputs: {
          selectedItemsChange: "selectedItemsChange"
        },
        standalone: false,
        decls: 15,
        vars: 20,
        consts: [["inputElement", ""], [1, "form-group", 3, "ngClass"], [1, "control-label"], [1, "multiSelect", "controls", "control-group"], [1, "ui-select-container", "ui-select-multiple", "ui-select-bootstrap"], [1, "ui-select-match"], ["tabindex", "-1", 1, "ui-select-match-item", "btn", "btn-default", "btn-xs"], [1, "custom-dropdown"], ["hideSelected", "true", 3, "ngModelChange", "name", "items", "multiple", "closeOnSelect", "searchable", "bindLabel", "clearable", "placeholder", "ngModel", "appendTo"], ["ng-multi-label-tmp", ""], [1, "help-inline", "validation-inline"], [1, "close", 3, "click"], [1, "validation-fail"], ["icon", "times", 1, "fa", "fa-fw"]],
        template: function VueMultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div")(5, "div", 3)(6, "div", 4)(7, "span", 5);
            i0.ɵɵrepeaterCreate(8, VueMultiSelectComponent_For_9_Template, 5, 1, "span", 6, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7)(11, "ng-select", 8, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function VueMultiSelectComponent_Template_ng_select_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedItems, $event) || (ctx.selectedItems = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function VueMultiSelectComponent_Template_ng_select_ngModelChange_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.setIsDirty());
            });
            i0.ɵɵtemplate(13, VueMultiSelectComponent_ng_template_13_Template, 0, 0, "ng-template", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(14, VueMultiSelectComponent_Conditional_14_Template, 3, 2, "div", 10);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c8, ctx.isInputFieldInError()));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.getLabelTranslation(), " ", ctx.getRequiredIndicator(), "");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("input-container ", ctx.getWidthClass(), "");
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.selectedItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("name", ctx.name)("items", ctx.items)("multiple", true)("closeOnSelect", true)("searchable", true)("bindLabel", ctx.bindLabel)("clearable", false)("placeholder", ctx.placeholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedItems);
            i0.ɵɵproperty("appendTo", ctx.appendTo);
            i0.ɵɵattribute("aria-label", ctx.getLabelTranslation());
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.isInputFieldInError() ? 14 : -1);
          }
        },
        dependencies: [i2.NgClass, i6.NgControlStatus, i6.NgModel, i1$2.FaIconComponent, i6$1.NgSelectComponent, i6$1.NgMultiLabelTemplateDirective],
        styles: [".select-error[_ngcontent-%COMP%]{color:#db0020}"]
      });
    }
  }
  return VueMultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class VueClientSubMenu {
  constructor(vueClientSubmenu) {
    Object.assign(this, vueClientSubmenu);
  }
  /**
   * This method is used to identify the level at which the given submenu is present
   *
   * @param submenuId
   *    Submenu to be found
   *
   * @return VueSubMenu object containing the level at which the given submenu is found
   */
  findSubmenuLevel(submenuId) {
    if (!this.subMenuList) {
      this.subMenuList = [];
    }
    let submenuLevel;
    const firstLevel = {
      defaultSubMenu: null,
      prevSubMenuTypeKey: null,
      subMenuId: null,
      subMenuList: this.subMenuList,
      subMenuName: null,
      subMenuNameKey: null,
      subMenuTypeKey: this.subMenuTypeKey,
      subMenuURL: null,
      translatedSubMenuName: null,
      translatedSubMenuTitle: this.translatedSubMenuTitle
    };
    // Check if the menu is present at the first level
    for (let i = 0; i < this.subMenuList.length; i++) {
      if (this.subMenuList[i].subMenuId === submenuId) {
        return firstLevel;
      }
    }
    // Do a tree search on each of the submenu at the first level
    for (let i = 0; i < this.subMenuList.length; i++) {
      submenuLevel = this.searchMenu(this.subMenuList[i], submenuId);
      if (submenuLevel) {
        break;
      }
    }
    return submenuLevel;
  }
  /**
   * This method does a recursive search on the submenu structure all the way down to the leaf nodes
   *
   * @param submenu
   *    The submenu to be searched
   * @param submenuId
   *    The id of the submenu to be found
   *
   * @return Returns a VueSubMenu object containing the level/parent menu where the given menu is found
   */
  searchMenu(submenu, submenuId) {
    if (!submenu.subMenuList) {
      submenu.subMenuList = [];
    }
    let submenuLevelFound = false;
    for (let i = 0; i < submenu.subMenuList.length; i++) {
      if (submenu.subMenuList[i].subMenuId === submenuId) {
        submenuLevelFound = true;
        break;
      }
    }
    if (submenuLevelFound) {
      return submenu;
    }
    let parentMenu;
    for (let i = 0; i < submenu.subMenuList.length; i++) {
      parentMenu = this.searchMenu(submenu.subMenuList[i], submenuId);
      if (parentMenu) {
        break;
      }
    }
    return parentMenu;
  }
}
class VueDisplaySubMenu {
  constructor(subMenuList, subMenuTypeKey, prevSubMenuTypeKey, subMenuId) {
    this.subMenuId = subMenuId;
    this.subMenuList = subMenuList;
    this.subMenuTypeKey = subMenuTypeKey;
    this.prevSubMenuTypeKey = prevSubMenuTypeKey;
    this.translatedSubMenuTitle = null;
    this.translatedPrevSubMenuTypeTitle = null;
  }
  // Function used to identify the submenu marked as default.
  getDefaultSubMenu() {
    if (this.isSubMenuEmpty()) {
      return null;
    }
    if (this.subMenuList.length === 1) {
      return this.subMenuList[0];
    }
    for (let j = 0; j < this.subMenuList.length; j++) {
      if (this.subMenuList[j].defaultSubMenu) {
        return this.subMenuList[j];
      }
    }
    return null;
  }
  isSubMenuEmpty() {
    if (!this.subMenuList) {
      return true;
    }
    return this.subMenuList.length === 0;
  }
}
class VueSelectedMenu {
  isSubMenuSelected() {
    return Boolean(this.subMenu);
  }
  isClientSelected() {
    return Boolean(this.client);
  }
  isApplicationSelected() {
    return Boolean(this.application);
  }
  isUserApplicationSelected() {
    return Boolean(this.userApplication);
  }
}
class VueSubMenu {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(jsonObj) {
    for (const prop of Object.keys(jsonObj)) {
      this[prop] = jsonObj[prop];
    }
  }
}
class VueHttpClientService {
  constructor(http, vueLoadingService) {
    this.http = http;
    this.vueLoadingService = vueLoadingService;
  }
  get(url, options) {
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.get(url, options).pipe(finalize(() => this.vueLoadingService.decrementCounter()));
    });
  }
  put(url, params, options) {
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.put(url, params, options).pipe(finalize(() => this.vueLoadingService.decrementCounter()));
    });
  }
  post(url, params, options) {
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.post(url, params, options).pipe(finalize(() => this.vueLoadingService.decrementCounter()));
    });
  }
  // This method is added for soap compatibility, normally this method will not be used for post service.
  // We needed a way to post just a primitive int or string used in SOAP calls.
  postPrimitive(url, params, options) {
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.post(url, params, options).pipe(finalize(() => this.vueLoadingService.decrementCounter()));
    });
  }
  delete(url, options) {
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.delete(url, options).pipe(finalize(() => this.vueLoadingService.decrementCounter()));
    });
  }
}
let VuePortalService = /*#__PURE__*/(() => {
  class VuePortalService {
    constructor(vueJavascriptUtilityService, vueLoadingService, vueUserSessionService, http) {
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueLoadingService = vueLoadingService;
      this.vueUserSessionService = vueUserSessionService;
      this.http = http;
      this.httpClient = new VueHttpClientService(this.http, this.vueLoadingService);
    }
    getApplications(queryParams) {
      const portalBaseRESTURL = this.vueUserSessionService.getPortalBaseRESTURL();
      const url = this.vueJavascriptUtilityService.getRestServiceURL('/rest/portal/applications', portalBaseRESTURL);
      let options = {};
      if (queryParams) {
        options.params = queryParams;
      } else {
        options = {};
      }
      return this.httpClient.get(url, options);
    }
    getApplicationsForUser(portalBaseRESTURL, queryParams) {
      const url = this.vueJavascriptUtilityService.getRestServiceURL('/rest/portal/applications/forLoggedInUser', portalBaseRESTURL);
      let options = {};
      if (queryParams) {
        options.params = queryParams;
      } else {
        options = {};
      }
      return this.httpClient.get(url, options);
    }
    getLocaleSettings(portalBaseRESTURL, relativePath) {
      const finalRelativePath = relativePath || '/rest/portal/localeSettings';
      const url = this.vueJavascriptUtilityService.getRestServiceURL(finalRelativePath, portalBaseRESTURL);
      return this.httpClient.get(url);
    }
    ssoInternalLogin(ssoRequest) {
      const portalBaseRESTURL = this.vueUserSessionService.getPortalBaseRESTURL();
      const url = this.vueJavascriptUtilityService.getRestServiceURL('/rest/sso/internalLogin', portalBaseRESTURL);
      const options = {
        withCredentials: true
      };
      return this.httpClient.post(url, ssoRequest, options);
    }
    getConfig() {
      const portalBaseRESTURL = this.vueUserSessionService.getPortalBaseRESTURL();
      const url = this.vueJavascriptUtilityService.getRestServiceURL('/rest/portal/config', portalBaseRESTURL);
      return this.httpClient.get(url);
    }
    loginTopazApp(appId) {
      const portalBaseRESTURL = this.vueUserSessionService.getPortalBaseRESTURL();
      const url = this.vueJavascriptUtilityService.getRestServiceURL(`/rest/portal/app/${appId}/login`, portalBaseRESTURL);
      return this.httpClient.post(url, {
        refreshToken: this.vueUserSessionService.getRefreshToken()
      });
    }
    static {
      this.ɵfac = function VuePortalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePortalService)(i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueLoadingService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VuePortalService,
        factory: VuePortalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VuePortalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component displays a page notification to the user. It needs to be outside of a form - so it's easiest just
 * to put it at the very top of your component.
 *
 * Example:
 *
 ```
 <vue-page-notification button1Label="Cancel"
                        button2Label="Continue"
                        message="This is a sample message. To continue press Cancel or Continue"
                        [show]="showPageNotification"
                        (button1Clicked)="cancelClicked($event)"
                        (button2Clicked)="continueClicked($event)">
 </vue-page-notification>
 ```
 *
 * The component will translate for you if you provide the 'key' version of all the fields.
 */
let VuePageNotificationComponent = /*#__PURE__*/(() => {
  class VuePageNotificationComponent {
    /**
     * Component constructor.
     *
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * Event emitted when the button 1 button is clicked.
       */
      this.button1Clicked = new EventEmitter();
      /**
       * Event emitted when the button 2 button is clicked.
       */
      this.button2Clicked = new EventEmitter();
    }
    /**
     * Gets the translated label for the primary button.
     *
     * @returns the translated button label.
     */
    getButton1Translation() {
      return this.button1Label ? this.button1Label : this.vueTranslationService.getTranslation(this.i18nBundle, this.button1LabelKey);
    }
    /**
     * Gets the translated label for the primary button.
     *
     * @returns the translated button label.
     */
    getButton2Translation() {
      return this.button2Label ? this.button2Label : this.vueTranslationService.getTranslation(this.i18nBundle, this.button2LabelKey);
    }
    /**
     * Gets the translated message to show to the user.
     *
     * @returns the translated message.
     */
    getMessageTranslation() {
      return this.message ? this.message : this.vueTranslationService.getTranslation(this.i18nBundle, this.messageKey);
    }
    /**
     * Should we show the second button?
     *
     * @returns whether to show the second button.
     */
    isButton2Desired() {
      return Boolean(this.button2Label || this.button2LabelKey);
    }
    /**
     * Called when the button 1 is clicked.
     * Emits a `button1Clicked` event.
     */
    button1Click() {
      this.button1Clicked.emit();
    }
    /**
     * Called when the button 2 is clicked.
     * Emits a `button2Clicked` event.
     */
    button2Click() {
      this.button2Clicked.emit();
    }
    static {
      this.ɵfac = function VuePageNotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePageNotificationComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePageNotificationComponent,
        selectors: [["vue-page-notification"]],
        inputs: {
          button1Label: "button1Label",
          button1LabelKey: "button1LabelKey",
          button2Label: "button2Label",
          button2LabelKey: "button2LabelKey",
          i18nBundle: "i18nBundle",
          message: "message",
          messageKey: "messageKey",
          show: "show"
        },
        outputs: {
          button1Clicked: "button1Clicked",
          button2Clicked: "button2Clicked"
        },
        standalone: false,
        decls: 10,
        vars: 4,
        consts: [["id", "dialog", 1, "session-timeout-container", 3, "hidden"], [1, "screen-overlay"], [1, "dashboard-message-wrapper"], [1, "dashboard-message-container"], ["id", "button1", 1, "btn", "btn-default", "btn-sm", "session-extend", 3, "click"], ["id", "button2", 1, "btn", "btn-default", "btn-sm", "session-extend"], ["id", "button2", 1, "btn", "btn-default", "btn-sm", "session-extend", 3, "click"]],
        template: function VuePageNotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "p");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "span")(7, "button", 4);
            i0.ɵɵlistener("click", function VuePageNotificationComponent_Template_button_click_7_listener() {
              return ctx.button1Click();
            });
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, VuePageNotificationComponent_Conditional_9_Template, 2, 1, "button", 5);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", !ctx.show);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.getMessageTranslation());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.getButton1Translation(), " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isButton2Desired() ? 9 : -1);
          }
        },
        styles: ["#button2[_ngcontent-%COMP%]{margin-left:2px}"]
      });
    }
  }
  return VuePageNotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueHttpPaginationClientService = /*#__PURE__*/(() => {
  class VueHttpPaginationClientService {
    constructor(http, vueTranslationService, vueJavascriptUtilityService, vueLoadingService) {
      this.http = http;
      this.vueTranslationService = vueTranslationService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueLoadingService = vueLoadingService;
      this.headers = {
        Range: ''
      };
    }
    pageParamsToRangeString(pageNumber, pageSize) {
      if (!pageNumber || !pageSize) {
        throw new Error('Both pageNumber and pageSize must be specified');
      }
      if (pageNumber < 1) {
        throw new Error('pageNumber must be a positive integer');
      }
      if (pageSize < 1) {
        throw new Error('pageSize must be a positive integer');
      }
      const rangeStart = (pageNumber - 1) * pageSize;
      const rangeEnd = pageNumber * pageSize - 1;
      return `items=${rangeStart}-${rangeEnd}`;
    }
    toDoubleColonNotation(param) {
      if (param) {
        if (Array.isArray(param)) {
          param.join('::');
        } else {
          return param;
        }
      }
      return null;
      /* return (angular.isDefined(param) && param != null) ?
        (angular.isArray(param)? param.join("::") : param) :
        null;*/
    }
    getErrorMsg(error, defaultMsg) {
      let text;
      if (error && error.data) {
        const errorData = Array.isArray(error.data) ? error.data[0] : error.data;
        const errorCode = errorData.code;
        if (errorCode && errorCode !== 'unknownServerError') {
          const errorKey = errorCode.indexOf('.') >= 0 ? errorCode.slice(errorCode.indexOf('.') + 1) : errorCode;
          const errorBundle = errorCode.indexOf('.') >= 0 ? errorCode.slice(0, errorCode.indexOf('.')) : '';
          text = this.vueTranslationService.getTranslation(errorBundle, errorKey, errorData.parameters);
        }
      }
      return text ? text : defaultMsg;
    }
    forPageSize(pageSize) {
      this.pageSize = pageSize;
      /* eslint-disable-next-line no-undefined */
      this.headers.Range = undefined;
      if (this.pageNumber && pageSize) {
        this.headers.Range = this.pageParamsToRangeString(this.pageNumber, pageSize);
      }
      return this;
    }
    /**
     * (optional) page number and page size
     */
    forPageNumber(pageNumber) {
      this.pageNumber = pageNumber;
      /* eslint-disable-next-line no-undefined */
      this.headers.Range = undefined;
      if (pageNumber && this.pageSize) {
        this.headers.Range = this.pageParamsToRangeString(pageNumber, this.pageSize);
      }
      return this;
    }
    /**
     * (optional) one or more fields used to sort the returned list -- may either be a single value or an array.
     */
    sortedBy(sort) {
      if (sort) {
        if (!this.params) {
          this.params = {};
        }
        this.params.sort = this.toDoubleColonNotation(sort);
      }
      return this;
    }
    /**
       * (optional) one or more fields used to control the content of application objects in the returned list.
       * Can be a single value or an array.
       */
    withFields(fields) {
      if (fields && fields.length > 0) {
        if (!this.params) {
          this.params = {};
        }
        this.params.fields = this.toDoubleColonNotation(fields);
      }
      return this;
    }
    addParam(key, value) {
      if (key) {
        this.params[key] = value;
      }
      return this;
    }
    addHeader(key, value) {
      if (key) {
        this.headers[key] = value;
      }
      return this;
    }
    setUrl(url) {
      if (this.restRootOverride) {
        this.url = this.vueJavascriptUtilityService.getRestServiceURL(url, this.restRootOverride);
      } else {
        this.url = url;
      }
      return this;
    }
    setRestRootOverride(restRootOverride) {
      this.restRootOverride = restRootOverride;
      return this;
    }
    get() {
      this.vueLoadingService.incrementCounter();
      return this.http.get(this.url, {
        headers: this.headers,
        observe: 'response',
        params: this.params
      }).pipe(tap(results => this.onSuccess(results), () => this.onError()), map(response => {
        const contentRange = response.headers.get('Content-Range') || response.headers.get('content-range');
        if (contentRange && this.pageSize) {
          const rangeInformation = contentRange.substring(6, contentRange.length);
          response.pagination = {
            beginRange: '0',
            endRange: '0',
            numPages: 0,
            overage: false,
            totalRows: '0'
          };
          response.pagination.beginRange = rangeInformation.substring(0, rangeInformation.indexOf('-'));
          response.pagination.endRange = rangeInformation.substring(rangeInformation.indexOf('-') + 1, rangeInformation.indexOf('/'));
          response.pagination.totalRows = rangeInformation.substring(rangeInformation.indexOf('/') + 1, rangeInformation.length);
          response.pagination.overage = response.pagination.totalRows >= 1 && response.pagination.totalRows[response.pagination.totalRows.length - 1] === '+';
          response.pagination.numPages = Math.ceil(Number(response.pagination.totalRows) / Number(this.pageSize));
        }
        // kind of useless
        return response;
      }));
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    onSuccess(results) {
      this.vueLoadingService.decrementCounter();
    }
    onError() {
      this.vueLoadingService.decrementCounter();
    }
    static {
      this.ɵfac = function VueHttpPaginationClientService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueHttpPaginationClientService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueLoadingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueHttpPaginationClientService,
        factory: VueHttpPaginationClientService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueHttpPaginationClientService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This service provides factory methods for getting an instance of VueHttpPaginationClientService or VueHttpClientService.
*/
let VueHttpClientFactoryService = /*#__PURE__*/(() => {
  class VueHttpClientFactoryService {
    constructor(http, vueTranslationService, vueJavascriptUtilityService, vueLoadingService) {
      this.http = http;
      this.vueTranslationService = vueTranslationService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueLoadingService = vueLoadingService;
    }
    getVueHttpPaginationClient() {
      return new VueHttpPaginationClientService(this.http, this.vueTranslationService, this.vueJavascriptUtilityService, this.vueLoadingService);
    }
    getVueHttpClient() {
      return new VueHttpClientService(this.http, this.vueLoadingService);
    }
    static {
      this.ɵfac = function VueHttpClientFactoryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueHttpClientFactoryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueLoadingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueHttpClientFactoryService,
        factory: VueHttpClientFactoryService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueHttpClientFactoryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VuePreferenceService = /*#__PURE__*/(() => {
  class VuePreferenceService {
    constructor(util, appDefaultsService, httpFactoryClient) {
      this.util = util;
      this.appDefaultsService = appDefaultsService;
      this.httpFactoryClient = httpFactoryClient;
    }
    preferenceUrl(userId, preferenceType) {
      const restRoot = this.appDefaultsService.getCASRESTRoot() || null;
      return this.util.getRestServiceURL(`/rest/preferences/${userId}/${preferenceType}`, restRoot);
    }
    /**
     *
     * Returns the specified preference for the specified user
     *
     * @param userId string
     * @param type string
     * @returns Observable based on the preference
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity */
    getPreference(userId, type) {
      return this.httpFactoryClient.getVueHttpClient().get(this.preferenceUrl(userId, type));
    }
    /**
     *
     * Updates the specified preference for the specified user.
     *
     * @param userId string
     * @param type string
     * @param preference any
     * @returns Observable based on the preference
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity */
    updatePreference(userId, type, preference) {
      return this.httpFactoryClient.getVueHttpClient().post(this.preferenceUrl(userId, type), preference);
    }
    /**
     *
     * Gets the users saved locale preference
     *
     * @param userId string
     * @returns AtlasLocale
     */
    getLocalePreference(userId) {
      return this.getPreference(userId, 'LOCALE').pipe(map(v => v.locale));
    }
    /**
     *
     * Saves the locale to preferences
     *
     * @param userId string
     * @param locale AtlasLocale
     * @returns Boolean
     */
    updateLocalePreference(userId, locale) {
      return this.updatePreference(userId, 'LOCALE', {
        locale
      }).pipe(map(() => true));
    }
    static {
      this.ɵfac = function VuePreferenceService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePreferenceService)(i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueHttpClientFactoryService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VuePreferenceService,
        factory: VuePreferenceService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VuePreferenceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueAtlasService = /*#__PURE__*/(() => {
  class VueAtlasService {
    constructor(vueLoadingService, http, defaults) {
      this.vueLoadingService = vueLoadingService;
      this.http = http;
      this.defaults = defaults;
      this.httpClient = new VueHttpClientService(this.http, this.vueLoadingService);
    }
    /**
     * Gets all locales from the Atlas service. Will call
     * the api once and then cache the result and return
     * that on subsequent calls.
     *
     * @returns AtlasLocale[]
     */
    getAllLocales() {
      if (this.allLocales) {
        return of(this.allLocales);
      }
      return this.httpClient.get(this.getLocalesUrl()).pipe(tap(v => {
        this.allLocales = v;
      }));
    }
    /**
     *
     * Will return a single AtlasLocale, by matching the tag
     *
     * @param tag string ex 'en-us'
     * @returns AtlasLocale
     */
    getLocaleByTag(tag) {
      return this.getAllLocales().pipe(map(val => {
        return val.find(i => i.localeTag.toLowerCase() === tag.toLowerCase());
      }));
    }
    /**
     * Get the urls for the atlas locales Service
     * @returns string
     */
    getLocalesUrl() {
      const url = this.defaults.getCASRESTRoot() || this.defaults.getPortalRESTRoot();
      return `${url}/rest/atlas/locales`;
    }
    static {
      this.ɵfac = function VueAtlasService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAtlasService)(i0.ɵɵinject(VueLoadingService), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueAtlasService,
        factory: VueAtlasService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueAtlasService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueLocaleConfirmationService = /*#__PURE__*/(() => {
  class VueLocaleConfirmationService {
    constructor(defaultService, localeService, preferenceService, vueAtlasService, userSessionService, translationService, modalService) {
      this.defaultService = defaultService;
      this.localeService = localeService;
      this.preferenceService = preferenceService;
      this.vueAtlasService = vueAtlasService;
      this.userSessionService = userSessionService;
      this.translationService = translationService;
      this.modalService = modalService;
    }
    /**
     * Checks the users selected locale with the
     * one saved in preference and shows a dialogue
     * if there is a difference.
     */
    showConfirmationIfNecessary() {
      /**
       * Don't bother confirmation localization change
       * if localization is not enabled
       */
      if (!this.defaultService.getLocalizationEnabled()) {
        return;
      }
      /**
       * Get our current tag's atlas record and the
       * users currently saved preference.
       */
      forkJoin([this.vueAtlasService.getLocaleByTag(this.localeService.locale), this.preferenceService.getLocalePreference(this.userSessionService.getOAuthToken().idToken.sub)]).subscribe(([valA, valB]) => this.checkPreference(valA, valB));
    }
    /**
     *
     * Compares the selected locale with the saved locale and
     * shows a dialogue if there is a difference.
     *
     * @param selected AtlasLocale
     * @param saved AtlasLocale
     */
    checkPreference(selected, saved) {
      if (!saved || selected.localeTag !== saved.localeTag) {
        const key = saved ? 'message.ChangeLocaleConfirmation' : 'message.SetLocaleConfirmation';
        const translation = this.translationService.getTranslation('PortalBase', key, [selected.localizedDescription, saved ? saved.localizedDescription : null]);
        const modalRef = this.modalService.open(VuePageNotificationComponent, {
          backdrop: 'static',
          keyboard: false,
          size: 'xxl'
        });
        const comp = modalRef.componentInstance;
        comp.message = translation;
        comp.show = true;
        comp.button1Label = this.translationService.getTranslation('PortalBase', 'button.SaveLocalePreference');
        comp.button1Clicked.subscribe(() => {
          modalRef.close();
          this.localeConfirmationSubmit(selected);
        });
      }
    }
    /**
     *
     * Saved the new selected locale preference
     *
     * @param locale AtlasLocale
     */
    localeConfirmationSubmit(locale) {
      this.preferenceService.updateLocalePreference(this.userSessionService.getOAuthToken().idToken.sub, locale).subscribe();
    }
    static {
      this.ɵfac = function VueLocaleConfirmationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLocaleConfirmationService)(i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueLocaleService), i0.ɵɵinject(VuePreferenceService), i0.ɵɵinject(VueAtlasService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(i4.NgbModal));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueLocaleConfirmationService,
        factory: VueLocaleConfirmationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueLocaleConfirmationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is used from the vue-navigation component, to display the client logo in the
 * navigation bar. When the user chooses a client from the menu, the client logo will appear
 * on the navigation bar. This component will be observing any client change via the
 * vue navigation service and will change the client log accordingly. if logo not
 * present or unable to load, this section will not be displayed.
 *
 * Example:
 * ```
 *  <div id="client-logo-div" class="client-logo-container" *ngIf="showLogo">
 *  <div class="client-logo">
 *  <img id="client-logo-img" [src]="logoPath" (error)='hideLogo()' alt="client logo">
 *  </div>
 * </div>
 * ```
 */
let VueNavigationLogoComponent = /*#__PURE__*/(() => {
  class VueNavigationLogoComponent {
    constructor(vueNavigationService, vueAppDefaultsService) {
      this.vueNavigationService = vueNavigationService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.showLogo = false;
      // Keeping a track of logoPath that were not able to load. So that the app does't try to load it again.
      // uplanis 5/19 made public for test to pass temporarily
      this.logoPathNotFoundList = [];
    }
    ngOnInit() {
      if (!this.imagePath) {
        this.imagePath = this.vueAppDefaultsService.getDefaultLogoImagePath();
      }
      this.vueNavigationService.getClientCode().subscribe(clientCode => {
        this.determineLogoPath(clientCode);
      });
    }
    // Called when an error occurs loading the logo.
    hideLogo() {
      // Turn on for debug
      // console.log('hide logo called - adding this logoPath to not found list' + this.logoPath);
      this.logoPathNotFoundList.push(this.logoPath);
      this.showLogo = false;
    }
    // Determines the logo path. If there were previous errors loading the logo, then we don't try to show them.
    determineLogoPath(clientCode) {
      const logoPath = `${this.imagePath}${clientCode}.png`;
      if (this.logoPathNotFoundList.indexOf(logoPath) === -1) {
        this.logoPath = logoPath;
        this.showLogo = true;
      } else {
        this.showLogo = false;
      }
    }
    static {
      this.ɵfac = function VueNavigationLogoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationLogoComponent)(i0.ɵɵdirectiveInject(VueNavigationService), i0.ɵɵdirectiveInject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationLogoComponent,
        selectors: [["vue-navigation-logo"]],
        inputs: {
          imagePath: "imagePath"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["id", "client-logo-div", 1, "client-logo-container"], [1, "client-logo"], ["id", "client-logo-img", "alt", "client logo", 3, "error", "src"]],
        template: function VueNavigationLogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueNavigationLogoComponent_Conditional_0_Template, 3, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.showLogo ? 0 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueNavigationLogoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueNavigationBreadCrumbComponent = /*#__PURE__*/(() => {
  class VueNavigationBreadCrumbComponent {
    /**
     * This method is used to check if a custom header detail text is provided.
     *
     * @return True if the header detail is found
     */
    isCustomHeaderDetailFound() {
      return Boolean(this.customHeaderDetail);
    }
    static {
      this.ɵfac = function VueNavigationBreadCrumbComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationBreadCrumbComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationBreadCrumbComponent,
        selectors: [["vue-navigation-bread-crumb"]],
        inputs: {
          customHeaderDetail: "customHeaderDetail",
          selectedMenu: [0, "menu", "selectedMenu"]
        },
        standalone: false,
        decls: 8,
        vars: 6,
        consts: [["id", "client-app-breadcrumb"], ["id", "dashboard-header-title"], [1, "all-three"], [1, "just-one"], [1, "both"], [1, "custom-title"]],
        template: function VueNavigationBreadCrumbComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, VueNavigationBreadCrumbComponent_Conditional_2_Template, 10, 3, "ul", 2)(3, VueNavigationBreadCrumbComponent_Conditional_3_Template, 4, 1, "ul", 3)(4, VueNavigationBreadCrumbComponent_Conditional_4_Template, 7, 2, "ul", 4)(5, VueNavigationBreadCrumbComponent_Conditional_5_Template, 4, 1, "ul", 3)(6, VueNavigationBreadCrumbComponent_Conditional_6_Template, 7, 2, "ul", 5)(7, VueNavigationBreadCrumbComponent_Conditional_7_Template, 4, 1, "ul", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.selectedMenu.isSubMenuSelected() && ctx.selectedMenu.isClientSelected() && !ctx.selectedMenu.isUserApplicationSelected() && !ctx.isCustomHeaderDetailFound() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectedMenu.isApplicationSelected() && !ctx.selectedMenu.isClientSelected() && !ctx.selectedMenu.isUserApplicationSelected() && !ctx.isCustomHeaderDetailFound() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectedMenu.isClientSelected() && !ctx.selectedMenu.isSubMenuSelected() && !ctx.selectedMenu.isUserApplicationSelected() && !ctx.isCustomHeaderDetailFound() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectedMenu.isUserApplicationSelected() && !ctx.isCustomHeaderDetailFound() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isCustomHeaderDetailFound() && ctx.selectedMenu.isApplicationSelected() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isCustomHeaderDetailFound() && !ctx.selectedMenu.isApplicationSelected() ? 7 : -1);
          }
        },
        styles: ["#dashboard-header-title[_ngcontent-%COMP%]   ul.custom-title[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{font-size:12px}#dashboard-header-title[_ngcontent-%COMP%]   ul.custom-title[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-child{font-size:16px}"]
      });
    }
  }
  return VueNavigationBreadCrumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
let VueNavigationStdRightTopMenuComponent = /*#__PURE__*/(() => {
  class VueNavigationStdRightTopMenuComponent {
    constructor(vueConfirmLoseChangesService, router, vueSessionCookieService, vueJavascriptUtilityService, vueUserSessionService, vueNavigationService, vueAppDefaultsService, vueWindow) {
      this.vueConfirmLoseChangesService = vueConfirmLoseChangesService;
      this.router = router;
      this.vueSessionCookieService = vueSessionCookieService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueNavigationService = vueNavigationService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueWindow = vueWindow;
      // Notify client application that user is logging out
      this.logoutClicked = new Subject();
      // Allow client application to call logout() when ready
      this.overrideLogout = false;
      // These sessionStorage values will be ignored when navigating from one domain to another.
      // This addresses the 413 (request entity too large) issue we have when hydrating cookies
      // from sessionStorage.
      // This is replicated in: vue-navigation.component.ts
      this.omitFromCookieValues = ['clientsAndApplications', 'menuTranslations', 'selectedApplication', 'navigationHistory'];
    }
    /**
     * This displays account settings link
     * @returns the account setting link
     */
    displayAccountSettingsLink() {
      const isExternalSSOUser = this.vueSessionCookieService.getAttribute('isExternalSSOUser') === 'true';
      if (this.showAccountMaint && this.vueSessionCookieService.getAttribute('realm') === 'E' || isExternalSSOUser) {
        return false;
      }
      return this.showAccountMaint;
    }
    /**
     * Gets the full name
     * @returns the full name
     */
    getName() {
      return this.vueUserSessionService.getUserFullName();
    }
    /**
     * launches the account maintenance
     * @param ev: MouseEvent
     */
    callLaunchAccountMaintenance(ev) {
      ev.preventDefault();
      if (this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        this.launchAccountMaintenance();
      }
    }
    /**
     * Logs out
     * @param ev: MouseEvent
     */
    callLogout(ev) {
      this.logoutClicked.next(null);
      ev.preventDefault();
      if (this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        if (!this.overrideLogout) {
          this.logout();
        }
      }
    }
    /**
     * Launches help
     * @param ev: MouseEvent
     */
    launchHelp(ev) {
      ev.preventDefault();
      // Help URL can come from 4 places.  See https://confluence.pearson.com/confluence/display/PVUERA/Help+in+RA+Apps
      // Help URL defined on state config
      if (this.vueUserSessionService.getHelpContext()) {
        this.vueWindow.open(this.vueUserSessionService.getHelpContext());
        return;
      }
      // Help URL defined for an application in JSON menu. selectApplication() assigns it.
      if (this.helpURL) {
        this.vueWindow.open(this.helpURL);
        return;
      }
      // Help URL defined in app constants
      if (this.vueAppDefaultsService.getDefaultHelpURL()) {
        this.vueWindow.open(this.vueAppDefaultsService.getDefaultHelpURL());
        return;
      }
      // No help defined anywhere, odd.
      /* eslint-disable-next-line no-console */
      console.log('No help defined in app. See confluence writeup.');
    }
    // uplanis 5/19 made public for test to pass temporarily
    /**
     * Launches account maintenance
     */
    launchAccountMaintenance() {
      const selectedUserApplication = this.translation['label.Account'];
      // In Commons 1, they were passing just this.selectedMenu.userApplication.translatedName below. Not sure why????
      this.vueUserSessionService.setSelectedUserApplication(selectedUserApplication);
      if (!this.accountMaintLink) {
        this.accountMaintLink = this.vueUserSessionService.getAccountMaintenanceURL();
      }
      this.vueNavigationService.changeAccountMaintSelected(true);
      if (!this.vueJavascriptUtilityService.isCurrentDomain(this.accountMaintLink)) {
        this.vueSessionCookieService.hydrateCookiesFromSession(null, this.omitFromCookieValues);
      }
      if (!this.vueJavascriptUtilityService.isCurrentDomain(this.accountMaintLink)) {
        /**
         * Remove selected application and submenu when navigating
         * away from current app into account maint. Fixes issue
         * where the app navigation in commons still considers you
         * inside an opened app open menu.
         */
        this.vueUserSessionService.removeSelectedSubmenu();
        this.vueUserSessionService.removeSelectedApplication();
        this.vueUserSessionService.removeSelectedApplicationId();
        this.vueWindow.location.assign(this.accountMaintLink);
      } else {
        this.router.navigateByUrl(this.vueJavascriptUtilityService.getNavigatePathFromUrl(this.accountMaintLink));
      }
    }
    /**
     * Launches the custom menu URL which will be provided by the application currently selected.
     * @param ev: MouseEvent
     */
    launchCustomMenu(ev) {
      ev.preventDefault();
      this.vueNavigationService.changeCustomMenuSelected(true);
      if (this.vueJavascriptUtilityService.isCurrentDomain(this.customMenuURL)) {
        this.router.navigateByUrl(this.vueJavascriptUtilityService.getNavigatePathFromUrl(this.customMenuURL));
      } else {
        this.vueSessionCookieService.hydrateCookiesFromSession(null, this.omitFromCookieValues);
        this.vueWindow.location.assign(this.customMenuURL);
      }
    }
    // uplanis 5/19 made public for test to pass temporarily
    /**
     * Logs out user
     */
    logout() {
      const logoutURL = this.vueUserSessionService.getLogoutURL();
      this.vueNavigationService.changeLogoffState(true);
      if (logoutURL) {
        // If we are on a different subdomain than the logout URL then
        // generate cookies from session storage values and clean up
        // the session storage on this subdomain.
        if (!this.vueJavascriptUtilityService.isCurrentDomain(logoutURL)) {
          this.vueSessionCookieService.hydrateCookiesFromSession(null, this.omitFromCookieValues);
          this.vueUserSessionService.destroy();
        }
        // We only need to handle navigation to the logout url here if we're
        // not already in the 'logout app'. For example, if I'm already in Navigator,
        // it's fine to just let Navigator take care of the logout with the core event listener.
        if (!this.vueJavascriptUtilityService.isURLInCurrentApp(logoutURL)) {
          this.vueWindow.location.assign(logoutURL);
        }
      }
    }
    static {
      this.ɵfac = function VueNavigationStdRightTopMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationStdRightTopMenuComponent)(i0.ɵɵdirectiveInject(VueConfirmLoseChangesService), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueSessionCookieService), i0.ɵɵdirectiveInject(VueJavascriptUtilityService), i0.ɵɵdirectiveInject(VueUserSessionService), i0.ɵɵdirectiveInject(VueNavigationService), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(WINDOW));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationStdRightTopMenuComponent,
        selectors: [["vue-navigation-std-right-top-menu"]],
        inputs: {
          accountMaintLink: "accountMaintLink",
          helpURL: "helpURL",
          showAccountMaint: "showAccountMaint",
          customMenuURL: "customMenuURL",
          translation: "translation"
        },
        standalone: false,
        decls: 18,
        vars: 5,
        consts: [[1, "top-nav"], [1, "nav", "navbar-nav", "navbar-right", "d-inline"], ["id", "helpLink", "role", "button", "href", "", 3, "click"], ["id", "nav-std-help-icon", "icon", "question-circle", 1, "fa", "fa-lg", "fa-fw"], ["ngbDropdown", "", 1, "dropdown"], ["role", "button", "aria-controls", "nav-std-my-account-menu", "id", "nav-std-account-settings-menu-link", "ngbDropdownToggle", "", 1, "dropdown-btn"], ["id", "userIcon", "icon", "user", 1, "fa", "fa-lg", "fa-fw"], ["role", "menu", "ngbDropdownMenu", "", "aria-describedby", "nav-std-account-settings-menu-link", "id", "nav-std-my-account-menu", 1, "dropdown-menu"], ["href", "", "role", "menuitem", "ngbDropdownItem", "", "id", "nav-std-account-settings-link", 1, "dropdown-item"], ["href", "", "role", "menuitem", "ngbDropdownItem", "", "id", "nav-std-signout-link", 1, "dropdown-item", 3, "click"], ["icon", "sign-out-alt", 1, "fa", "fa-lg", "fa-fw"], ["href", "", "role", "button", "id", "nav-std-change-site", 3, "click"], ["id", "nav-std-change-site-icon", 1, "fa", "fa-lg", "fa-fw", 3, "icon"], ["href", "", "role", "menuitem", "ngbDropdownItem", "", "id", "nav-std-account-settings-link", 1, "dropdown-item", 3, "click"], ["icon", "user", 1, "fa", "fa-lg", "fa-fw"]],
        template: function VueNavigationStdRightTopMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
            i0.ɵɵtemplate(2, VueNavigationStdRightTopMenuComponent_Conditional_2_Template, 5, 4, "li");
            i0.ɵɵelementStart(3, "li")(4, "a", 2);
            i0.ɵɵlistener("click", function VueNavigationStdRightTopMenuComponent_Template_a_click_4_listener($event) {
              return ctx.launchHelp($event);
            });
            i0.ɵɵelement(5, "fa-icon", 3);
            i0.ɵɵelementStart(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "li", 4)(9, "button", 5);
            i0.ɵɵelement(10, "fa-icon", 6);
            i0.ɵɵelementStart(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 7);
            i0.ɵɵtemplate(14, VueNavigationStdRightTopMenuComponent_Conditional_14_Template, 3, 1, "a", 8);
            i0.ɵɵelementStart(15, "a", 9);
            i0.ɵɵlistener("click", function VueNavigationStdRightTopMenuComponent_Template_a_click_15_listener($event) {
              return ctx.callLogout($event);
            });
            i0.ɵɵelement(16, "fa-icon", 10);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.customMenuURL ? 2 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.translation["label.Help"]);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.getName());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.displayAccountSettingsLink() ? 14 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.translation["label.Logout"], " ");
          }
        },
        dependencies: [i1$2.FaIconComponent, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem],
        styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropdown-item[_ngcontent-%COMP%]{padding:12px 15px}fa-icon[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{margin-inline-start:5px}.dropdown-btn[_ngcontent-%COMP%]{background-color:transparent;border:none;padding:10px}.dropdown-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:none}@media (min-width: 767px){.dropdown-btn[_ngcontent-%COMP%]{padding:15px}.dropdown-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block}}"]
      });
    }
  }
  return VueNavigationStdRightTopMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is a child to VueNavigationMenu.
 * It styles a back button when needed and outputs a selection
 * based on mouse click or enter. All other styles come from
 * vue-navigation.component.css
 */
let VueNavigationMenuItemComponent = /*#__PURE__*/(() => {
  class VueNavigationMenuItemComponent {
    constructor(element) {
      this.element = element;
      this.isBackButton = false;
      this.selected = new EventEmitter();
    }
    keydown(event) {
      if (event.key === 'Enter') {
        this.selected.emit(this.label);
      }
    }
    click() {
      this.selected.emit(this.label);
    }
    getLabel() {
      return this.label;
    }
    focus() {
      this.element.nativeElement.focus();
    }
    static {
      this.ɵfac = function VueNavigationMenuItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationMenuItemComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationMenuItemComponent,
        selectors: [["vue-navigation-menu-item"]],
        hostAttrs: ["tabindex", "-1"],
        hostBindings: function VueNavigationMenuItemComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function VueNavigationMenuItemComponent_keydown_HostBindingHandler($event) {
              return ctx.keydown($event);
            })("click", function VueNavigationMenuItemComponent_click_HostBindingHandler() {
              return ctx.click();
            });
          }
        },
        inputs: {
          label: "label",
          isBackButton: "isBackButton"
        },
        outputs: {
          selected: "selected"
        },
        standalone: false,
        decls: 3,
        vars: 4,
        consts: [[1, "nav-back-button-icon"], ["icon", "caret-left", 1, "fa", "fa-fw", "rtl-icon"]],
        template: function VueNavigationMenuItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueNavigationMenuItemComponent_Conditional_0_Template, 2, 0, "div", 0);
            i0.ɵɵelementStart(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isBackButton ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("is-back", ctx.isBackButton);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        dependencies: [i1$2.FaIconComponent],
        styles: [".nav-back-button-icon[_ngcontent-%COMP%]{position:absolute;margin-top:1px;margin-inline-start:-10px}.is-back[_ngcontent-%COMP%]{font-size:12px}"]
      });
    }
  }
  return VueNavigationMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The component encapsulate the main menu in order to provide for keyboard navigation.
 * Up,down,enter on individual items. If a back button is present, it will pre-focus the
 * second item in the list.
 * All styles come from vue-navigation.component.css
 */
let VueNavigationMenuComponent = /*#__PURE__*/(() => {
  class VueNavigationMenuComponent {
    manage(event) {
      this.keyManager.onKeydown(event);
    }
    ngAfterContentInit() {
      this.keyManager = new FocusKeyManager(this.items).withWrap();
      this.items.changes.subscribe(() => {
        if (this.items && this.items.first) {
          if (this.items.first.isBackButton && this.items.length > 1) {
            this.keyManager.setActiveItem(1);
          } else {
            this.keyManager.setActiveItem(0);
          }
        }
      });
    }
    static {
      this.ɵfac = function VueNavigationMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationMenuComponent,
        selectors: [["vue-navigation-menu"]],
        contentQueries: function VueNavigationMenuComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, VueNavigationMenuItemComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
          }
        },
        hostAttrs: ["tabindex", "0"],
        hostBindings: function VueNavigationMenuComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function VueNavigationMenuComponent_keydown_HostBindingHandler($event) {
              return ctx.manage($event);
            });
          }
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function VueNavigationMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueNavigationMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Pipe used to translate text.
 *
 * **Usage**:<br />
 * Default (use `AppDefaultsService.getDefaultAppBundle()`): `{{ 'translation.key' | translate | async }}`<br />
 * Override bundle: `{{ 'translation.key' | translate:'MyBundle' | async }}`<br />
 * Override bundle and add params: `{{ 'translation.key' | translate:'MyBundle':['Param1','Param2'] | async }}`<br />
 * Default bundle and add params: `{{ 'translation.key' | translate:null:['Param1','Param2'] | async }}`<br />
 * </ul>
 */
let VueTranslatePipe = /*#__PURE__*/(() => {
  class VueTranslatePipe {
    /**
     * Pipe constructor.
     *
     * @param vueAppDefaultsService service used to fetch application-wide default attributes.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(vueAppDefaultsService, vueTranslationService) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueTranslationService = vueTranslationService;
    }
    /**
     * Gets the translation for the key param from VueTranslationService.
     *
     * @param key the translation key.
     * @param bundle the optional bundle if overriding is needed.
     * @param params the optional translation parameters.
     * @returns an Observable for the translated results.
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    transform(key, bundle, params) {
      const xliffBundle = bundle || this.vueAppDefaultsService.getDefaultAppBundle();
      return this.vueTranslationService.getTranslationBundle(xliffBundle, null).pipe(map(() => {
        return this.vueTranslationService.getTranslation(xliffBundle, key, params);
      }));
    }
    static {
      this.ɵfac = function VueTranslatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTranslatePipe)(i0.ɵɵdirectiveInject(VueAppDefaultsService, 16), i0.ɵɵdirectiveInject(VueTranslationService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "translate",
        type: VueTranslatePipe,
        pure: false,
        standalone: false
      });
    }
  }
  return VueTranslatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Usage: Use this sort method to sort an Array of objects.
          sortArray method takes 2 parameters the array & sort by.
          If the sort by has a '-' sorts in desc order, asc by default.
          ex: (by default) Asc - let option of getTestArray() | sortArray: 'code'"
                           Desc - let option of getTestArray() | sortArray: '-code'"
 */
let VueArraySortPipe = /*#__PURE__*/(() => {
  class VueArraySortPipe {
    transform(arrayToSort, by) {
      // if the by argument is empty return the unsorted array
      if (by === '' || by === null) {
        return arrayToSort;
      }
      // check if the first character of the sort by has -1
      if (by.charAt(0).indexOf('-') >= 0) {
        // eslint-disable-next-line no-param-reassign
        by = by.slice(1);
        // sort the array in desc
        arrayToSort.sort((left, right) => {
          let leftElement;
          let rightElement;
          /* Sort ignorecase, If sort by string */
          if (left[by] !== null && typeof left[by] === 'string') {
            leftElement = left[by].toLowerCase();
          } else {
            leftElement = left[by];
          }
          if (right[by] !== null && typeof right[by] === 'string') {
            rightElement = right[by].toLowerCase();
          } else {
            rightElement = right[by];
          }
          if (leftElement < rightElement) {
            return 1;
          } else if (leftElement > rightElement) {
            return -1;
          }
          return 0;
        });
        return arrayToSort;
      }
      // sort the array in asc
      arrayToSort.sort((left, right) => {
        let leftElement;
        let rightElement;
        /* Sort ignorecase, If sort by string */
        if (left[by] !== null && typeof left[by] === 'string') {
          leftElement = left[by].toLowerCase();
        } else {
          leftElement = left[by];
        }
        if (right[by] !== null && typeof right[by] === 'string') {
          rightElement = right[by].toLowerCase();
        } else {
          rightElement = right[by];
        }
        if (leftElement < rightElement) {
          return -1;
        } else if (leftElement > rightElement) {
          return 1;
        }
        return 0;
      });
      return arrayToSort;
    }
    static {
      this.ɵfac = function VueArraySortPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueArraySortPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "sortBy",
        type: VueArraySortPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return VueArraySortPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any, valid-jsdoc */
/**
 This directive should be placed as shown below.  It will show itself only when user is authenticated.
 It calls the portal service endpoint to get applications for the logged in user.

 ```
 <vue-login-header></vue-login-header>
 <vue-navigation></vue-navigation>
 <vue-cookie-policy></vue-cookie-policy>
 <div id="main-content" class="" vueMainContent>
 <vue-loading-indicator></vue-loading-indicator>
 <div class="app-wrapper">
 <div class="app-container">
 <router-outlet></router-outlet>
 </div>
 </div>
 </div>
 <vue-footer></vue-footer>```

 */
let VueNavigationComponent = /*#__PURE__*/(() => {
  class VueNavigationComponent {
    constructor(vueNavigationService, titleService, vueAppDefaultsService, vueUserSessionService, vueTranslationService, vueConfirmLoseChangesService, router, vueSessionCookieService, vueJavascriptUtilityService, vuePortalService, vueLocaleConfirmationService, vueWindow) {
      this.vueNavigationService = vueNavigationService;
      this.titleService = titleService;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueTranslationService = vueTranslationService;
      this.vueConfirmLoseChangesService = vueConfirmLoseChangesService;
      this.router = router;
      this.vueSessionCookieService = vueSessionCookieService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vuePortalService = vuePortalService;
      this.vueLocaleConfirmationService = vueLocaleConfirmationService;
      this.vueWindow = vueWindow;
      this.showAccountMaint = true;
      this.applicationMenuClicked = new EventEmitter();
      this.clientMenuClicked = new EventEmitter();
      this.subMenuClicked = new EventEmitter();
      // Details for Navigation. Menu List referred in the view.
      this.clientsAndApplications = [];
      this.clientList = [];
      // Use in view to display a section or hide a section.
      this.showSideMenu = true;
      this.showSubMenu = false;
      this.showClientList = false;
      this.showPrevSubMenu = false;
      this.showApplicationList = true;
      this.showMenuButton = true;
      /**
       * Holds the Submenu history details - breadcrumb
       */
      this.previousSubMenuListStack = [];
      // Current selected Menu options.
      this.selectedMenu = new VueSelectedMenu();
      this.externalNavigationContextChanged = false;
      // These sessionStorage values will be ignored when navigating from one domain to another.
      // This addresses the 413 (request entity too large) issue we have when hydrating cookies
      // from sessionStorage.
      // This is replicated in: vue-navigation-std-right-top-menu.component.ts
      this.omitFromCookieValues = ['clientsAndApplications', 'menuTranslations', 'selectedApplication', 'navigationHistory', 'displaySubMenu'];
      this.untranslatedPrefix = '[@@';
      /**
       * Listens if another part of the app has selected an application.
       * We wait for clientsAndApplications to be loaded before
       * attempting select the application. We poll this local
       * property every 200ms until it has been loaded
       */
      this.getSelectedAppSubscription = this.vueNavigationService.getSelectedApplication().pipe(switchMap(id => timer(0, 200).pipe(filter(() => this.clientsAndApplications.length > 0), take(1), mapTo(id)))).subscribe(id => {
        const app = this.clientsAndApplications.find(a => a.id === id);
        this.callSelectApplication(app);
      });
    }
    ngOnInit() {
      // Initialize all the variables.
      this.initialize();
      if (!this.i18nBundle) {
        this.i18nBundle = this.vueAppDefaultsService.getPortalMessageBundle();
      }
      // Note: HydrateSessionFromCookies is called from performBootStrap method itself.
      if (this.isUserAuthenticated()) {
        this.portalBaseRESTURL = this.vueUserSessionService.getPortalBaseRESTURL();
        if (this.vueUserSessionService.getClientsAndApplications()) {
          const previouslyExcludedApps = this.vueUserSessionService.getExcludedApplications() || [];
          this.vueTranslationService.getTranslationBundle(this.i18nBundle, this.portalBaseRESTURL).subscribe(() => {
            this.initializeClientsAndApplication(this.vueUserSessionService.getClientsAndApplications().concat(previouslyExcludedApps), true);
            this.translation = this.vueUserSessionService.getMenuTranslations();
            this.afterUserAuthenticationProcess();
            // Only after the translation bundle is present. we have to call this method.
            // So that the translated page title can be derived after state change.
            const routeInfo = this.vueUserSessionService.getTransientRouteAndStateInfo();
            if (routeInfo && routeInfo.route) {
              this.vueNavigationService.changeCurrentMenuSelectedState(routeInfo.route.data);
            }
          });
        } else {
          // Clients and applications will be null when navigating to a different domain (as with Preview
          // and Affiliator).  In this case we need to repopulate Clients And Applications which we get
          // from the portal.
          // We don't want to make these calls until it is necessary so this flag is only true
          // if we are hydrating session storage from cookie values.
          this.vueTranslationService.getTranslationBundle(this.i18nBundle, this.portalBaseRESTURL).subscribe(() => {
            this.retrieveMenuAndCheckAuthorizationForUser();
          });
        }
      }
      /** * Define the observers *****/
      this.vueNavigationService.getMenuSelected().subscribe(newState => {
        this.setPageTitleAfterMenuSelected(newState);
      });
      this.vueNavigationService.isAuthenticationChanged().subscribe(ignored => {
        this.retrieveMenuAndCheckAuthorizationForUser();
        this.vueLocaleConfirmationService.showConfirmationIfNecessary();
      });
      this.vueConfirmLoseChangesService.getLeavePageConfirmed().subscribe(leavePageConfirmed => {
        if (leavePageConfirmed) {
          this.callMethodAfterLeavePageConfirmed();
        }
      });
      this.vueNavigationService.getLogoffState().subscribe(state => {
        if (state) {
          this.hideSideMenu();
          this.initialize();
        }
      });
      this.vueNavigationService.getCustomMenuSelected().subscribe(selected => {
        if (selected) {
          this.hideSideMenu();
        }
      });
      this.vueNavigationService.getAccountMaintSelected().subscribe(selected => {
        if (selected) {
          this.selectedMenu.userApplication = this.vueUserSessionService.getSelectedUserApplication();
          // account maintenance is not client related
          this.selectedMenu.client = null;
          this.selectedMenu.subMenu = null;
          this.hideSideMenu();
          // this.removeMenuSelection();
        }
      });
      this.vueNavigationService.getExternalNavigationContextChanged().subscribe(subject => {
        this.externalNavigationContextChanged = true;
        this.clearSelectedUserApplication();
        this.selectApplicationAndClientExternal(subject.application, subject.client);
      });
    }
    ngOnDestroy() {
      this.getSelectedAppSubscription.unsubscribe();
      if (this.refreshTokenSub) {
        this.refreshTokenSub.unsubscribe();
      }
      if (this.tokenIdSub) {
        this.tokenIdSub.unsubscribe();
      }
    }
    /** ********* PUBLIC FUNCTIONS ****************/
    callBackToMenu(menu) {
      this.clearUserPreviouslySelected();
      this.clearSelectedUserApplication();
      if (!this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        this.storeSelectedCall = menu;
        return;
      }
      switch (menu) {
        case 'backToApplications':
          {
            this.backToApplications();
            break;
          }
        case 'backToClients':
          {
            this.backToClients();
            break;
          }
        case 'backToPrevSubMenu':
          {
            this.backToPrevSubMenu();
            break;
          }
      }
    }
    callSelectApplication(application) {
      this.clearUserPreviouslySelected();
      this.clearSelectedUserApplication();
      if (this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        this.selectApplication(application);
      } else {
        this.storeSelectedObject = application;
        this.storeSelectedCall = 'SelectApplication';
      }
    }
    callSelectClient(client) {
      this.clearUserPreviouslySelected();
      this.clearSelectedUserApplication();
      if (this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        this.selectClient(client);
      } else {
        this.storeSelectedObject = client;
        this.storeSelectedCall = 'SelectClient';
      }
    }
    callSelectSubMenu(subMenu) {
      this.clearUserPreviouslySelected();
      this.clearSelectedUserApplication();
      if (this.vueConfirmLoseChangesService.menuNavigationCheck()) {
        this.selectSubMenu(subMenu);
      } else {
        this.storeSelectedObject = subMenu;
        this.storeSelectedCall = 'SelectSubMenu';
      }
    }
    retrieveMenuAndCheckAuthorizationForUser() {
      this.retrieveClientsAndApplicationsForUser().subscribe(results => {
        this.initializeClientsAndApplication(results, false);
        // Check if the user is authorized for this route.
        const routeInfo = this.vueUserSessionService.getTransientRouteAndStateInfo();
        if (routeInfo && routeInfo.route && !this.vueUserSessionService.checkAuthorizationAndSetContext(routeInfo.route, routeInfo.state)) {
          this.router.navigate(['/notAuthorized']);
        } else {
          this.afterUserAuthenticationProcess();
        }
      });
    }
    clearUserPreviouslySelected() {
      this.storeSelectedObject = null;
      this.storeSelectedCall = null;
    }
    callMethodAfterLeavePageConfirmed() {
      switch (this.storeSelectedCall) {
        case 'SelectApplication':
          {
            this.selectApplication(this.storeSelectedObject);
            break;
          }
        case 'SelectClient':
          {
            this.selectClient(this.storeSelectedObject);
            break;
          }
        case 'SelectSubMenu':
          {
            this.selectSubMenu(this.storeSelectedObject);
            break;
          }
        case 'backToApplications':
          {
            this.backToApplications();
            break;
          }
        case 'backToClients':
          {
            this.backToClients();
            break;
          }
        case 'backToPrevSubMenu':
          {
            this.backToPrevSubMenu();
            break;
          }
        default:
          {
            /* eslint-disable-next-line no-console */
            console.log('Invalid choice');
            break;
          }
      }
    }
    displayPleaseSelectIfAppNotLaunched() {
      if (!this.launchAppCalled && this.router.url !== '/pleaseSelect') {
        this.router.navigate(['pleaseSelect']);
      }
    }
    /*
     * This function determine the next step after an application is selected from the Menu.
     * if multiple client's are present, then displays the client list in the Menu.
     * if only one client, then that client is Auto-selected.
     * if the client is selected, then displays the sub menu list.
     */
    selectApplication(application) {
      this.applicationMenuClicked.emit(application);
      this.launchAppCalled = false;
      let previousApp;
      // TODO: != null is bad practice, fix and evaluate side effects
      /* eslint-disable-next-line no-eq-null */
      if (this.selectedMenu.application != null) {
        previousApp = this.selectedMenu.application;
      }
      // set new Application.
      this.selectedMenu.application = application;
      this.firstTimeLaunch = true;
      // If its a topaz app, don't do any of the stuff below
      if (application.appVersion === '3') {
        this.vueUserSessionService.setSelectedApplication(this.selectedMenu.application);
        this.vueUserSessionService.setSelectedApplicationId(this.selectedMenu.application.id);
        this.vuePortalService.loginTopazApp(application.id).subscribe({
          error: err => {
            // eslint-disable-next-line no-console
            console.error('failed to launch topaz app:', err);
          },
          next: () => {
            this.setCookies();
            this.vueWindow.open(application.defaultURI, '_blank');
          }
        });
        return;
      }
      this.helpURL = this.selectedMenu.application.helpURL;
      this.customMenuURL = this.selectedMenu.application.customMenuURL;
      // Translate the first level submenu before setting it into the User Session.
      if (this.selectedMenu.application.submenuExists && this.selectedMenu.application.doesMenuExists()) {
        const clientSubMenu = this.selectedMenu.application.applicationMenuOptions[0].clientSubMenuList[0];
        // eslint-disable-next-line no-undefined
        if (clientSubMenu && (clientSubMenu.clientId === null || undefined === clientSubMenu.clientId)) {
          this.selectedMenu.application.applicationMenuOptionsTitle = clientSubMenu.subMenuTypeKey;
        }
        this.vueTranslationService.getTranslationBundle(this.selectedMenu.application.applicationMenuOptions[0].i18nBundle, this.vueAppDefaultsService.getPortalRESTRoot()).subscribe(() => {
          this.translateApplicationMenuOptions(this.selectedMenu.application.applicationMenuOptions[0].i18nBundle, this.selectedMenu.application.applicationMenuOptions, this.selectedMenu.application.applicationMenuOptionsTitle, this.selectedMenu.application.previousSubMenuType);
        });
      }
      this.vueUserSessionService.setSelectedApplication(this.selectedMenu.application);
      this.vueUserSessionService.setSelectedApplicationId(this.selectedMenu.application.id);
      this.determineClientsToDisplay(this.selectedMenu.application, previousApp);
    }
    getDate() {
      const minutes = 2;
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      return date;
    }
    setCookies() {
      const cookieOptions = {
        domain: '.pearsonvue.com',
        expires: this.getDate(),
        namespace: '',
        path: '/'
      };
      const pathDomain = `path=${cookieOptions.path}; domain=${cookieOptions.domain};Secure`;
      const portalContext = this.getPortalContext();
      this.tokenIdSub = this.vueSessionCookieService.watchAttribute('encodedToken').subscribe(() => {
        const key = portalContext + '-idToken';
        const value = this.vueSessionCookieService.getAttribute('encodedToken');
        this.vueWindow.document.cookie = `${key}=${value}; ${cookieOptions.expires + ';'}; ${pathDomain}`;
      });
      this.refreshTokenSub = this.vueSessionCookieService.watchAttribute('refreshToken').subscribe(() => {
        const key = portalContext + '-refreshToken';
        const value = this.vueSessionCookieService.getAttribute('refreshToken');
        this.vueWindow.document.cookie = `${key}=${value}; ${cookieOptions.expires + ';'}; ${pathDomain}`;
      });
    }
    getPortalContext() {
      let context = '';
      this.vueWindow.document.cookie.split(';').filter(item => {
        if (item.includes('portal-context=')) {
          const myArray = item.split('=');
          context = myArray[1];
        }
      });
      return context;
    }
    selectClient(client) {
      this.clientMenuClicked.emit(client);
      this.launchAppCalled = false;
      // Set New Client
      this.selectedMenu.client = client;
      this.vueUserSessionService.setSelectedClient(client);
      this.vueUserSessionService.setClientId(client.clientId);
      // Clear old Menu
      this.vueUserSessionService.removeSelectedSubmenu();
      this.selectedMenu.subMenu = null;
      // Send change Client notification.
      this.vueNavigationService.changeClientCode(this.selectedMenu.client.code);
      const selectedApplication = new VueApplication(this.selectedMenu.application);
      // If no submenu exists, then launch application directly.
      if (!selectedApplication.doesMenuExists()) {
        this.launchApp();
        return;
      }
      let subMenuLocal;
      // Check to see if generic sub menu is present.
      const genericSubMenu = selectedApplication.getGenericSubMenuList();
      if (genericSubMenu) {
        subMenuLocal = this.constructDisplaySubMenu(genericSubMenu);
      }
      // Check to see if client specific sub menu is present.
      const clientSpecificSubMenu = selectedApplication.getClientSpecificSubMenuList(this.selectedMenu.client.clientId);
      if (clientSpecificSubMenu) {
        subMenuLocal = this.constructDisplaySubMenu(clientSpecificSubMenu);
      }
      this.determineSubMenuToDisplay(subMenuLocal);
      this.displayPleaseSelectIfAppNotLaunched();
    }
    selectSubMenu(subMenu) {
      this.subMenuClicked.emit(subMenu);
      this.launchAppCalled = false;
      this.selectedSubMenuId = subMenu.subMenuId;
      this.selectedMenu.subMenu = subMenu;
      this.vueUserSessionService.setSelectedSubmenu(subMenu);
      // Create a submenu navigation history for the selected application. This will be done only when
      // submenu exist and is greater than 1. Single menu option will be selected by default. The last
      // level of submenu need not be saved in history as the current object will hold it.
      // Check if we have reached the last level of the submenu (URL != null). If not then move to the
      // next submenu level
      if (this.selectedMenu.subMenu.subMenuURL) {
        // first replace any instance of [client] with actual client ID
        let launchURL = subMenu.subMenuURL;
        if (launchURL.indexOf(':clientID') > -1) {
          launchURL = launchURL.replace(':clientID', this.selectedMenu.client.clientId);
        }
        // -- Start changes for dynamic site selection for test center realm applications in Connect portal
        let siteID = this.vueSessionCookieService.getAttribute('siteID', 'VUE');
        const realmDetail = this.vueUserSessionService.getRealmDetail();
        if (!siteID && realmDetail) {
          siteID = realmDetail.siteID;
          this.vueSessionCookieService.setAttribute('siteID', siteID, 'VUE');
        }
        if (launchURL.indexOf(':siteID') > -1) {
          launchURL = launchURL.replace(':siteID', siteID);
        }
        // -- End changes for Connect portal
        // Launch the application while coming in for the first time
        if (this.firstTimeLaunch) {
          this.launchApp();
          this.firstTimeLaunch = false;
        } else {
          this.launchAppCalled = true;
          this.router.navigate([launchURL]);
        }
      } else {
        this.storePrevSubMenu();
        // Move to the next sub level
        this.displaySubMenu = this.constructDisplaySubMenu(this.selectedMenu.subMenu);
        this.vueUserSessionService.setDisplaySubmenu(this.displaySubMenu);
        this.storeSubMenuTitle(this.displaySubMenu.translatedSubMenuTitle, this.displaySubMenu.translatedPrevSubMenuTypeTitle);
      }
      this.displayPleaseSelectIfAppNotLaunched();
    }
    storePrevSubMenu() {
      this.prevSubMenu = new VueDisplaySubMenu(this.displaySubMenu.subMenuList, this.displaySubMenu.subMenuTypeKey, this.displaySubMenu.prevSubMenuTypeKey, this.displaySubMenu.subMenuId);
      this.prevSubMenu.translatedSubMenuTitle = this.displaySubMenu.translatedSubMenuTitle;
      this.prevSubMenu.translatedPrevSubMenuTypeTitle = this.displaySubMenu.translatedPrevSubMenuTypeTitle;
      if (this.prevSubMenu && !this.prevSubMenu.isSubMenuEmpty()) {
        this.previousSubMenuListStack.push(this.prevSubMenu);
      }
      // Store the previous submenu list in selected application also. So, it will get passed via the cookie.
      this.selectedMenu.application.navigationHistory = {
        ang6: {
          previousSubMenuListStack: this.previousSubMenuListStack
        }
      };
      this.vueUserSessionService.setSelectedApplication(this.selectedMenu.application);
    }
    goToDefaultStateIfNoAppState() {
      this.router.navigate(['pleaseSelect']);
    }
    getTranslation(key) {
      const portalMessageBundle = this.vueAppDefaultsService.getPortalMessageBundle();
      return this.vueTranslationService.getTranslation(portalMessageBundle, key);
    }
    hideSideMenu() {
      this.showSideMenu = false;
      this.vueNavigationService.changeCurrentMenuStateClosed();
    }
    toggleSideMenu() {
      this.showSideMenu = !this.showSideMenu;
      if (this.showSideMenu) {
        this.vueNavigationService.changeCurrentMenuStateOpen();
      } else {
        this.vueNavigationService.changeCurrentMenuStateClosed();
      }
    }
    /** ********* PUBLIC FUNCTIONS USED FOR SHOW/HIDE a view section****************/
    isMenuOverridden() {
      return this.vueAppDefaultsService.getNavigationOverrideMenu() !== '';
    }
    isUserAuthenticated() {
      return this.vueUserSessionService.isUserAuthenticated();
    }
    isUserApplicationSelected() {
      return Boolean(this.selectedMenu.userApplication);
    }
    /**
     * Returns true if the application list should be shown in the side menu
     */
    showApplicationSideMenu() {
      return this.showSideMenu && this.showApplicationList && !this.showClientList && !this.showSubMenu;
    }
    showBackToApplications() {
      return !this.showBackToClients() && this.clientsAndApplications.length > 1 && !this.showBackToPreviousSubMenu();
    }
    showBackToClients() {
      return this.clientList && this.clientList.length > 1 && !this.showBackToPreviousSubMenu();
    }
    showBackToPreviousSubMenu() {
      return this.previousSubMenuListStack.length >= 1;
    }
    /**
     * Returns true if the client list should be shown in the side menu
     */
    showClientSideMenu() {
      return this.showSideMenu && this.showClientList && this.clientList && this.clientList.length > 1;
    }
    userHasMultipleApplications() {
      return this.clientsAndApplications.length > 1 || Boolean(this.vueUserSessionService.getExcludedApplications()) && this.vueUserSessionService.getExcludedApplications().length > 1;
    }
    // These next three methods are used for keeping the highlight on the currently selected menu option.
    // See the CSS class that is added in the HTML file.
    isAppCurrentlySelected(applicationObject) {
      return applicationObject && this.selectedMenu.application && applicationObject.id === this.selectedMenu.application.id && applicationObject.name === this.selectedMenu.application.name;
    }
    isClientCurrentlySelected(clientObject) {
      return clientObject && this.selectedMenu.client && clientObject.clientId === this.selectedMenu.client.clientId;
    }
    isSubMenuCurrentlySelected(subMenuObject) {
      return subMenuObject && subMenuObject.subMenuId === this.selectedSubMenuId;
    }
    /** ********* PRIVATE FUNCTIONS****************/
    findApplicationById() {
      const clientsAndApplications = this.vueUserSessionService.getClientsAndApplications();
      const appId = this.vueUserSessionService.getSelectedApplicationId();
      if (!clientsAndApplications || !appId) {
        return null;
      }
      for (let i = 0; i < clientsAndApplications.length; i++) {
        if (clientsAndApplications[i].id === appId) {
          return new VueApplication(clientsAndApplications[i]);
        }
      }
      return null;
    }
    /* eslint-disable-next-line complexity */
    afterUserAuthenticationProcess() {
      if (this.vueUserSessionService.getSelectedApplication()) {
        this.selectedMenu.application = new VueApplication(this.vueUserSessionService.getSelectedApplication());
      } else {
        this.selectedMenu.application = this.findApplicationById();
        this.vueUserSessionService.setSelectedApplication(this.selectedMenu.application);
      }
      if (this.vueUserSessionService.getNavigationHistory() && this.selectedMenu.application && !this.isNavigationHistoryFound()) {
        this.selectedMenu.application.navigationHistory = this.vueUserSessionService.getNavigationHistory();
        this.vueUserSessionService.setSelectedApplication(this.selectedMenu.application);
      }
      if (this.vueUserSessionService.getSelectedClient()) {
        this.selectedMenu.client = new VueClient(this.vueUserSessionService.getSelectedClient());
      }
      if (this.vueUserSessionService.getSelectedUserApplication()) {
        this.selectedMenu.userApplication = this.vueUserSessionService.getSelectedUserApplication();
      }
      if (this.vueUserSessionService.getSelectedSubmenu() && this.selectedMenu.application.doesMenuExists()) {
        this.selectedMenu.subMenu = new VueSubMenu(this.vueUserSessionService.getSelectedSubmenu());
        this.selectedSubMenuId = this.vueUserSessionService.getSelectedSubmenu().subMenuId;
      }
      if (this.selectedMenu.application) {
        this.helpURL = this.selectedMenu.application.helpURL;
        this.customMenuURL = this.selectedMenu.application.customMenuURL;
        this.clientList = this.selectedMenu.application.clients;
        // If application not client restricted there should be no client selected and because there are no clients
        if (!this.selectedMenu.application.clientRestricted && !this.clientList?.length) {
          this.vueUserSessionService.removeSelectedClient();
          this.vueUserSessionService.removeClientId();
          this.selectedMenu.client = null;
        }
      }
      if (this.selectedMenu.application && this.selectedMenu.client && !this.selectedMenu.subMenu && this.clientList && this.clientList.length > 1) {
        this.showApplicationList = false;
        this.showSubMenu = false;
        this.showClientList = true;
      } else if (this.selectedMenu.application && this.selectedMenu.subMenu && this.selectedMenu.application.applicationMenuOptions && this.selectedMenu.application.applicationMenuOptions.length > 0) {
        // Scenario: user with access to single application, single client, multiple sub menu options
        // AND user has selected a menu item
        if (this.clientList?.length === 1 && this.selectedMenu.subMenu) {
          this.showApplicationList = false;
          this.showSubMenu = true;
          this.showClientList = false;
          // Prevent reloading entire app on subsequent submenu selections
          this.firstTimeLaunch = false;
          this.launchAppCalled = true;
        }
        this.vueTranslationService.getTranslationBundle(this.selectedMenu.application.applicationMenuOptions[0].i18nBundle, this.portalBaseRESTURL).subscribe(() => {
          this.reBuildNavigationBreadcrumb();
        });
      } else {
        this.showApplicationList = true;
      }
    }
    /**
     * This method builds the menu list to be displayed and a stack of previous submenus. This is based on the history
     * read from the session
     *
     * @param navigationHistory
     *    History object with submenu details
     */
    buildNavigationStack(navigationHistory) {
      const previousSubMenuListStack = navigationHistory.ang6.previousSubMenuListStack;
      const subMenu = this.vueUserSessionService.getDisplaySubmenu();
      const displaySubMenu = new VueDisplaySubMenu(subMenu.subMenuList, subMenu.subMenuTypeKey, subMenu.prevSubMenuTypeKey, subMenu.subMenuId);
      displaySubMenu.translatedSubMenuTitle = subMenu.translatedSubMenuTitle;
      displaySubMenu.translatedPrevSubMenuTypeTitle = subMenu.translatedPrevSubMenuTypeTitle;
      this.previousSubMenuListStack = previousSubMenuListStack;
      this.displaySubMenu = this.constructDisplaySubMenu(displaySubMenu);
    }
    /**
     * This method builds the menu list to be displayed and a stack of previous submenus. This is based on the history
     * read from the older angular version
     *
     * @param navigationHistory
     *    History object with submenu details
     */
    buildOldNavigationStack(navigationHistory) {
      const oldSubMenu = navigationHistory.selectedSubmenu;
      const displaySubMenu = new VueDisplaySubMenu(oldSubMenu.subMenuList, oldSubMenu.subMenuTypeKey, oldSubMenu.prevSubMenuTypeKey, oldSubMenu.subMenuId);
      displaySubMenu.translatedSubMenuTitle = oldSubMenu.translatedSubMenuName;
      this.previousSubMenuListStack = this.convertNavigationHistoryToNewType(navigationHistory);
      this.displaySubMenu = this.constructDisplaySubMenu(displaySubMenu);
    }
    /**
     * This method is used to build a new navigation stack based on the selectedSubmenuId. The application's original
     * submenu structure is retrieved and the navigation is backtracked from the last submenu selected using the
     * submenu IDs
     */
    createFreshNavigationStack() {
      const selectedApplication = new VueApplication(this.selectedMenu.application);
      let applicationSubmenu;
      // Check to see if generic sub menu is present.
      applicationSubmenu = new VueClientSubMenu(selectedApplication.getGenericSubMenuList());
      if (!Object.keys(applicationSubmenu).length && this.selectedMenu.client?.clientId) {
        applicationSubmenu = new VueClientSubMenu(selectedApplication.getClientSpecificSubMenuList(this.selectedMenu.client.clientId));
      }
      const reverseSubMenu = [];
      const previousSubMenuListStack = [];
      if (this.selectedSubMenuId) {
        let submenuLevel = applicationSubmenu.findSubmenuLevel(this.selectedSubMenuId);
        // Loop until we reach the top most level (first submenu level)
        while (submenuLevel && submenuLevel.subMenuId) {
          reverseSubMenu.push(this.constructDisplaySubMenu(submenuLevel));
          submenuLevel = applicationSubmenu.findSubmenuLevel(submenuLevel.subMenuId);
        }
        reverseSubMenu.push(this.constructDisplaySubMenu(submenuLevel));
        // Reverse the list so that the top one is the latest menu
        while (reverseSubMenu.length > 0) {
          previousSubMenuListStack.push(reverseSubMenu.pop());
        }
        this.displaySubMenu = previousSubMenuListStack.pop();
        this.previousSubMenuListStack = previousSubMenuListStack;
        this.storeSubMenuTitle(this.displaySubMenu.translatedSubMenuTitle, this.displaySubMenu.translatedPrevSubMenuTypeTitle);
        this.vueUserSessionService.setDisplaySubmenu(this.displaySubMenu);
      }
    }
    /**
     * This method reads the navigation history stack from the older angular version (angular-js-commons) to the new
     * format
     *
     * @param navigationHistory
     *    History object with navigation details
     */
    convertNavigationHistoryToNewType(navigationHistory) {
      const reverseSubMenu = [];
      const previousSubMenuListStack = [];
      while (navigationHistory.selectedSubmenu) {
        let subMenuId;
        let prevSubMenuTypeKey;
        if (navigationHistory.selectedSubmenu.previousSubmenu) {
          subMenuId = navigationHistory.selectedSubmenu.previousSubmenu.subMenuId;
          prevSubMenuTypeKey = navigationHistory.selectedSubmenu.previousSubmenu.prevSubMenuTypeKey;
        }
        const displaySubMenu = new VueDisplaySubMenu(navigationHistory.selectedSubmenu.previousSubmenuList, navigationHistory.selectedSubmenu.previousSubmenuTitle, prevSubMenuTypeKey, subMenuId);
        reverseSubMenu.push(this.constructDisplaySubMenu(displaySubMenu));
        navigationHistory.selectedSubmenu = navigationHistory.selectedSubmenu.previousSubmenu;
      }
      while (reverseSubMenu.length > 0) {
        previousSubMenuListStack.push(reverseSubMenu.pop());
      }
      return previousSubMenuListStack;
    }
    /**
     * Checks if the new version of angular history is found
     *
     * @return True if the history is found
     */
    isNavigationHistoryFound() {
      return this.selectedMenu.application && this.selectedMenu.application.navigationHistory && this.selectedMenu.application.navigationHistory.ang6;
    }
    /**
     * This method is called when we have to build the navigation menu by using the values from session.
     * The two scenarios here are,
     *  1. When we move from an older angular app to this current VUEFramework based app
     *  2. Switching within the same VUEFramework version (or page refresh).
     *
     *  If existing navigation history is not present in the session, a new stack will be created based on the
     *  last submenu selected
     */
    reBuildNavigationBreadcrumb() {
      const navigationHistory = this.selectedMenu.application.navigationHistory;
      // Potentially an empty object
      if (navigationHistory && Object.keys(navigationHistory).length > 0) {
        if (!navigationHistory.ang6) {
          this.buildOldNavigationStack(navigationHistory);
        } else {
          this.buildNavigationStack(navigationHistory);
        }
        this.vueUserSessionService.setDisplaySubmenu(this.displaySubMenu);
        this.storeSubMenuTitle(this.displaySubMenu.translatedSubMenuTitle, this.displaySubMenu.translatedPrevSubMenuTypeTitle);
      } else {
        this.createFreshNavigationStack();
      }
      // show subMenu
      this.showApplicationList = false;
      this.showSubMenu = true;
      this.showClientList = false;
    }
    backToApplications() {
      this.selectedMenu.subMenu = null;
      this.selectedSubMenuId = null;
      this.selectedMenu.client = null;
      this.clientList = [];
      this.vueUserSessionService.removeSelectedSubmenu();
      this.vueUserSessionService.removeSelectedClient();
      this.showSubMenu = false;
      this.showClientList = false;
      this.showApplicationList = true;
    }
    backToClients() {
      this.selectedMenu.subMenu = null;
      this.selectedSubMenuId = null;
      // update userSessionService.
      this.vueUserSessionService.removeSelectedSubmenu();
      this.showSubMenu = false;
      this.showClientList = true;
    }
    backToPrevSubMenu() {
      const currentDisplaySubMenu = new VueDisplaySubMenu(null, null, null, this.vueUserSessionService.getDisplaySubmenu().subMenuId);
      this.selectedSubMenuId = currentDisplaySubMenu.subMenuId;
      this.displaySubMenu = this.previousSubMenuListStack.pop();
      this.vueUserSessionService.setDisplaySubmenu(this.displaySubMenu);
      this.storeSubMenuTitle(this.displaySubMenu.translatedSubMenuTitle, this.displaySubMenu.translatedPrevSubMenuTypeTitle);
    }
    clearSelectedUserApplication() {
      if (this.selectedMenu.userApplication || this.vueUserSessionService.getSelectedUserApplication()) {
        this.selectedMenu.userApplication = null;
        this.vueUserSessionService.removeSelectedUserApplication();
      }
    }
    // Takes input parameter as VueClientSubMenu and VueSubMenu.
    constructDisplaySubMenu(subMenu) {
      const tempSubMenu = new VueDisplaySubMenu(subMenu.subMenuList, subMenu.subMenuTypeKey, subMenu.prevSubMenuTypeKey, subMenu.subMenuId);
      tempSubMenu.translatedSubMenuTitle = subMenu.translatedSubMenuTitle;
      tempSubMenu.translatedPrevSubMenuTypeTitle = subMenu.translatedPrevSubMenuTypeTitle;
      this.translateSubMenuList(this.selectedMenu.application.applicationMenuOptions[0].i18nBundle, tempSubMenu);
      return tempSubMenu;
    }
    // eslint-disable-next-line complexity
    determineClientsToDisplay(application, previousApp) {
      // Determine the client List to display.
      this.clientList = application.clients;
      this.selectedMenu.subMenu = null;
      this.vueUserSessionService.removeSelectedSubmenu();
      // If no clients exists, see if there are submenu's.
      if (this.clientList && this.clientList.length === 0) {
        // If no submenu exists, then launch application directly.
        if (!this.selectedMenu.application.doesMenuExists()) {
          // Sanitize any selected clients from another application before launching a client-less application.
          if (!application.clientRestricted && this.vueUserSessionService.getSelectedClient()) {
            this.vueUserSessionService.removeSelectedClient();
            this.vueUserSessionService.removeClientId();
          }
          this.launchApp();
        } else {
          // Check to see if generic sub menu is present.
          const genericSubMenu = this.selectedMenu.application.getGenericSubMenuList();
          if (genericSubMenu) {
            this.determineSubMenuToDisplay(this.constructDisplaySubMenu(genericSubMenu));
          }
        }
      } else if (this.clientList && this.clientList.length === 1) {
        // Auto-Select the existing one client.
        this.selectClient(this.clientList[0]);
      } else {
        // With MultipleClients. Show clients list.
        if (previousApp && !previousApp.external) {
          this.displayPleaseSelectIfAppNotLaunched();
        }
        this.showApplicationList = false;
        this.showClientList = true;
        if (this.showSideMenu) {
          this.vueNavigationService.changeCurrentMenuStateOpen();
        }
      }
    }
    determineSubMenuToDisplay(subMenu) {
      // If no sub menu list is present. Launch application directly.
      if (subMenu.isSubMenuEmpty()) {
        this.launchApp();
      } else {
        // check to see if one menu or default sub menu is present to auto-select.
        this.selectedMenu.subMenu = subMenu.getDefaultSubMenu();
        if (this.selectedMenu.subMenu) {
          // you don't want to come to the default subMenu.
          // this.vueUserSessionService.setSelectedSubmenu(<any> this.selectedMenu.subMenu);
          this.launchApp();
        } else {
          // Multiple subMenu is present.
          this.storeSubMenuTitle(subMenu.translatedSubMenuTitle, null);
          this.displaySubMenu = subMenu;
          this.showSubMenu = true;
          this.showClientList = false;
          this.showApplicationList = false;
        }
      }
    }
    initialize() {
      this.customMenuURL = null;
      /* Details for Navigation. Menu List referred in the view.*/
      this.clientsAndApplications = [];
      this.clientList = [];
      this.displaySubMenu = new VueDisplaySubMenu(null, null, null, null);
      this.launchAppCalled = false;
      this.prevSubMenu = null;
      // Current selected Menu options.
      this.selectedMenu = new VueSelectedMenu();
      this.selectedSubMenuId = null;
      // Storing the previously selected option.
      this.previousSubMenuListStack = [];
      // Use in view to display a section or hide a section.
      this.showSideMenu = true;
      this.showSubMenu = false;
      this.showClientList = false;
      this.showPrevSubMenu = false;
      this.showApplicationList = true;
      this.translation = {};
    }
    // eslint-disable-next-line complexity
    initializeClientsAndApplication(appList, populateFromCookie) {
      let jsonObj;
      const clientsAndApplicationsUnsorted = [];
      const excludedApplications = [];
      // For test Moce we need to parse the Json
      // if (!populateFromCookie)
      if (this.isMenuOverridden() && !populateFromCookie) {
        // string to generic object first
        jsonObj = JSON.parse(appList);
      } else {
        jsonObj = appList;
      }
      const apps = jsonObj;
      /* Json Parsed object should be assigned via the constructor only.
       * Otherwise the functions inside the class will not be accessible.
       */
      for (const appObj of apps) {
        clientsAndApplicationsUnsorted.push(new VueApplication(appObj));
      }
      // When you populate from cookies from Angular 1 then you need to do the translation.
      // if (!populateFromCookie) {
      // Translate Title/label Terms.
      this.translateTerms(this.i18nBundle);
      // Populate translated Name.
      for (let i = 0; i < clientsAndApplicationsUnsorted.length; i++) {
        clientsAndApplicationsUnsorted[i].translatedName = this.vueTranslationService.getTranslation(this.i18nBundle, clientsAndApplicationsUnsorted[i].name);
        if (clientsAndApplicationsUnsorted[i].submenuRetrievalSuccess === false && clientsAndApplicationsUnsorted[i].submenuExists) {
          excludedApplications.push(clientsAndApplicationsUnsorted[i]);
        }
      }
      this.clientsAndApplications = clientsAndApplicationsUnsorted.slice(0);
      this.clientsAndApplications.sort((leftSide, rightSide) => {
        if (leftSide.translatedName < rightSide.translatedName) {
          return -1;
        }
        if (leftSide.translatedName > rightSide.translatedName) {
          return 1;
        }
        return 0;
      });
      // Portal app needs to enableSubmenuMessage or individual app check already excluded in session by Portal app
      this.handleExcludeApplication(excludedApplications);
      this.vueUserSessionService.setClientsAndApplications(this.clientsAndApplications);
      // Checking whether submenu item has been clicked
      // Without this check, selectApplication() -> determineClientsToDisplay() removes cached submenu
      // And treats submenu selections as first time app launches, navigation user to pleaseSelect page
      const previouslySelectedSubmenuItem = this.vueUserSessionService.getSelectedSubmenu();
      // if only one application, then auto-select.
      // if user has not selected a submenu item.
      // if no applications, direct to /noApplications
      if (this.clientsAndApplications.length === 1 && excludedApplications.length === 0 && !previouslySelectedSubmenuItem) {
        this.selectApplication(this.clientsAndApplications[0]);
      } else if (this.clientsAndApplications.length === 0) {
        this.showMenuButton = false;
        this.hideSideMenu();
        this.router.navigate(['/noApplications']);
      } else {
        this.vueNavigationService.changeCurrentMenuStateOpen();
      }
    }
    handleExcludeApplication(excludedApplications) {
      const prevExcluded = this.vueUserSessionService.getExcludedApplications();
      if (this.vueAppDefaultsService.enableSubmenuMessage() || prevExcluded && prevExcluded.length > 0) {
        this.clientsAndApplications = this.clientsAndApplications.filter(app => excludedApplications.indexOf(app) === -1);
        this.vueUserSessionService.setExcludedApplications(excludedApplications);
      } else {
        this.vueUserSessionService.setExcludedApplications([]);
      }
    }
    /* eslint-disable-next-line complexity */
    launchApp() {
      this.launchAppCalled = true;
      // Hide the menu only if there is no subMenu
      if (!this.selectedMenu.application.doesMenuExists()) {
        this.showSubMenu = false;
        this.hideSideMenu();
      } else {
        this.showSubMenu = true;
      }
      this.clearSelectedUserApplication();
      // First replace any instance of [client] with actual client ID.
      let launchURL = this.selectedMenu.application.defaultURI;
      if (launchURL.indexOf(':clientID') > -1) {
        launchURL = launchURL.replace(':clientID', this.selectedMenu.client.clientId);
      }
      // -- Start changes for dynamic site selection for test center realm applications in Connect portal
      let siteId = this.vueSessionCookieService.getAttribute('siteID', 'VUE');
      const realmDetail = this.vueUserSessionService.getRealmDetail();
      if (!siteId && realmDetail) {
        siteId = realmDetail.siteID;
        this.vueSessionCookieService.setAttribute('siteID', siteId, 'VUE');
      }
      // Replace site ID placeholder with selected/logged in Site ID
      if (launchURL.indexOf(':siteID') > -1) {
        launchURL = launchURL.replace(':siteID', siteId);
      }
      // -- End changes for Connect portal
      // If a submenu is selected then replace the location path with the submenu URL.
      if (this.selectedMenu.isSubMenuSelected()) {
        let subMenuPath = this.selectedMenu.subMenu.subMenuURL;
        if (subMenuPath.indexOf(':siteID') > -1) {
          subMenuPath = subMenuPath.replace(':siteID', siteId);
        }
        if (subMenuPath.indexOf(':clientID') > -1) {
          subMenuPath = subMenuPath.replace(':clientID', this.selectedMenu.client.clientId);
        }
        if (this.selectedMenu.application.external && launchURL.indexOf('#') === -1) {
          launchURL += subMenuPath;
        } else {
          const url = launchURL.substring(launchURL.indexOf('#') + 1);
          launchURL = launchURL.replace(url, subMenuPath);
        }
      }
      if (!this.vueJavascriptUtilityService.isCurrentDomain(launchURL)) {
        this.vueSessionCookieService.hydrateCookiesFromSession(null, this.omitFromCookieValues);
      }
      if (!this.selectedMenu.application.external && !this.selectedMenu.application.externalAppLauncher) {
        // next, the URL is either a Angular relative or a full URL
        if (launchURL.indexOf('/') === 0) {
          this.router.navigate([launchURL]);
        } else {
          this.vueWindow.location.href = launchURL;
        }
      } else if (this.selectedMenu.application.externalAppLauncher) {
        this.vueUserSessionService.setHelpContext('');
        if (launchURL.indexOf('/') === 0) {
          this.router.navigate([launchURL], {
            queryParams: {
              appId: this.selectedMenu.application.id
            }
          });
        } else {
          this.vueWindow.location.href = launchURL + '?appId=' + this.selectedMenu.application.id;
        }
      } else if (this.vueWindow.location.href.indexOf(launchURL) === -1) {
        /*
         * If the app is external, launch in a new window
         * if and only if we're not already there :-)
         */
        this.vueWindow.location.href = launchURL;
      }
    }
    retrieveClientsAndApplicationsForUser() {
      this.initialize();
      let appList;
      let timeDelay;
      if (!this.isMenuOverridden() && !this.vueUserSessionService.getClientsAndApplications()) {
        return this.vuePortalService.getApplicationsForUser(this.portalBaseRESTURL, null).pipe(tap(results => this.initializeClientsAndApplication(results, false)));
      } else if (this.isMenuOverridden()) {
        appList = this.vueAppDefaultsService.getNavigationOverrideMenu();
        // SDW - not sure what this is - Sudha had timeDelay of 4000 for framework sample app
        // but this works.  Mental note to circle back
        timeDelay = 10;
      }
      return new Observable(observer => {
        setTimeout(() => {
          observer.next(appList);
          observer.complete();
        }, timeDelay);
      });
    }
    selectApplicationAndClientExternal(application, client) {
      const submenu = this.vueUserSessionService.getSelectedSubmenu();
      if (application) {
        this.selectedMenu.application = new VueApplication(application);
        this.vueUserSessionService.setSelectedApplication(application);
        this.vueUserSessionService.setSelectedApplicationId(application.id);
        this.clientList = application.clients;
      }
      if (client) {
        this.selectedMenu.client = new VueClient(client);
        this.vueUserSessionService.setSelectedClient(client);
        this.vueUserSessionService.setClientId(client.clientId);
      }
      // If a submenu is already selected then we need to retain it
      if (application && !client && !submenu) {
        this.showApplicationList = true;
        this.showClientList = false;
        this.selectApplication(this.selectedMenu.application);
      } else if (application && client && !submenu) {
        this.showApplicationList = false;
        this.showClientList = true;
        this.selectClient(this.selectedMenu.client);
      }
    }
    setPageTitleAfterMenuSelected(newState) {
      this.applicationTitle = newState.title;
      let translatedTitle = '';
      if (newState.pageTitle && newState.pageTitle.key) {
        let bundle = this.vueAppDefaultsService.getPortalMessageBundle();
        if (newState.pageTitle.i18nBundle) {
          bundle = newState.pageTitle.i18nBundle;
        }
        this.vueTranslationService.getTranslationBundle(bundle, this.portalBaseRESTURL).subscribe(() => {
          translatedTitle = this.vueTranslationService.getTranslation(bundle, newState.pageTitle.key);
          const prefix = this.vueAppDefaultsService.getDefaultPageTitle() || 'Pearson VUE';
          if (translatedTitle.startsWith(this.untranslatedPrefix)) {
            this.titleService.setTitle(prefix);
          } else {
            this.titleService.setTitle(`${prefix}-${translatedTitle}`);
          }
        });
      } else {
        /* eslint-disable-next-line no-console */
        console.warn('You have not defined pageTitle element on your route');
      }
      // Do we need this here? this.helpURL = newState.helpURL;
    }
    storeSubMenuTitle(newSubMenuTitle, prevSubMenuTitle) {
      if (prevSubMenuTitle) {
        this.translation.PrevSubMenuTitle = prevSubMenuTitle;
      }
      this.translation.SubMenuTitle = newSubMenuTitle;
      this.vueUserSessionService.setMenuTranslations(this.translation);
    }
    /**
     *  call this before you call this method:
     *  this.vueTranslationService.getTranslationBundle(i18nBundle, this.vueAppDefaultsService.getPortalRESTRoot())
     * Translate the given application's submenu details. The translated Submenu title and labels will
     * be saved to the session
     * @param i18nBundle
     * @param applicationMenuOptions submenu
     * @param subMenuTitle
     * @param previousSubMenuTitle
     */
    translateApplicationMenuOptions(i18nBundle, applicationMenuOptions, /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    subMenuTitle, previousSubMenuTitle) {
      if (subMenuTitle) {
        this.storeSubMenuTitle(this.vueTranslationService.getTranslation(i18nBundle, subMenuTitle), null);
      }
      for (let j = 0; j < applicationMenuOptions[0].clientSubMenuList.length; j++) {
        for (let i = 0; i < applicationMenuOptions[0].clientSubMenuList[j].subMenuList.length; i++) {
          let translatedSubMenuName = null;
          if (applicationMenuOptions[0].clientSubMenuList[j].subMenuList[i].subMenuNameKey) {
            translatedSubMenuName = this.vueTranslationService.getTranslation(i18nBundle, applicationMenuOptions[0].clientSubMenuList[j].subMenuList[i].subMenuNameKey);
          } else {
            translatedSubMenuName = applicationMenuOptions[0].clientSubMenuList[j].subMenuList[i].subMenuName;
          }
          applicationMenuOptions[0].clientSubMenuList[j].subMenuList[i].translatedSubMenuName = translatedSubMenuName;
        }
      }
    }
    translateSubMenuList(i18nBundle, displaySubMenu) {
      // Translate the submenu title.
      displaySubMenu.translatedSubMenuTitle = this.vueTranslationService.getTranslation(i18nBundle, displaySubMenu.subMenuTypeKey);
      displaySubMenu.translatedPrevSubMenuTypeTitle = this.vueTranslationService.getTranslation(i18nBundle, displaySubMenu.prevSubMenuTypeKey);
      for (let i = 0; i < displaySubMenu.subMenuList.length; i++) {
        if (!displaySubMenu.subMenuList[i].translatedSubMenuName) {
          let translatedSubMenuName = null;
          if (displaySubMenu.subMenuList[i].subMenuNameKey) {
            translatedSubMenuName = this.vueTranslationService.getTranslation(i18nBundle, displaySubMenu.subMenuList[i].subMenuNameKey);
          } else {
            translatedSubMenuName = displaySubMenu.subMenuList[i].subMenuName;
          }
          displaySubMenu.subMenuList[i].translatedSubMenuName = translatedSubMenuName;
        }
      }
    }
    translateTerms(i18nBundle) {
      forkJoin([this.vueTranslationService.getTranslationBundle(i18nBundle, null), this.vueTranslationService.getTranslationBundle(this.vueTranslationService.portalBaseBundle, null)]).subscribe(() => {
        this.translation['label.Help'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Help');
        this.translation['label.Account'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Account');
        this.translation['label.CustomMenuName'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.CustomMenuName');
        this.translation['label.Logout'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Logout');
        this.translation['label.Applications'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Applications');
        this.translation['label.Clients'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Clients');
        this.translation['label.Submenu'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.Submenu');
        this.translation['label.BackToApplications'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.BackToApplications');
        this.translation['label.BackToClients'] = this.vueTranslationService.getTranslation(i18nBundle, 'label.BackToClients');
        this.translation['pageTitle.menu'] = this.vueTranslationService.getTranslation(this.vueTranslationService.portalBaseBundle, 'pageTitle.menu');
        this.vueUserSessionService.setMenuTranslations(this.translation);
      });
    }
    static {
      this.ɵfac = function VueNavigationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNavigationComponent)(i0.ɵɵdirectiveInject(VueNavigationService), i0.ɵɵdirectiveInject(i2$1.Title), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueUserSessionService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueConfirmLoseChangesService), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueSessionCookieService), i0.ɵɵdirectiveInject(VueJavascriptUtilityService), i0.ɵɵdirectiveInject(VuePortalService), i0.ɵɵdirectiveInject(VueLocaleConfirmationService), i0.ɵɵdirectiveInject(WINDOW));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNavigationComponent,
        selectors: [["vue-navigation"]],
        viewQuery: function VueNavigationComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.navigationStdRightTopMenu = _t.first);
          }
        },
        inputs: {
          imagePath: "imagePath",
          showAccountMaint: "showAccountMaint",
          accountMaintLink: "accountMaintLink",
          customHeaderDetail: "customHeaderDetail",
          i18nBundle: "i18nBundle",
          firstTimeLaunch: "firstTimeLaunch"
        },
        outputs: {
          applicationMenuClicked: "applicationMenuClicked",
          clientMenuClicked: "clientMenuClicked",
          subMenuClicked: "subMenuClicked"
        },
        standalone: false,
        decls: 2,
        vars: 2,
        consts: [["navigationStdRightTopMenu", ""], ["role", "banner", 1, "pearson-header-neutral", "dashboard", "custom-brand-color"], ["role", "navigation"], ["id", "sidebar-button", 1, "sidebar-toggle"], [3, "click", "hidden"], ["icon", "bars", 1, "fa", "fa-lg", "fa-fw"], [1, "sidebar-button-text"], [3, "imagePath"], [3, "menu", "customHeaderDetail"], [3, "helpURL", "customMenuURL", "showAccountMaint", "accountMaintLink", "translation"], ["role", "menu"], [1, "navigation-logo"], [1, "pearson"], ["id", "nav-app-header"], ["role", "menuitem", 3, "label"], ["role", "menuitem", 3, "selected", "label"], ["id", "nav-client-header"], ["role", "menuitem", 3, "isBackButton", "label"], ["role", "menuitem", 3, "selected", "isBackButton", "label"], ["id", "nav-submenu-header"]],
        template: function VueNavigationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueNavigationComponent_Conditional_0_Template, 14, 22, "header", 1)(1, VueNavigationComponent_Conditional_1_Template, 8, 3, "nav", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isUserAuthenticated() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSideMenu && ctx.isUserAuthenticated() ? 1 : -1);
          }
        },
        dependencies: [i1$2.FaIconComponent, VueNavigationLogoComponent, VueNavigationBreadCrumbComponent, VueNavigationStdRightTopMenuComponent, VueNavigationMenuComponent, VueNavigationMenuItemComponent, i2.AsyncPipe, VueTranslatePipe, VueArraySortPipe],
        styles: ["header[_ngcontent-%COMP%]{display:flex}.sidebar-toggle[_ngcontent-%COMP%]{cursor:pointer;display:inline-block}#sidebar-button[_ngcontent-%COMP%]{padding:3px 10px}#sidebar-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#333;font-size:11px;border:1px solid #c5c5c5;padding:8px 10px;border-radius:2px;background-color:#eee}.sidebar-button-text[_ngcontent-%COMP%]{display:none;font-size:12px;margin-inline-start:5px}vue-navigation-bread-crumb[_ngcontent-%COMP%]{flex:1}@media (min-width: 767px){#sidebar-button[_ngcontent-%COMP%]{padding:8px 15px}.sidebar-button-text[_ngcontent-%COMP%]{display:inline}}nav[_ngcontent-%COMP%]{position:fixed;top:45px;bottom:0;background-color:#fff;width:210px}.accept-cookie[_nghost-%COMP%]   nav[_ngcontent-%COMP%], .accept-cookie   [_nghost-%COMP%]   nav[_ngcontent-%COMP%]{top:95px}@media (min-width: 767px){nav[_ngcontent-%COMP%]{top:55px}.accept-cookie[_nghost-%COMP%]   nav[_ngcontent-%COMP%], .accept-cookie   [_nghost-%COMP%]   nav[_ngcontent-%COMP%]{top:105px}}nav[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#333;font-size:13px;padding:18px 20px;font-weight:600;border-bottom:1px solid #ddd;position:sticky;top:0;background-color:#fff;height:52px}.navigation-logo[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;text-align:center;background-color:#fff}.navigation-logo[_ngcontent-%COMP%]   .pearson[_ngcontent-%COMP%]{margin:0 auto;float:none}vue-navigation-menu[_ngcontent-%COMP%]{display:block;padding-bottom:50px;position:relative;overflow-y:auto;height:100%}vue-navigation-menu-item[_ngcontent-%COMP%]{padding:10px 20px;display:block;text-decoration:none;color:#333;cursor:pointer}vue-navigation-menu-item.back[_ngcontent-%COMP%]{font-size:12px}vue-navigation-menu-item[_ngcontent-%COMP%]:hover, vue-navigation-menu-item[aria-selected=true][_ngcontent-%COMP%]{color:#fff;background-color:#007fa3}"]
      });
    }
  }
  return VueNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component should be placed on the top of every application page.
 *
 * It provides a title and (optional) action buttons for a given form.<br />
 * There are three possible buttons, and each can either be a typical button or a confirm-style button:
 * <ul>
 *     <li>Primary</li>
 *     <li>Secondary</li>
 *     <li>Default</li>
 * </ul>
 *
 * TODO:
 * <ol>
 *     <li>Functionality to hide buttons based on users privileges.</li>
 * </ol>
 * Example:
 * ```
 * <div>
 *     <vue-page-header pageTitle="Hello World"></vue-page-header>
 *     <form #myForm="ngForm"  class="app-form" novalidate>
 *         <vue-panel>
 *             ...
 *         </vue-panel>
 *     </form>
 * </div>
 * ```
 */
let VuePageHeaderComponent = /*#__PURE__*/(() => {
  class VuePageHeaderComponent {
    /**
     * Default constructor.
     */
    constructor(vueTranslationService, vueUserSessionService) {
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      /**
       * The event emitted when the previous page button is clicked.
       */
      this.previousPageButtonClicked = new EventEmitter();
      /**
       * Whether or not the primary button is visible.
       */
      this.primaryVisible = true;
      /**
       * The event emitted when the primary button is clicked.
       */
      this.primaryButtonClicked = new EventEmitter();
      /**
       * The event emitted when the primary button's cancel option is clicked.
       */
      this.primaryCancelClicked = new EventEmitter();
      /**
       * The event emitted when the primary button's confirm option is clicked.
       */
      this.primaryConfirmClicked = new EventEmitter();
      /**
       * Whether or not the secondary button is visible.
       */
      this.secondaryVisible = true;
      /**
       * The event emitted when the secondary button is clicked.
       */
      this.secondaryButtonClicked = new EventEmitter();
      /**
       * The event emitted when the secondary button's cancel option is clicked.
       */
      this.secondaryCancelClicked = new EventEmitter();
      /**
       * The event emitted when the secondary button's confirm option is clicked.
       */
      this.secondaryConfirmClicked = new EventEmitter();
      /**
       * The default button's position.
       * Defaults to 'btn-right'.
       * <ul>
       *     <li>'btn-left' - will be on the left of the header.</li>
       *     <li>'btn-right' - will be on the right of the header.</li>
       * </ul>
       */
      this.defaultPosition = 'btn-right';
      /**
       * Whether or not the default button is visible.
       */
      this.defaultVisible = true;
      /**
       * The event emitted when the default button is clicked.
       */
      this.defaultButtonClicked = new EventEmitter();
      /**
       * The event emitted when the default button's cancel option is clicked.
       */
      this.defaultCancelClicked = new EventEmitter();
      /**
       * The event emitted when the default button's confirm option is clicked.
       */
      this.defaultConfirmClicked = new EventEmitter();
    }
    /**
     * Gets the translation for the current page title.
     *
     * @returns the current page title, translated.
     */
    getPageTitleTranslation() {
      if (this.pageTitle) {
        return this.pageTitle;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.pageTitleKey);
    }
    /**
     * Checks whether a page button is desired.
     *
     * @returns whether a page button is desired.
     */
    isPageButtonDesired() {
      return this.isPrimaryButtonDesiredAndAuthorized() || this.isSecondaryButtonDesiredAndAuthorized() || this.isDefaultButtonDesiredAndAuthorized();
    }
    // ========== PREVIOUS BUTTON METHODS
    /**
     * Gets the translation for the previous page button label.
     *
     * @returns the previous page button label, translated.
     */
    getPreviousPageButtonTranslation() {
      if (this.previousPageTitle) {
        return this.previousPageTitle;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.previousPageTitleKey);
    }
    /**
     * Checks whether a previous page button is desired.
     *
     * @returns whether a previous button is desired.
     */
    isPreviousPageButtonDesired() {
      return Boolean(this.previousPageTitle || this.previousPageTitleKey);
    }
    /**
     * Function called when the previous page button is clicked.
     * Emits a 'previousPageButtonClicked' event.
     */
    previousPageButtonClick() {
      this.previousPageButtonClicked.emit();
    }
    // ========== PRIMARY BUTTON METHODS
    /**
     * Gets the translation for the primary button label.
     *
     * @returns the primary button label, translated.
     */
    getPrimaryButtonTranslation() {
      if (this.primaryLabel) {
        return this.primaryLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryLabelKey);
    }
    /**
     * Gets the translation for the primary button's cancel option.
     *
     * @returns the primary button's cancel option, translated.
     */
    getPrimaryCancelTranslation() {
      if (this.primaryCancelLabel) {
        return this.primaryCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryCancelLabelKey);
    }
    /**
     * Gets the translation for the primary button's confirm header label.
     *
     * @returns the primary button's confirm header label, translated.
     */
    getPrimaryConfirmHeaderTranslation() {
      if (this.primaryConfirmHeaderLabel) {
        return this.primaryConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryConfirmHeaderLabelKey);
    }
    /**
     * Gets the translation for the primary button's confirm option.
     *
     * @returns the primary button's confirm option, translated.
     */
    getPrimaryConfirmTranslation() {
      if (this.primaryConfirmLabel) {
        return this.primaryConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.primaryConfirmLabelKey);
    }
    /**
     * Checks whether a primary button is desired and user is authorized.
     *
     * @returns whether a primary button is desired.
     */
    isPrimaryButtonDesiredAndAuthorized() {
      if (this.primaryVisible && (this.primaryLabel || this.primaryLabelKey)) {
        if (this.primaryRoles) {
          return this.vueUserSessionService.userHasOneRole(this.primaryRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the primary button is a confirm-style button.
     *
     * @returns whether the primary button is a confirm-style button.
     */
    isPrimaryConfirmStyleDesired() {
      return Boolean(this.primaryConfirmHeaderLabelKey || this.primaryConfirmHeaderLabel);
    }
    /**
     * Function called when the primary button is clicked.
     * Emits a 'primaryButtonClicked' event.
     */
    primaryButtonClick() {
      this.primaryButtonClicked.emit();
    }
    /**
     * Function called when the primary button's cancel action is clicked.
     * Emits a 'primaryCancelClicked' event.
     */
    primaryCancelClick() {
      this.primaryCancelClicked.emit();
    }
    /**
     * Function called when the primary button's confirm action is clicked.
     * Emits a 'primaryConfirmClicked' event.
     */
    primaryConfirmClick() {
      this.primaryConfirmClicked.emit();
    }
    // ========== SECONDARY BUTTON METHODS
    /**
     * Gets the translation for the secondary button label.
     *
     * @returns the secondary button label, translated.
     */
    getSecondaryButtonTranslation() {
      if (this.secondaryLabel) {
        return this.secondaryLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryLabelKey);
    }
    /**
     * Gets the translation for the secondary button's cancel option.
     *
     * @returns the secondary button's cancel option, translated.
     */
    getSecondaryCancelTranslation() {
      if (this.secondaryCancelLabel) {
        return this.secondaryCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryCancelLabelKey);
    }
    /**
     * Gets the translation for the secondary button's confirm header label.
     *
     * @returns the secondary button's confirm header label, translated.
     */
    getSecondaryConfirmHeaderTranslation() {
      if (this.secondaryConfirmHeaderLabel) {
        return this.secondaryConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryConfirmHeaderLabelKey);
    }
    /**
     * Gets the translation for the secondary button's confirm option.
     *
     * @returns the secondary button's confirm option, translated.
     */
    getSecondaryConfirmTranslation() {
      if (this.secondaryConfirmLabel) {
        return this.secondaryConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.secondaryConfirmLabelKey);
    }
    /**
     * Checks whether a secondary button is desired and user is authorized.
     *
     * @returns whether a secondary button is desired.
     */
    isSecondaryButtonDesiredAndAuthorized() {
      if (this.secondaryVisible && (this.secondaryLabel || this.secondaryLabelKey)) {
        if (this.secondaryRoles) {
          return this.vueUserSessionService.userHasOneRole(this.secondaryRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the secondary button is a confirm-style button.
     *
     * @returns whether the secondary button is a confirm-style button.
     */
    isSecondaryConfirmStyleDesired() {
      return Boolean(this.secondaryConfirmHeaderLabelKey || this.secondaryConfirmHeaderLabel);
    }
    /**
     * Function called when the secondary button is clicked.
     * Emits a 'secondaryButtonClicked' event.
     */
    secondaryButtonClick() {
      this.secondaryButtonClicked.emit();
    }
    /**
     * Function called when the secondary button's cancel action is clicked.
     * Emits a 'secondaryCancelClicked' event.
     */
    secondaryCancelClick() {
      this.secondaryCancelClicked.emit();
    }
    /**
     * Function called when the secondary button's confirm action is clicked.
     * Emits a 'secondaryConfirmClicked' event.
     */
    secondaryConfirmClick() {
      this.secondaryConfirmClicked.emit();
    }
    // ========== DEFAULT BUTTON METHODS
    /**
     * Function called when the default button is clicked.
     * Emits a 'defaultButtonClicked' event.
     */
    defaultButtonClick() {
      this.defaultButtonClicked.emit();
    }
    /**
     * Function called when the default button's cancel action is clicked.
     * Emits a 'defaultCancelClicked' event.
     */
    defaultCancelClick() {
      this.defaultCancelClicked.emit();
    }
    /**
     * Function called when the default button's confirm action is clicked.
     * Emits a 'defaultConfirmClicked' event.
     */
    defaultConfirmClick() {
      this.defaultConfirmClicked.emit();
    }
    /**
     * Gets the translation for the default button label.
     *
     * @returns the default button label, translated.
     */
    getDefaultButtonTranslation() {
      if (this.defaultLabel) {
        return this.defaultLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultLabelKey);
    }
    /**
     * Gets the translation for the default button's cancel option.
     *
     * @returns the default button's cancel option, translated.
     */
    getDefaultCancelTranslation() {
      if (this.defaultCancelLabel) {
        return this.defaultCancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultCancelLabelKey);
    }
    /**
     * Gets the translation for the default button's confirm header label.
     *
     * @returns the default button's confirm header label, translated.
     */
    getDefaultConfirmHeaderTranslation() {
      if (this.defaultConfirmHeaderLabel) {
        return this.defaultConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultConfirmHeaderLabelKey);
    }
    /**
     * Gets the translation for the default button's confirm option.
     *
     * @returns the default button's confirm option, translated.
     */
    getDefaultConfirmTranslation() {
      if (this.defaultConfirmLabel) {
        return this.defaultConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultConfirmLabelKey);
    }
    /**
     * Checks whether a default button is desired and user is authorized.
     *
     * @returns whether a default button is desired.
     */
    isDefaultButtonDesiredAndAuthorized() {
      if (this.defaultVisible && (this.defaultLabel || this.defaultLabelKey)) {
        if (this.defaultRoles) {
          return this.vueUserSessionService.userHasOneRole(this.defaultRoles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks whether the default button is a confirm-style button.
     *
     * @returns whether the default button is a confirm-style button.
     */
    isDefaultConfirmStyleDesired() {
      return Boolean(this.defaultConfirmHeaderLabelKey || this.defaultConfirmHeaderLabel);
    }
    isDescriptiveTextLabelDesired() {
      return Boolean(this.descriptiveText || this.descriptiveTextKey);
    }
    /**
     * Gets the translation for the descriptive text if descriptiveText is null.
     *
     * @returns the descriptive text, translated if descriptiveText is null.
     */
    getDescriptiveTextTranslation() {
      if (this.descriptiveText) {
        return this.descriptiveText;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.descriptiveTextKey);
    }
    static {
      this.ɵfac = function VuePageHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePageHeaderComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePageHeaderComponent,
        selectors: [["vue-page-header"]],
        inputs: {
          i18nBundle: "i18nBundle",
          pageTitle: "pageTitle",
          pageTitleKey: "pageTitleKey",
          previousPageTitle: "previousPageTitle",
          previousPageTitleKey: "previousPageTitleKey",
          primaryCancelLabel: "primaryCancelLabel",
          primaryCancelLabelKey: "primaryCancelLabelKey",
          primaryConfirmHeaderLabel: "primaryConfirmHeaderLabel",
          primaryConfirmHeaderLabelKey: "primaryConfirmHeaderLabelKey",
          primaryConfirmLabel: "primaryConfirmLabel",
          primaryConfirmLabelKey: "primaryConfirmLabelKey",
          primaryLabel: "primaryLabel",
          primaryLabelKey: "primaryLabelKey",
          primaryVisible: "primaryVisible",
          primaryRoles: "primaryRoles",
          secondaryCancelLabel: "secondaryCancelLabel",
          secondaryCancelLabelKey: "secondaryCancelLabelKey",
          secondaryConfirmHeaderLabel: "secondaryConfirmHeaderLabel",
          secondaryConfirmHeaderLabelKey: "secondaryConfirmHeaderLabelKey",
          secondaryConfirmLabel: "secondaryConfirmLabel",
          secondaryConfirmLabelKey: "secondaryConfirmLabelKey",
          secondaryLabel: "secondaryLabel",
          secondaryLabelKey: "secondaryLabelKey",
          secondaryVisible: "secondaryVisible",
          secondaryRoles: "secondaryRoles",
          defaultCancelLabel: "defaultCancelLabel",
          defaultCancelLabelKey: "defaultCancelLabelKey",
          defaultConfirmHeaderLabel: "defaultConfirmHeaderLabel",
          defaultConfirmHeaderLabelKey: "defaultConfirmHeaderLabelKey",
          defaultConfirmLabel: "defaultConfirmLabel",
          defaultConfirmLabelKey: "defaultConfirmLabelKey",
          defaultLabel: "defaultLabel",
          defaultLabelKey: "defaultLabelKey",
          defaultPosition: "defaultPosition",
          defaultVisible: "defaultVisible",
          defaultRoles: "defaultRoles",
          descriptiveText: "descriptiveText",
          descriptiveTextKey: "descriptiveTextKey",
          descriptiveTextHasWarning: "descriptiveTextHasWarning"
        },
        outputs: {
          previousPageButtonClicked: "previousPageButtonClicked",
          primaryButtonClicked: "primaryButtonClicked",
          primaryCancelClicked: "primaryCancelClicked",
          primaryConfirmClicked: "primaryConfirmClicked",
          secondaryButtonClicked: "secondaryButtonClicked",
          secondaryCancelClicked: "secondaryCancelClicked",
          secondaryConfirmClicked: "secondaryConfirmClicked",
          defaultButtonClicked: "defaultButtonClicked",
          defaultCancelClicked: "defaultCancelClicked",
          defaultConfirmClicked: "defaultConfirmClicked"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 11,
        vars: 4,
        consts: [[1, "app-header", "d-flex", "align-items-center"], [1, "app-actions-container"], [1, "d-flex", "align-items-center"], [1, "d-flex", "align-items-center", "flex-grow-1"], ["id", "page-header-previous-button", 1, "btn", "btn-sm", "btn-default"], [1, "flex-grow-1"], [1, "d-inline-flex", "right-btn-section"], ["id", "page-header-previous-button", 1, "btn", "btn-sm", "btn-default", 3, "click"], ["icon", "chevron-left", 1, "fa", "fa-fw", "rtl-icon"], [1, "page-header-previous-button-label"], ["icon", "exclamation-triangle", 1, "fa", "fa-fw", "warning-icon"], ["ngbDropdown", "", 1, "confirm-dropdown", "d-inline-block"], ["id", "page-header-default-button", "ngbDropdownToggle", "", 1, "btn", "btn-sm", "btn-default", "vue-page-header-btn"], ["ngbDropdownMenu", "", "aria-labelledby", "page-header-default-button", 1, "dropdown-menu"], [1, "dropdown-header"], ["ngbDropdownItem", "", "id", "page-header-default-button-confirm-true", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["ngbDropdownItem", "", "id", "page-header-default-button-confirm-false", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["id", "page-header-default-button", "type", "submit", 1, "btn", "btn-sm", "btn-default", "vue-page-header-btn", 3, "click"], ["id", "page-header-secondary-button", "ngbDropdownToggle", "", 1, "btn", "btn-sm", "btn-default", "vue-page-header-btn"], ["ngbDropdownMenu", "", "aria-labelledby", "page-header-secondary-button", "role", "menu", 1, "dropdown-menu"], ["ngbDropdownItem", "", "id", "page-header-secondary-button-confirm-true", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["ngbDropdownItem", "", "id", "page-header-secondary-button-confirm-false", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["id", "page-header-secondary-button", "type", "submit", 1, "btn", "btn-sm", "btn-default", "vue-page-header-btn", 3, "click"], ["id", "page-header-primary-button", "type", "submit", 1, "btn", "btn-primary", "btn-right", "btn-sm"], ["id", "page-header-primary-button", "ngbDropdownToggle", "", 1, "btn", "btn-sm", "btn-primary", "btn-right"], ["ngbDropdownMenu", "", "aria-labelledby", "page-header-primary-button", "role", "menu", 1, "dropdown-menu"], ["ngbDropdownItem", "", "id", "page-header-primary-button-confirm-true", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["ngbDropdownItem", "", "id", "page-header-primary-button-confirm-false", "role", "menuitem", 1, "dropdown-item", 3, "click"], ["id", "page-header-primary-button", "type", "submit", 1, "btn", "btn-primary", "btn-right", "btn-sm", 3, "click"]],
        template: function VuePageHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, VuePageHeaderComponent_Conditional_4_Template, 4, 1, "button", 4);
            i0.ɵɵelementStart(5, "div", 5)(6, "h1");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵprojection(8);
            i0.ɵɵtemplate(9, VuePageHeaderComponent_Conditional_9_Template, 4, 2, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, VuePageHeaderComponent_Conditional_10_Template, 4, 3, "div", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.isPreviousPageButtonDesired() ? 4 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.getPageTitleTranslation());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isDescriptiveTextLabelDesired() ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isPageButtonDesired() ? 10 : -1);
          }
        },
        dependencies: [i1$2.FaIconComponent, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i4.NgbDropdownButtonItem],
        styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.page-header-previous-button-label[_ngcontent-%COMP%]{margin-inline-start:3px}.vue-page-header-btn[_ngcontent-%COMP%]{margin-inline-end:5px}.breadcrumb[_ngcontent-%COMP%]{display:block}.confirm-dropdown[_ngcontent-%COMP%] > button.btn.btn-sm.btn-primary.btn-right.dropdown-toggle[_ngcontent-%COMP%]{background-color:#005a70;border-color:#1a4b6c}.right-btn-section[_ngcontent-%COMP%]{padding-inline-start:40px}@media (max-width: 768px){.app-header[_ngcontent-%COMP%]{margin-top:-30px!important;margin-bottom:15px!important}}.warning-icon[_ngcontent-%COMP%]{color:#fbaa19;margin-right:.3em}.dropdown-item[_ngcontent-%COMP%]{padding:12px 15px}.dropdown-header[_ngcontent-%COMP%]{color:inherit;font-size:inherit;text-transform:none;white-space:normal}.dropdown-menu[_ngcontent-%COMP%]{border:1px solid #fbaa19;width:350px;padding-top:5px}h1[_ngcontent-%COMP%]{margin-inline-start:10px}"]
      });
    }
  }
  return VuePageHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component produces a drop-down menu at the bottom of a table to pick a page size.
 *
 * Example:
 * ```
 *   <div class="table-bar">
 *     <...>
 *   </div>
 *   <div class="table-bottom-bar table-options">
 *       <div class="table-options">
 *           <vue-page-rows i18nBundle="portal"
 *                        [pageSize]="pageSize"
 *                        [pageRows]="pageRows"
 *                        [pageNumber]="pageNumber"
 *                        [totalRows]="totalRows"
 *                        changePageClicked)="pageSizeChange($event)">
 *           </vue-page-rows>
 *       </div>
 *   </div>
 * ```
 */
let VuePageRowsComponent = /*#__PURE__*/(() => {
  class VuePageRowsComponent {
    static {
      this.nextId = 0;
    }
    /**
     * Component constructor.
     */
    constructor(translationService) {
      this.translationService = translationService;
      /**
       * The I18N bundle used for translation.
       */
      this.i18nBundle = 'PortalBase';
      /**
       * If the dropdown should go up
       */
      this.dropup = false;
      /**
       * An event fired when the page is changed.
       * Event's payload equals to the newly selected page.
       */
      this.changePageClicked = new EventEmitter();
      /**
       * Available page sizes.
       */
      this.pageSizes = [5, 10, 20, 30, 40, 50];
    }
    ngOnInit() {
      if (!this.idSuffix) {
        this.idSuffix = VuePageRowsComponent.nextId++;
      }
      this.buttonId = `vuePageRows-listPerPageButton${this.idSuffix}`;
    }
    /**
     * Set the new page size.
     *
     * @param size the new page size.
     */
    changePageSize(size) {
      this.changePageClicked.emit(size);
    }
    /**
     * Gets the row number at the beginning of the current page's range.
     *
     * @returns the start of the current page's range.
     */
    getFrom() {
      return this.pageSize * (this.pageNumber - 1) + 1;
    }
    /**
     * Gets the row number at the end of the current page's range.
     *
     * @returns the end of the current page's range.
     */
    getTo() {
      const to = this.getFrom() + this.pageRows - 1;
      if (to > this.totalRows) {
        return this.totalRows;
      }
      return to;
    }
    /**
     * This method is here to force recalculation of from and to when needed.
     *
     * @returns the total number of rows.
     */
    getTotalRows() {
      return this.totalRows;
    }
    /**
     * Translates a key.
     *
     * @param key the text to translate.
     * @returns the translated text.
     */
    getTranslation(key) {
      if (this.i18nBundle) {
        return this.translationService.getTranslation(this.i18nBundle, key);
      }
      return key;
    }
    static {
      this.ɵfac = function VuePageRowsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePageRowsComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePageRowsComponent,
        selectors: [["vue-page-rows"]],
        inputs: {
          i18nBundle: "i18nBundle",
          pageNumber: "pageNumber",
          pageRows: "pageRows",
          pageSize: "pageSize",
          totalRows: "totalRows",
          dropup: "dropup",
          idSuffix: "idSuffix"
        },
        outputs: {
          changePageClicked: "changePageClicked"
        },
        standalone: false,
        decls: 13,
        vars: 17,
        consts: [[1, "nav", "nav-pills"], ["ngbDropdown", "", 3, "placement", "ngClass"], ["ngbDropdownToggle", "", "role", "button", 1, "dropdown-toggle", "btn", "btn-xs", "btn-default", 3, "id"], [1, "caret"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], ["ngbDropdownItem", "", 1, "dropdown-item"], [1, "table-counter"], ["ngbDropdownItem", "", 1, "dropdown-item", 3, "click"]],
        template: function VuePageRowsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 0)(1, "li", 1)(2, "button", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵelement(6, "span", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 4);
            i0.ɵɵrepeaterCreate(8, VuePageRowsComponent_For_9_Template, 2, 1, "button", 5, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "li", 6)(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("placement", ctx.dropup ? "top-left" : "bottom-left")("ngClass", ctx.dropup ? "dropup" : "dropdown");
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.buttonId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 13, i0.ɵɵpipeBind3(4, 9, "vuePageRows.NumberPerPage", ctx.i18nBundle, i0.ɵɵpureFunction1(15, _c11, ctx.pageSize))), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵattribute("aria-labelledby", ctx.buttonId);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.pageSizes);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate4("", ctx.getFrom(), " - ", ctx.getTo(), " ", ctx.getTranslation("vuePageRows.of"), " ", ctx.getTotalRows(), "");
          }
        },
        dependencies: [i2.NgClass, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i4.NgbDropdownButtonItem, i2.AsyncPipe, VueTranslatePipe],
        styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropup[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%], .navbar-fixed-bottom[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{bottom:inherit}.menu[_ngcontent-%COMP%]{z-index:9001}button.dropdown-toggle[_ngcontent-%COMP%]{height:31px}button.dropdown-item[_ngcontent-%COMP%]{padding:10px}"]
      });
    }
  }
  return VuePageRowsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is a wrapper for NgBootstrap's
 * [ngb-pagination](https://ng-bootstrap.github.io/#/components/pagination/overview)
 *
 * This is so we can replace the underlying component if necessary in the future. The only change here is the
 * field mapping below NgBootstrap collectionSize = our totalRows and page = our pageNumber
 *
 * Example:
```
<div class="table-bar">
  <...>
</div>
<div class="table-bottom-bar table-options">
  <div class="table-pagination">
    <vue-pagination [boundaryLinks]="true"
                    [maxSize]="5"
                    [pageNumber]="pageNumber"
                    [pageSize]="pageSize"
                    [rotate]="false"
                    [totalRows]="totalRows"
                    (pageChange)="pageNumberChange($event)">
    </vue-pagination>
  </div>
</div>
```
 */
let VuePaginationComponent = /*#__PURE__*/(() => {
  class VuePaginationComponent {
    constructor() {
      /**
       * Maximum number of pages to display.
       * Defaults to 5.
       */
      this.maxSize = 5;
      /**
       * Current page. Page numbers start with 1.
       */
      this.pageNumber = 1;
      /**
       * An event fired when the page is changed.
       *
       * Event's payload equals to the newly selected page.
       * Will fire only if collection size is set and all values are valid.
       * Page numbers start with 1.
       */
      this.pageChange = new EventEmitter(true);
    }
    /**
     * Function called when the page changes.
     *
     * @param newPageNumber the new page number.
     */
    pageNumberChange(newPageNumber) {
      this.pageChange.emit(newPageNumber);
    }
    static {
      this.ɵfac = function VuePaginationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePaginationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePaginationComponent,
        selectors: [["vue-pagination"]],
        inputs: {
          boundaryLinks: "boundaryLinks",
          directionLinks: "directionLinks",
          ellipses: "ellipses",
          maxSize: "maxSize",
          pageNumber: "pageNumber",
          pageSize: "pageSize",
          rotate: "rotate",
          totalRows: "totalRows"
        },
        outputs: {
          pageChange: "pageChange"
        },
        standalone: false,
        decls: 1,
        vars: 8,
        consts: [[3, "pageChange", "boundaryLinks", "collectionSize", "directionLinks", "ellipses", "maxSize", "page", "pageSize", "rotate"]],
        template: function VuePaginationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ngb-pagination", 0);
            i0.ɵɵlistener("pageChange", function VuePaginationComponent_Template_ngb_pagination_pageChange_0_listener($event) {
              return ctx.pageNumberChange($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("boundaryLinks", ctx.boundaryLinks)("collectionSize", ctx.totalRows)("directionLinks", ctx.directionLinks)("ellipses", ctx.ellipses)("maxSize", ctx.maxSize)("page", ctx.pageNumber)("pageSize", ctx.pageSize)("rotate", ctx.rotate);
          }
        },
        dependencies: [i4.NgbPagination],
        encapsulation: 2
      });
    }
  }
  return VuePaginationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated
 * This should not be used. It is a security concern
 * HTML should be properly sanitized
 * Check out this PR if you still need style tags, but want to make sure HTML is properly scrubbed
 * https://bitbucket.pearson.com/projects/PVVA/repos/sitemanagerangular/pull-requests/351/overview
 *
 * Pipe to render HTML content inside text component.
 *
 *  **Usage**:
 ```
 <p [innerHtml]="message | vuehtmlsafe"></p>
 ```
 */
let VueHtmlSafePipe = /*#__PURE__*/(() => {
  class VueHtmlSafePipe {
    /**
     * Pipe constructor.
     *
     * @param domSanitizer service to disable sanitization and show HTML.
     */
    constructor(domSanitizer) {
      this.domSanitizer = domSanitizer;
    }
    /**
     * Takes a string containing HTML content and bypasses security for it.
     *
     * @param value a string containing HTML content.
     * @returns a `SafeHtml` object matching the string passed without escaping its HTML content.
     */
    transform(value) {
      return this.domSanitizer.bypassSecurityTrustHtml(value);
    }
    static {
      this.ɵfac = function VueHtmlSafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueHtmlSafePipe)(i0.ɵɵdirectiveInject(i2$1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "vuehtmlsafe",
        type: VueHtmlSafePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return VueHtmlSafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable valid-jsdoc */
/**
 * This component provides a basic palette for all forms as well as action buttons for a given panel.<br/>
 * There are 6 possible action buttons, and each can either be a typical button or a confirm-style button:
 *
 * TODO:
 * <ol>
 *     <li>still needs role security</li>
 * </ol>
 *
 * Example:
 * ```
 * <vue-panel i18nBundle="PortalBase" title="My Panel"
 *    primaryButtonNumber="2"
 *    action1LabelKey="action1Btn"
 *    (action1ButtonClicked)="action1Click($event)"
 *    action2Label="Action 2"
 *    (action2ButtonClicked)="action2Click($event)">
 *
 *    Panel with a title and 2 actions.<br/>
 * </vue-panel>
 * ```
 */
let VuePanelComponent = /*#__PURE__*/(() => {
  class VuePanelComponent {
    /**
     * Whether the panel is toggleable
     */
    set toggle(value) {
      this.isToggleDesired = typeof value !== 'undefined' && value !== false;
    }
    get toggle() {
      return this.isToggleDesired;
    }
    /**
     * Whether the panel is expanded.
     * If this is not included, the panel will not be expanded.
     */
    set expanded(value) {
      this.isExpanded = typeof value !== 'undefined' && value !== false;
    }
    get expanded() {
      return this.isExpanded;
    }
    /**
     * Default constructor.
     */
    constructor(vueTranslationService, vueUserSessionService) {
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      /**
       * How many primary buttons desired.
       *
       * Defaults to 1.
       */
      this.primaryButtonNumber = '1';
      /**
       * Whether the first action button is visible.
       */
      this.action1Visible = true;
      /**
       * Event emitter when the first action button is clicked.
       */
      this.action1ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the first action's cancel button is clicked.
       */
      this.action1CancelClicked = new EventEmitter();
      /**
       * Event emitter when the first action's confirm button is clicked.
       */
      this.action1ConfirmClicked = new EventEmitter();
      /**
       * Whether the second action button is visible.
       */
      this.action2Visible = true;
      /**
       * Event emitter when the second action button is clicked.
       */
      this.action2ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the second action's cancel button is clicked.
       */
      this.action2CancelClicked = new EventEmitter();
      /**
       * Event emitter when the second action's confirm button is clicked.
       */
      this.action2ConfirmClicked = new EventEmitter();
      /**
       * Whether the third action button is visible.
       */
      this.action3Visible = true;
      /**
       * Event emitter when the third action button is clicked.
       */
      this.action3ButtonClicked = new EventEmitter();
      /**
       * Whether the fourth action button is visible.
       */
      this.action4Visible = true;
      /**
       * Event emitter when the fourth action button is clicked.
       */
      this.action4ButtonClicked = new EventEmitter();
      /**
       * Whether the fifth action button is visible.
       */
      this.action5Visible = true;
      /**
       * Event emitter when the fifth action button is clicked.
       */
      this.action5ButtonClicked = new EventEmitter();
      /**
       * Whether the sixth action button is visible.
       */
      this.action6Visible = true;
      /**
       * String to be added to the end of an element's id attribute
       */
      this.idSuffix = '';
      /**
       * Specifies the container for the drop down menu. Currently
       * only supports "body".
       * https://ng-bootstrap.github.io/#/components/dropdown/examples#container
       */
      this.dropDownAppend = null;
      /**
       * Event emitter when the sixth action button is clicked.
       */
      this.action6ButtonClicked = new EventEmitter();
      /**
      * i18n key of the label used by the collapse button
      */
      this.collapseLabelKey = 'button.collapse';
      /**
      * i18n key of the label used by the expand button
      */
      this.expandLabelKey = 'button.expand';
      /**
       * The up chevron icon
       */
      this.chevronUp = faChevronUp;
      /**
       * The down chevron icon
       */
      this.chevronDown = faChevronDown;
      /**
       * This controlls if the component is expanded or not
       */
      this.isExpanded = false;
    }
    /**
     * Gets the CSS class defining whether a border is needed.<br/>
     * We need a border only if there's a title.
     *
     * @returns the css class
     */
    getBorderClass() {
      return this.isTitleDesired() ? '' : 'no-border';
    }
    /**
     * Gets the translated label for hte More button.
     */
    getMoreButtonTranslation() {
      return this.vueTranslationService.getTranslation(this.i18nBundle, 'button.more');
    }
    /**
     * Gets the translated title.
     *
     * @returns the translated title.
     */
    getTitleTranslation() {
      if (this.title) {
        return this.title;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.titleKey);
    }
    /**
     * Checks if we need a header.<br/>
     * Header is only needed if there's a first action or a title.
     *
     * @returns whether a header is needed.
     */
    isHeaderNeeded() {
      return this.isTitleDesired() || this.isAction1ButtonDesired();
    }
    /**
     * Checks whether we want a title.
     */
    isTitleDesired() {
      return Boolean(this.title || this.titleKey);
    }
    /**
     * Checks if the title should be in a span tag.<br/>
     * H1 is used on login page, maybe others.
     */
    isTitleH1Tag() {
      return this.titleTag === 'h1';
    }
    /**
     * Checks whether we need two primary buttons.
     */
    isTwoPrimaryButtonsDesired() {
      return this.primaryButtonNumber === '2';
    }
    // ========== ACTION 1 METHODS
    /**
     * Function called when first action's button is clicked.
     *
     * Emits an action1ButtonClicked event.
     */
    action1ButtonClick() {
      this.action1ButtonClicked.emit();
    }
    /**
     * Function called when first action's cancel button is clicked.
     *
     * Emits an action1ButtonClicked event.
     */
    action1CancelClick() {
      this.action1CancelClicked.emit();
    }
    /**
     * Function called when first action's confirm button is clicked.
     *
     * Emits an action1ConfirmClicked event.
     */
    action1ConfirmClick() {
      this.action1ConfirmClicked.emit();
    }
    /**
     * Get the translated text for the first action button.
     */
    getAction1ButtonTranslation() {
      if (this.action1Label) {
        return this.action1Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action1LabelKey);
    }
    /**
     * Get the translated text for the first action's cancel button.
     */
    getAction1CancelTranslation() {
      if (this.action1CancelLabel) {
        return this.action1CancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action1CancelLabelKey);
    }
    /**
     * Get the translated text for the first action's confirm header.
     */
    getAction1ConfirmHeaderTranslation() {
      if (this.action1ConfirmHeaderLabel) {
        return this.action1ConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action1ConfirmHeaderLabelKey);
    }
    /**
     * Get the translated text for the first action's confirm button.
     */
    getAction1ConfirmTranslation() {
      if (this.action1ConfirmLabel) {
        return this.action1ConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action1ConfirmLabelKey);
    }
    /**
     * Checks if we need a first button.
     */
    isAction1ButtonDesired() {
      return Boolean(this.action1Label || this.action1LabelKey);
    }
    /**
     * Checks if we need a first button and user is authorized.
     */
    isAction1ButtonDesiredAndAuthorized() {
      if (this.action1Label || this.action1LabelKey) {
        if (this.action1Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action1Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks if the first action is a confirm button.
     */
    isAction1ConfirmStyleDesired() {
      return Boolean(this.action1ConfirmHeaderLabelKey || this.action1ConfirmHeaderLabel);
    }
    /**
     * Check if the first action is hidden.
     */
    isAction1Hidden() {
      return !this.action1Visible;
    }
    // ========== ACTION 2 METHODS
    /**
     * Function called when second action's button is clicked.
     *
     * Emits an action2ButtonClicked event.
     */
    action2ButtonClick() {
      this.action2ButtonClicked.emit();
    }
    /**
     * Function called when second action's cancel button is clicked.
     *
     * Emits an action2ButtonClicked event.
     */
    action2CancelClick() {
      this.action2CancelClicked.emit();
    }
    /**
     * Function called when second action's confirm button is clicked.
     *
     * Emits an action2ConfirmClicked event.
     */
    action2ConfirmClick() {
      this.action2ConfirmClicked.emit();
    }
    /**
     * Get the translated text for the second action button.
     */
    getAction2ButtonTranslation() {
      if (this.action2Label) {
        return this.action2Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action2LabelKey);
    }
    /**
     * Get the translated text for the second action's cancel button.
     */
    getAction2CancelTranslation() {
      if (this.action2CancelLabel) {
        return this.action2CancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action2CancelLabelKey);
    }
    /**
     * Get the translated text for the second action's confirm header.
     */
    getAction2ConfirmHeaderTranslation() {
      if (this.action2ConfirmHeaderLabel) {
        return this.action2ConfirmHeaderLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action2ConfirmHeaderLabelKey);
    }
    /**
     * Get the translated text for the first action's confirm button.
     */
    getAction2ConfirmTranslation() {
      if (this.action2ConfirmLabel) {
        return this.action2ConfirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action2ConfirmLabelKey);
    }
    /**
     * Checks if we need a second button and user is authorized.
     */
    isAction2ButtonDesiredAndAuthorized() {
      if (this.action2Label || this.action2LabelKey) {
        if (this.action2Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action2Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Checks if the first action is a confirm button.
     */
    isAction2ConfirmStyleDesired() {
      return Boolean(this.action2ConfirmHeaderLabelKey || this.action2ConfirmHeaderLabel);
    }
    /**
     * Check if the second action is hidden.
     */
    isAction2Hidden() {
      return !this.action2Visible;
    }
    // ========== ACTION 3 METHODS
    /**
     * Function called when third action's button is clicked.
     *
     * Emits an action3ButtonClicked event.
     */
    action3ButtonClick() {
      this.action3ButtonClicked.emit();
    }
    /**
     * Get the translated text for the third action button.
     */
    getAction3ButtonTranslation() {
      if (this.action3Label) {
        return this.action3Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action3LabelKey);
    }
    /**
     * Checks if we need a third button and user is authorized.
     */
    isAction3ButtonDesiredAndAuthorized() {
      if (this.action3Label || this.action3LabelKey) {
        if (this.action3Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action3Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Check if the third action is hidden.
     */
    isAction3Hidden() {
      return !this.action3Visible;
    }
    // ========== ACTION 4 METHODS
    /**
     * Function called when fourth action's button is clicked.
     *
     * Emits an action4ButtonClicked event.
     */
    action4ButtonClick() {
      this.action4ButtonClicked.emit();
    }
    /**
     * Get the translated text for the fourth action button.
     */
    getAction4ButtonTranslation() {
      if (this.action4Label) {
        return this.action4Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action4LabelKey);
    }
    /**
     * Checks if we need a fourth button and user is authorized.
     */
    isAction4ButtonDesiredAndAuthorized() {
      if (this.action4Label || this.action4LabelKey) {
        if (this.action4Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action4Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Check if the fourth action is hidden.
     */
    isAction4Hidden() {
      return !this.action4Visible;
    }
    // ========== ACTION 5 METHODS
    /**
     * Function called when fifth action's button is clicked.
     *
     * Emits an action5ButtonClicked event.
     */
    action5ButtonClick() {
      this.action5ButtonClicked.emit();
    }
    /**
     * Get the translated text for the fifth action button.
     */
    getAction5ButtonTranslation() {
      if (this.action5Label) {
        return this.action5Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action5LabelKey);
    }
    /**
     * Checks if we need a sixth button and user is authorized.
     */
    isAction5ButtonDesiredAndAuthorized() {
      if (this.action5Label || this.action5LabelKey) {
        if (this.action5Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action5Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Check if the fifth action is hidden.
     */
    isAction5Hidden() {
      return !this.action5Visible;
    }
    // ========== ACTION 6 METHODS
    /**
     * Function called when sixth action's button is clicked.
     *
     * Emits an action6ButtonClicked event.
     */
    action6ButtonClick() {
      this.action6ButtonClicked.emit();
    }
    /**
     * Get the translated text for the sixth action button.
     */
    getAction6ButtonTranslation() {
      if (this.action6Label) {
        return this.action6Label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.action6LabelKey);
    }
    /**
     * Checks if we need a sixth button and user is authorized.
     */
    isAction6ButtonDesiredAndAuthorized() {
      if (this.action6Label || this.action6LabelKey) {
        if (this.action6Roles) {
          return this.vueUserSessionService.userHasOneRole(this.action6Roles);
        }
        return true;
      }
      return false;
    }
    /**
     * Check if the sixth action is hidden.
     */
    isAction6Hidden() {
      return !this.action6Visible;
    }
    /**
     * Toggles the body
     */
    toggleSection() {
      this.isExpanded = !this.isExpanded;
    }
    /**
     * Returns the label for collapse action of this component
     *
     * @returns string value of the label.
     */
    getCollapseLabelTranslation() {
      if (this.collapseLabel) {
        return this.collapseLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.collapseLabelKey);
    }
    /**
     * Returns the label for expand action of this component
     *
     * @returns string value of the label.
     */
    getExpandLabelTranslation() {
      if (this.expandLabel) {
        return this.expandLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.expandLabelKey);
    }
    /**
     * Returns the aria label for the collapse button
     *
     * @param {boolean} collapsed if the item is collapsed
     * @returns string value of aria-label
     */
    getCollapseAriaLabelTranslation(expanded) {
      return expanded ? this.getCollapseLabelTranslation() : this.getExpandLabelTranslation();
    }
    static {
      this.ɵfac = function VuePanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePanelComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueUserSessionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePanelComponent,
        selectors: [["vue-panel"]],
        inputs: {
          i18nBundle: "i18nBundle",
          primaryButtonNumber: "primaryButtonNumber",
          title: "title",
          titleKey: "titleKey",
          titleTag: "titleTag",
          action1CancelLabel: "action1CancelLabel",
          action1CancelLabelKey: "action1CancelLabelKey",
          action1ConfirmHeaderLabel: "action1ConfirmHeaderLabel",
          action1ConfirmHeaderLabelKey: "action1ConfirmHeaderLabelKey",
          action1ConfirmLabel: "action1ConfirmLabel",
          action1ConfirmLabelKey: "action1ConfirmLabelKey",
          action1Label: "action1Label",
          action1LabelKey: "action1LabelKey",
          action1Visible: "action1Visible",
          action1Roles: "action1Roles",
          action2CancelLabel: "action2CancelLabel",
          action2CancelLabelKey: "action2CancelLabelKey",
          action2ConfirmHeaderLabel: "action2ConfirmHeaderLabel",
          action2ConfirmHeaderLabelKey: "action2ConfirmHeaderLabelKey",
          action2ConfirmLabel: "action2ConfirmLabel",
          action2ConfirmLabelKey: "action2ConfirmLabelKey",
          action2Label: "action2Label",
          action2LabelKey: "action2LabelKey",
          action2Visible: "action2Visible",
          action2Roles: "action2Roles",
          action3Label: "action3Label",
          action3LabelKey: "action3LabelKey",
          action3Visible: "action3Visible",
          action3Roles: "action3Roles",
          action4Label: "action4Label",
          action4LabelKey: "action4LabelKey",
          action4Visible: "action4Visible",
          action4Roles: "action4Roles",
          action5Label: "action5Label",
          action5LabelKey: "action5LabelKey",
          action5Visible: "action5Visible",
          action5Roles: "action5Roles",
          action6Label: "action6Label",
          action6LabelKey: "action6LabelKey",
          action6Visible: "action6Visible",
          action6Roles: "action6Roles",
          idSuffix: "idSuffix",
          dropDownAppend: "dropDownAppend",
          toggle: "toggle",
          expanded: "expanded",
          collapseLabel: "collapseLabel",
          collapseLabelKey: "collapseLabelKey",
          expandLabel: "expandLabel",
          expandLabelKey: "expandLabelKey"
        },
        outputs: {
          action1ButtonClicked: "action1ButtonClicked",
          action1CancelClicked: "action1CancelClicked",
          action1ConfirmClicked: "action1ConfirmClicked",
          action2ButtonClicked: "action2ButtonClicked",
          action2CancelClicked: "action2CancelClicked",
          action2ConfirmClicked: "action2ConfirmClicked",
          action3ButtonClicked: "action3ButtonClicked",
          action4ButtonClicked: "action4ButtonClicked",
          action5ButtonClicked: "action5ButtonClicked",
          action6ButtonClicked: "action6ButtonClicked"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [[1, "panel", "panel-default"], [1, "panel-body"], [3, "class", "ngClass"], [3, "id"], [3, "ngClass"], [1, "btn", "btn-default", "btn-xs", 3, "title"], [1, "subpanel-actions"], [1, "btn", "btn-default", "btn-xs", 3, "click", "title"], [3, "icon"], [1, "subpanel-title"], ["ngbDropdown", "", 1, "confirm-dropdown", "d-inline", 3, "hidden", "container"], ["ngbDropdownToggle", "", 1, "btn", "btn-default", "btn-xs", "action-btn", 3, "id"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], [1, "dropdown-header", 3, "innerHtml"], ["ngbDropdownItem", "", 3, "click", "id"], ["type", "submit", 1, "btn", "btn-default", "btn-xs", "d-inline", "action-btn", 3, "click", "id", "hidden"], ["ngbDropdown", "", 1, "d-inline", 3, "hidden", "container"], [1, "caret"], ["ngbDropdownItem", "", 3, "id"]],
        template: function VuePanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, VuePanelComponent_Conditional_2_Template, 5, 8, "div", 2)(3, VuePanelComponent_Conditional_3_Template, 2, 2, "div", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isHeaderNeeded() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.toggle || ctx.expanded ? 3 : -1);
          }
        },
        dependencies: [i2.NgClass, i1$2.FaIconComponent, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i4.NgbDropdownButtonItem, VueHtmlSafePipe],
        styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.action-btn[_ngcontent-%COMP%]{margin-inline-start:5px}.show[_ngcontent-%COMP%]{display:inline!important}.subpanel-header.content-collapsed[_ngcontent-%COMP%]{margin:-10px -15px}.dropdown-item[_ngcontent-%COMP%]{padding:12px 15px}.dropdown-header[_ngcontent-%COMP%]{color:inherit;font-size:inherit;text-transform:none;white-space:normal}.dropdown-menu[_ngcontent-%COMP%]{border:1px solid #fbaa19;width:350px;padding-top:5px}"]
      });
    }
  }
  return VuePanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Progress bar types.
 * <ul>
 *     <li>Loading - Status bar with no definite progress shown, simply an animated loading indicator.</li>
 *     <li>Progress - Actual progress bar, where progress can be updated in fractions of 100.</li>
 * </ul>
 */
var ProgressBarType = /*#__PURE__*/function (ProgressBarType) {
  ProgressBarType["Loading"] = "indeterminate";
  ProgressBarType["Progress"] = "determinate";
  return ProgressBarType;
}(ProgressBarType || {});
/**
 * Progress bar component used to display the progress of a task.
 * Comes in two flavors, defined in ProgressBarType:
 * <ul>
 *     <li>Loading: animated status bar that just shows that activity is occurring, it doesn't show actual progress</li>
 *     <li>Progress: progress bar that will show actual progress in fractions of 100 / percentage.
 * </ul>
 *
 * Example:
 ```
 <vue-progress-bar [name]="name" [type]="type" [progress]="progress"></vue-progress-bar>
 ```
 */
let VueProgressBarComponent = /*#__PURE__*/(() => {
  class VueProgressBarComponent {
    /**
     * Checks whether the progress bar type is `Loading`.
     *
     * @returns whether the progress bar type is `Loading`.
     */
    isProgressBarTypeLoading() {
      return this.type === ProgressBarType.Loading;
    }
    static {
      this.ɵfac = function VueProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueProgressBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueProgressBarComponent,
        selectors: [["vue-progress-bar"]],
        inputs: {
          progress: "progress",
          type: "type",
          name: "name"
        },
        standalone: false,
        decls: 3,
        vars: 2,
        consts: [[1, "progressbar"], ["animated", "true", "striped", "true", "type", "error", "value", "100"], [3, "mode", "value"]],
        template: function VueProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, VueProgressBarComponent_Conditional_1_Template, 1, 0, "ngb-progressbar", 1)(2, VueProgressBarComponent_Conditional_2_Template, 1, 3, "mat-progress-bar", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isProgressBarTypeLoading() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isProgressBarTypeLoading() ? 2 : -1);
          }
        },
        dependencies: [i1$3.MatProgressBar, i4.NgbProgressbar],
        styles: [".mat-mdc-progress-bar[_ngcontent-%COMP%]{border:1px solid #eeeeee;border-radius:10px;height:30px}"]
      });
    }
  }
  return VueProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is used to display forms as readonly. It takes a list of {@code VueReadOnlyFormItems}.
 *
 * Example:
 ```
 <vue-panel title="Read Only Form">
  <vue-read-only-form [items]="items" i18nBundle="portal"></vue-read-only-form>
 </vue-panel>
 ```
 */
let VueReadOnlyFormComponent = /*#__PURE__*/(() => {
  class VueReadOnlyFormComponent {
    /**
     * Component constructor.
     *
     * @param iterableDiffers iterable diffing tool.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(iterableDiffers, vueTranslationService) {
      this.iterableDiffers = iterableDiffers;
      this.vueTranslationService = vueTranslationService;
      /**
       * List of readonly form items to display.
       */
      this.items = [];
    }
    /**
     * On component initialization, initialize the difference tracker.
     */
    ngOnInit() {
      this.differ = this.iterableDiffers.find(this.items).create();
    }
    /**
     * When changes are detected, update the display items.
     */
    ngDoCheck() {
      const changes = this.differ.diff(this.items);
      if (changes) {
        this.translateReadOnlyFormItems();
      }
    }
    /**
     * Translate, if needed, the form items.
     */
    translateReadOnlyFormItems() {
      for (const item of this.items) {
        const itemName = item.getName() ? item.getName() : this.vueTranslationService.getTranslation(this.i18nBundle, item.getNameKey());
        const itemValue = item.getValue() ? item.getValue() : this.vueTranslationService.getTranslation(this.i18nBundle, item.getValueKey());
        item.setTranslatedName(itemName);
        item.setTranslatedValue(itemValue);
      }
    }
    static {
      this.ɵfac = function VueReadOnlyFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueReadOnlyFormComponent)(i0.ɵɵdirectiveInject(i0.IterableDiffers), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueReadOnlyFormComponent,
        selectors: [["vue-read-only-form"]],
        inputs: {
          i18nBundle: "i18nBundle",
          items: "items"
        },
        standalone: false,
        decls: 3,
        vars: 0,
        consts: [[1, "app-form"], [1, "form-group", "read-only"], [1, "control-label"], [1, "input-container"]],
        template: function VueReadOnlyFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵrepeaterCreate(1, VueReadOnlyFormComponent_For_2_Template, 6, 2, "div", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [i6.ɵNgNoValidate, i6.NgControlStatusGroup, i6.NgForm],
        encapsulation: 2
      });
    }
  }
  return VueReadOnlyFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 This component provides are standard search paradigm.  See Search link in component tester for examples.
 An example usage is:

```
<vue-panel i18nBundle="portal" title="Basic Search">
  <vue-search label="Enter text to search by employee ID" [(showBasicSearchError)]="basicSearchError"
    basicSearchError="Employee ID is required" [(genericSearchField)]="employeeName"
    (basicSearchButtonClicked)="basicSearch()">
  </vue-search>
</vue-panel>```

In general the component provides the following functionality
<li>Presents itself as either basic, standalone or advanced search (combination of both)</li>
<li>Provides button events so you can know when the user is trying to execute a search</li>
<li>Provides bindings for validations.  For example, maybe your search requires 1 of 5 possible fields filled in</li>
<li>As with all components will i18n labels or not

*/
let VueSearchComponent = /*#__PURE__*/(() => {
  class VueSearchComponent {
    set toggle(value) {
      this.toggleDesired = typeof value !== 'undefined' && value !== false;
    }
    get toggle() {
      return this.toggleDesired;
    }
    set collapsed(value) {
      this.isExpanded = this.toggle && typeof value !== 'undefined' && value !== false;
    }
    get collapsed() {
      return this.isExpanded;
    }
    constructor(translationService) {
      this.translationService = translationService;
      this.genericSearchFieldChange = new EventEmitter();
      this.showBasicSearchError = false;
      this.showBasicSearchErrorOverride = false;
      this.advancedSearch = 'false';
      this.standaloneSearch = 'false';
      this.showAdvancedSearchError = false;
      this.showAdvancedSearchErrorChange = new EventEmitter();
      /*
        This is used for size of advanced container.
        */
      this.widthClass = '';
      this.basicSearchButtonClicked = new EventEmitter();
      this.clearSearchButtonClicked = new EventEmitter();
      this.advancedSearchToggleClicked = new EventEmitter();
      this.advancedSearchButtonClicked = new EventEmitter();
      this.isSearchComponentExpanded = new EventEmitter();
      this.chevronUp = faChevronUp;
      this.chevronDown = faChevronDown;
      this.showAdvanced = false;
      this.showClearSearch = false;
    }
    ngOnInit() {
      // user does not get to toggle this in standalone mode.
      if (this.standaloneSearch === 'true') {
        this.showAdvanced = true;
      }
      if (this.clearSearchButtonClicked.observers.length > 0) {
        this.showClearSearch = true;
      }
    }
    toggleContent() {
      if (this.toggle) {
        this.isExpanded = !this.isExpanded;
      }
      this.isSearchComponentExpanded.emit(this.isExpanded);
    }
    isLabelSpecified() {
      return Boolean(this.label || this.labelKey);
    }
    getLabelTranslation() {
      if (this.label) {
        return this.label;
      }
      return this.translationService.getTranslation(this.i18nBundle, this.labelKey);
    }
    getSearchOptionsTitleLabelTranslation() {
      if (this.searchOptionsTitleLabel) {
        return this.searchOptionsTitleLabel;
      } else if (this.searchOptionsTitleLabelKey) {
        return this.translationService.getTranslation(this.i18nBundle, this.searchOptionsTitleLabelKey);
      }
      return 'Search options';
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    checkBasicSearchKey(event) {
      if (this.genericSearchField.length > 0) {
        this.showBasicSearchError = false;
      }
      if (this.showBasicSearchErrorOverride) {
        this.showBasicSearchError = true;
      }
      // user clicked enter in basic search field
      if (event.keyCode === 13) {
        this.basicSearchButtonClick();
        event.preventDefault();
        event.stopPropagation();
      }
    }
    getBasicErrorClass() {
      if (this.showBasicSearchError) {
        return 'has-error';
      }
      return '';
    }
    clearAdvancedError() {
      this.showAdvancedSearchError = false;
      this.showAdvancedSearchErrorChange.emit(false);
    }
    isAdvancedOrStandaloneSearch() {
      return this.isAdvancedSearch() || this.isStandaloneSearch();
    }
    isAdvancedSearch() {
      return this.advancedSearch === 'true';
    }
    isStandaloneSearch() {
      return this.standaloneSearch === 'true';
    }
    genericSearchChange() {
      this.genericSearchFieldChange.emit(this.genericSearchField);
    }
    getSearchOptionsLabelTranslation() {
      if (!this.i18nBundle) {
        return 'Search options';
      }
      return this.translationService.getTranslation(this.i18nBundle, 'vueSearch.searchOptions');
    }
    getSearchLabelTranslation() {
      if (!this.i18nBundle) {
        return 'Search';
      }
      return this.translationService.getTranslation(this.i18nBundle, 'vueSearch.search');
    }
    getClearLabelTranslation() {
      if (!this.i18nBundle) {
        return 'Clear search';
      }
      return this.translationService.getTranslation(this.i18nBundle, 'vueSearch.clearSearch');
    }
    toggleAdvanced() {
      this.showAdvanced = this.showAdvanced !== true;
      this.advancedSearchToggleClicked.emit(this.showAdvanced);
    }
    closeAdvanced() {
      this.showAdvanced = false;
    }
    isShowAdvanced() {
      return this.showAdvanced === true;
    }
    basicSearchButtonClick() {
      this.basicSearchButtonClicked.emit();
    }
    advancedSearchButtonClick() {
      this.advancedSearchButtonClicked.emit();
    }
    clearSearchButtonClick() {
      this.clearSearchButtonClicked.emit();
    }
    getWidthClass() {
      return this.widthClass;
    }
    getPlaceHolderTranslation() {
      if (this.placeholder) {
        return this.placeholder;
      }
      if (this.placeholderKey) {
        return this.translationService.getTranslation(this.i18nBundle, this.placeholderKey);
      }
      return '';
    }
    static {
      this.ɵfac = function VueSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueSearchComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueSearchComponent,
        selectors: [["vue-search"]],
        inputs: {
          i18nBundle: "i18nBundle",
          label: "label",
          labelKey: "labelKey",
          genericSearchField: "genericSearchField",
          showBasicSearchError: "showBasicSearchError",
          showBasicSearchErrorOverride: "showBasicSearchErrorOverride",
          basicSearchError: "basicSearchError",
          advancedSearch: "advancedSearch",
          standaloneSearch: "standaloneSearch",
          searchOptionsTitleLabel: "searchOptionsTitleLabel",
          searchOptionsTitleLabelKey: "searchOptionsTitleLabelKey",
          showAdvancedSearchError: "showAdvancedSearchError",
          advancedSearchError: "advancedSearchError",
          placeholder: "placeholder",
          placeholderKey: "placeholderKey",
          widthClass: "widthClass",
          toggle: "toggle",
          collapsed: "collapsed"
        },
        outputs: {
          genericSearchFieldChange: "genericSearchFieldChange",
          showAdvancedSearchErrorChange: "showAdvancedSearchErrorChange",
          basicSearchButtonClicked: "basicSearchButtonClicked",
          clearSearchButtonClicked: "clearSearchButtonClicked",
          advancedSearchToggleClicked: "advancedSearchToggleClicked",
          advancedSearchButtonClicked: "advancedSearchButtonClicked",
          isSearchComponentExpanded: "isSearchComponentExpanded"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [["id", "search-bar", 1, "search-bar-row"], ["id", "advanced-search-menu", 1, "advanced-search-row", "show-advanced-search", 3, "hidden"], [1, "searchbar", 3, "ngClass"], ["for", "vueSearch-searchText", 1, "control-label"], [1, "input-group"], ["type", "text", "id", "vueSearch-searchText", "autocomplete", "off", 1, "form-control", 3, "ngModelChange", "keyup", "ngModel", "placeholder"], [1, "input-group-btn"], ["id", "vueSearch-searchButton", "type", "submit", 1, "btn", "btn-xs", "btn-default", 3, "click", "hidden"], ["id", "vueSearch-searchOptions", 1, "btn", "btn-xs", "btn-default", "advanced-search-btn"], ["id", "vueSearch-clearButton", "type", "button", 1, "btn", "btn-default", "btn-left"], [1, "help-inline", "validation-inline", 3, "hidden"], [1, "validation-fail"], ["icon", "times", 1, "fa", "fa-fw"], ["id", "vueSearch-searchOptions", 1, "btn", "btn-xs", "btn-default", "advanced-search-btn", 3, "click"], ["icon", "angle-down", 1, "fa", "fa-fw"], ["id", "vueSearch-clearButton", "type", "button", 1, "btn", "btn-default", "btn-left", 3, "click"], [1, "panel", "panel-default", "panel-multipart"], [1, "panel-body"], [1, "subpanel-header", 3, "ngClass"], ["aria-controls", "search-content", 1, "btn", "btn-default", "btn-xs", 3, "title"], [1, "subpanel-title"], [1, "subpanel-actions"], [1, "btn", "btn-xs", "btn-default", "advanced-search-cancel-btn", 3, "click", "hidden", "routerLink"], ["id", "search-content", 1, "app-form"], ["aria-controls", "search-content", 1, "btn", "btn-default", "btn-xs", 3, "click", "title"], [3, "icon"], ["tabindex", "-1", "role", "alert", 1, "alert", "alert-danger", 3, "hidden"], ["id", "vueSearch-clearErrorButton", "type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], ["id", "searchError", "role", "alert"], [1, "btn-section", "form-btn-section"], ["id", "vueSearch-AdvSearchButton", "type", "button", 1, "btn", "btn-default", "btn-right", 3, "click"]],
        template: function VueSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, VueSearchComponent_Conditional_1_Template, 15, 11, "div", 0)(2, VueSearchComponent_Conditional_2_Template, 12, 11, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isStandaloneSearch() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isAdvancedOrStandaloneSearch() ? 2 : -1);
          }
        },
        dependencies: [i2.NgClass, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i1$2.FaIconComponent, i1$1.RouterLink],
        styles: ["#vueSearch-searchOptions[_ngcontent-%COMP%]{margin-right:10px}.subpanel-header.collapsed[_ngcontent-%COMP%]{margin-bottom:-11px}"]
      });
    }
  }
  return VueSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Message types.
 *
 * In order in which they will be displayed on the page if there's more than one message:
 *
 * <ol>
 *     <li>Error - a message styled in red to denote an unrecoverable error.</li>
 *     <li>Info - a standard message styled in blue to denote information.</li>
 *     <li>Warning - a message styled in yellow to warn the user of potential consequences of an action.</li>
 *     <li>Success - a message styled in green to denote the successful completion of an action.</li>
 * </ol>
 */
var VueServerMessageType = /*#__PURE__*/function (VueServerMessageType) {
  VueServerMessageType["Error"] = "error";
  VueServerMessageType["Info"] = "info";
  VueServerMessageType["Success"] = "success";
  VueServerMessageType["Warning"] = "warning";
  return VueServerMessageType;
}(VueServerMessageType || {});
/**
 * This component provide page-level messaging, coming in four flavors and two types:<br/>
 * Error, Info, Warning, and Success message are each either dismissible or non-dismissible.<br/>
 *
 * Example:
 ```
 private messages: VueServerMessage[] = [];
 <...>
 this.messages =
    this.messages.splice().push(new VueServerMessage(VueServerMessageType.Error, 'This is error message'));
 // or
 this.messages =
    this.messages.splice().push(new VueServerMessage({
      type: VueServerMessageType.Error,
      messageText: 'This is a dismissible error msg',
      clickable: true,
      id: '1',
      scrollIntoView: true )
  });
 ```

 ```
 <!-- In your template -->

 <vue-server-messages [messages]="messages" (messageRemoved)="messageRemoved($event)"></vue-server-messages>
 ```
 */
let VueServerMessagesComponent = /*#__PURE__*/(() => {
  class VueServerMessagesComponent {
    constructor(elRef) {
      this.elRef = elRef;
      /**
       * The i18n key for the label for the button
       * to dismiss the alert
       */
      this.dismissLabelKey = 'button.dismissAlertA11y';
      /**
       * The i18n bundle
       */
      this.i18nBundle = 'PortalBase';
      /**
       * An array of messages to display.
       */
      this.messages = [];
      /**
       * Event emitted when a message is clicked on.
       */
      this.messageClicked = new EventEmitter();
      /**
       * Event emitted when a message is dismissed.
       */
      this.messageRemoved = new EventEmitter();
    }
    /**
     * This watches for new messages and will
     * call scrollIntoView if a new message has
     * this set.
     *
     * @param changes
     */
    ngOnChanges(changes) {
      if (changes.messages && changes.messages.currentValue.some(m => m.scrollIntoView)) {
        this.scrollIntoView();
      }
    }
    /**
     * Scrolls this element into view.
     */
    scrollIntoView() {
      this.elRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
    /**
     * Clears a given message.
     *
     * @param index the index of the message to clear.
     */
    clearMessage(index) {
      const message = this.messages[index];
      this.messageRemoved.emit(message);
      this.messages.splice(index, 1);
    }
    /**
     * Called when a given clickable message is clicked.
     *
     * @param index the index of the message clicked.
     * @param event the click event.
     */
    clickMessage(index, event) {
      // stop the normal click behavior first.
      event.stopPropagation();
      event.preventDefault();
      const message = this.messages[index];
      this.messageClicked.emit(message);
    }
    /**
     * Gets the appropriate alert-* CSS class for the message type.
     *
     * @param message the message to style.
     * @returns the class to use.
     */
    getMessageClass(message) {
      switch (message.type) {
        case VueServerMessageType.Error:
          return 'alert-danger';
        case VueServerMessageType.Info:
          return 'alert-info';
        case VueServerMessageType.Success:
          return 'alert-success';
        case VueServerMessageType.Warning:
          return 'alert-warning';
        default:
          return null;
      }
    }
    /**
     * Checks if the message is clickable. This is used sparingly but when there is additional link in the message.
     * Note: this will generate a click event.
     *
     * @param message the message to check.
     */
    isClickable(message) {
      return message.clickable === true;
    }
    /**
     * Checks if the message is dismissible.
     *
     * @param message the message to check.
     */
    isDismissible(message) {
      return message.dismissible === true;
    }
    /**
     * Checks if the message needs to be rendered in HTML.
     * This is used when the message has HTML components and we don't want to generate a click event.
     *
     * @param message the message to check.
     */
    isRenderInHtml(message) {
      return message.renderInHtml === true;
    }
    static {
      this.ɵfac = function VueServerMessagesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueServerMessagesComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueServerMessagesComponent,
        selectors: [["vue-server-messages"]],
        inputs: {
          dismissLabel: "dismissLabel",
          dismissLabelKey: "dismissLabelKey",
          i18nBundle: "i18nBundle",
          messages: "messages"
        },
        outputs: {
          messageClicked: "messageClicked",
          messageRemoved: "messageRemoved"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 0,
        consts: [[1, "vue-server-message", 3, "ngClass", "tabindex"], ["id", "formErrorMsg", "role", "alert"], ["role", "alert", 1, "dismissible"], ["role", "alert", 1, "dismissible", "html", 3, "innerHTML"], ["role", "alert"], ["type", "button", 1, "close"], [1, "default"], [1, "html", 3, "innerHTML"], [1, "clickable", 3, "innerHTML"], [1, "clickable", 3, "click", "innerHTML"], [1, "dismissible", "clickable", 3, "click", "innerHTML"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"]],
        template: function VueServerMessagesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, VueServerMessagesComponent_For_1_Template, 8, 7, "div", null, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.messages);
          }
        },
        dependencies: [i2.NgClass, i2.AsyncPipe, VueTranslatePipe],
        styles: [".vue-server-message[_ngcontent-%COMP%]{display:flex;justify-content:space-between}"]
      });
    }
  }
  return VueServerMessagesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides styling for table headers that are sortable, and will emit an event when sort order changes.
 *
 * Example:
 ```
 <table class="table table-edit">
   <thead>
     <tr>
       <th>
         <vue-sort [fieldName]="'field1'" [sortField]="sortField" (sortChange)="sortChange($event)">
           Field 1
         </vue-sort>
       </th>
       <th>
         <vue-sort [fieldName]="'field2'" [sortField]="sortField" (sortChange)="sortChange($event)">
           Field 2
         </vue-sort>
       </th>
     </tr>
   </thead>
 </table>
 ```
 */
let VueSortComponent = /*#__PURE__*/(() => {
  class VueSortComponent {
    /**
     * Component constructor.
     *
     * @param elementRef native view component.
     */
    constructor(elementRef) {
      this.elementRef = elementRef;
      /**
       * Emits an event when the sort changes.
       */
      this.sortChange = new EventEmitter();
    }
    /**
     * respond to click
     */
    onClick() {
      this.sort();
    }
    /**
     * respond to keyboard Enter press
     */
    onEnter() {
      this.sort();
    }
    /**
     * On component changes, update the class name of the parent column.
     */
    ngOnChanges() {
      if (this.isAscending() || this.isDescending()) {
        this.elementRef.nativeElement.parentElement.classList.add('col-sorted');
      } else {
        this.elementRef.nativeElement.parentElement.classList.remove('col-sorted');
      }
    }
    /**
     * Is the current field sorted in an ascending order?
     *
     * @returns whether the current field is sorted in ascending order.
     */
    isAscending() {
      return this.fieldName === this.sortField;
    }
    /**
     * Is the current field sorted in descending order?
     *
     * @returns whether the current field is sorted in descending order.
     */
    isDescending() {
      return `-${this.fieldName}` === this.sortField;
    }
    /**
     * Method called when sorting order changes.
     * Will emit a "sortChange" event.
     */
    sort() {
      let newSortField;
      // If ascending, toggle.
      if (this.isAscending()) {
        newSortField = `-${this.fieldName}`;
      } else {
        newSortField = this.fieldName;
      }
      this.sortChange.emit(newSortField);
    }
    static {
      this.ɵfac = function VueSortComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueSortComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueSortComponent,
        selectors: [["vue-sort"]],
        hostAttrs: ["role", "button", "tabindex", "0"],
        hostBindings: function VueSortComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function VueSortComponent_click_HostBindingHandler() {
              return ctx.onClick();
            })("keydown.enter", function VueSortComponent_keydown_enter_HostBindingHandler() {
              return ctx.onEnter();
            });
          }
        },
        inputs: {
          fieldName: "fieldName",
          sortField: "sortField"
        },
        outputs: {
          sortChange: "sortChange"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 2,
        consts: [["icon", "sort-up", 1, "fa", "pull-right"], ["icon", "sort-down", 1, "fa", "pull-right"]],
        template: function VueSortComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div")(1, "span");
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, VueSortComponent_Conditional_3_Template, 2, 0, "span")(4, VueSortComponent_Conditional_4_Template, 2, 0, "span");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.isAscending() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDescending() ? 4 : -1);
          }
        },
        dependencies: [i1$2.FaIconComponent],
        encapsulation: 2
      });
    }
  }
  return VueSortComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive provides row-specific action button within a table.<br />
 * Notes:
 *
 * <ul>
 *     <li>A row can have up to six actions, and up to two primary buttons.</li>
 *     <li>If there are two or more actions, with only one primary button, only the primary button
 *     will show and the rest will be hidden inside a "More" drop-down.</li>
 *     <li>Each action can either be a standard button, or a confirm-type button.</li>
 * </ul>
 *
 * Example:
 * ```
 * <vue-table-actions
 *    i18nBundle="PortalBase"
 *    action1Label="Edit"
 *    (action1ButtonClicked)="edit(employee)"
 *
 *    action2Label="Delete"
 *    action2ConfirmHeaderLabel="Are you sure you wish to remove?"
 *    action2ConfirmLabel="OK"
 *    action2CancelLabel="Cancel"
 *    (action2ConfirmClicked)="ok(employee)"
 *    (action2CancelClicked)="cancel()"
 *
 *    action3Label="Action 3"
 *    (action3ButtonClicked)="action3Click(employee)">
 * </vue-table-actions>
 * ```
 */
let VueTableActionsComponent = /*#__PURE__*/(() => {
  class VueTableActionsComponent {
    static {
      this.nextId = 0;
    }
    /**
     * Tracks RTL for positioning
     */
    get isRTL() {
      return document.documentElement.dir === 'rtl';
    }
    /**
     * Default constructor.
     */
    constructor(vueTranslationService, vueUserSessionService, dialog) {
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      this.dialog = dialog;
      /**
       * How many primary buttons desired.
       *
       * Defaults to 1.
       */
      this.primaryButtonNumber = '1';
      /**
       * Whether the first action button is visible.
       *
       * Visible by default.
       */
      this.action1Visible = true;
      /**
       * Event emitter when the first action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action1ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the first action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action1CancelClicked = new EventEmitter();
      /**
       * Event emitter when the first action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action1ConfirmClicked = new EventEmitter();
      /**
       * Whether the second action button is visible.
       *
       * Visible by default.
       */
      this.action2Visible = true;
      /**
       * Event emitter when the second action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action2ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the second action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action2CancelClicked = new EventEmitter();
      /**
       * Event emitter when the second action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action2ConfirmClicked = new EventEmitter();
      /**
       * Whether the third action button is visible.
       *
       * Visible by default.
       */
      this.action3Visible = true;
      /**
       * Event emitter when the third action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action3ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the third action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action3CancelClicked = new EventEmitter();
      /**
       * Event emitter when the third action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action3ConfirmClicked = new EventEmitter();
      /**
       * Whether the fourth action button is visible.
       *
       * Visible by default.
       */
      this.action4Visible = true;
      /**
       * Event emitter when the fourth action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action4ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the fourth action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action4CancelClicked = new EventEmitter();
      /**
       * Event emitter when the fourth action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action4ConfirmClicked = new EventEmitter();
      /**
       * Whether the fifth action button is visible.
       *
       * Visible by default.
       */
      this.action5Visible = true;
      /**
       * Event emitter when the fifth action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action5ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the fifth action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action5CancelClicked = new EventEmitter();
      /**
       * Event emitter when the fifth action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action5ConfirmClicked = new EventEmitter();
      /**
       * Whether the sixth action button is visible.
       *
       * Visible by default.
       */
      this.action6Visible = true;
      /**
       * Event emitter when the sixth action button is clicked.
       *
       * <u>USED ON REGULAR BUTTONS.</u>
       */
      this.action6ButtonClicked = new EventEmitter();
      /**
       * Event emitter when the sixth action's cancel button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action6CancelClicked = new EventEmitter();
      /**
       * Event emitter when the sixth action's confirm button is clicked.
       *
       * <u>USED ON CONFIRM BUTTONS.</u>
       */
      this.action6ConfirmClicked = new EventEmitter();
      /**
       * Additional string attached to the end of all elements with id attribute
       */
      this.idSuffix = '';
      /**
       * Buttons displayed inline
       */
      this.primaryButtons = [];
      /**
       * Buttons displayed in an inline dropdown
       */
      this.moreButtons = [];
    }
    /**
     * Runs on component initialization
     */
    ngOnInit() {
      /**
       * Since this used in tables, it will most likely be repeated. We should
       * ensure that we have an id suffix if it was not provided.
       */
      if (!this.idSuffix) {
        this.idSuffix = VueTableActionsComponent.nextId++;
      }
    }
    /**
     * When our @Inputs change we should rebuild our buttons
     */
    ngOnChanges() {
      this.buildButtons();
    }
    /**
     * Creates our list of buttons
     */
    buildButtons() {
      const buttons = [];
      for (let x = 1; x < 7; x++) {
        const info = this.getButtonInfo(x);
        if (this.isVisible(info)) {
          buttons.push(info);
        }
      }
      const primaryCount = Number(this.primaryButtonNumber);
      /**
       * Since "more" takes up a button space, we add
       * one to the primary count and see if it is
       * more than the amount of buttons requested
       * to see if we need a drop down for "more"
       * buttons
       */
      if (primaryCount + 1 >= buttons.length) {
        this.primaryButtons = buttons;
      } else {
        this.primaryButtons = buttons.splice(0, primaryCount);
        this.moreButtons = buttons;
      }
    }
    /**
     * Gets properties for a specific button index
     * @param x number
     * @returns TableButton
     */
    getButtonInfo(x) {
      return {
        cancelLabel: this.getLabel(this[`action${x}CancelLabel`], this[`action${x}CancelLabelKey`]),
        confirmHeaderLabel: this.getLabel(this[`action${x}ConfirmHeaderLabel`], this[`action${x}ConfirmHeaderLabelKey`]),
        confirmLabel: this.getLabel(this[`action${x}ConfirmLabel`], this[`action${x}ConfirmLabelKey`]),
        hidden: !this[`action${x}Visible`],
        id: `table-action-button-${x}-${this.idSuffix}`,
        label: this.getLabel(this[`action${x}Label`], this[`action${x}LabelKey`]),
        num: x,
        roles: this[`action${x}Roles`]
      };
    }
    /**
     * Determines label for button
     * @param label string
     * @param key string
     * @returns string
     */
    getLabel(label, key) {
      if (label) {
        return label;
      } else if (key) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, key);
      }
      return null;
    }
    /**
     * Determines if a button is shown or not
     * @param button TableButton
     * @returns boolean
     */
    isVisible(button) {
      if (!button.label) {
        return false;
      }
      if (button.hidden) {
        return false;
      }
      if (!button.roles) {
        return true;
      }
      return this.vueUserSessionService.userHasOneRole(button.roles);
    }
    /**
     * Executed with a primary or 'more' button is activated
     * @param button TableButton
     * @param originatingButton HTMLElement
     */
    buttonClick(button, originatingButton) {
      if (!button.confirmLabel) {
        this[`action${button.num}ButtonClicked`].emit();
        return;
      }
      this.doConfirm(button, originatingButton);
    }
    /**
     * Initiated when a button has a confirmation step.
     * Will open a confirm dialog
     * @param button TableButton
     * @param originatingButton HTMLElement
     */
    doConfirm(button, originatingButton) {
      const rect = originatingButton.getBoundingClientRect();
      this.dialog.open(this.confirmDialog, {
        ariaDescribedBy: 'confirm-aria-description',
        backdropClass: 'vue-confirm-cancel-backdrop-noop',
        closeOnNavigation: true,
        data: button,
        direction: document.documentElement.dir,
        hasBackdrop: true,
        maxWidth: '200px',
        position: {
          left: this.isRTL ? `${rect.left}px` : null,
          right: !this.isRTL ? `${document.body.clientWidth - rect.right}px` : null,
          top: `${rect.bottom}px`
        }
      }).afterClosed().subscribe(val => {
        // only react to specifically to TRUE / FALSE
        // ignore null, undefined values as it means they
        // clicked outside the dialog and did not make
        // a choice
        if (val === false) {
          this[`action${button.num}CancelClicked`].emit();
        }
        if (val === true) {
          this[`action${button.num}ConfirmClicked`].emit();
        }
      });
    }
    static {
      this.ɵfac = function VueTableActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTableActionsComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueUserSessionService), i0.ɵɵdirectiveInject(i3$1.MatDialog));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueTableActionsComponent,
        selectors: [["vue-table-actions"]],
        viewQuery: function VueTableActionsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c12, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDialog = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle",
          primaryButtonNumber: "primaryButtonNumber",
          action1CancelLabel: "action1CancelLabel",
          action1CancelLabelKey: "action1CancelLabelKey",
          action1ConfirmHeaderLabel: "action1ConfirmHeaderLabel",
          action1ConfirmHeaderLabelKey: "action1ConfirmHeaderLabelKey",
          action1ConfirmLabel: "action1ConfirmLabel",
          action1ConfirmLabelKey: "action1ConfirmLabelKey",
          action1Label: "action1Label",
          action1LabelKey: "action1LabelKey",
          action1Roles: "action1Roles",
          action1Visible: "action1Visible",
          action2CancelLabel: "action2CancelLabel",
          action2CancelLabelKey: "action2CancelLabelKey",
          action2ConfirmHeaderLabel: "action2ConfirmHeaderLabel",
          action2ConfirmHeaderLabelKey: "action2ConfirmHeaderLabelKey",
          action2ConfirmLabel: "action2ConfirmLabel",
          action2ConfirmLabelKey: "action2ConfirmLabelKey",
          action2Label: "action2Label",
          action2LabelKey: "action2LabelKey",
          action2Roles: "action2Roles",
          action2Visible: "action2Visible",
          action3CancelLabel: "action3CancelLabel",
          action3CancelLabelKey: "action3CancelLabelKey",
          action3ConfirmHeaderLabel: "action3ConfirmHeaderLabel",
          action3ConfirmHeaderLabelKey: "action3ConfirmHeaderLabelKey",
          action3ConfirmLabel: "action3ConfirmLabel",
          action3ConfirmLabelKey: "action3ConfirmLabelKey",
          action3Label: "action3Label",
          action3LabelKey: "action3LabelKey",
          action3Roles: "action3Roles",
          action3Visible: "action3Visible",
          action4CancelLabel: "action4CancelLabel",
          action4CancelLabelKey: "action4CancelLabelKey",
          action4ConfirmHeaderLabel: "action4ConfirmHeaderLabel",
          action4ConfirmHeaderLabelKey: "action4ConfirmHeaderLabelKey",
          action4ConfirmLabel: "action4ConfirmLabel",
          action4ConfirmLabelKey: "action4ConfirmLabelKey",
          action4Label: "action4Label",
          action4LabelKey: "action4LabelKey",
          action4Roles: "action4Roles",
          action4Visible: "action4Visible",
          action5CancelLabel: "action5CancelLabel",
          action5CancelLabelKey: "action5CancelLabelKey",
          action5ConfirmHeaderLabel: "action5ConfirmHeaderLabel",
          action5ConfirmHeaderLabelKey: "action5ConfirmHeaderLabelKey",
          action5ConfirmLabel: "action5ConfirmLabel",
          action5ConfirmLabelKey: "action5ConfirmLabelKey",
          action5Label: "action5Label",
          action5LabelKey: "action5LabelKey",
          action5Roles: "action5Roles",
          action5Visible: "action5Visible",
          action6CancelLabel: "action6CancelLabel",
          action6CancelLabelKey: "action6CancelLabelKey",
          action6ConfirmHeaderLabel: "action6ConfirmHeaderLabel",
          action6ConfirmHeaderLabelKey: "action6ConfirmHeaderLabelKey",
          action6ConfirmLabel: "action6ConfirmLabel",
          action6ConfirmLabelKey: "action6ConfirmLabelKey",
          action6Label: "action6Label",
          action6LabelKey: "action6LabelKey",
          action6Roles: "action6Roles",
          action6Visible: "action6Visible",
          idSuffix: "idSuffix"
        },
        outputs: {
          action1ButtonClicked: "action1ButtonClicked",
          action1CancelClicked: "action1CancelClicked",
          action1ConfirmClicked: "action1ConfirmClicked",
          action2ButtonClicked: "action2ButtonClicked",
          action2CancelClicked: "action2CancelClicked",
          action2ConfirmClicked: "action2ConfirmClicked",
          action3ButtonClicked: "action3ButtonClicked",
          action3CancelClicked: "action3CancelClicked",
          action3ConfirmClicked: "action3ConfirmClicked",
          action4ButtonClicked: "action4ButtonClicked",
          action4CancelClicked: "action4CancelClicked",
          action4ConfirmClicked: "action4ConfirmClicked",
          action5ButtonClicked: "action5ButtonClicked",
          action5CancelClicked: "action5CancelClicked",
          action5ConfirmClicked: "action5ConfirmClicked",
          action6ButtonClicked: "action6ButtonClicked",
          action6CancelClicked: "action6CancelClicked",
          action6ConfirmClicked: "action6ConfirmClicked"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 1,
        consts: [["confirmDialog", ""], ["currentButton", ""], ["moreButton", ""], [1, "btn", "btn-default", "btn-xs", "action-btn", 3, "id"], ["ngbDropdown", "", 3, "placement"], [1, "btn", "btn-default", "btn-xs", "action-btn", 3, "click", "id"], ["ngbDropdownToggle", "", "type", "button", 1, "btn", "btn-default", "btn-xs", "dropdown-toggle", "action-btn", 3, "id"], [1, "caret"], ["ngbDropdownMenu", "", "role", "menu", 1, "dropdown-menu"], ["ngbDropdownItem", "", 3, "id"], ["ngbDropdownItem", "", 3, "click", "id"], [1, "confirm-content"], ["id", "confirm-aria-description", 1, "dropdown-header", 3, "innerHTML"], [1, "dropdown-item", 3, "keydown.arrowdown", "keydown.arrowup", "id", "mat-dialog-close"]],
        template: function VueTableActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, VueTableActionsComponent_For_1_Template, 3, 2, "button", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵtemplate(2, VueTableActionsComponent_Conditional_2_Template, 10, 9, "div", 4)(3, VueTableActionsComponent_ng_template_3_Template, 6, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.primaryButtons);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.moreButtons.length ? 2 : -1);
          }
        },
        dependencies: [i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i4.NgbDropdownButtonItem, i3$1.MatDialogClose, i2.AsyncPipe, VueTranslatePipe, VueHtmlSafePipe],
        styles: ["[_nghost-%COMP%]{display:flex}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.action-btn[_ngcontent-%COMP%]{margin-left:5px}button.dropdown-item[_ngcontent-%COMP%]{padding:8px 10px}.confirm-content[_ngcontent-%COMP%]{border:1px solid #fbaa19;font-size:12px;color:#212529}.confirm-content[_ngcontent-%COMP%]   p.dropdown-header[_ngcontent-%COMP%]{padding:10px 12px;white-space:normal;text-transform:none;color:inherit;font-size:inherit}"]
      });
    }
  }
  return VueTableActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive provides filter/search functionality for a table. Adds a table row for filtering wherever needed
 * in the table. Automatically creates <code><input></code> and <code><select></code> for filtering.<br />
 *
 * <h3>Usage:</h3>
 * <ul>
 *     <li>Pass the list of fields <code>tableFields</code> to be filtered. If <code>tableFields</code> is
 *     changed/updated, <code>tableFilterComponent.applyFilter()</code> must be called.</li>
 *     <li> Construct and pass in the list of filter fields to be created: <code>{@link FilterInput}[]</code>.</li>
 *     <li>Get the filtered list out through the <code>onFilterTableFields @Output</code>. The filtered list is
 *     bound to <code>$event</code>.</li>
 * </ul>
 *
 * <h3>Properties:</h3>
 * <ul>
 *     <li><code>showFilterOptions</code> - Use this to show/hide this filter row</li>
 *     <li><code>filterInputs</code> - List of {@link FilterInput}, i.e. <code>{@link FilterInput}[]</code>
 *     <li><code>tableFields</code> - The data, i.e. list of table fields</li>
 *     <li><code>onFilterTableFields</code> - Event to get the filtered list</li>
 * </ul>
 *
 * Note: As of 2024 only <code><input></code> and <code><select></code> filter inputs are supported.
 *
 * <h3>Example:</h3>
 * ```
 * <tr vue-table-filter
 *     [showFilterOptions]="true"
 *     [filterInputs]="employeesFilterInputs"
 *     [tableFields]="employeesToBeFiltered"
 *     (onFilterTableFields)="setFilteredList($event)">
 * </tr>
 * ```
 */
class VueTableFilterComponent {
  static {
    this.nextId = Number.MIN_VALUE + 1;
  }
  constructor(vueTranslationService) {
    this.vueTranslationService = vueTranslationService;
    /**
     * Used to toggle between showing and hiding the filter row
     */
    this.showFilterRow = true;
    /**
     * Event that emits the filtered list of fields
     * Note: Required subscription
     */
    this.onFilterTableFields = new EventEmitter();
  }
  ngOnInit() {
    this.checkFilterSubscription();
    this.tableFieldKeys = Object.keys(this.tableFields[0]);
    if (this.filterInputs.length > this.tableFieldKeys.length) {
      throw Error('Number of filter fields to be created greater than number of columns on the table');
    }
    if (!this.idSuffix) {
      this.idSuffix = VueTableFilterComponent.nextId++;
    }
    this.clearFilter();
  }
  /**
   * Applies filter on the set of columns that are in <code>tableFields</code>.
   */
  applyFilter() {
    const filteredFields = this.tableFields.filter(tableField => {
      return this.isTableFieldInFilteredView(tableField);
    });
    this.onFilterTableFields.emit(filteredFields);
  }
  /**
   * Function used when filtering that checks if this
   * <code>tableField</code> is in the final filtered view.
   * @param tableField object of field
   * @return boolean
   */
  isTableFieldInFilteredView(tableField) {
    return this.tableFieldKeys.every(key => {
      const filterInput = this.filterInputs.find(fi => fi.fieldName.toLowerCase().includes(key.toLowerCase()));
      if (!filterInput) {
        // No filter field detected for this table field
        return true;
      }
      // filter based on whether the filterInput is an <input> or a <select>
      if (!this.isFilterInputDropdown(filterInput)) {
        return String(tableField[key]).toLowerCase().includes(String(filterInput.fieldValue).toLowerCase());
      }
      return String(tableField[key]).toLowerCase() === String(filterInput.fieldValue).toLowerCase() || filterInput.fieldValue === '';
    });
  }
  /**
   * Clears the filter values and re"filters" table fields.
   */
  clearFilter() {
    this.filterInputs.forEach(filterInput => {
      if (!this.isFilterInputDropdown(filterInput)) {
        filterInput.fieldValue = '';
      } else {
        filterInput.fieldValue = filterInput.selectOptions[0].ngValue;
      }
    });
    this.applyFilter();
  }
  isFilterInputDropdown(filterInput) {
    return typeof filterInput.selectOptions !== 'undefined' && filterInput.selectOptions !== null;
  }
  /**
   * Checks if subscription exists for <code>onFilterTableFields</code>.
   */
  checkFilterSubscription() {
    if (!this.onFilterTableFields.observed) {
      throw Error('Required event subscription for "onFilterTableFields" is missing');
    }
  }
  static {
    this.ɵfac = function VueTableFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VueTableFilterComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VueTableFilterComponent,
      selectors: [["tr", "vue-table-filter", ""]],
      inputs: {
        showFilterRow: "showFilterRow",
        tableFields: "tableFields",
        filterInputs: "filterInputs",
        idSuffix: "idSuffix"
      },
      outputs: {
        onFilterTableFields: "onFilterTableFields"
      },
      standalone: false,
      attrs: _c13,
      decls: 1,
      vars: 1,
      consts: [["type", "submit", 1, "btn", "btn-default", "btn-xs", "action-btn", "filter-clear", 3, "click", "id"], ["autocomplete", "off", 1, "form-control", "filter-input", 3, "name", "id", "ngModel"], [1, "form-control", "filter-select", 3, "name", "id", "ngModel"], ["autocomplete", "off", 1, "form-control", "filter-input", 3, "ngModelChange", "input", "name", "id", "ngModel"], [1, "form-control", "filter-select", 3, "ngModelChange", "change", "name", "id", "ngModel"], [3, "ngValue"]],
      template: function VueTableFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, VueTableFilterComponent_Conditional_0_Template, 7, 7);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.showFilterRow ? 0 : -1);
        }
      },
      dependencies: [i6.NgSelectOption, i6.ɵNgSelectMultipleOption, i6.DefaultValueAccessor, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgModel, i2.AsyncPipe, VueTranslatePipe],
      styles: [".filter-clear[_ngcontent-%COMP%]{float:right;margin-right:.5em;max-width:100px;overflow-x:hidden}.filter-input[_ngcontent-%COMP%]{width:100%;height:2em}.filter-select[_ngcontent-%COMP%]{width:fit-content;min-width:4em;height:2em}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive will focus a dom element on load.
 * It works with *ngIf and other angular directives that
 * build and tear down components.
 *
 * It should be used in stead of `[autofocus]` attribute.
 *
 * It also accepts a boolean so if the item should be focused
 * can be dynamic.
 *
 * Usage:
 ```html
  <input vueAutofocus />

  or

  <input [vueAutofocus]="shouldAutofocus" />
```
 */
let AutofocusDirective = /*#__PURE__*/(() => {
  class AutofocusDirective {
    constructor(host) {
      this.host = host;
    }
    ngAfterContentInit() {
      if (this.vueAutofocus !== false) {
        setTimeout(() => this.host.nativeElement.focus());
      }
    }
    static {
      this.ɵfac = function AutofocusDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AutofocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AutofocusDirective,
        selectors: [["", "vueAutofocus", ""]],
        inputs: {
          vueAutofocus: "vueAutofocus"
        },
        standalone: false
      });
    }
  }
  return AutofocusDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This class is a slave of VueTimeoutService.  It subscribes and shows itself when told by the timeout service.
*/
let VueTimeoutDialogComponent = /*#__PURE__*/(() => {
  class VueTimeoutDialogComponent {
    constructor(vueTimeoutService, vueTranslationService) {
      this.vueTimeoutService = vueTimeoutService;
      this.vueTranslationService = vueTranslationService;
      this.extendSessionText = '';
      this.timeoutMessageText = '';
      this.timeoutMessage = '';
      this.show = false;
      this.untranslatedPrefix = '[@@';
    }
    ngOnInit() {
      this.vueTimeoutService.getShowTimeoutDialog().subscribe(state => {
        if (state) {
          if (this.extendSessionText === '') {
            this.extendSessionText = this.vueTranslationService.getTranslation('PortalBase', 'button.ExtendSession');
            if (this.extendSessionText.startsWith(this.untranslatedPrefix)) {
              this.extendSessionText = 'Extend Session';
            }
            this.timeoutMessageText = this.vueTranslationService.getTranslation('PortalBase', 'message.TimeoutMessage');
            if (this.timeoutMessageText.startsWith(this.untranslatedPrefix)) {
              this.timeoutMessageText = 'Your session will expire in {0} seconds because of inactivity.';
            }
          }
          this.show = true;
        } else {
          this.show = false;
        }
      });
      this.vueTimeoutService.getExtendTimer().subscribe(timeLeft => {
        // this.countdownTimer = timeLeft;
        this.timeoutMessage = this.timeoutMessageText.replace('{0}', timeLeft.toString());
      });
    }
    extendSession() {
      this.vueTimeoutService.extendSession();
      this.show = false;
    }
    static {
      this.ɵfac = function VueTimeoutDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTimeoutDialogComponent)(i0.ɵɵdirectiveInject(VueTimeoutService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueTimeoutDialogComponent,
        selectors: [["vue-timeout-dialog"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["cdkTrapFocus", "", 1, "session-timeout-container"], [1, "screen-overlay", 3, "click"], [1, "dashboard-message-wrapper"], [1, "dashboard-message-container"], ["cdkFocusInitial", "", "vueAutofocus", "", 1, "btn", "btn-primary", "btn-sm", "session-extend", 3, "click"]],
        template: function VueTimeoutDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueTimeoutDialogComponent_Conditional_0_Template, 8, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.show ? 0 : -1);
          }
        },
        dependencies: [i1$4.CdkTrapFocus, AutofocusDirective],
        encapsulation: 2
      });
    }
  }
  return VueTimeoutDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Class used to validate password strength using regex patterns
 */
class VueValidationRules {}
/**
 * Default classes for displaying inline error messages.
 */
const classSuccess = 'validation-success';
const classDisabled = 'validation-disabled';
const classFail = 'validation-fail';
/**
 * Used in if statement do decide if there will be a change in class for a rule.
 */
const classNone = 'not a class';
/**
 * Strong passwords are required.
 * A password must be a minimum of 8 characters and a password cannot contain the user name.
 * contain three of the following:
 *  uppercase letters,
 *  lowercase letters, numbers,
 *  and special characters.
 */
const defaultRequiredValidation = {
  rules: [{
    class: classNone,
    label: '',
    labelKey: 'passwordRule.label.notIncludeUsername',
    order: 2
  }, {
    class: classDisabled,
    label: '',
    labelKey: 'passwordRule.label.minimumLength',
    labelParams: [8],
    order: 1,
    regex: new RegExp('^.{8,}$')
  }]
};
const defaultOptionalValidation = {
  rules: [{
    class: classDisabled,
    label: '',
    labelKey: 'passwordRule.label.atleastOneUppercase',
    order: 1,
    regex: new RegExp('(?=.*[A-Z])')
  }, {
    class: classDisabled,
    label: '',
    labelKey: 'passwordRule.label.atleastOneLowercase',
    order: 2,
    regex: new RegExp('(?=.*[a-z])')
  }, {
    class: classDisabled,
    label: '',
    labelKey: 'passwordRule.label.atleastOneDigit',
    order: 3,
    regex: new RegExp('(?=.*\\d)')
  }, {
    class: classDisabled,
    label: '',
    labelKey: 'passwordRule.label.atleastOneSpecial',
    order: 4,
    regex: new RegExp('(?=.*[!-/:-@\\[-`{-~{-~])')
  }]
};
const minValidOptionalRules = 3;

/**
 * This component is included by default in the vue-password-strength-input component. It will errors based on regex
 * tests from validationRules. This component is intended to be used in a form with a control to be passed in, but can
 * be used without.
 *
 * Usage:
 * ```
 <vue-control-group [control]="newPasswordControl" [excludeValidationMessage]="true" [formError]="formError"
  widthClass="shorter" [i18nBundle]="i18nBundle" [label]="newPasswordLabel">
   <input #inputElement name="newPassword" class="form-control" id="newPasswordField"
    pattern="\b{{confirmPassword}}\b" type="password" [(ngModel)]="newPassword" required
    #newPasswordControl="ngModel" autocomplete="off">
   <vue-validation-message [control]="newPasswordControl" [formError]="formError" [i18nBundle]="i18nBundle"
    [pattern]="patternNotMatch">
   </vue-validation-message>
 </vue-control-group>

 <vue-inline-validation-message id="requiredRules" [control]="newPasswordControl"
   [i18nBundle]="i18nBundle" [validationRules]="validationRequiredRules"
   [ruleHelpLabel]="Password Must:">
 </vue-inline-validation-message>```
 *
 * You can override the validationRules, and ruleHelpLabel.
 *
 * <b>Note</b>: You need to provide translation keys present in the `i18nBundle` provided.
 * The vue-inline-validation-message is outside of control-group because otherwise it will be affected by widthClass
 */
let VueInlineValidationMessageComponent = /*#__PURE__*/(() => {
  class VueInlineValidationMessageComponent {
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * Classes used to display validation, need these here even though we have them in VueValidationRules because html
       * needs to get the values
       */
      this.classSuccess = classSuccess;
      this.classDisabled = classDisabled;
      this.classFail = classFail;
      this.classNone = classNone;
    }
    getTranslations() {
      if (!this.ruleHelpLabel && this.ruleHelpLabelKey) {
        this.ruleHelpLabel = this.vueTranslationService.getTranslation(this.i18nBundle, this.ruleHelpLabelKey);
      }
      if (this.validationRules && this.validationRules.rules) {
        this.validationRules.rules.forEach(rule => {
          if (!rule.label && rule.labelKey) {
            rule.label = rule.labelParams ? this.vueTranslationService.getTranslation(this.i18nBundle, rule.labelKey, rule.labelParams) : this.vueTranslationService.getTranslation(this.i18nBundle, rule.labelKey);
          }
        });
      }
    }
    checkValid(value) {
      let s = value;
      if (!s) {
        s = this.control.value;
      }
      let validRules = 0;
      if (this.validationRules.rules && this.validationRules.rules.length > 0) {
        this.validationRules.rules.forEach(rule => {
          if (rule.class !== classNone) {
            if (rule.regex.test(s)) {
              rule.class = this.classSuccess;
              rule.valid = true;
              validRules++;
            } else {
              rule.class = this.classFail;
              rule.valid = false;
            }
          } else {
            validRules++;
          }
        });
      }
      return validRules;
    }
    ngOnInit() {
      this.getTranslations();
    }
    /**
     * This component retains class values even after router navigates to different page
     * so ngOnDestroy is used to set classes back to the init state.
     */
    ngOnDestroy() {
      this.validationRules.rules.forEach(rule => {
        rule.valid = false;
        if (rule.class !== classNone) {
          rule.class = classDisabled;
        }
      });
    }
    static {
      this.ɵfac = function VueInlineValidationMessageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueInlineValidationMessageComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueInlineValidationMessageComponent,
        selectors: [["vue-inline-validation-message"]],
        inputs: {
          control: "control",
          validationRules: "validationRules",
          i18nBundle: "i18nBundle",
          ruleHelpLabel: "ruleHelpLabel",
          ruleHelpLabelKey: "ruleHelpLabelKey"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "help-inline", "validation-inline"], [3, "class"], [3, "ngClass"], ["icon", "times", 1, "fa", "fa-fw"], ["icon", "check", 1, "fa", "fa-fw"]],
        template: function VueInlineValidationMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueInlineValidationMessageComponent_Conditional_0_Template, 5, 1, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.validationRules && ctx.validationRules.rules.length > 0 ? 0 : -1);
          }
        },
        dependencies: [i2.NgClass, i1$2.FaIconComponent],
        styles: [".validation-inline[_ngcontent-%COMP%]   .validation-fail[_ngcontent-%COMP%]{color:#dc3240;width:100%;float:none}.validation-inline[_ngcontent-%COMP%]   .validation-success[_ngcontent-%COMP%]{color:#3b8635;width:100%;float:none}.validation-inline[_ngcontent-%COMP%]   .validation-disabled[_ngcontent-%COMP%]{color:#6d6d6d;width:100%;float:none}"]
      });
    }
  }
  return VueInlineValidationMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class is used to indicate whether a form is valid or invalid, and which is the first
 * field that has an error.
 */
class VueFormError {
  /**
   * Form error constructor.
   */
  constructor() {
    this.invalidFormSubmit = false;
    this.fieldInError = '';
  }
}

/**
 * This directive should be placed as shown below.  Unlike the core angular max length functionality,
 * this won't stop input but shows an error on the fly to make it more clear to the user.
 *
 * Usage:
 ```
 <vue-control-group i18nBundle="portal" labelKey="heroName"[control]="heroName"  [formError]="formError">
 <input autocomplete="off"
        class="form-control"
        name="heroName"
        required
        vueMaxLength="6"
        #inputElement
        #heroName="ngModel"
        [(ngModel)]="hero.name">
 </vue-control-group>
 ```
 */
let VueMaxLengthDirective = /*#__PURE__*/(() => {
  class VueMaxLengthDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateLength();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateLength().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that the length of an input does not surpass a given maximum.
     *
     * @returns a validator function.
     */
    vueValidateLength() {
      return formControl => {
        // The form value will be a string
        const stringValue = formControl && formControl.value ? formControl.value : '';
        const isValid = stringValue.length <= this.vueMaxLength;
        return isValid ? null : {
          vueValidateLength: {
            maxLength: this.vueMaxLength,
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueMaxLengthDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMaxLengthDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueMaxLengthDirective,
        selectors: [["", "vueMaxLength", "", "ngModel", ""]],
        inputs: {
          vueMaxLength: "vueMaxLength"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueMaxLengthDirective
        }])]
      });
    }
  }
  return VueMaxLengthDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component used to validate that a password meets the required and
 * optional criteria using regex rules in VueValidationRules. First created for
 * AccountRecovery and was based on the AngularJS from Navigator
 *
 * Usage:
 * ```
 <vue-password-strength-input
   #passwordComponent
   [i18nBundle]="portalBundle"
   [hasOldPassword]="false"
   minValidOptionalRules = "minOptional"
   requiredRuleLabel="Password must:"
   optionalRuleLabel="And meet at least 2 of the 3 requirements:"
   newPasswordLabel="New Password"
   confirmPasswordLabel="Confirm Password">
 </vue-password-strength-input>```
 *
 * You can override the validationRules, but a default from VueValidationRulesles.ts will be used unless a
 * validationRule with an empty rule list is used to override. Most labels can be overwritten.
 *
 * <b>Note</b>: You need to provide translation keys present in the `i18nBundle` provided. The Confirm password and New
 * Password fields must always match, AND their respective input DOM elements must exist because there is a pattern
 * used to confirm both match each other.
 */
let VuePasswordStrengthInputComponent = /*#__PURE__*/(() => {
  class VuePasswordStrengthInputComponent {
    constructor(vueTranslationService, appDefaultsService) {
      this.vueTranslationService = vueTranslationService;
      this.appDefaultsService = appDefaultsService;
      /**
       * Map this field to your component that contains this object. In general, system design indicates this when the user
       * presses save and something is wrong on the form, the programmer should turn this field to true and mark the first
       * field in error. This will then 'light up' all the field errors as appropriate and position cursor in first field
       * with error.
       */
      this.formError = new VueFormError();
      /**
       * All required rules that must be met
       */
      this.validationRequiredRules = defaultRequiredValidation;
      /**
       * Optional rules that may or may not be valid for password.
       */
      this.validationOptionalRules = defaultOptionalValidation;
      /**
       * Minimum required validationOptionalRules that need to be valid.
       */
      this.minValidOptionalRules = minValidOptionalRules;
      /**
       *  Boolean used to display field level error message when username is used in password.
       *  This value is received externally from the backend service because a responsive and dynamic
       *  error message would be a security risk.
       */
      this.passwordContainsUsername = false;
      /**
       * The object that contains new password and validation information.
       * This was done to allow pass-by-reference when using this component;
       * when using this component, this should be property binded.
       */
      this.passwordInput = {
        isStrongPassword: false,
        newPassword: '',
        oldPassword: ''
      };
      /**
       * Width of the password input
       */
      this.inputWidthClass = 'shorter';
      /**
       * Max length of password allowed. Couldn't be bound to [vueMaxLength] because
       * the VueMaxLength selector is the same as variable name.
       */
      this.maxPasswordLength = 50;
      /**
       * Boolean value for when new password field and confirm password field are equal
       */
      this.passwordsMatch = true;
      /**
       * The value of the confirm password field.
       */
      this.confirmPassword = '';
    }
    ngOnInit() {
      this.validationOptionalRules.rules = this.validationOptionalRules.rules.slice().sort((x, y) => x.order > y.order ? 1 : -1);
      this.validationRequiredRules.rules = this.validationRequiredRules.rules.slice().sort((x, y) => x.order > y.order ? 1 : -1);
      this.getTranslations();
    }
    /**
     * Gets the translations for component. Does not support params when overriding, would recommend overriding label and
     * not labelKey when need to use params.
     */
    /* eslint-disable-next-line complexity */
    getTranslations() {
      if (!this.i18nBundle) {
        this.i18nBundle = this.appDefaultsService.getFieldErrorMessageBundle();
      }
      if (!this.i18nOverrideBundle) {
        this.i18nOverrideBundle = this.appDefaultsService.getFieldErrorMessageBundle();
      }
      if (!this.oldPasswordLabel) {
        this.oldPasswordLabel = this.oldPasswordLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.oldPasswordLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.oldPassword');
      }
      if (!this.newPasswordLabel) {
        this.newPasswordLabel = this.newPasswordLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.newPasswordLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.newPassword');
      }
      if (!this.confirmPasswordLabel) {
        this.confirmPasswordLabel = this.confirmPasswordLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.confirmPasswordLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.confirmPassword');
      }
      if (!this.optionalRuleLabel) {
        this.optionalRuleLabel = this.optionalRuleLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.optionalRuleLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'passwordRule.label.minimumRulesToMatch', [minValidOptionalRules, this.validationOptionalRules.rules.length]);
      }
      if (!this.requiredRuleLabel) {
        this.requiredRuleLabel = this.requiredRuleLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.requiredRuleLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.passwordRulesListHeader');
      }
      if (!this.passwordNotMatchLabel) {
        this.passwordNotMatchLabel = this.passwordNotMatchLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.passwordNotMatchLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'error.PasswordNotMatch');
      }
      if (!this.passwordContainsUsernameLabel) {
        this.passwordContainsUsernameLabel = this.passwordContainsUsernameLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.passwordContainsUsernameLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.passwordContainsUsername');
      }
      if (!this.passwordsMatchLabel) {
        this.passwordsMatchLabel = this.passwordsMatchLabelKey ? this.vueTranslationService.getTranslation(this.i18nBundle, this.passwordsMatchLabelKey) : this.vueTranslationService.getTranslation(this.i18nOverrideBundle, 'label.passwordsMatch');
      }
    }
    /**
     * Checks if password meets all the required criteria for validationRequiredRules
     * and the minimum for validationOptionalRules and newPassword matches confirmPassword
     * @returns true if all required rules are valid and the minimum optional rules are valid, false otherwise
     */
    checkPasswordStrong() {
      this.passwordContainsUsername = false;
      let validRequired = false;
      let validOptional = false;
      if (this.validationRequiredRules.rules.length > 0) {
        validRequired = this.inlineValidatorRequired.checkValid(this.passwordInput.newPassword) === this.validationRequiredRules.rules.length;
      }
      if (this.validationOptionalRules.rules.length > 0) {
        validOptional = this.inlineValidatorMatch.checkValid(this.passwordInput.newPassword) >= this.minValidOptionalRules;
        if (validOptional) {
          this.validationOptionalRules.rules.forEach(rule => {
            if (!rule.valid) {
              rule.class = classDisabled;
              // valid is used here to trigger the validation-disabled when options are valid
              rule.valid = true;
            }
          });
        }
      }
      /**
       * Do not show the custom field level messages when these are specific, and
       * higher priority error messages are present.
       */
      this.showCustomNewPassMsg = !this.passwordResetForm.form.controls.newPasswordField.errors;
      this.passwordInput.isStrongPassword = validOptional && validRequired;
      return this.passwordInput.isStrongPassword;
    }
    /**
     * Method to determine if newPassword's value is equal to confirmPassword's value.
     * Calls checkPasswordStrong to update the isPasswordStrong value when fields are matching.
     * @returns true if newPassword's value is equal to confirmPassword's value false otherwise.
     */
    isPasswordsMatch() {
      this.showCustomConfirmPassMsg = !this.passwordResetForm.form.controls.confirmPasswordField.errors;
      this.passwordsMatch = this.confirmPassword && this.passwordInput.newPassword === this.confirmPassword;
      return this.passwordsMatch;
    }
    /**
     * Prevent users from pasting into password field.
     * @param $event paste event
     * @return boolean false to stop event
     */
    noPaste($event) {
      $event.preventDefault();
      return false;
    }
    /**
     * Method used to determine if generic (vue-validation-messages)
     * are to be displayed for Confirm Password input field.
     * @return boolean value to render vue-validation-message for Confirm Password component
     */
    showGenericConfirmPasswordMessage() {
      return this.passwordsMatch || !this.confirmPassword.length || !this.showCustomConfirmPassMsg;
    }
    static {
      this.ɵfac = function VuePasswordStrengthInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePasswordStrengthInputComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePasswordStrengthInputComponent,
        selectors: [["vue-password-strength-input"]],
        viewQuery: function VuePasswordStrengthInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c15, 5);
            i0.ɵɵviewQuery(_c16, 5);
            i0.ɵɵviewQuery(_c17, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordResetForm = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inlineValidatorRequired = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inlineValidatorMatch = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle",
          i18nOverrideBundle: "i18nOverrideBundle",
          messages: "messages",
          formError: "formError",
          validationRequiredRules: "validationRequiredRules",
          validationOptionalRules: "validationOptionalRules",
          minValidOptionalRules: "minValidOptionalRules",
          oldPasswordLabel: "oldPasswordLabel",
          oldPasswordLabelKey: "oldPasswordLabelKey",
          hasOldPassword: "hasOldPassword",
          newPasswordLabel: "newPasswordLabel",
          newPasswordLabelKey: "newPasswordLabelKey",
          confirmPasswordLabel: "confirmPasswordLabel",
          confirmPasswordLabelKey: "confirmPasswordLabelKey",
          requiredRuleLabel: "requiredRuleLabel",
          requiredRuleLabelKey: "requiredRuleLabelKey",
          optionalRuleLabel: "optionalRuleLabel",
          optionalRuleLabelKey: "optionalRuleLabelKey",
          passwordNotMatchLabel: "passwordNotMatchLabel",
          passwordNotMatchLabelKey: "passwordNotMatchLabelKey",
          passwordContainsUsernameLabel: "passwordContainsUsernameLabel",
          passwordContainsUsernameLabelKey: "passwordContainsUsernameLabelKey",
          passwordContainsUsername: "passwordContainsUsername",
          passwordsMatchLabel: "passwordsMatchLabel",
          passwordsMatchLabelKey: "passwordsMatchLabelKey",
          autofocus: "autofocus",
          passwordInput: "passwordInput",
          inputWidthClass: "inputWidthClass",
          maxPasswordLength: "maxPasswordLength"
        },
        standalone: false,
        decls: 21,
        vars: 29,
        consts: [["passwordResetForm", "ngForm"], ["inputElement", "", "newPasswordField", "ngModel"], ["inputElement", "", "confirmPasswordField", "ngModel"], ["inputElement", "", "oldPasswordField", "ngModel"], ["inlineValidatorRequired", ""], ["inlineValidatorMatch", ""], ["novalidate", "", 1, "app-form"], [3, "control", "excludeValidationMessage", "formError", "widthClass", "i18nBundle", "label"], [3, "ngClass"], ["name", "newPasswordField", "id", "newPasswordField", "type", "password", "required", "", "pattern", "^[ -~]*$", "autocomplete", "off", 1, "form-control", 3, "ngModelChange", "paste", "ngModel", "vueMaxLength"], ["pattern", "error.IllegalCharacters", "singleFieldLevelErrorPriority", "pattern", 3, "control", "formError", "i18nBundle", "isSingleFieldLevelErrorEnabled"], [1, "help-inline", "validation-inline"], [1, "pad-top"], ["id", "requiredRules", 3, "control", "i18nBundle", "validationRules", "ruleHelpLabel"], [1, "pad-bot"], ["id", "matchRules", 3, "control", "i18nBundle", "validationRules", "ruleHelpLabel"], [3, "control", "excludeValidationMessage", "widthClass", "formError", "i18nBundle", "label"], ["name", "confirmPasswordField", "id", "confirmPasswordField", "type", "password", "required", "", "pattern", "^[ -~]*$", "autocomplete", "off", 1, "form-control", 3, "ngModelChange", "paste", "ngModel", "vueMaxLength"], ["name", "oldPasswordField", "id", "oldPasswordField", "type", "password", "pattern", "^[ -~]*$", "required", "", "autocomplete", "off", 1, "form-control", 3, "paste", "ngModelChange", "vueAutofocus", "ngModel", "vueMaxLength"], ["singleFieldLevelErrorPriority", "pattern", "pattern", "error.IllegalCharacters", 3, "control", "formError", "i18nBundle", "isSingleFieldLevelErrorEnabled"], [1, "validation-fail"], ["icon", "times", 1, "fa", "fa-fw"], [1, "validation-success"], ["icon", "check", 1, "fa", "fa-fw"]],
        template: function VuePasswordStrengthInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 6, 0);
            i0.ɵɵtemplate(2, VuePasswordStrengthInputComponent_Conditional_2_Template, 5, 13, "vue-control-group", 7);
            i0.ɵɵelementStart(3, "div", 8)(4, "vue-control-group", 7)(5, "input", 9, 1);
            i0.ɵɵtwoWayListener("ngModelChange", function VuePasswordStrengthInputComponent_Template_input_ngModelChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.passwordInput.newPassword, $event) || (ctx.passwordInput.newPassword = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("paste", function VuePasswordStrengthInputComponent_Template_input_paste_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.noPaste($event));
            })("ngModelChange", function VuePasswordStrengthInputComponent_Template_input_ngModelChange_5_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.checkPasswordStrong();
              return i0.ɵɵresetView(ctx.isPasswordsMatch());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, VuePasswordStrengthInputComponent_Conditional_8_Template, 1, 4, "vue-validation-message", 10)(9, VuePasswordStrengthInputComponent_Conditional_9_Template, 2, 1, "div", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 12);
            i0.ɵɵtemplate(11, VuePasswordStrengthInputComponent_Conditional_11_Template, 2, 4, "vue-inline-validation-message", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 14);
            i0.ɵɵtemplate(13, VuePasswordStrengthInputComponent_Conditional_13_Template, 2, 4, "vue-inline-validation-message", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 8)(15, "vue-control-group", 16)(16, "input", 17, 2);
            i0.ɵɵtwoWayListener("ngModelChange", function VuePasswordStrengthInputComponent_Template_input_ngModelChange_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.confirmPassword, $event) || (ctx.confirmPassword = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("paste", function VuePasswordStrengthInputComponent_Template_input_paste_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.noPaste($event));
            })("ngModelChange", function VuePasswordStrengthInputComponent_Template_input_ngModelChange_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.isPasswordsMatch());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(19, VuePasswordStrengthInputComponent_Conditional_19_Template, 1, 4, "vue-validation-message", 10)(20, VuePasswordStrengthInputComponent_Conditional_20_Template, 3, 2, "div", 11);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const newPasswordField_r5 = i0.ɵɵreference(7);
            const confirmPasswordField_r6 = i0.ɵɵreference(18);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.hasOldPassword ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c3, ctx.passwordContainsUsername));
            i0.ɵɵadvance();
            i0.ɵɵproperty("control", newPasswordField_r5)("excludeValidationMessage", true)("formError", ctx.formError)("widthClass", ctx.inputWidthClass)("i18nBundle", ctx.i18nBundle)("label", ctx.newPasswordLabel);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.passwordInput.newPassword);
            i0.ɵɵproperty("vueMaxLength", ctx.maxPasswordLength);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.passwordContainsUsername || !ctx.showCustomNewPassMsg ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.passwordContainsUsername || ctx.showCustomNewPassMsg ? 9 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.validationRequiredRules && ctx.validationRequiredRules.rules.length > 0 ? 11 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.validationOptionalRules && ctx.validationOptionalRules.rules.length > 0 ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c3, !ctx.passwordsMatch && ctx.showCustomConfirmPassMsg));
            i0.ɵɵadvance();
            i0.ɵɵproperty("control", confirmPasswordField_r6)("excludeValidationMessage", true)("widthClass", ctx.inputWidthClass)("formError", ctx.formError)("i18nBundle", ctx.i18nBundle)("label", ctx.confirmPasswordLabel);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.confirmPassword);
            i0.ɵɵproperty("vueMaxLength", ctx.maxPasswordLength);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.showGenericConfirmPasswordMessage() ? 19 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showCustomConfirmPassMsg ? 20 : -1);
          }
        },
        dependencies: [i2.NgClass, i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.PatternValidator, i6.NgModel, i6.NgForm, i1$2.FaIconComponent, VueControlGroupComponent, VueMaxLengthDirective, VueValidationMessageComponent, VueInlineValidationMessageComponent, AutofocusDirective],
        styles: [".pad-top[_ngcontent-%COMP%]{padding-top:.5em}.pad-bot[_ngcontent-%COMP%]{padding-bottom:.5em}  fa-icon{margin-right:.325em}"]
      });
    }
  }
  return VuePasswordStrengthInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive defines the behaviour of the drag item to be used
 * along with VueA11yDropListDirective.
 *
 * Usage:
 ```
 <div cdkDropList (cdkDropListDropped)="drop($event)" appVueA11yDropList
 aria-describedby="instructions" [itemsData]="itemsData">
 <div *ngFor="let item of itemsData; let i = index" cdkDrag>
 <div class="panel panel-default move-cursor" appVueA11yDrag [itemData]="item">
 <div class="panel-body">
 <b>{{ i + 1 }}. {{ item.label }}</b>
 </div>
 </div>
 </div>
 <span id="instructions" class="cdk-visually-hidden">
 {{instructions}}
 </span>
 </div>
 ```
 */
let VueA11yDragDirective = /*#__PURE__*/(() => {
  class VueA11yDragDirective {
    constructor(host) {
      this.host = host;
      this.dragItemFocused = new EventEmitter();
    }
    /**
     * Sets focus on the item
     */
    onFocus() {
      this.dragItemFocused.emit(this.itemData);
    }
    /**
     * Sets focus on the item
     */
    focus() {
      this.host.nativeElement.focus();
    }
    static {
      this.ɵfac = function VueA11yDragDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueA11yDragDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueA11yDragDirective,
        selectors: [["", "appVueA11yDrag", ""], ["vue-a11y-drag"]],
        hostAttrs: ["role", "option", "tabindex", "0", 1, "vue-a11y-drag"],
        hostBindings: function VueA11yDragDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function VueA11yDragDirective_focus_HostBindingHandler() {
              return ctx.onFocus();
            });
          }
        },
        inputs: {
          itemData: "itemData"
        },
        outputs: {
          dragItemFocused: "dragItemFocused"
        },
        standalone: false
      });
    }
  }
  return VueA11yDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive performs drag drop operations using keyboard events.
 * Press Space to enter into drag mode
 * Use Down/Up arrow keys to select an item
 * Press Space to drop item in new position
 * Press Escape to cancel a grab action without dropping
 * Usage:
 ```
 <div cdkDropList (cdkDropListDropped)="drop($event)" appVueA11yDropList
 aria-describedby="instructions" [itemsData]="itemsData">
 <div *ngFor="let item of itemsData; let i = index" cdkDrag>
 <div class="panel panel-default move-cursor" appVueA11yDrag [itemData]="item">
 <div class="panel-body">
 <b>{{ i + 1 }}. {{ item.label }}</b>
 </div>
 </div>
 </div>
 <span id="instructions" class="cdk-visually-hidden">
 {{instructions}}
 </span>
 </div>
 ```
 */
let VueA11yDropListDirective = /*#__PURE__*/(() => {
  class VueA11yDropListDirective {
    constructor(el, liveAnnouncer) {
      this.el = el;
      this.liveAnnouncer = liveAnnouncer;
      this.dropped = new EventEmitter();
    }
    /**
     * When arrow keys are pressed, move focus between dragItems
     *
     * @param event the KeyboardEvent
     */
    onArrowKeyDown(event) {
      if (this.keyboardEventsManager) {
        this.keyboardEventsManager.onKeydown(event);
        this.keyboardEventsManager.activeItem.focus();
        if (this.isDragMode) {
          const currentIndex = this.keyboardEventsManager.activeItemIndex;
          this.moveItem(this.previousIndex, currentIndex, currentIndex);
          this.previousIndex = currentIndex;
        }
      }
    }
    /**
     * When tab key is pressed, cancel drag operation
     * since the focus moves away from the dragged item
     */
    onTab() {
      this.cancelDrag();
    }
    /**
     * When escape key is pressed, cancel drag operation
     */
    onSpaceDown() {
      this.cancelDrag();
    }
    /**
     * When space key is pressed, start drag mode if isDragMode is false
     * If aleardy in drag mode, drop the dragged item at the current index
     */
    onSpaceKeyDown() {
      if (this.keyboardEventsManager) {
        if (this.isDragMode) {
          const currentIndex = this.keyboardEventsManager.activeItemIndex;
          this.updateAssistiveText(this.itemsData[currentIndex].label + ' dropped at position ' + (currentIndex + 1));
        } else {
          this.dragBeginIndex = this.keyboardEventsManager.activeItemIndex;
          this.previousIndex = this.dragBeginIndex;
          this.updateAssistiveText(this.itemsData[this.dragBeginIndex].label + ' grabbed. Press Spacebar to drop, Escape key to cancel.');
        }
        this.isDragMode = !this.isDragMode;
      }
    }
    ngAfterViewInit() {
      this.keyboardEventsManager = new FocusKeyManager(this.dragItems).withWrap();
      this.dragItems.forEach(dragItem => dragItem.dragItemFocused.subscribe(item => {
        this.updateActiveItemIndex(item);
      }));
    }
    ngOnDestroy() {
      this.dragItems.forEach(dragItem => dragItem.dragItemFocused.unsubscribe());
    }
    /**
     * Sets focus on the active item
     *
     * @param index Index of the item to be set as active.
     */
    setActiveDragItem(index) {
      this.keyboardEventsManager.updateActiveItem(index);
      this.keyboardEventsManager.activeItem.focus();
      this.liveAnnouncer.announce('focused on ' + index);
    }
    /**
     * Moves item during drag operation
     *
     * @param previousIndex Index of the item to moved.
     * @param currentIndex Index the item is to be moved to.
     * @param focusIndex Index to set focus on.
     **/
    moveItem(previousIndex, currentIndex, focusIndex) {
      this.dropped.emit({
        container: null,
        currentIndex: currentIndex,
        distance: {
          x: 0,
          y: 0
        },
        dropPoint: {
          x: 0,
          y: 0
        },
        event: new MouseEvent('', {}),
        isPointerOverContainer: false,
        item: null,
        previousContainer: null,
        previousIndex: previousIndex
      });
      setTimeout(() => this.setActiveDragItem(focusIndex), 5);
    }
    /**
     * Cancels drag operation and returns the dragged item to its original position
     **/
    cancelDrag() {
      if (this.keyboardEventsManager && this.isDragMode) {
        const currentIndex = this.keyboardEventsManager.activeItemIndex;
        this.moveItem(currentIndex, this.dragBeginIndex, currentIndex);
        this.updateAssistiveText('Drag cancelled');
        this.isDragMode = false;
      }
    }
    /**
     * When this user changes the focus index by mouse click or tab key,
     * updates keyboardEventsManager.activeItemIndex
     *
     * @param item Item that has focus
     **/
    updateActiveItemIndex(item) {
      if (this.keyboardEventsManager) {
        const index = this.itemsData.indexOf(item);
        const keyboardEventsManagerIndex = this.keyboardEventsManager.activeItemIndex;
        if (keyboardEventsManagerIndex !== index) {
          this.keyboardEventsManager.updateActiveItem(index);
        }
      }
    }
    /**
     * Sets assistive text that will be read by screen readers
     *
     * @param text Text to be read
     */
    updateAssistiveText(text) {
      this.liveAnnouncer.announce(text);
    }
    static {
      this.ɵfac = function VueA11yDropListDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueA11yDropListDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$4.LiveAnnouncer));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueA11yDropListDirective,
        selectors: [["", "appVueA11yDropList", ""], ["vue-a11y-drop-list"]],
        contentQueries: function VueA11yDropListDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, VueA11yDragDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragItems = _t);
          }
        },
        hostAttrs: ["role", "listbox", 1, "vue-a11y-drop-list"],
        hostBindings: function VueA11yDropListDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.arrowup", function VueA11yDropListDirective_keydown_arrowup_HostBindingHandler($event) {
              return ctx.onArrowKeyDown($event);
            })("keydown.arrowdown", function VueA11yDropListDirective_keydown_arrowdown_HostBindingHandler($event) {
              return ctx.onArrowKeyDown($event);
            })("keydown.tab", function VueA11yDropListDirective_keydown_tab_HostBindingHandler() {
              return ctx.onTab();
            })("keydown.escape", function VueA11yDropListDirective_keydown_escape_HostBindingHandler() {
              return ctx.onSpaceDown();
            })("keydown.space", function VueA11yDropListDirective_keydown_space_HostBindingHandler() {
              return ctx.onSpaceKeyDown();
            });
          }
        },
        inputs: {
          itemsData: "itemsData"
        },
        outputs: {
          dropped: "cdkDropListDropped"
        },
        standalone: false
      });
    }
  }
  return VueA11yDropListDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is used to create a list of VUE Panels that can be dragged and dropped to any order. Insert the
 * below snippet into your application's or component's *.html
 *
 * <vue-drag-drop [itemsData]="panelList" (dropped)="onDrop()"></vue-drag-drop>
 *
 * Here the 'panelList' is an array of objects which must contain a 'label' property that will be used in the panel
 * display. Additional properties can be added if necessary.
 *
 * eg:
 * public readonly panelList = [
 *    {id: '1', label: 'Step 1 - Ready'},
 *    {id: '2', label: 'Step 2 - Get'},
 *    {id: '3', label: 'Step 3 - Set'},
 *    {id: '4', label: 'Step 4 - Go'}
 * ];
 *
 * A serial number will be prefixed to each panel name to indicate the order.
 */
let VueDragDropComponent = /*#__PURE__*/(() => {
  class VueDragDropComponent {
    constructor() {
      /**
       * Emits mutated itemsData when something is dropped
       */
      this.dropped = new EventEmitter();
      this.faArrowsAltV = faArrowsAltV;
      /**
       * Instructions to be read by screen reader on using keyboard for drag and drop
       */
      this.instructions = 'Use arrow keys to select an item. Press Space to enter into drag mode.';
    }
    /**
     * This is the event handler method that is used to reorder the list when a cdkDropListDropped event is triggered
     * @param event
     *    Details about the item moved
     */
    drop(event) {
      moveItemInArray(this.itemsData, event.previousIndex, event.currentIndex);
      if (event.previousIndex !== event.currentIndex) {
        this.dropped.emit();
      }
    }
    static {
      this.ɵfac = function VueDragDropComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueDragDropComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueDragDropComponent,
        selectors: [["vue-drag-drop"]],
        inputs: {
          itemsData: "itemsData"
        },
        outputs: {
          dropped: "dropped"
        },
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [["cdkDropList", "", "appVueA11yDropList", "", "aria-describedby", "instructions", 3, "cdkDropListDropped", "itemsData"], ["cdkDrag", ""], ["id", "instructions", 1, "cdk-visually-hidden"], ["appVueA11yDrag", "", 1, "panel", "panel-default", "move-cursor", 3, "itemData"], [1, "panel-body"], [3, "icon"]],
        template: function VueDragDropComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("cdkDropListDropped", function VueDragDropComponent_Template_div_cdkDropListDropped_0_listener($event) {
              return ctx.drop($event);
            });
            i0.ɵɵrepeaterCreate(1, VueDragDropComponent_For_2_Template, 6, 4, "div", 1, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("itemsData", ctx.itemsData);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.itemsData);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.instructions, " ");
          }
        },
        dependencies: [i1$5.CdkDropList, i1$5.CdkDrag, i1$2.FaIconComponent, VueA11yDropListDirective, VueA11yDragDirective],
        styles: [".move-cursor[_ngcontent-%COMP%]{cursor:move}fa-icon[_ngcontent-%COMP%]{margin-right:.5rem}.panel-body[_ngcontent-%COMP%]{display:flex;align-items:center}.cdk-drag-preview[_ngcontent-%COMP%]{-moz-box-shadow:5px 5px 10px 1px rgba(0,0,0,.2);-webkit-box-shadow:5px 5px 10px 1px rgba(0,0,0,.2);box-shadow:5px 5px 10px 1px #0003}"]
      });
    }
  }
  return VueDragDropComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable */
/**
 * This component is used to create a list of VUE Panels that can be considered as a group of items (multipart) with
 * similar properties.
 *
 * Below is a sample code snippet
 *
 * <vue-multipart
 *  [itemsData]="watchlist"
 *  [headerLabel] = "'TV series watchlist'"
 *  [defaultCounterLabel] = "'This is the default title given by the application'"
 *  [addLabel] = "addButtonLabel"
 *  [sortable] = "isSortable"
 *  [deleteConfirmationLabel]="'Are you sure you want to delete?'"
 *  [confirmLabel]="'Yes'"
 *  [cancelLabel]="'No'"
 *  (multiPartChange)="multipartChange()"
 *  (added)="add()"
 *  (copied)="copy($event)"
 *  (remove)="remove($event)">
 *
 *  <ng-template let-item>
 *    <vue-control-group [control]="seriesName" [formError]="formError" label="Series Name" i18nBundle="sample">
 *      <input #inputElement
 *      [name]="'seriesName' + item.itemDetail.id"
 *      class="form-control"
 *      [(ngModel)]="item.itemDetail.name"
 *      required #seriesName="ngModel">
 *    </vue-control-group>
 *
 *    <vue-control-group [control]="favoriteCharacter" [formError]="formError" label="Favourite Character"
 *      i18nBundle="sample">
 *      <input #inputElement
 *      [name]="'favoriteCharacter' + item.itemDetail.id"
 *      class="form-control"
 *      [(ngModel)]="item.itemDetail.character"
 *      required #favoriteCharacter="ngModel">
 *    </vue-control-group>
 *  </ng-template>
 * </vue-multipart>
 *
 * The 'watchlist' object in the above example is an array of VueMultipartElement
 * Eg:
 * watchlist = [
 * {
 *  collapsed: false,
 *  counterLabel: 'One of the favorites',
 *  itemDetail: { character: 'Gary Mendez', id: 11, name: 'A Million Little Things' }
 * },
 * {
 *  collapsed: false,
 *  counterLabel: 'All time favorite',
 *  itemDetail: { character: 'Sheldon Cooper', id: 12, name: 'The Big Bang Theory' }
 * }
 * ];
 *
 *
 * Translations
 *
 * PortalBase has all the translations to utilize this out of the box w/o customization.
 * By omitting the i18nBundle input, this will use PortalBase translations for
 *
 * - Add
 * - Remove
 * - Expand
 * - Collapse
 * - Yes (confirm)
 * - No (cancel)
 * - copy
 * - Move item up
 * - Move item down
 *
 *
 */
let VueMultipartComponent = /*#__PURE__*/(() => {
  class VueMultipartComponent {
    constructor(vueTranslationService) {
      /**
       * I18N key of the label used by the add button
       */
      this.addLabelKey = 'button.Add';
      /**
       * i18n key of the label used by the delete confirmation's 'True' option
       */
      this.confirmLabelKey = 'label.Yes';
      /**
       * i18n key of the label used by the delete confirmation's 'False' option
       */
      this.cancelLabelKey = 'label.No';
      /**
       * This is to enable the action button on the multipart items
       */
      this.enableActionButton = false;
      /**
       * enable the copy button on the individual items
       */
      this.enableCopyButton = false;
      /**
       * enable multipart numbering
       */
      this.enableMultipartNumbering = false;
      /**
       * enable the remove button on the individual items
       */
      this.enableRemoveButton = false;
      /**
       * i18n key of the label used by the remove button
       */
      this.removeLabelKey = 'button.Remove';
      /**
      * i18n key of the label used by the copy button
      */
      this.copyLabelKey = 'button.copy';
      /**
      * i18n key of the label used by the collapse button
      */
      this.collapseLabelKey = 'button.collapse';
      /**
      * i18n key of the label used by the expand button
      */
      this.expandLabelKey = 'button.expand';
      /**
      * i18n key of the label used by the move down button
      */
      this.moveDownLabelKey = 'button.moveItemDown';
      /**
      * i18n key of the label used by the move up button
      */
      this.moveUpLabelKey = 'button.moveItemUp';
      /**
       * Name of the i18n Bundle to be used for translation
       */
      this.i18nBundle = 'PortalBase';
      /**
       * Unique number that can be used to identify this instance of the component. This is used to keep the HTML
       * component IDs unique.
       */
      this.identifier = 0;
      /**
       * This is used to show/hide the add button which enables the user to add more items to the multipart
       */
      this.showAddButton = true;
      /**
       * This property can be used to add the sorting/re-arranging buttons to the panel actions
       */
      this.sortable = false;
      /**
       * Event emitted every time the actionButton is clicked on an item.
       */
      this.actionButtonClicked = new EventEmitter();
      /**
       * Event emitted every time there is a change in the existing list of items
       */
      this.multiPartChange = new EventEmitter();
      /**
       * If the component should use text instead of icon for copy button
       */
      this.useCopyText = false;
      /**
       * If the component should use text instead of icon for delete button
       */
      this.useRemoveText = false;
      /**
       * Output Action for copy button. `<vue-multipart (copied)="doCopy($event: index)"` If this is present,
       * the component will let the parent container perform the copy action.
       */
      this.copyAction = new EventEmitter();
      /**
       * Output Action for add button. `<vue-multipart (added)="doAdd($event: index)"` If this is present,
       * the component will let the parent container perform the add action.
       */
      this.addAction = new EventEmitter();
      /**
       * Event emitted every time an item is removed from the multipart
       */
      this.multiPartRemove = new EventEmitter();
      this.vueTranslationService = vueTranslationService;
    }
    /**
     * Returns the label for the action button
     *
     * @returns string value of the label.
     */
    getActionButtonTranslation() {
      if (this.actionButtonLabel) {
        return this.actionButtonLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.actionButtonLabelKey);
    }
    /**
     * Returns the label for the title of this component
     *
     * @returns string value of the label.
     */
    getLabelTranslation() {
      if (this.headerLabel) {
        return this.headerLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.headerLabelKey);
    }
    /**
     * Returns the label for collapse action of this component
     *
     * @returns string value of the label.
     */
    getCollapseLabelTranslation() {
      if (this.collapseLabel) {
        return this.collapseLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.collapseLabelKey);
    }
    /**
     * Returns the label for expand action of this component
     *
     * @returns string value of the label.
     */
    getExpandLabelTranslation() {
      if (this.expandLabel) {
        return this.expandLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.expandLabelKey);
    }
    /**
     * Returns the aria label for the collapse button
     *
     * @param {boolean} collapsed if the item is collapsed
     * @returns string value of aria-label
     */
    getCollapseAriaLabelTranslation(collapsed) {
      return collapsed ? this.getExpandLabelTranslation() : this.getCollapseLabelTranslation();
    }
    /**
     * Returns the label for move down action of this component
     *
     * @returns string value of the label.
     */
    getMoveDownLabelTranslation() {
      if (this.moveDownLabel) {
        return this.moveDownLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.moveDownLabelKey);
    }
    /**
     * Returns the label for move up action of this component
     *
     * @returns string value of the label.
     */
    getMoveUpLabelTranslation() {
      if (this.moveUpLabel) {
        return this.moveUpLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.moveUpLabelKey);
    }
    /**
     * Returns the aria label for the move buttons
     *
     * @param {'up' | 'down'} direction the move direction
     * @returns the translation for move
     */
    getMoveAriaLabelTranslation(direction) {
      return direction === 'up' ? this.getMoveUpLabelTranslation() : this.getMoveDownLabelTranslation();
    }
    /**
     * Returns the aria label for the copy buttons
     *
     * @returns the translation for copy
     */
    getCopyAriaLabelTranslation() {
      if (this.copyLabel) {
        return this.copyLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.copyLabelKey);
    }
    /**
     * Returns the aria label for the remove buttons
     *
     * @returns the translation for remove
     */
    getRemoveAriaLabelTranslation() {
      if (this.removeLabel) {
        return this.removeLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.removeLabelKey);
    }
    /**
     * Returns the label for the element at the given index
     *
     * @param i Index of the element in itemsData list
     * @returns string value of the label.
     */
    getCounterLabelTranslation(i) {
      if (this.itemsData[i].counterLabel) {
        return this.itemsData[i].counterLabel;
      }
      if (this.itemsData[i].counterLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.itemsData[i].counterLabelKey);
      }
      if (this.defaultCounterLabel) {
        return this.defaultCounterLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.defaultCounterLabelKey);
    }
    /**
     * Returns the label of the cancel button
     *
     * @returns string value of the label.
     */
    getCancelLabelTranslation() {
      if (this.cancelLabel) {
        return this.cancelLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.cancelLabelKey);
    }
    /**
     * Returns the confirmation label
     *
     * @returns string value of the label.
     */
    getConfirmationLabelTranslation() {
      if (this.confirmLabel) {
        return this.confirmLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.confirmLabelKey);
    }
    /**
     * Returns the delete confirmation label
     *
     * @returns string value of the label.
     */
    getDeleteConfirmationLabelTranslation() {
      if (this.deleteConfirmationLabel) {
        return this.deleteConfirmationLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.deleteConfirmationLabelKey);
    }
    /**
     * Returns the add button's label
     *
     * @returns string value of the label.
     */
    getAddButtonTranslation() {
      if (this.addLabel) {
        return this.addLabel;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.addLabelKey);
    }
    /**
     * Check if the header label is available
     *
     * @returns True if either the header label or its key is available.
     */
    headerLabelAvailable() {
      if (this.headerLabel || this.headerLabelKey) {
        return true;
      }
      return false;
    }
    /**
     * Inserts a new item into the itemsData array
     * or send add event depending on if addAction
     * is present.
     */
    add() {
      if (this.addAction.observers.length) {
        this.addAction.emit();
        return;
      }
      this.itemsData.push({
        collapsed: false,
        itemDetail: {}
      });
    }
    /**
     * Duplicates the item at the given index and
     * inserts the new item below the current one or sends
     * copy event instead if copy action is present.
     *
     * @param index
     *    Index of the item to be copied
     */
    copy(index) {
      if (this.copyAction.observers.length) {
        this.copyAction.emit(index);
        return;
      }
      const temp = Object.assign({}, this.itemsData[index]);
      this.itemsData.splice(index, 0, temp);
      this.emitChange();
    }
    /**
     * Removes the item at the given index
     * @param index
     *    Index of the item to be removed
     */
    remove(index) {
      this.multiPartRemove.emit(this.itemsData[index]);
      this.itemsData.splice(index, 1);
      this.emitChange();
    }
    /**
     * Moves the item at the given index one spot down to index + 1
     * @param index
     *    Index of the item to be moved
     */
    down(index) {
      // do nothing if only 1 entry
      if (this.itemsData.length <= 1) {
        return;
      }
      const temp = this.itemsData[index + 1];
      this.itemsData[index + 1] = this.itemsData[index];
      this.itemsData[index] = temp;
      this.emitChange();
    }
    /**
     * Moves the item at the given index one spot up to index - 1
     * @param index
     *    Index of the item to be moved
     */
    up(index) {
      // do nothing if only 1 entry
      if (this.itemsData.length <= 1) {
        return;
      }
      const temp = this.itemsData[index - 1];
      this.itemsData[index - 1] = this.itemsData[index];
      this.itemsData[index] = temp;
      this.emitChange();
    }
    /**
     * Emits the actionButtonClicked event when the action button at the given index is clicked
     * @param i
     *    Index of the item whose action button is clicked
     */
    emitActionButtonEvent(i) {
      this.actionButtonClicked.emit(i);
    }
    /**
     * Emits the multiPartChange event when there is a change in the multipart
     */
    emitChange() {
      // a multipart is special and really only the user knows if 0 or more parts are valid.
      // for now just emit an event when the multipart is added, removed, or moved...
      this.multiPartChange.emit();
    }
    static {
      this.ɵfac = function VueMultipartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMultipartComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueMultipartComponent,
        selectors: [["vue-multipart"]],
        contentQueries: function VueMultipartComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
          }
        },
        inputs: {
          actionButtonLabel: "actionButtonLabel",
          actionButtonLabelKey: "actionButtonLabelKey",
          addLabel: "addLabel",
          addLabelKey: "addLabelKey",
          confirmLabel: "confirmLabel",
          confirmLabelKey: "confirmLabelKey",
          cancelLabel: "cancelLabel",
          cancelLabelKey: "cancelLabelKey",
          defaultCounterLabel: "defaultCounterLabel",
          defaultCounterLabelKey: "defaultCounterLabelKey",
          deleteConfirmationLabel: "deleteConfirmationLabel",
          deleteConfirmationLabelKey: "deleteConfirmationLabelKey",
          enableActionButton: "enableActionButton",
          enableCopyButton: "enableCopyButton",
          enableMultipartNumbering: "enableMultipartNumbering",
          enableRemoveButton: "enableRemoveButton",
          removeLabel: "removeLabel",
          removeLabelKey: "removeLabelKey",
          copyLabel: "copyLabel",
          copyLabelKey: "copyLabelKey",
          collapseLabel: "collapseLabel",
          collapseLabelKey: "collapseLabelKey",
          expandLabel: "expandLabel",
          expandLabelKey: "expandLabelKey",
          moveDownLabel: "moveDownLabel",
          moveDownLabelKey: "moveDownLabelKey",
          moveUpLabel: "moveUpLabel",
          moveUpLabelKey: "moveUpLabelKey",
          headerLabel: "headerLabel",
          headerLabelKey: "headerLabelKey",
          i18nBundle: "i18nBundle",
          identifier: "identifier",
          itemsData: "itemsData",
          showAddButton: "showAddButton",
          sortable: "sortable",
          useCopyText: "useCopyText",
          useRemoveText: "useRemoveText"
        },
        outputs: {
          actionButtonClicked: "actionButtonClicked",
          multiPartChange: "multiPartChange",
          copyAction: "copied",
          addAction: "added",
          multiPartRemove: "multiPartRemove"
        },
        standalone: false,
        decls: 4,
        vars: 2,
        consts: [[1, "form-group", 3, "id"], ["type", "button", 1, "btn", "btn-xs", "btn-default", "trigger", 3, "id"], [1, "control-label"], [1, "panel", "panel-default"], [1, "panel-body"], [3, "ngClass"], [1, "subpanel-collapse"], [1, "btn", "btn-xs", "btn-default", 3, "click", "title", "id", "ngClass"], ["icon", "chevron-down", 1, "fa", "fa-fw"], [1, "subpanel-header-content"], [3, "id", "ngClass"], ["icon", "exclamation-triangle", 1, "fa", "fa-fw", "panel-has-warning"], [1, "subpanel-actions"], [3, "hidden", "id"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "subpanel-action-align"], [1, "btn", "btn-default", "btn-xs", "d-inline", "action-btn", 3, "id"], [1, "btn", "btn-xs", "btn-default", 3, "id", "title"], ["ngbDropdown", "", 1, "confirm-dropdown", "d-inline", "dropdown"], [1, "btn", "btn-xs", "btn-default", 3, "click", "title", "id"], [1, "fa", "fa-fw", 3, "icon"], [1, "btn", "btn-default", "btn-xs", "d-inline", "action-btn", 3, "click", "id"], [1, "btn", "btn-xs", "btn-default", 3, "click", "id", "title"], ["ngbDropdownToggle", "", 1, "btn", "btn-xs", "btn-default", 3, "title", "id"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], [1, "dropdown-header", 3, "id"], ["role", "button", "ngbDropdownItem", "", 1, "dropdown-item", 3, "click", "id"], ["role", "button", "ngbDropdownItem", "", 1, "dropdown-item", 3, "id"], ["type", "button", 1, "btn", "btn-xs", "btn-default", "trigger", 3, "click", "id"]],
        template: function VueMultipartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VueMultipartComponent_Conditional_0_Template, 3, 2, "div", 0);
            i0.ɵɵrepeaterCreate(1, VueMultipartComponent_For_2_Template, 16, 19, "span", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵtemplate(3, VueMultipartComponent_Conditional_3_Template, 2, 3, "button", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.headerLabelAvailable() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.itemsData);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showAddButton ? 3 : -1);
          }
        },
        dependencies: [i2.NgClass, i2.NgTemplateOutlet, i1$2.FaIconComponent, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i4.NgbDropdownItem, i4.NgbDropdownButtonItem],
        styles: [".panel-has-warning[_ngcontent-%COMP%]{color:#fbaa19;padding-right:.3em}.panel-has-error[_ngcontent-%COMP%]{color:#db0020}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropdown-header[_ngcontent-%COMP%]{white-space:pre-line!important}.no-border[_ngcontent-%COMP%]{border-bottom:0;margin:-10px -15px!important}.rotate[_ngcontent-%COMP%]{transform:rotate(-180deg)}.subpanel-actions[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-top:3px;margin-left:10px}.subpanel-action-align[_ngcontent-%COMP%]{display:flex}.subpanel-collapse[_ngcontent-%COMP%]{width:29px;margin:auto}.subpanel-header[_ngcontent-%COMP%]{display:flex}.subpanel-header-content[_ngcontent-%COMP%]{width:97%;float:right;padding-right:5px}.subpanel-title[_ngcontent-%COMP%]{overflow-wrap:break-word;word-wrap:break-word;width:73%;float:left;padding-top:5px}[dir=rtl][_nghost-%COMP%]   .subpanel-title[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .subpanel-title[_ngcontent-%COMP%]{float:right}.subpanel-title[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-right:5px}.dropdown-item[_ngcontent-%COMP%]{padding:12px 15px}.dropdown-header[_ngcontent-%COMP%]{color:inherit;font-size:inherit;text-transform:none;white-space:normal}.dropdown-menu[_ngcontent-%COMP%]{border:1px solid #fbaa19;width:350px;padding-top:5px}"]
      });
    }
  }
  return VueMultipartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component dynamically hides or shows its content
 */
let VueToggleSectionComponent = /*#__PURE__*/(() => {
  class VueToggleSectionComponent {
    /**
     * This attribute determines if the section will be collapsed by default
     * There is no need to assign a value to this attribute. The getter and setter methods convert
     * undefined to a boolean value.
     * @param {boolean} [value] Optional: If you want to databind this value, use a boolean
     */
    set expanded(value) {
      this.expandedDesired = typeof value !== 'undefined' && value !== false;
    }
    get expanded() {
      return this.expandedDesired;
    }
    /**
     * This injects the translation service
     * @param vueTranslationService the translation service
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * Additional string attached to the end of all elements with id attribute
       */
      this.idSuffix = '';
      /**
       * This emits when the toggle is clicked/selected
       */
      this.onToggle = new EventEmitter();
      /**
       * This holds the open icon
       */
      this.chevronOpen = faChevronDown;
      /**
       * This holds the closed icon
       */
      this.chevronClosed = faChevronUp;
    }
    /**
     * This gets triggered whenever an input changes and emits the current state of the component
     */
    ngOnChanges() {
      this.onToggle.emit(this.expandedDesired);
    }
    /**
     * This toggles the section. It works with the private getter/setter controlling var
     */
    toggleSection() {
      this.expandedDesired = !this.expandedDesired;
      this.onToggle.emit(this.expandedDesired);
    }
    /**
     * This gets the translation for the title
     * @returns the translated title
     */
    getTitleTranslation() {
      if (this.title) {
        return this.title;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.titleKey);
    }
    static {
      this.ɵfac = function VueToggleSectionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueToggleSectionComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueToggleSectionComponent,
        selectors: [["vue-toggle-section"]],
        inputs: {
          title: "title",
          i18nBundle: "i18nBundle",
          titleKey: "titleKey",
          idSuffix: "idSuffix",
          expanded: "expanded"
        },
        outputs: {
          onToggle: "onToggle"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 6,
        consts: [[1, "holder"], ["type", "button", 1, "btn", "btn-default", "btn-xs", 3, "click"], [3, "icon"], [1, "section-title"], [1, "content", 3, "id"]],
        template: function VueToggleSectionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function VueToggleSectionComponent_Template_button_click_1_listener() {
              return ctx.toggleSection();
            });
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵelement(3, "fa-icon", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, VueToggleSectionComponent_Conditional_6_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-label", ctx.getTitleTranslation())("aria-controls", "content" + ctx.idSuffix)("aria-expanded", ctx.expanded);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("icon", ctx.expanded ? ctx.chevronClosed : ctx.chevronOpen);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.getTitleTranslation());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.expanded ? 6 : -1);
          }
        },
        dependencies: [i1$2.FaIconComponent],
        styles: [".holder[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;margin:1em 0}.holder[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:block;width:10.5px}.holder[_ngcontent-%COMP%]   .section-title[_ngcontent-%COMP%]{font-weight:700;margin:0 1rem}.holder[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{width:100%;flex-grow:1;margin-top:1rem}"]
      });
    }
  }
  return VueToggleSectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive will transform the user's input to upper case.
 *
 * Usage:
 ```
 <vue-control-group label="Field is restricted to capital letters" [control]="sampleName8"  [formError]="formError">
 <input autocomplete="off"
        class="form-control"
        name="sampleName8"
        vueCapitalize
        #inputElement
        #sampleName8="ngModel"
        [(ngModel)]="sample.uppercase">
 </vue-control-group>
 ```
 */
let VueCapitalizeDirective = /*#__PURE__*/(() => {
  class VueCapitalizeDirective {
    /**
     * Directive constructor.
     *
     * @param elementRef native view component.
     */
    constructor(elementRef) {
      this.elementRef = elementRef;
    }
    /**
     * When text is entered in the input element, capitalize it.
     *
     * @param value the new string value of the input element.
     */
    onInput(value) {
      this.elementRef.nativeElement.value = value.toUpperCase();
    }
    static {
      this.ɵfac = function VueCapitalizeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueCapitalizeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueCapitalizeDirective,
        selectors: [["", "vueCapitalize", ""]],
        hostBindings: function VueCapitalizeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function VueCapitalizeDirective_input_HostBindingHandler($event) {
              return ctx.onInput($event.target.value);
            });
          }
        },
        standalone: false
      });
    }
  }
  return VueCapitalizeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-undefined */
/**
 * This directive validates that a field only contains integers.
 *
 * Usage:
 ```
 <vue-control-group label="Field is integer only"
                    [control]="sampleName7"
                    [formError]="formError">
   <input autocomplete="off"
         class="form-control"
         name="sampleName7"
         vueInteger
         #inputElement
         #sampleName7="ngModel"
         [(ngModel)]="sample.maxLength">
 </vue-control-group>
 ```
 */
let VueIntegerDirective = /*#__PURE__*/(() => {
  class VueIntegerDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateInteger();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateMinInteger().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an input value is an integer.
     *
     * @returns a validator function.
     */
    vueValidateInteger() {
      return formControl => {
        const stringValue = formControl && formControl.value !== null && formControl.value !== undefined ? formControl.value : '';
        if (stringValue === '') {
          // Empty value is valid
          return null;
        }
        const regex = new RegExp(/^[-+]?\d+$/gm);
        const isValid = regex.test(stringValue);
        return isValid ? null : {
          vueValidateInteger: {
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueIntegerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueIntegerDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueIntegerDirective,
        selectors: [["", "vueInteger", "", "ngModel", ""]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueIntegerDirective
        }])]
      });
    }
  }
  return VueIntegerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive should be placed as shown below. It subscribes to a menu state on the navigation service.
 * The purpose is to add a class that will make apps appear in a shorter width area while menu is open.
 *
 * Usage:
 ```
 <vue-login-header></vue-login-header>
 <vue-navigation></vue-navigation>
 <vue-cookie-policy></vue-cookie-policy>
 <div id="main-content" vueMainContent>
   <vue-loading-indicator></vue-loading-indicator>
   <div class="app-wrapper">
     <div class="app-container">
       <router-outlet></router-outlet>
     </div>
   </div>
 </div>
 <vue-footer></vue-footer>
 ```
 */
// https://github.com/angular/angular/issues/20351#issuecomment-344009887
/** @dynamic */
let VueMainContentDirective = /*#__PURE__*/(() => {
  class VueMainContentDirective {
    /**
     * Directive constructor.
     *
     * @param elementRef native view component.
     * @param vueNavigationService service controlling navigation.
     * @param document: Window document
     */
    constructor(vueNavigationService, vueLocaleService, document) {
      this.vueNavigationService = vueNavigationService;
      this.vueLocaleService = vueLocaleService;
      this.document = document;
      /**
       * applies menu opened / closed class to host
       */
      this.menuOpened = false;
    }
    /**
     * On component initialization, subscribe to the navigation menu state.
     */
    ngOnInit() {
      this.vueNavigationService.getMenuState().subscribe(state => {
        this.menuOpened = state === 'menu-open';
      });
      this.vueLocaleService.localeObs.subscribe(() => {
        const lang = this.vueLocaleService.findLanguageFromLocale();
        // hard coded dir until we implement atlas service
        const dir = lang === 'ar' ? 'rtl' : 'ltr';
        this.document.documentElement.lang = lang;
        this.document.documentElement.dir = dir;
      });
    }
    static {
      this.ɵfac = function VueMainContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMainContentDirective)(i0.ɵɵdirectiveInject(VueNavigationService), i0.ɵɵdirectiveInject(VueLocaleService), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueMainContentDirective,
        selectors: [["", "vueMainContent", ""]],
        hostVars: 2,
        hostBindings: function VueMainContentDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("menu-open", ctx.menuOpened);
          }
        },
        standalone: false
      });
    }
  }
  return VueMainContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-undefined */
/**
 * This directive validates that a field contains an integer less than or equal to parameter.<br/>
 * **Note**: Needs to be combined with the `vueInteger` directive.
 *
 * Usage:
 ```
 <vue-control-group label="Field is integer only with maximum of 20"
                    [control]="sampleName9"
                    [formError]="formError">
   <input autocomplete="off"
          class="form-control"
          name="sampleName9"
          required
          vueInteger
          vueMaxInteger="20"
          #inputElement
          #sampleName9="ngModel"
          [(ngModel)]="sample.integerMinMax">
 </vue-control-group>
 ```
 */
let VueMaxIntegerDirective = /*#__PURE__*/(() => {
  class VueMaxIntegerDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateMaxInteger();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateMaxInteger().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an integer input value is higher than a given maximum value.
     *
     * @returns a validator function.
     */
    vueValidateMaxInteger() {
      return formControl => {
        // The form value will be a string
        const stringValue = formControl && formControl.value !== null && formControl.value !== undefined ? formControl.value : '';
        if (stringValue === '') {
          // Empty value is valid
          return null;
        }
        // Attempt to coerce stringValue to a number - assign null if it fails
        const numberValue = isNaN(parseInt(stringValue, 10)) ? null : parseInt(stringValue, 10);
        if (numberValue === null) {
          // We return null here as the expectation that vueInteger is used in combination, which will
          // catch values that cannot be parsed into numbers.
          return null;
        }
        const isValid = numberValue <= this.vueMaxInteger;
        return isValid ? null : {
          vueValidateMaxInteger: {
            maxInteger: this.vueMaxInteger,
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueMaxIntegerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMaxIntegerDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueMaxIntegerDirective,
        selectors: [["", "vueMaxInteger", "", "ngModel", ""]],
        inputs: {
          vueMaxInteger: "vueMaxInteger"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueMaxIntegerDirective
        }])]
      });
    }
  }
  return VueMaxIntegerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-undefined */
/**
 * This directive validates that a field contains an integer greater than or equal to parameter.<br/>
 * **Note**: Needs to be combined with the `vueInteger` directive.
 *
 * Usage:
 ```
 <vue-control-group label="Field is integer only with min of 3"
                    [control]="sampleName9"
                    [formError]="formError">
   <input #inputElement autocomplete="off"
                        class="form-control"
                        name="sampleName9"
                        required
                        vueInteger
                        vueMinInteger="3"
                        #sampleName9="ngModel"
                        [(ngModel)]="sample.integerMinMax">
 </vue-control-group>
 ```
 */
let VueMinIntegerDirective = /*#__PURE__*/(() => {
  class VueMinIntegerDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateMinInteger();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateMinInteger().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an integer input value is higher than a given minimum value.
     *
     * @returns a validator function.
     */
    vueValidateMinInteger() {
      return formControl => {
        // The form value will be a string
        const stringValue = formControl && formControl.value !== null && formControl.value !== undefined ? formControl.value : '';
        if (stringValue === '') {
          // Empty value is valid
          return null;
        }
        // Attempt to coerce stringValue to a number - assign null if it fails
        const numberValue = isNaN(parseInt(stringValue, 10)) ? null : parseInt(stringValue, 10);
        if (numberValue === null) {
          // We return null here as the expectation that vueInteger is used in combination, which will
          // catch values that cannot be parsed into numbers.
          return null;
        }
        const isValid = numberValue >= this.vueMinInteger;
        return isValid ? null : {
          vueValidateMinInteger: {
            minInteger: this.vueMinInteger,
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueMinIntegerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueMinIntegerDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueMinIntegerDirective,
        selectors: [["", "vueMinInteger", "", "ngModel", ""]],
        inputs: {
          vueMinInteger: "vueMinInteger"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueMinIntegerDirective
        }])]
      });
    }
  }
  return VueMinIntegerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive validates that a field only contains alpha numeric characters.
 *
 * Usage:
 ```
 <vue-control-group label="Field is integer only" [control]="sampleName7" [formError]="formError">
   <input autocomplete="off"
          class="form-control"
          name="sampleName7"
          vueAlphaNumeric
          #inputElement
          #sampleName7="ngModel"
          [(ngModel)]="sample.alphaNumericOnly">
 </vue-control-group>
 ```
 */
let VueAlphaNumericDirective = /*#__PURE__*/(() => {
  class VueAlphaNumericDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateAlphaNumeric();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateAlphaNumeric().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an input value is alphanumeric.
     *
     * @returns a validator function.
     */
    vueValidateAlphaNumeric() {
      return formControl => {
        const stringValue = formControl && formControl.value ? formControl.value : '';
        const regex = new RegExp(/^[a-zA-Z0-9]*$/gm);
        const isValid = regex.test(stringValue);
        return isValid ? null : {
          vueValidateAlphaNumeric: {
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueAlphaNumericDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAlphaNumericDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueAlphaNumericDirective,
        selectors: [["", "vueAlphaNumeric", "", "ngModel", ""]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueAlphaNumericDirective
        }])]
      });
    }
  }
  return VueAlphaNumericDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive validates that a field is truthy and does not only contain white space.
 * Recomended use is on input[type=text|email] fields. Not for use where `false` is a valid
 * value.
 *
 * Usage:
 ```
 <vue-control-group label="VueRequired field"
                    [control]="sampleName12"
                    [formError]="formError">
   <input autocomplete="off"
          class="form-control"
          name="sampleName12"
          vueRequired
          #inputElement
          #sampleName12="ngModel"
          [(ngModel)]="sample.vueRequiredExample">
 </vue-control-group>
 ```
 */
let VueRequiredDirective = /*#__PURE__*/(() => {
  class VueRequiredDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueRequiredValidator();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueRequiredValidator().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an input value is truthy and not only white space.
     *
     * @returns a validator function.
     */
    vueRequiredValidator() {
      return formControl => {
        const stringValue = formControl && formControl.value ? formControl.value : '';
        const regex = new RegExp(/(\s*[^\s]+\s*)+/gm);
        const isValid = regex.test(stringValue);
        return isValid && stringValue ? null : {
          required: {
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueRequiredDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueRequiredDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueRequiredDirective,
        selectors: [["", "vueRequired", "", "ngModel", ""]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueRequiredDirective
        }])]
      });
    }
  }
  return VueRequiredDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class represents a user's credentials, which are used to log in to a portal.
 */
class VueCredentials {}

/**
 * Login status types.
 * <ul>
 *     <li>LOGIN_SUCCESS - user SSunthenticated successfully.</li>
 *     <li>LOGIN_FAILED - user unthentication failed .</li>
 * </ul>
 */
var VueLoginStatus = /*#__PURE__*/function (VueLoginStatus) {
  VueLoginStatus[VueLoginStatus["LOGIN_SUCCESS"] = 0] = "LOGIN_SUCCESS";
  VueLoginStatus[VueLoginStatus["LOGIN_FAILED"] = 1] = "LOGIN_FAILED";
  return VueLoginStatus;
}(VueLoginStatus || {});
/**
 * Utility class used with VueServerMessageComponent to appropriately format messages to be displayed on the page.
 */
class VueServerMessage {
  constructor(type, messageText, dismissible, id, clickable, renderInHtml, scrollIntoView) {
    if (typeof type === 'object') {
      this.type = type.type;
      this.messageText = type.messageText;
      this.dismissible = type.dismissible;
      this.id = type.id;
      this.clickable = type.clickable;
      this.renderInHtml = type.renderInHtml;
      this.scrollIntoView = type.scrollIntoView;
    } else {
      this.type = type;
      this.messageText = messageText;
      this.dismissible = dismissible;
      this.id = id;
      this.clickable = clickable;
      this.renderInHtml = renderInHtml;
      this.scrollIntoView = scrollIntoView;
    }
  }
}

/* eslint-disable valid-jsdoc */
/**
 * This service provides the REST access to allow a user to log into a portal.
 */
let VueAuthenticationService = /*#__PURE__*/(() => {
  class VueAuthenticationService {
    /**
     * Constructor with all necessary services being injected.
     *
     * @param router
     * @param vueAppDefaultsService
     * @param vueHttpClientFactoryService
     * @param vueLocaleService
     * @param vueNavigationService
     * @param vueTranslationService
     * @param vueUserSessionService
     * @param vueJavascriptUtilityService
     */
    constructor(router, vueAppDefaultsService, vueHttpClientFactoryService, vueLocaleService, vueNavigationService, vueTranslationService, vueUserSessionService, vueJavascriptUtilityService) {
      this.router = router;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueHttpClientFactoryService = vueHttpClientFactoryService;
      this.vueLocaleService = vueLocaleService;
      this.vueNavigationService = vueNavigationService;
      this.vueTranslationService = vueTranslationService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      /**
       * Missing translations start with this string.
       */
      this.missingTranslation = '[@@ Message ';
      /**
       * unknownServerError standard string.
       */
      this.unknownServerError = 'unknownServerError';
      this.loginURL = `${this.vueAppDefaultsService.getPortalRESTRoot()}/rest/portal/login`;
      this.requestCodeUrl = `${this.vueAppDefaultsService.getCASRESTRoot() || this.vueAppDefaultsService.getPortalRESTRoot()}/rest/twofactor/verificationCodes`;
    }
    /**
     * Gets the translated error message from an error code.<br/>
     * If bundleKey is provided, then first look in that bundle for an override message.<br/>
     * If no message is found in the override or bundleKey is not defined, then use the bundle key from the error message.
     *
     * @param errorCode error code returned from the response
     * @param bundleKeys list of bundle name override. First match will win.
     * @returns translated error message
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity */
    getErrorMessage(errorCode, bundleKeys) {
      let errorMessage = '';
      if (errorCode && errorCode !== this.unknownServerError) {
        const errorKey = errorCode.indexOf('.') >= 0 ? errorCode.slice(errorCode.indexOf('.') + 1) : errorCode;
        const errorBundle = errorCode.indexOf('.') >= 0 ? errorCode.slice(0, errorCode.indexOf('.')) : '';
        // See if a bundle overrides this message
        if (Array.isArray(bundleKeys)) {
          for (const bundle of bundleKeys) {
            // Overridden keys should specify the bundle name they are overriding as part of the key
            const key = (errorBundle ? `${errorBundle}.` : '') + errorKey;
            errorMessage = this.vueTranslationService.getTranslation(bundle, key);
            // We found an overridden message, and it was not the "key not found" error
            if (errorMessage && !errorMessage.startsWith(this.missingTranslation)) {
              break;
            } else {
              // In case "key not found" error was returned, reset it
              errorMessage = '';
            }
          }
        }
        // If not found in overridden bundles, find in default
        if (!errorMessage) {
          errorMessage = this.vueTranslationService.getTranslation(errorBundle, errorKey);
        }
      } else {
        errorMessage = this.vueTranslationService.getTranslation('CAS', 'System.UnableToConnect');
      }
      return errorMessage;
    }
    /**
     * Performs login by authenticating with CAS.
     *
     * @param userName username entered by the user
     * @param password password entered by the user
     * @param siteID optional site id
     * @param targetURL optional target URL
     */
    login(userName, password, siteID, targetURL, verificationCode) {
      const httpHeaders = new HttpHeaders().set('Accept', 'application/json').set('Accept-Language', this.vueLocaleService.getLocaleFromCookie());
      const constructedUserName = this.constructUserName(userName, siteID);
      const credentials = {
        password: password,
        targetUrl: targetURL,
        username: constructedUserName
      };
      if (verificationCode) {
        credentials.verificationCode = verificationCode;
      }
      const options = {
        headers: httpHeaders,
        withCredentials: true
      };
      return this.vueHttpClientFactoryService.getVueHttpClient().post(this.loginURL, credentials, options).pipe(tap(token => this.postLoginProcess(token)));
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity */
    requestVerificationCode(credentials) {
      const payload = {
        realm: this.vueAppDefaultsService.getLoginRealm(),
        siteId: credentials.siteId,
        username: credentials.username
      };
      const httpHeaders = new HttpHeaders().set('Accept', 'application/json').set('Accept-Language', this.vueLocaleService.getLocaleFromCookie());
      const options = {
        headers: httpHeaders
      };
      return this.vueHttpClientFactoryService.getVueHttpClient().post(this.requestCodeUrl, payload, options);
    }
    /**
     * Performs post-login process (e.g. go to default state, create token in user session, etc.)
     *
     * @param token the OAuth token created on login
     */
    postLoginProcess(token) {
      this.vueUserSessionService.create(token);
      // TODO   IdleService.startIdleTimer();
      this.vueNavigationService.authenticationChanged(true);
      this.goToDefaultStateIfNoAppState();
    }
    /**
     * Creates a username to conform to CAS username.<br/>
     * Format: `REALM/siteID/username`
     *
     * @param username username entered by the user
     * @param siteID optional siteId
     * @returns CAS formatted username
     */
    constructUserName(username, siteID) {
      const userName = [];
      if (this.vueAppDefaultsService.getLoginRealm()) {
        userName.push(this.vueAppDefaultsService.getLoginRealm());
      }
      if (this.vueAppDefaultsService.getLoginSiteIDRequired() && siteID) {
        userName.push(siteID);
      }
      userName.push(username);
      return userName.join('/');
    }
    /**
     * Redirects to default state (`pleaseSelect`).<br/>
     * TODO: Right now, always redirects to pleaseSelect.
     */
    goToDefaultStateIfNoAppState() {
      // if (!$state.current || $state.current.name === 'base.authenticate' || $state.current.name === 'base.verify') {
      //  $state.go('base.pleaseSelect');
      // }
      const defaultState = this.vueAppDefaultsService.getAuthenticatedDefaultState();
      if (!this.vueJavascriptUtilityService.isBlank(defaultState)) {
        this.router.navigate([defaultState]);
      }
    }
    static {
      this.ɵfac = function VueAuthenticationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAuthenticationService)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueHttpClientFactoryService), i0.ɵɵinject(VueLocaleService), i0.ɵɵinject(VueNavigationService), i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(VueJavascriptUtilityService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueAuthenticationService,
        factory: VueAuthenticationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueAuthenticationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This class is expected to be overridden by each portal to define routes or links for each below.

*/
let VueForgotCredentialsService = /*#__PURE__*/(() => {
  class VueForgotCredentialsService {
    forgotPassword() {
      /* eslint-disable-next-line no-alert */
      alert('This forgot password implementation should be overridden by each portal (by extending this class)');
    }
    forgotUserName() {
      /* eslint-disable-next-line no-alert */
      alert('This forgot user name implementation should be overridden by each portal (by extending this class)');
    }
    static {
      this.ɵfac = function VueForgotCredentialsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueForgotCredentialsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueForgotCredentialsService,
        factory: VueForgotCredentialsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueForgotCredentialsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component presents the forgot password and forgot username links on the login page, and hands off
 * the requests to the forgot credentials service.
 *
 * The content to the account reset or password retrieval is found inside the portals
 * xliff file which is inserted as innerHTML to the component.  The portals can take
 * care of whether they want both username and password reset or just password.
 *
 * Angular intercepts the communication with the inserted inputs by attaching listeners
 * on the IDs "#forgotPassword" / "#forgotPassword" and removing these listers once
 * the component is removed from the DOM.
 *
 * Usage:
 ```
 <div>
   <div class="btn-section form-btn-section" id="verify">
     <vue-forgot-credentials (resetPasswordClicked)="resetAccount()"></vue-forgot-credentials>
     <button class="btn btn-primary btn-right" id="primaryBtnLogin" type="submit" (click)="login()">
       Login
     </button>
   </div>
 </div>
 ```
 */
let VueForgotCredentialsComponent = /*#__PURE__*/(() => {
  class VueForgotCredentialsComponent {
    /**
     * Component constructor.
     *
     * @param domSanitizer service to disable sanitization and show HTML.
     * @param elementRef native view component.
     * @param vueAppDefaultsService service used to fetch application-wide default attributes.
     * @param vueForgotCredentialsService service responsible for handling reset username and password functionality.
     * @param vueJavascriptUtilityService service containing common utility functions.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(elementRef, vueAppDefaultsService, vueForgotCredentialsService, vueTranslationService) {
      this.elementRef = elementRef;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueForgotCredentialsService = vueForgotCredentialsService;
      this.vueTranslationService = vueTranslationService;
      /**
       * Event emitted when the reset password link is clicked.
       */
      this.resetPasswordClicked = new EventEmitter();
      /**
       * Query selector for the forgot password link.
       */
      this.forgotPasswordLinkSelector = '.forgot-password';
      /**
       * Query selector for the forgot username link.
       */
      this.forgotUsernameLinkSelector = '.forgot-username';
    }
    /**
     * On component initialization, fetch the text to display in the forgot password/username links.
     */
    ngOnInit() {
      const portalMessageBundle = this.vueAppDefaultsService.getPortalMessageBundle();
      this.displayResetAccountConfirmation = this.vueAppDefaultsService.getLoginDisplayResetAccountConfirmation();
      this.resetText = this.vueTranslationService.getTranslation(portalMessageBundle, 'link.resetAccount');
    }
    /**
     * After the view initializes, register event listeners for reset password and username links.
     *
     */
    ngAfterViewInit() {
      const forgotPassElement = this.elementRef.nativeElement.querySelector(this.forgotPasswordLinkSelector);
      if (forgotPassElement) {
        forgotPassElement.addEventListener('click', this.onForgotPasswordClick.bind(this));
        forgotPassElement.addEventListener('keypress', this.onForgotPasswordKeypress.bind(this));
        forgotPassElement.setAttribute('tabIndex', '0');
      }
      const forgotUserNameElement = this.elementRef.nativeElement.querySelector(this.forgotUsernameLinkSelector);
      if (forgotUserNameElement) {
        forgotUserNameElement.addEventListener('click', this.onForgotUsernameClick.bind(this));
        forgotUserNameElement.addEventListener('keypress', this.onForgotUsernameKeypress.bind(this));
        forgotUserNameElement.setAttribute('tabIndex', '0');
      }
    }
    isValidKeyPress(ev) {
      return ['Enter', 'Space'].indexOf(ev.code) !== -1;
    }
    onForgotPasswordKeypress(ev) {
      if (this.isValidKeyPress(ev)) {
        this.onForgotPasswordClick(ev);
      }
    }
    onForgotUsernameKeypress(ev) {
      if (this.isValidKeyPress(ev)) {
        this.onForgotUsernameClick(ev);
      }
    }
    /**
     * Method called when the forgot password link is clicked.
     *
     * @param event the click event.
     */
    onForgotPasswordClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (!this.displayResetAccountConfirmation) {
        this.vueForgotCredentialsService.forgotPassword();
      } else {
        this.resetPasswordClicked.emit();
      }
    }
    /**
     * Method called when the forgot username link is clicked.
     *
     * @param event the click event.
     */
    onForgotUsernameClick(event) {
      event.stopPropagation();
      event.preventDefault();
      this.vueForgotCredentialsService.forgotUserName();
    }
    static {
      this.ɵfac = function VueForgotCredentialsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueForgotCredentialsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueForgotCredentialsService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueForgotCredentialsComponent,
        selectors: [["vue-forgot-credentials"]],
        outputs: {
          resetPasswordClicked: "resetPasswordClicked"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[3, "innerHTML"]],
        template: function VueForgotCredentialsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("innerHTML", ctx.resetText, i0.ɵɵsanitizeHtml);
          }
        },
        styles: ["[_nghost-%COMP%]     #forgotUsername, [_nghost-%COMP%]     #forgotPassword{color:#007fa3;text-decoration:underline}"]
      });
    }
  }
  return VueForgotCredentialsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides a full page login form, with the ability
 * to reset an account's password or username.
 *
 * ### Usage:
 * Can be used as a route ex:
  ```.ts
      {
        path: 'authenticate',
        component: VueAuthenticationComponent,
      }
  ```
 * Or as the only element in another component
 *
 * template: `<vue-authentication></vue-authentication>`
 *
 * ### Configuration:
 *
 * `displayForgotCredentials` provided by `VueAppDefaultsService` and defaults to `true` determines if
 * instructions to reset username and password are displayed.
 *
 * `getLoginDisplayResetAccountConfirmation` provided by `VueAppDefaultsService` and defaults to `false`
 * determines if a confirmation message shows on password reset. Currently should only show up only in
 * the Assist portal
 *
 * If login returns a Password Expired error message, the consuming app needs to listen for
 * the 'VueEventCASUserPasswordExpired' on the window and respond accordingly.
 *
 * Example:
  ```.ts
      constructor(
        @Inject(WINDOW) private vueWindow: Window
      ) {
        this.vueWindow.addEventListener('VueEventCASUserPasswordExpired', (e: CustomEvent) => {
            this.router.navigate([ '/passwordexpired' ], {
            state: {
              credentials: e.detail
            }
          });
        })
      }
  ```
 *
 * Todo:
 * - Redirect on success
 *
 */
let VueAuthenticationComponent = /*#__PURE__*/(() => {
  class VueAuthenticationComponent {
    /**
     * Component constructor.
     *
     * @param activatedRoute provides access to the current route.
     * @param router provides navigation and URL manipulation capabilities.
     * @param vueAppDefaultsService service used to fetch application-wide default attributes.
     * @param vueAuthenticationService service used to authenticate users against CAS.
     * @param vueForgotCredentialsService service responsible for handling reset username and password functionality.
     * @param vueJavascriptUtilityService service containing common utility functions.
     * @param vueTimeoutService service used to keep track of session activity and session timeouts.
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(activatedRoute, router, vueAppDefaultsService, vueAuthenticationService, vueForgotCredentialsService, vueJavascriptUtilityService, vueTimeoutService, vueTranslationService) {
      this.activatedRoute = activatedRoute;
      this.router = router;
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueAuthenticationService = vueAuthenticationService;
      this.vueForgotCredentialsService = vueForgotCredentialsService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueTimeoutService = vueTimeoutService;
      this.vueTranslationService = vueTranslationService;
      /**
       * Stores user credentials.
       */
      this.credentials = new VueCredentials();
      /**
       * Keeps track of form errors.
       */
      this.formError = new VueFormError();
      /**
       * A potentially empty list of server messages.
       */
      this.messages = [];
      /**
       * Whether to show the rest account dropdown.
       */
      this.showResetAccountDropdown = false;
      /**
       * The XLIFF key to translate the title. Defaults to `title.login`.
       */
      this.titleKey = 'title.Login';
      /**
       * If we should show 2FA Dialog
       */
      this.showVerifyForm = false;
      /**
       * The loginStatus is used to emit login status event.
       */
      this.loginStatus = new EventEmitter();
      /**
       * Event emitted when an error occurred.
       */
      this.serverMessageError = new EventEmitter();
      /**
       * The ID to use for the timeout VueServerMessage.
       */
      this.timeoutMessageId = '1';
    }
    /**
     * On initialization, get application defaults and translate labels.
     */
    ngOnInit() {
      this.displayInformationPanel = this.vueAppDefaultsService.getLoginDisplayInformationPanel();
      this.displayResetAccountConfirmation = this.vueAppDefaultsService.getLoginDisplayResetAccountConfirmation();
      this.displayForgotCredentials = this.vueAppDefaultsService.displayForgotCredentials();
      this.isSiteIdRequired = this.vueAppDefaultsService.getLoginSiteIDRequired();
      this.validateTimeout();
      this.initializePageTitle();
      this.initializeLabels();
      this.checkForMessages();
      this.checkForUsername();
    }
    /**
     * Checks if messages exist on the state object and
     * displays them if present
     */
    checkForMessages() {
      if (history.state && history.state.message) {
        this.messages = [...this.messages, history.state.message];
      }
    }
    /**
       * Checks if username exist on the state object and
       * displays them if present
       */
    checkForUsername() {
      if (history.state && history.state.username) {
        this.credentials.username = history.state.username;
      }
    }
    /**
     * This method is called when an info message is dismissed.
     */
    closeInfoMessage() {
      this.infoMessage = null;
    }
    /**
     * When the login button is clicked, validate the login form and attempt to authenticate the user.
     */
    login() {
      if (this.loginForm.form.valid === true) {
        this.loginForm.form.markAsPristine();
        if (this.vueAppDefaultsService.getPortalRESTRoot() === '') {
          /* eslint-disable-next-line no-alert */
          alert('Login functionality only works in a portal context. Extend vueAppDefaultsService.getPortalRESTRoot()');
          return;
        }
        this.vueAuthenticationService.login(this.credentials.username, this.credentials.password, this.credentials.siteId).subscribe({
          error: err => this.onLoginFailure(err),
          next: data => this.onLoginSuccess(data)
        });
      } else {
        this.formError.fieldInError = 'username';
        this.formError.invalidFormSubmit = true;
        if (this.hideErrorMessage) {
          const portalMessageBundle = this.vueAppDefaultsService.getPortalMessageBundle();
          /* eslint-disable-next-line max-len */
          const errorMessageFormInvalid = this.vueTranslationService.getTranslation(portalMessageBundle, 'invalidFormData');
          const serverErrorMessages = [new VueServerMessage({
            messageText: errorMessageFormInvalid,
            scrollIntoView: true,
            type: VueServerMessageType.Error
          })];
          this.serverMessageError.emit(serverErrorMessages);
        }
      }
    }
    /**
     * Method called when a server message is dismissed. If it's the timeout error, reload the page to get rid of the
     * query parameter.
     *
     * @param message the VueServerMessage that was dismissed.
     */
    messageRemoved(message) {
      if (message.id === this.timeoutMessageId) {
        this.router.navigate(['authenticate']);
      }
    }
    /**
     * When the user clicks 'No' in the reset account dropdown, hide the dropdown and do nothing.
     */
    cancelResetAccount() {
      this.showResetAccountDropdown = false;
    }
    /**
     * When the user clicks 'Yes' in the reset account dropdown, perform the forgot password routine
     * and hide the dropdown.
     */
    doResetAccount() {
      this.vueForgotCredentialsService.forgotPassword();
      this.showResetAccountDropdown = false;
    }
    /**
     * When reset password is clicked, show the reset account dropdown.
     */
    resetPasswordClicked() {
      this.showResetAccountDropdown = true;
    }
    /**
     * Initialize labels to be displayed - translate them or choose correct message based on predefined logic.
     */
    initializeLabels() {
      const portalMessageBundle = this.vueAppDefaultsService.getPortalMessageBundle();
      this.infoMessage = this.vueAppDefaultsService.getLoginRealm() === 'EMPLOYEE' ? this.vueTranslationService.getTranslation('PortalBase', 'info.NetworkLogin') : '';
      this.loginButtonText = this.vueTranslationService.getTranslation('PortalBase', 'button.LogIn');
      this.resetAccountConfirmationText = this.vueJavascriptUtilityService.replaceEscapedHTML(this.vueTranslationService.getTranslation(portalMessageBundle, 'info.ConfirmResetAccount'));
      this.resetAccountNo = this.vueTranslationService.getTranslation(portalMessageBundle, 'link.ConfirmResetAccountNo');
      this.resetAccountYes = this.vueTranslationService.getTranslation(portalMessageBundle, 'link.ConfirmResetAccountYes');
      this.welcomeMessage = this.vueTranslationService.getTranslation(portalMessageBundle, 'message.Welcome');
      this.welcomeTitle = this.vueTranslationService.getTranslation(portalMessageBundle, 'title.Welcome');
      this.browserInformationMessage = this.vueTranslationService.getTranslation('PortalBase', 'message.browserInformation');
    }
    /**
     * Initialize the page title.
     */
    initializePageTitle() {
      const displayTitle = this.vueAppDefaultsService.getLoginDisplayTitleBar();
      if (!displayTitle) {
        // Assigning null to key will force title to bar to not to render
        this.titleKey = null;
      }
    }
    /**
     * On login failure,
     *
     * @param response the error response from the server.
     */
    onLoginFailure(response) {
      if (response.error.code === 'CAS.User.PasswordExpired') {
        this.credentials.password = '';
        const expiredEvent = new CustomEvent('VueEventCASUserPasswordExpired', {
          detail: this.credentials
        });
        window.dispatchEvent(expiredEvent);
        if (this.vueAppDefaultsService.displayPasswordExpiredErrorMessage()) {
          this.errorMessage = this.vueAuthenticationService.getErrorMessage(response.error.code, [this.vueAppDefaultsService.getPortalMessageBundle(), 'PortalBase']);
        }
      } else if (response.error.code === 'CAS.TwoFactorCookie.NullOrExpired') {
        this.maskedEmailAddress = response.error.maskedEmail;
        this.showVerify();
      } else {
        this.credentials.password = '';
        this.formError.invalidFormSubmit = false;
        this.formError.fieldInError = '';
        this.loginForm.form.markAsPristine();
        this.errorMessage = this.vueAuthenticationService.getErrorMessage(response.error.code, [this.vueAppDefaultsService.getPortalMessageBundle(), 'PortalBase']);
        this.loginStatus.emit(VueLoginStatus.LOGIN_FAILED);
      }
      if (this.hideErrorMessage) {
        const serverErrorMessages = [new VueServerMessage({
          messageText: this.errorMessage,
          scrollIntoView: true,
          type: VueServerMessageType.Error
        })];
        this.serverMessageError.emit(serverErrorMessages);
      }
    }
    /**
     * On successful login, start the idle timeout and redirect to the target URL.
     *
     * @param token the VueOAuthToken that was returned on authentication.
     */
    onLoginSuccess(token) {
      const validatedTargetUrl = token && token.targetUrl ? token.targetUrl : null;
      this.vueTimeoutService.startIdleTimer();
      this.loginStatus.emit(VueLoginStatus.LOGIN_SUCCESS);
      if (validatedTargetUrl) {
        // TODO $window.location = targetUrl; DO NOT USE directly window object.
      }
    }
    /**
     * Check if the user was sent to the authentication page due to a timeout. If it is so, display an error message.
     */
    validateTimeout() {
      if (this.activatedRoute.snapshot.queryParams.timeout) {
        this.messages = [new VueServerMessage(VueServerMessageType.Error, this.vueTranslationService.getTranslation('PortalBase', 'error.timedOut'), true, this.timeoutMessageId)];
      }
    }
    /**
     * Sets up the Two Factor Verification View
     */
    showVerify() {
      this.showVerifyForm = true;
      this.formError = new VueFormError();
      const message = this.vueTranslationService.getTranslation('PortalBase', 'message.TwoFactorDescriptionWithMaskedEmail', [`${this.maskedEmailAddress}`]);
      this.messages = [new VueServerMessage(VueServerMessageType.Info, message, false, null, false, true)];
    }
    /**
     * Performs the 2FA verification
     */
    doVerify() {
      this.messages = [];
      this.formError.invalidFormSubmit = false;
      if (this.verifyForm.invalid) {
        const message = this.vueTranslationService.getTranslation('PortalBase', 'error.LoginFormInvalid');
        this.messages = [new VueServerMessage(VueServerMessageType.Error, message)];
        this.formError.invalidFormSubmit = true;
        this.formError.fieldInError = 'verificationCodeInput';
        return;
      }
      this.vueAuthenticationService.login(this.credentials.username, this.credentials.password, this.credentials.siteId, null, this.verificationCode).subscribe(data => this.onLoginSuccess(data), err => this.onVerifyFailure(err));
    }
    /**
     * Runs when login fails with 2FA
     * @param response HttpErrorResponse
     */
    onVerifyFailure(response) {
      const errorCode = response.error.code;
      let errorMessage;
      if (errorCode && errorCode !== 'unknownServerError') {
        errorMessage = this.vueAuthenticationService.getErrorMessage(response.error.code, ['PortalBase']);
      } else {
        errorMessage = this.vueTranslationService.getTranslation(this.vueAppDefaultsService.getPortalMessageBundle(), 'error.ServerError');
      }
      this.messages = [new VueServerMessage(VueServerMessageType.Error, errorMessage)];
    }
    /**
     * Runs ux for requesting verification code.
     */
    requestVerificationCode() {
      this.messages = [];
      this.verificationCode = '';
      this.vueAuthenticationService.requestVerificationCode(this.credentials).subscribe(() => this.onRequestVerificationCodeSuccess(), () => this.onRequestVerificationCodeFailure());
    }
    /**
     * runs when requestVerificationCode succeeds and shows the user an info message
     */
    onRequestVerificationCodeSuccess() {
      const message = this.vueTranslationService.getTranslation('PortalBase', 'message.TwoFactorCodeSent');
      this.messages = [new VueServerMessage(VueServerMessageType.Info, message, true)];
    }
    /**
     * Runs when requestVerificationCode fails and shows the user and error.
     */
    onRequestVerificationCodeFailure() {
      const message = this.vueTranslationService.getTranslation(this.vueAppDefaultsService.getPortalMessageBundle(), 'error.ServerError');
      this.messages = [new VueServerMessage(VueServerMessageType.Error, message)];
    }
    /**
     * Returns the user form the 2FA screen to the regular login screen
     */
    cancelVerify() {
      this.messages = [];
      this.formError = new VueFormError();
      this.credentials = new VueCredentials();
      this.verificationCode = '';
      this.verifyForm.form.markAsPristine();
      this.showVerifyForm = false;
    }
    static {
      this.ɵfac = function VueAuthenticationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAuthenticationComponent)(i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueAuthenticationService), i0.ɵɵdirectiveInject(VueForgotCredentialsService), i0.ɵɵdirectiveInject(VueJavascriptUtilityService), i0.ɵɵdirectiveInject(VueTimeoutService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueAuthenticationComponent,
        selectors: [["vue-authentication"]],
        viewQuery: function VueAuthenticationComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c23, 5);
            i0.ɵɵviewQuery(_c24, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginForm = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.verifyForm = _t.first);
          }
        },
        inputs: {
          hideErrorMessage: "hideErrorMessage"
        },
        outputs: {
          loginStatus: "loginStatus",
          serverMessageError: "serverMessageError"
        },
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [["loginForm", "ngForm"], ["inputElement", "", "username", "ngModel"], ["inputElement", "", "password", "ngModel"], ["inputElement", "", "siteId", "ngModel"], ["verifyForm", "ngForm"], ["inputElement", "", "verificationCodeInput", "ngModel"], [1, "row"], [1, "panel-container", "col-sm-12"], [3, "messageRemoved", "messages"], ["id", "loginFormTemplate", 1, "row"], ["id", "verificationFormTemplate", 1, "row"], [1, "panel-container", "col-sm-7"], [1, "panel-container", "col-sm-5"], ["i18nBundle", "PortalBase", "titleTag", "h1", 3, "titleKey"], ["id", "infoAlert", "type", "info", 3, "dismissible"], ["id", "dangerAlert", "type", "danger", 3, "dismissible"], ["autocomplete", "off", "novalidate", "", 1, "app-form"], ["i18nBundle", "PortalBase", "labelKey", "field.Username", "widthClass", "widest", 3, "control", "formError"], ["autocomplete", "off", "id", "username", "vueAutofocus", "", "name", "username", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel"], ["i18nBundle", "PortalBase", "labelKey", "field.Password", "widthClass", "widest", 3, "control", "formError"], ["autocomplete", "off", "name", "password", "required", "", "type", "password", "id", "password", 1, "form-control", 3, "ngModelChange", "ngModel"], ["i18nBundle", "PortalBase", "labelKey", "field.SiteID", "widthClass", "widest", 3, "control", "formError"], ["id", "verify", 1, "btn-section", "form-btn-section"], ["id", "primaryBtnLogin", "type", "submit", 1, "btn", "btn-primary", "btn-right", 3, "click"], [1, "supportedBrowsers", "small"], ["id", "confirmResetAccountDropdown", "tabindex", "-1", 1, "panel", "confirm-reset-account"], [3, "innerHTML"], ["id", "userMoreOptionsDropdown", 1, "list-unstyled"], ["id", "confirmResetAccount", 3, "click", "routerLink"], ["id", "cancelResetAccount", 1, "reset-account-no", 3, "click", "routerLink"], ["id", "infoPanel", "titleTag", "h1", 3, "title"], ["id", "authentication-welcome-text", 3, "innerHTML"], ["id", "infoAlert", "type", "info", 3, "close", "dismissible"], ["autocomplete", "off", "name", "siteId", "required", "", "id", "siteID", 1, "form-control", 3, "ngModelChange", "ngModel"], [3, "resetPasswordClicked"], ["titleKey", "title.TwoFactorVerification", "i18nBundle", "PortalBase"], ["novalidate", "", "autocomplete", "off", 1, "app-form"], ["i18nBundle", "PortalBase", "labelKey", "field.VerificationCode", 3, "control", "formError"], ["autocomplete", "off", "vueAutofocus", "", "name", "verificationCodeInput", "required", "", "minlength", "8", "id", "verificationCode", 1, "form-control", 3, "ngModelChange", "keyup.enter", "ngModel"], ["secondaryLabelKey", "button.cancel", "defaultLabelKey", "button.RequestVerificationCode", "primaryLabelKey", "button.Verify", "i18nBundle", "PortalBase", 3, "secondaryButtonClicked", "defaultButtonClicked", "primaryButtonClicked"]],
        template: function VueAuthenticationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "vue-server-messages", 8);
            i0.ɵɵlistener("messageRemoved", function VueAuthenticationComponent_Template_vue_server_messages_messageRemoved_2_listener($event) {
              return ctx.messageRemoved($event);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(3, VueAuthenticationComponent_Conditional_3_Template, 34, 23, "div", 9)(4, VueAuthenticationComponent_Conditional_4_Template, 10, 3, "div", 10);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.showVerifyForm ? 3 : 4);
          }
        },
        dependencies: [i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.MinLengthValidator, i6.NgModel, i6.NgForm, i4.NgbAlert, i1$1.RouterLink, VueControlGroupComponent, VueForgotCredentialsComponent, VueFormButtonsComponent, VuePanelComponent, VueServerMessagesComponent, AutofocusDirective],
        styles: [".passwordLink[_ngcontent-%COMP%]{color:#007fa3}"]
      });
    }
  }
  return VueAuthenticationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides panel indicating that the content is restricted and that the user does not have access.
 *
 * **TODO**:
 * <ul>
 *   <li>Translate the page text.</li>
 *   <li>Complete panel text.</li>
 * </ul>
 */
let VueAuthorityRestrictedComponent = /*#__PURE__*/(() => {
  class VueAuthorityRestrictedComponent {
    static {
      this.ɵfac = function VueAuthorityRestrictedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAuthorityRestrictedComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueAuthorityRestrictedComponent,
        selectors: [["vue-authority-restricted"]],
        standalone: false,
        decls: 2,
        vars: 0,
        template: function VueAuthorityRestrictedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "vue-panel");
            i0.ɵɵtext(1, " authority-restricted works but how come! See route definition and authority checker.ts\n");
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [VuePanelComponent],
        encapsulation: 2
      });
    }
  }
  return VueAuthorityRestrictedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 This component should be included in every project as shown below.  It subscribes to the VueLoadingService and will
 display our approved loading indicator when told to.

 Only ONE <vue-loading-indicator> should be used on your site. The are controlled by a single
 loading service.

 ```
 <vue-navigation></vue-navigation>
 <vue-cookie-policy></vue-cookie-policy>
 <div id="main-content" class="" vueMainContent>
   <vue-loading-indicator></vue-loading-indicator>
   <div class="app-wrapper">
     <div class="app-container">
       <router-outlet></router-outlet>
     </div>
   </div>
 </div>
 <vue-footer></vue-footer>```
 */
let VueLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class VueLoadingIndicatorComponent {
    constructor(vueLoadingService, vueTranslationService, cdr) {
      this.vueLoadingService = vueLoadingService;
      this.vueTranslationService = vueTranslationService;
      this.cdr = cdr;
      /**
       * Whether to show the loading component or not
       */
      this.showLoader = false;
    }
    ngOnInit() {
      this.loading = '';
      this.displayProperLoadingText();
      this.vueLoadingService.getRestState().subscribe(state => {
        if (state) {
          this.showLoader = true;
        } else {
          this.showLoader = false;
        }
      });
    }
    ngAfterViewInit() {
      // https://stackoverflow.com/questions/34364880/expression-has-changed-after-it-was-checked
      this.cdr.detectChanges();
    }
    ngOnChanges() {
      this.displayProperLoadingText();
    }
    /**
     * Disables keyboard interaction while loading is shown
     * @param e the keyboard event
     */
    disableKeyboardInteraction(e) {
      if (!this.showLoader) {
        return;
      }
      e.preventDefault();
    }
    displayProperLoadingText() {
      if (this.loadingText || this.loadingTextKey) {
        if (this.loadingTextKey) {
          this.loading = this.vueTranslationService.getTranslation(this.i18nBundle, this.loadingTextKey);
        } else {
          this.loading = this.loadingText;
        }
      } else if (this.loading === '') {
        if (this.vueTranslationService.isBundleAvailable('PortalBase')) {
          this.loading = this.vueTranslationService.getTranslation('PortalBase', 'label.loading');
        } else {
          this.loading = 'Loading';
        }
      }
    }
    static {
      this.ɵfac = function VueLoadingIndicatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(VueLoadingService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLoadingIndicatorComponent,
        selectors: [["vue-loading-indicator"]],
        hostBindings: function VueLoadingIndicatorComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function VueLoadingIndicatorComponent_keydown_HostBindingHandler($event) {
              return ctx.disableKeyboardInteraction($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          loadingText: "loadingText",
          loadingTextKey: "loadingTextKey",
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [["content", ""], ["id", "form-loader", "aria-live", "assertive", "aria-atomic", "true", 1, "loading-container"], [1, "loading-component"], [1, "loading-screen-block"], [3, "hidden"], [1, "dot-holder"], [1, "dotdotdot"]],
        template: function VueLoadingIndicatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, VueLoadingIndicatorComponent_Conditional_1_Template, 8, 2, "div", 2)(2, VueLoadingIndicatorComponent_Conditional_2_Template, 1, 0, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showLoader ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showLoader ? 2 : -1);
          }
        },
        styles: [".loading-container[_ngcontent-%COMP%]{display:flex;justify-content:center}.loading-container[_ngcontent-%COMP%]   .loading-component[_ngcontent-%COMP%]{display:flex;background-color:#007fa3;height:25px;padding:0 10px;color:#fff;position:relative;z-index:2055;min-width:84px}.dot-holder[_ngcontent-%COMP%]{width:10px}.loading-container[_ngcontent-%COMP%]   .loading-component[_ngcontent-%COMP%]   p.dotdotdot[_ngcontent-%COMP%]{display:inline-block;overflow:hidden;animation:loading 1s;-webkit-animation:loading 1s;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite}"]
      });
    }
  }
  return VueLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated Use VueAuthenticationComponent Instead
 *
 * This component is a wrapper around `VueAuthenticationComponent`.
 *
 * TODO: Why is this needed? Why not use `vue-authentication` itself?
 */
let VueLoginComponent = /*#__PURE__*/(() => {
  class VueLoginComponent {
    static {
      this.ɵfac = function VueLoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLoginComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLoginComponent,
        selectors: [["vue-login"]],
        standalone: false,
        decls: 1,
        vars: 0,
        template: function VueLoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "vue-authentication");
          }
        },
        dependencies: [VueAuthenticationComponent],
        encapsulation: 2
      });
    }
  }
  return VueLoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 This component provides a "no applications" panel displaying a server message explaining the user does not have
 permissions to any applications in the portal.

 Message translation should use the 'message.NoApplications' key in the PortalMessageBundle.
*/
let VueNoApplicationsComponent = /*#__PURE__*/(() => {
  class VueNoApplicationsComponent {
    constructor(vueAppDefaultsService, vueTranslationService) {
      this.vueAppDefaultsService = vueAppDefaultsService;
      this.vueTranslationService = vueTranslationService;
      /**
       Message array object displayed in the UI.
       */
      this.messages = [];
    }
    ngOnInit() {
      // add "no applications" message
      this.messages.push(new VueServerMessage(VueServerMessageType.Error, this.vueTranslationService.getTranslation(this.vueAppDefaultsService.getPortalMessageBundle(), 'message.NoApplications'), false));
    }
    static {
      this.ɵfac = function VueNoApplicationsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNoApplicationsComponent)(i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNoApplicationsComponent,
        selectors: [["vue-no-applications"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[3, "messages"]],
        template: function VueNoApplicationsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "vue-server-messages", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("messages", ctx.messages);
          }
        },
        dependencies: [VueServerMessagesComponent],
        encapsulation: 2
      });
    }
  }
  return VueNoApplicationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides a page not authorized panel.
 */
let VueNotAuthorizedComponent = /*#__PURE__*/(() => {
  class VueNotAuthorizedComponent {
    static {
      this.ɵfac = function VueNotAuthorizedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNotAuthorizedComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNotAuthorizedComponent,
        selectors: [["vue-not-authorized"]],
        standalone: false,
        decls: 2,
        vars: 0,
        consts: [[1, "well", "col-lg-6", "col-lg-offset-3"], ["i18nBundle", "PortalBase", "labelKey", "message.NotAuthorizedFunction"]],
        template: function VueNotAuthorizedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "vue-label", 1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [VueLabelComponent],
        encapsulation: 2
      });
    }
  }
  return VueNotAuthorizedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides a page not found panel.
 *
 * **TODO**:
 * <ul>
 *   <li>Translate the page text.</li>
 * </ul>
 */
let VuePageNotFoundComponent = /*#__PURE__*/(() => {
  class VuePageNotFoundComponent {
    static {
      this.ɵfac = function VuePageNotFoundComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePageNotFoundComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePageNotFoundComponent,
        selectors: [["vue-page-not-found"]],
        standalone: false,
        decls: 3,
        vars: 0,
        consts: [[1, "well", "col-lg-6", "col-lg-offset-3"]],
        template: function VuePageNotFoundComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span");
            i0.ɵɵtext(2, "The page you are looking for does not exist.");
            i0.ɵɵelementEnd()();
          }
        },
        encapsulation: 2
      });
    }
  }
  return VuePageNotFoundComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component provides a panel with text instructing the user to select an application.
 */
let VuePleaseSelectComponent = /*#__PURE__*/(() => {
  class VuePleaseSelectComponent {
    constructor(vueUserSession, vueAppDefaults, vueTranslationService) {
      this.vueUserSession = vueUserSession;
      this.vueAppDefaults = vueAppDefaults;
      this.vueTranslationService = vueTranslationService;
      this.messages = [];
      // Removes or displays server messages, for now only submenu warning message is expected to show.
      this.showServerMessages = false;
    }
    ngOnInit() {
      if (this.vueAppDefaults.enableSubmenuMessage()) {
        this.showServerMessages = true;
        this.vueUserSession.getClientsAndApplicationsChange().subscribe(() => {
          const excludedApps = this.vueUserSession.getExcludedApplications();
          this.messages = [];
          if (excludedApps && excludedApps.length > 0) {
            const excludedAppNames = excludedApps.map(app => app.translatedName).join(', ');
            const message = this.vueTranslationService.getTranslation('PortalBase', 'warning.SubmenuRetrieval', [excludedAppNames]);
            this.messages.push(new VueServerMessage(VueServerMessageType.Warning, message, false));
          }
        });
      }
    }
    static {
      this.ɵfac = function VuePleaseSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePleaseSelectComponent)(i0.ɵɵdirectiveInject(VueUserSessionService), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePleaseSelectComponent,
        selectors: [["vue-please-select"]],
        standalone: false,
        decls: 3,
        vars: 1,
        consts: [[3, "messages"], [1, "well", "col-lg-6", "col-lg-offset-3"], ["i18nBundle", "PortalBase", "labelKey", "message.SelectSidebar"]],
        template: function VuePleaseSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, VuePleaseSelectComponent_Conditional_0_Template, 1, 1, "vue-server-messages", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵelement(2, "vue-label", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.showServerMessages ? 0 : -1);
          }
        },
        dependencies: [VueLabelComponent, VueServerMessagesComponent],
        encapsulation: 2
      });
    }
  }
  return VuePleaseSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive validates that a field only contains CAPVA valid inputs.
 * This means the field should not contain `<`, `>`, or `,`.
 *
 * Usage:
 ```
 <vue-control-group label="Required filed like CAPVA" [control]="sampleName10" [formError]="formError">
 <input autocomplete="off"
        autofocus
        class="form-control"
        name="sampleName10"
        required
        vueValidateAlphaNumericCapva
        #inputElement
        #sampleName10="ngModel"
        [(ngModel)]="sample.alphaNumericCapvaExample">
 </vue-control-group>
 ```
 */
let VueAlphaNumericCapvaDirective = /*#__PURE__*/(() => {
  class VueAlphaNumericCapvaDirective {
    /**
     * Directive constructor.
     */
    constructor() {
      this.validator = this.vueValidateAlphaNumericCapva();
    }
    /**
     * Implementation of Validator.validates(), will forward the request to vueValidateAlphaNumericCapva().
     *
     * @param formControl the form control to validate.
     * @returns a potentially empty ValidationErrors object.
     */
    validate(formControl) {
      return this.validator(formControl);
    }
    /**
     * Returns a function that validates that an input value is valid CAPVA (no `<`, `>`, or `,`).
     *
     * @returns a validator function.
     */
    vueValidateAlphaNumericCapva() {
      return formControl => {
        const stringValue = formControl && formControl.value ? formControl.value : '';
        const regex = new RegExp(/^[^<>,"]*$/gm);
        const isValid = regex.test(stringValue);
        return isValid ? null : {
          vueValidateAlphaNumericCapva: {
            valid: false
          }
        };
      };
    }
    static {
      this.ɵfac = function VueAlphaNumericCapvaDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAlphaNumericCapvaDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueAlphaNumericCapvaDirective,
        selectors: [["", "vueAlphaNumericCapva", "", "ngModel", ""]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          multi: true,
          provide: NG_VALIDATORS,
          /* eslint-disable-next-line @typescript-eslint/no-use-before-define */
          useExisting: VueAlphaNumericCapvaDirective
        }])]
      });
    }
  }
  return VueAlphaNumericCapvaDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueTabComponent = /*#__PURE__*/(() => {
  class VueTabComponent {
    constructor(translationService) {
      this.translationService = translationService;
      this.infoCircle = faInfoCircle;
      this.vueTabHasError = false;
    }
    getToolTipTranslation() {
      if (this.toolTipMessage) {
        return this.toolTipMessage;
      }
      return this.translationService.getTranslation(this.i18nBundle, this.toolTipMessageKey);
    }
    static {
      this.ɵfac = function VueTabComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTabComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueTabComponent,
        selectors: [["vue-tab"]],
        viewQuery: function VueTabComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatTab, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matTab = _t.first);
          }
        },
        inputs: {
          label: "label",
          toolTipMessage: "toolTipMessage",
          i18nBundle: "i18nBundle",
          toolTipMessageKey: "toolTipMessageKey",
          vueTabHasError: "vueTabHasError"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 3,
        vars: 1,
        consts: [[3, "label"], ["mat-tab-label", ""], ["matTooltipPosition", "below", 3, "matTooltip"], [1, "fas", "fa-info-circle", "faIconLabel", "faInfoIcon", 3, "icon"]],
        template: function VueTabComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-tab", 0);
            i0.ɵɵtemplate(1, VueTabComponent_ng_template_1_Template, 3, 4, "ng-template", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.label);
          }
        },
        dependencies: [i1$2.FaIconComponent, i3$2.MatTabLabel, i3$2.MatTab, i4$1.MatTooltip],
        styles: [".mat-mdc-tooltip{background-color:#000000bf;width:180px;text-align:center;font:12px Open Sans;padding:10px 12px}.faInfoIcon{color:#505759;padding-left:2px}\n"],
        encapsulation: 2
      });
    }
  }
  return VueTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueTabGroupComponent = /*#__PURE__*/(() => {
  class VueTabGroupComponent {
    constructor() {
      this.animationDuration = '500ms';
      this.animationDone = new EventEmitter();
      this.focusChange = new EventEmitter();
      this.selectedIndexChange = new EventEmitter();
      this.selectedTabChange = new EventEmitter();
    }
    ngAfterViewInit() {
      setTimeout(() => {
        const matTabsFromQueryList = this.vueTabs.map(vueTab => vueTab.matTab);
        const matTabs = new QueryList();
        matTabs.reset([matTabsFromQueryList]);
        // eslint-disable-next-line no-underscore-dangle
        this.matTabGroup._allTabs = matTabs;
        this.matTabGroup.selectedIndex = this.selectedIndex;
        this.matTabGroup.ngAfterContentInit();
      });
    }
    ngAfterViewChecked() {
      this.realignTabFocus();
    }
    /**
     * This is to realign the 'InkBar' under the tab that is currently selected. This is used when the tab group is
     * made visible from hidden state
     */
    realignTabFocus() {
      this.matTabGroup.realignInkBar();
    }
    static {
      this.ɵfac = function VueTabGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTabGroupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueTabGroupComponent,
        selectors: [["vue-tab-group"]],
        contentQueries: function VueTabGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, VueTabComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vueTabs = _t);
          }
        },
        viewQuery: function VueTabGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatTabGroup, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matTabGroup = _t.first);
          }
        },
        inputs: {
          animationDuration: "animationDuration",
          backgroundColor: "backgroundColor",
          disablePagination: "disablePagination",
          dynamicHeight: "dynamicHeight",
          headerPosition: "headerPosition",
          selectedIndex: "selectedIndex"
        },
        outputs: {
          animationDone: "animationDone",
          focusChange: "focusChange",
          selectedIndexChange: "selectedIndexChange",
          selectedTabChange: "selectedTabChange"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 2,
        vars: 6,
        consts: [["mat-stretch-tabs", "false", "mat-align-tabs", "start", 3, "animationDone", "focusChange", "selectedIndexChange", "selectedTabChange", "animationDuration", "backgroundColor", "disablePagination", "dynamicHeight", "headerPosition", "selectedIndex"]],
        template: function VueTabGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-tab-group", 0);
            i0.ɵɵlistener("animationDone", function VueTabGroupComponent_Template_mat_tab_group_animationDone_0_listener($event) {
              return ctx.animationDone.emit($event);
            })("focusChange", function VueTabGroupComponent_Template_mat_tab_group_focusChange_0_listener($event) {
              return ctx.focusChange.emit($event);
            })("selectedIndexChange", function VueTabGroupComponent_Template_mat_tab_group_selectedIndexChange_0_listener($event) {
              return ctx.selectedIndexChange.emit($event);
            })("selectedTabChange", function VueTabGroupComponent_Template_mat_tab_group_selectedTabChange_0_listener($event) {
              return ctx.selectedTabChange.emit($event);
            });
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("animationDuration", ctx.animationDuration)("backgroundColor", ctx.backgroundColor)("disablePagination", ctx.disablePagination)("dynamicHeight", ctx.dynamicHeight)("headerPosition", ctx.headerPosition)("selectedIndex", ctx.selectedIndex);
          }
        },
        dependencies: [i3$2.MatTabGroup],
        styles: [".mat-mdc-tab-group.mat-primary .mat-ink-bar{background-color:#0089b7!important}  .mdc-tab{min-width:180px!important}  .mdc-tab__content .mdc-tab__text-label{color:#333!important;font-weight:600!important;font-family:Open Sans,sans-serif!important;font-size:14px!important;letter-spacing:0}  .mdc-tab__ripple{background-color:#0000}  .mdc-tab-indicator__content.mdc-tab-indicator__content--underline{border-color:#0089b7!important}  .mat-mdc-tab-labels{font-weight:500!important;opacity:1!important}  span.mat-tab-label-content-has-error{color:#db0020!important}  .mat-mdc-tab-body-content{margin:1.5rem 1rem;font-family:Open Sans,sans-serif}"]
      });
    }
  }
  return VueTabGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 *
 * This component allows to create a check box with required flag true or false. Or even toggle required field
 * depending on other component. For instance, depending on a option button the required flag can be switched.
 * Also, customize the error message when no item checked in required mode.
 *
Example usage of this component:

 ```
 <vue-checkbox name="requiredCheckBox"
      label="Required checkbox"
      [options]="items"
      (toggle)='onRolesChange($event)'
      [required]="getRequiredStatus()"
      error="A response is required"
      [formError]="formError">
 </vue-checkbox>

 */
let VueCheckboxComponent = /*#__PURE__*/(() => {
  class VueCheckboxComponent {
    /**
     * This injects the translation service
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * This is the width class
       */
      this.widthClass = '';
      /**
       * This is the event emitter for the toggle
       */
      this.toggle = new EventEmitter();
      /**
       * This is the list of checked items
       */
      this.checkedItems = [];
      /**
       * This is if the component has been touched
       */
      this.isDirty = false;
    }
    /**
     * This initializes the component
     */
    ngOnInit() {
      this.translateErrorKey();
      if (this.noInitialDirty) {
        this.doToggle();
      } else {
        this.onToggle();
      }
    }
    /**
     * This gets the width class
     * NOTE: This method seems to be unnecissary
     * Why not just use the value directly?
     * @returns the width classs
     */
    getWidthClass() {
      return this.widthClass;
    }
    /**
     * This method will translate (using VueTranslationService) or will return hardcoded string
     *  @returns the translated label
     */
    getLabelTranslation() {
      if (this.label) {
        return this.label;
      }
      return this.vueTranslationService.getTranslation(this.i18nBundle, this.labelKey);
    }
    /**
     * This sets the field to dirty
     */
    setIsDirty() {
      this.isDirty = true;
    }
    /**
     * This checks if there is an error
     * @returns if there is an error
     */
    isInputFieldInError() {
      return this.required === true && (this.formError && this.formError.invalidFormSubmit || this.isDirty) && this.checkedItems.length < 1;
    }
    /**
     * Adds asterisks to the label if the required flag is set to true and removes if the flag is false
     * @returns the asterisk (or not)
     */
    getRequiredIndicator() {
      if (this.required === true) {
        return '*';
      }
      return '';
    }
    /**
     * This toggles the options
     */
    onToggle() {
      this.setIsDirty();
      this.doToggle();
    }
    /**
     * Performs the toggle operation without setting the dirty flag. Can be called directly
     * from initialization when this field is `required` to avoid it initially showing up
     * red with error messages, etc.
     * @private
     */
    doToggle() {
      const checkedOptions = this.options.filter(x => x.checked);
      this.checkedItems = checkedOptions.map(x => x.value);
      this.toggle.emit(checkedOptions.map(x => x.value));
    }
    /**
     * This method will translate (using VueTranslationService) or will return hardcoded string
     */
    translateErrorKey() {
      if (!this.error && this.errorKey) {
        this.error = this.vueTranslationService.getTranslation(this.i18nBundle, this.errorKey);
      }
    }
    static {
      this.ɵfac = function VueCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueCheckboxComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueCheckboxComponent,
        selectors: [["vue-checkbox"]],
        contentQueries: function VueCheckboxComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          name: "name",
          options: "options",
          formError: "formError",
          widthClass: "widthClass",
          i18nBundle: "i18nBundle",
          labelKey: "labelKey",
          label: "label",
          error: "error",
          errorKey: "errorKey",
          required: "required",
          noInitialDirty: "noInitialDirty"
        },
        outputs: {
          toggle: "toggle"
        },
        standalone: false,
        decls: 9,
        vars: 9,
        consts: [[1, "form-group", 3, "ngClass"], [1, "control-label"], [1, "input-container", "mat-checkbox"], [1, "help-inline", "validation-inline"], [3, "ngModelChange", "change", "ngModel"], [1, "validation-fail"], ["icon", "times", 1, "fa", "fa-fw"]],
        template: function VueCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div")(5, "div", 2);
            i0.ɵɵrepeaterCreate(6, VueCheckboxComponent_For_7_Template, 3, 2, "div", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, VueCheckboxComponent_Conditional_8_Template, 4, 1, "div", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c25, ctx.isInputFieldInError()));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.getLabelTranslation(), " ", ctx.getRequiredIndicator(), "");
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("input-container ", ctx.getWidthClass(), "");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.options);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isInputFieldInError() ? 8 : -1);
          }
        },
        dependencies: [i2.NgClass, i6.NgControlStatus, i6.NgModel, i1$2.FaIconComponent, i5.MatCheckbox],
        encapsulation: 2
      });
    }
  }
  return VueCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component generates a list of network statistics against each given url configs.
 * Each object of VueNetwork will holds two set of information as follows:
 *  <ol>
 *    <li style="color: blue; font-weight: bold">Network Statistic</li>
 *      <ul>
 *        <li>Total attempts made for one url</li>
 *        <li>Total success responses</li>
 *        <li>Total failed responses</li>
 *        <li>Average jitter value</li>
 *        <li>Average latency value</li>
 *        <li>Packet loss value in percentage</li>
 *      </ul>
 *    <li style="color: blue; font-weight: bold">Ping list with following detail</li>
 *      <ul>
 *        <li>Url for the ping</li>
 *        <li>Latency</li>
 *        <li>Jitter value if not first request</li>
 *        <li>Success(true) or Fail(false)</li>
 *        <li>Error detail in case of failed request</li>
 *        <li>Date and time the ping was made</li>
 *        <li>The response status code (eg: 200, 204, 404....)</li>
 *      </ul>
 * </ol>
 */
let VueNetworkComponent = /*#__PURE__*/(() => {
  class VueNetworkComponent {
    constructor(vueNetworkService) {
      this.vueNetworkService = vueNetworkService;
      /**
       * A list of url configs to generate Statistics. Each config would have their own Statistic generated.
       */
      this.urlConfigs = [];
      /**
       * This input required to be true if user needs network statistic generated on component load.
       */
      this.buildStatsOnInit = false;
      /**
       * full execution timeout to stop complete process
       */
      this.executionTimeout = 20000;
      /**
       * The output emitter with full Network statistics.
       */
      this.fullInfo = new EventEmitter();
    }
    /**
     * On initialization, if buildStatsOnInit input is true execute buildStats.
     */
    ngOnInit() {
      if (this.buildStatsOnInit) {
        this.buildStats();
      }
    }
    /**
     * Executes Network Statistics for given URLConfigs.
     */
    buildStats() {
      const start = performance.now();
      if (this.validateConfigs()) {
        this.vueNetworkService.generateStatistics(this.urlConfigs, this.executionTimeout).subscribe(networkResults => this.collectStats(networkResults, start), networkError => {
          this.collectStats(networkError.statsUntil, start);
          throw networkError;
        });
      }
    }
    /**
     * Helper method for collecting status and assign them for output.
     *
     * @param networks Results generated after stats execution.
     * @param startTime Time when the stats execution was started.
     */
    collectStats(networks, startTime) {
      if (Array.isArray(networks) && networks) {
        this.vueNetworks = networks;
        this.fullInfo.emit(this.vueNetworks);
        this.executionTime = Math.round(performance.now() - startTime);
      }
    }
    /**
     * Validates if provided list of url configs are not empty.
     * @returns True if config is valid
     */
    validateConfigs() {
      return Array.isArray(this.urlConfigs) && this.urlConfigs.length > 0;
    }
    static {
      this.ɵfac = function VueNetworkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNetworkComponent)(i0.ɵɵdirectiveInject(i1$6.VueNetworkService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueNetworkComponent,
        selectors: [["vue-network"]],
        inputs: {
          urlConfigs: "urlConfigs",
          buildStatsOnInit: "buildStatsOnInit",
          executionTimeout: "executionTimeout"
        },
        outputs: {
          fullInfo: "fullInfo"
        },
        standalone: false,
        decls: 0,
        vars: 0,
        template: function VueNetworkComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return VueNetworkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This pipe will format the date using the current locale allowing for a custom
 * parse format to be entered as well.
 * Usage {{ date | dateLocale:'longDate' }} => 3 August 2015 12:12
 *
 * checkout localizedDateFormats
 * in https://bitbucket.pearson.com/projects/pvuic/repos/vueframework/browse/projects/vueframework/src/lib/services/vue-locale.service.ts
 */
let DateLocalePipe = /*#__PURE__*/(() => {
  class DateLocalePipe {
    constructor(vueLocaleService) {
      this.vueLocaleService = vueLocaleService;
    }
    transform(value, format, parseFormat) {
      return this.vueLocaleService.dateFormatLocale(value, format, parseFormat);
    }
    static {
      this.ɵfac = function DateLocalePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DateLocalePipe)(i0.ɵɵdirectiveInject(VueLocaleService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dateLocale",
        type: DateLocalePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return DateLocalePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This is primarily for calling the services that allow users
 * to maintain/setup their own account. It is realm agnostic.
 *
 * Many of these endpoints are unauthenticated.
 *
 * Those that are used by your app will need to be white
 * listed in AppDefaultServices.getApplicationsUnAuthenticatedURLList
 * which accepts regex strings.
 *
 * When bringing services over from angular-js-commons
 *   "accountMaintenance" and "accountManagement"
 * are combined here. Methods were renamed where applicable
 * to be more descriptive of their job. However their old name
 * will be found in the description to help with searching.
 */
let VueAccountManagementService = /*#__PURE__*/(() => {
  class VueAccountManagementService {
    constructor(defaults, localeService, vueLoadingService, http) {
      this.defaults = defaults;
      this.localeService = localeService;
      this.httpClient = new VueHttpClientService(http, vueLoadingService);
    }
    /**
     * Default options for http calls to apply locale.
     * Not all endpoints requires this, but many
     * do so its put here to simplify method calls below.
     *
     * @param options: additional request options
     * @returns RequestOptions
     */
    httpOptions(options) {
      return {
        headers: new HttpHeaders({
          'Accept-Language': this.localeService.locale
        }),
        ...options
      };
    }
    /**
     * Constructs the base URL for service calls
     * to account management
     * @returns string
     */
    accountManagementUrl() {
      return this.defaults.getPortalRESTRoot() + '/rest/accountManagement/' + this.defaults.getLoginRealm();
    }
    /**
     * Constructs the base URL for service calls
     * to realms
     * @returns string
     */
    realmUrl() {
      const restRoot = this.defaults.getCASRESTRoot() || this.defaults.getPortalRESTRoot();
      return restRoot + '/rest/realms/' + this.defaults.getLoginRealm();
    }
    /**
     * Constructs the base URL for service calls
     * to realms/users
     * @param nameOrId: username or id
     * @returns string
     */
    userRealmUrl(nameOrId) {
      return this.realmUrl() + '/users/' + nameOrId;
    }
    /**
     * This returns security questions based on
     * validating inputs. Used for "retrieve username"
     *
     * @param firstName string
     * @param lastName string
     * @param email string
     * @param siteID string
     * @returns Observable<VueSecurityQuestionPromptGroup[]>
     */
    validateUserAndGetSecurityQuestions(firstName, lastName, email, siteID) {
      const url = this.accountManagementUrl() + '/usersecurityquestions';
      const options = this.httpOptions({
        params: new HttpParams({
          fromObject: {
            context: 'usernameLookup',
            email: email,
            firstName: firstName,
            lastName: lastName,
            scopeID: siteID
          }
        })
      });
      return this.httpClient.get(url, options);
    }
    /**
     * API call to retrieve username after security
     * questions are answered.
     *
     * lookupUsername in angular-js-commons
     *
     * @param user Object representing user
     * @param questionAnswers Answered questions
     * @returns Observable<string>
     */
    forgotUsernameLookup(user, questionAnswers) {
      const url = this.accountManagementUrl() + '/usernamelookup';
      return this.httpClient.post(url, {
        questionAnswers,
        user
      }).pipe(pluck('username'));
    }
    /**
     * Get a full list of security questions for realm
     *
     * @returns Observable<VueSecurityQuestionGroup[]>
     */
    getSecurityQuestionGroups() {
      const url = this.realmUrl() + '/securityQuestionGroups';
      return this.httpClient.get(url, this.httpOptions()).pipe(pluck('securityQuestionGroups'));
    }
    /**
     * Initiates password reset email
     *
     * @param username string
     * @param siteID string
     * @returns Observable<null>
     */
    initiatePasswordReset(username, siteID) {
      const url = this.accountManagementUrl() + '/initiatepasswordreset';
      const payload = {
        locale: this.localeService.locale,
        scopeID: siteID,
        username: username
      };
      return this.httpClient.post(url, payload);
    }
    /**
     * Saves new password. Used in password expired
     * or account maintenance views.
     *
     * @param username string
     * @param newPassword string
     * @param oldPassword string
     * @param siteID string
     * @returns Observable<null>
     */
    updateExpiredPassword(username, newPassword, oldPassword, siteID) {
      const url = this.userRealmUrl(username) + '/changePassword';
      const payload = {
        newPassword: newPassword,
        oldPassword: oldPassword,
        scopeID: siteID
      };
      return this.httpClient.post(url, payload);
    }
    /**
     * Validates the hash from a new user / reset email.
     *
     * @param userId number
     * @param hash string param from the Email
     * @returns list of security questions
     */
    validateNewUserEmailAndGetSecurityQuestions(userId, hash) {
      const url = this.accountManagementUrl() + '/securityquestions';
      const params = {
        hash: hash,
        userId: userId
      };
      const options = {
        params: new HttpParams({
          fromObject: params
        })
      };
      return this.httpClient.get(url, this.httpOptions(options));
    }
    /**
     * Validates a password reset email link and
     * returns security questions for user
     *
     * getUserSecurityQuestions in angular-js-commons
     *
     * @param userId string params from url
     * @param hash string param from the url
     * @returns list of security questions
     */
    forgotPasswordGetSecurityQuestions(userId, hash) {
      const url = this.accountManagementUrl() + '/usersecurityquestions';
      const options = this.httpOptions({
        params: new HttpParams({
          fromObject: {
            context: 'passwordReset',
            hash: hash,
            userId: userId
          }
        })
      });
      return this.httpClient.get(url, options);
    }
    /**
     * Verifies answers to security questions.
     *
     * verifyQuestionAnswers in angular-js-commons
     *
     * @param userId string params from url
     * @param hash string param from the url
     * @param questionAnswers VueSecurityQuestionAnswer
     * @returns Observable<null>
     */
    forgotPasswordVerifyQuestionAnswers(userId, hash, questionAnswers) {
      const url = this.accountManagementUrl() + '/usersecurityquestions/validate';
      const payload = {
        questionAnswers: questionAnswers,
        user: {
          hash,
          userId
        }
      };
      return this.httpClient.post(url, payload);
    }
    /**
     * Update password from the forgot password
     * reset link workflow
     *
     * changePassword - in angular-js-commons
     *
     * @param userId string params from url
     * @param hash string param from the url
     * @param password new password
     * @param questionAnswers VueSecurityQuestionAnswer
     * @returns Observable<null>
     */
    forgotPasswordUpdatePassword(userId, hash, password, questionAnswers) {
      const url = this.accountManagementUrl() + '/password';
      const payload = {
        password: password,
        questionAnswers: questionAnswers,
        user: {
          hash,
          userId
        }
      };
      return this.httpClient.post(url, payload);
    }
    /**
     * Updates user's security question preferences
     *
     * @param userId UserId of user who's questions we are updating
     * @param questionResponses Updated questions to save
     * @param password string
     * @returns Observable<null>
     */
    setUserSecurityQuestions(userId, questionResponses, password) {
      const url = this.userRealmUrl(userId) + '/changeSecurityResponses';
      const payload = {
        password: password,
        questionResponses: questionResponses.map(v => ({
          answer: v.answer,
          questionID: v.questionId
        }))
      };
      return this.httpClient.post(url, payload, this.httpOptions());
    }
    /**
     * Used on first time account setup or reset
     *
     * setUserPasswordAndSecurityQuestions - in angular-js-commons
     *
     * @param userId string params from url
     * @param hash string param from the url
     * @param password: string
     * @param questionAnswers: Questions / Answers to save
     * @returns Observable<null>
     */
    accountSetupActivate(userId, hash, password, questionAnswers) {
      const url = this.accountManagementUrl() + '/activate';
      const payload = {
        password: password,
        questionAnswers: questionAnswers,
        user: {
          hash,
          userId
        }
      };
      return this.httpClient.post(url, payload);
    }
    /**
     * Get personal and address infor of user
     * @param userId of the user
     *
     * @returns Observable<null>
     */
    getPersonalAndAddressInfo(userId) {
      return this.httpClient.get(this.userRealmUrl(userId), this.httpOptions());
    }
    /**
     * Get a list of security questions selected by user
     * @param userId of the user
     *
     * @returns Observable<number[]>
     */
    getSelectedSecurityQuestions(userId) {
      const url = this.realmUrl() + '/answeredQuestionIDs?userId=' + userId;
      return this.httpClient.get(url, this.httpOptions());
    }
    static {
      this.ɵfac = function VueAccountManagementService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAccountManagementService)(i0.ɵɵinject(VueAppDefaultsService), i0.ɵɵinject(VueLocaleService), i0.ɵɵinject(VueLoadingService), i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueAccountManagementService,
        factory: VueAccountManagementService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueAccountManagementService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is for a user to reset
 * their password
 *
 * It is normally placed on a route
 * path: 'resetPassword'
 *
 * and it made to communicate with the login route
 * path: 'authenticate
 *
 */
let VueForgotPasswordComponent = /*#__PURE__*/(() => {
  class VueForgotPasswordComponent {
    constructor(router, vueAppDefaultsService, vueAuthenticationService, vueTranslationService, vueAccountManagementService) {
      this.router = router;
      this.vueAuthenticationService = vueAuthenticationService;
      this.vueTranslationService = vueTranslationService;
      this.vueAccountManagementService = vueAccountManagementService;
      this.formError = new VueFormError();
      /**
       * Page level messages displayed to the user
       */
      this.messages = [];
      this.vueAppDefaultsService = vueAppDefaultsService;
    }
    /**
     * Navigates back to the Login Page
     */
    cancel() {
      this.goToLogin();
    }
    /**
     * Navigates back to the Login Page
     * @param showSuccessMessage flag for whether success message should be shown in login page
     */
    goToLogin(showSuccessMessage = false) {
      if (showSuccessMessage) {
        const message = this.vueTranslationService.getTranslation('PortalBase', 'info.resetPassword');
        this.router.navigate(['/authenticate'], {
          state: {
            message: new VueServerMessage(VueServerMessageType.Success, message)
          }
        });
        return;
      }
      this.router.navigate(['/authenticate']);
    }
    /**
     * Navigates to the Username lookup page
     */
    goToUsernameLookup() {
      this.router.navigate(['/usernamelookup']);
    }
    ngOnInit() {
      this.i18nBundle = this.vueAppDefaultsService.getPortalMessageBundle();
    }
    resetPassword() {
      this.formError.invalidFormSubmit = true;
      if (this.initiatePasswordResetForm.valid) {
        this.messages.length = 0;
        this.formError.invalidFormSubmit = false;
        this.vueAccountManagementService.initiatePasswordReset(this.inputUserName, this.inputSiteID).subscribe(() => this.goToLogin(true), err => this.updateFail(err));
      }
    }
    /**
     * Checks if error should be displayed in the login screen instead
     * @param errorCode - Error code that will be evaluated
     * @return boolean - Flag for whether to redirect to login
     */
    isRedirectToLogin(errorCode) {
      return errorCode === 'CAS.User.PendingUserCannotReset' || errorCode === 'CAS.User.AccountDisabled' || errorCode === 'CAS.User.PasswordChange24Hours';
    }
    /**
     * On failed update get error and display to user.
     * @param response HttpErrorResponse
     */
    updateFail(response) {
      const code = response.error[0].code;
      const errorMessage = this.vueAuthenticationService.getErrorMessage(code, [this.vueAppDefaultsService.getPortalMessageBundle(), 'CAS']);
      if (this.isRedirectToLogin(code)) {
        this.router.navigate(['/authenticate'], {
          state: {
            message: new VueServerMessage(VueServerMessageType.Error, errorMessage)
          }
        });
      } else {
        this.messages = [new VueServerMessage(VueServerMessageType.Error, errorMessage, null, null, null, null, true)];
      }
    }
    static {
      this.ɵfac = function VueForgotPasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueForgotPasswordComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueAuthenticationService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueAccountManagementService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueForgotPasswordComponent,
        selectors: [["vue-forgot-password"]],
        viewQuery: function VueForgotPasswordComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c26, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.initiatePasswordResetForm = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        decls: 29,
        vars: 43,
        consts: [["initiatePasswordResetForm", "ngForm"], ["inputElement", "", "userName", "ngModel"], ["inputElement", "", "siteID", "ngModel"], [3, "previousPageButtonClicked", "pageTitle", "previousPageTitle"], [1, "full-width"], [1, "row"], [1, "panel-container", "col-xs-12", "col-sm-10", "col-sm-push-1"], [3, "messages"], [1, "app-form"], [3, "label", "control", "formError"], ["type", "text", "name", "userName", "required", "", "vueAutofocus", "", 1, "form-control", 3, "ngModelChange", "ngModel"], [3, "primaryButtonClicked", "secondaryButtonClicked", "defaultButtonClicked", "primaryLabel", "secondaryLabel", "defaultLabel", "defaultPosition", "defaultConfirmPlacementOverride"], [3, "label", "control", "i18nBundle", "formError"], ["type", "text", "name", "siteID", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel"]],
        template: function VueForgotPasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "vue-page-header", 3);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵlistener("previousPageButtonClicked", function VueForgotPasswordComponent_Template_vue_page_header_previousPageButtonClicked_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.goToLogin());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6);
            i0.ɵɵelement(8, "vue-server-messages", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 4)(10, "div", 5)(11, "div", 6)(12, "vue-panel")(13, "form", 8, 0)(15, "vue-control-group", 9);
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵpipe(17, "async");
            i0.ɵɵelementStart(18, "input", 10, 1);
            i0.ɵɵtwoWayListener("ngModelChange", function VueForgotPasswordComponent_Template_input_ngModelChange_18_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.inputUserName, $event) || (ctx.inputUserName = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(21, VueForgotPasswordComponent_Conditional_21_Template, 7, 10, "div");
            i0.ɵɵelementStart(22, "vue-form-buttons", 11);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵpipe(24, "async");
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵpipe(26, "async");
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵpipe(28, "async");
            i0.ɵɵlistener("primaryButtonClicked", function VueForgotPasswordComponent_Template_vue_form_buttons_primaryButtonClicked_22_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.resetPassword());
            })("secondaryButtonClicked", function VueForgotPasswordComponent_Template_vue_form_buttons_secondaryButtonClicked_22_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.goToUsernameLookup());
            })("defaultButtonClicked", function VueForgotPasswordComponent_Template_vue_form_buttons_defaultButtonClicked_22_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.cancel());
            });
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            const userName_r5 = i0.ɵɵreference(20);
            i0.ɵɵproperty("pageTitle", i0.ɵɵpipeBind1(2, 16, i0.ɵɵpipeBind2(1, 13, "label.forgotPassword", "PortalBase")))("previousPageTitle", i0.ɵɵpipeBind1(4, 21, i0.ɵɵpipeBind2(3, 18, "title.Login", "PortalBase")));
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(17, 26, i0.ɵɵpipeBind2(16, 23, "field.Username", "PortalBase")))("control", userName_r5)("formError", ctx.formError);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.inputUserName);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.vueAppDefaultsService.getLoginSiteIDRequired() ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(24, 31, i0.ɵɵpipeBind2(23, 28, "label.retrievePassword", "PortalBase")))("secondaryLabel", i0.ɵɵpipeBind1(26, 36, i0.ɵɵpipeBind2(25, 33, "label.forgotUsername", "PortalBase")))("defaultLabel", i0.ɵɵpipeBind1(28, 41, i0.ɵɵpipeBind2(27, 38, "button.cancel", "PortalBase")))("defaultPosition", "btn-left")("defaultConfirmPlacementOverride", "left");
          }
        },
        dependencies: [i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.NgModel, i6.NgForm, VueControlGroupComponent, VueFormButtonsComponent, VuePageHeaderComponent, VuePanelComponent, VueServerMessagesComponent, AutofocusDirective, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VueForgotPasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is for a user to update
 * an expired password after logging in
 *
 * It is normally placed on a route
 * path: 'passwordexpired'
 *
 * and it made to communicate with the login route
 * path: 'authenticate
 *
 */
let VuePasswordExpiredComponent = /*#__PURE__*/(() => {
  class VuePasswordExpiredComponent {
    constructor(router, translationService, accountService, vueAuthenticationService, defaults) {
      this.router = router;
      this.translationService = translationService;
      this.accountService = accountService;
      this.vueAuthenticationService = vueAuthenticationService;
      this.defaults = defaults;
      /**
       * Page level messages displayed to the user
       */
      this.messages = [];
      /**
       * Required rules for the password strength.
       * We currently use default optional rules.
       */
      this.requiredRules = {
        rules: [{
          class: 'validation-disabled',
          label: '',
          labelKey: 'passwordRule.label.minimumLength',
          labelParams: [8],
          order: 1,
          regex: new RegExp('^.{8,}$')
        }]
      };
    }
    /**
     * We setup initial messages and confirm that credentials are found in
     * state
     */
    ngOnInit() {
      this.messages = [new VueServerMessage(VueServerMessageType.Error, this.translationService.getTranslation('PortalBase', 'passwordExpired.pageLevelError'))];
      /**
       * A credentials object (with empty password)
       * needs be handed to this component from the
       * authentication component. If credentials is
       * not passed into route, then we redirect back
       * to login
       */
      if (history.state && history.state.credentials) {
        this.credentials = history.state.credentials;
      } else {
        this.backToLogin();
      }
    }
    /**
     * Returns user to login screen with optional success message.
     *
     * @param showSuccessMessage: boolean
     */
    backToLogin(showSuccessMessage = false) {
      if (showSuccessMessage) {
        const message = this.translationService.getTranslation('PortalBase', 'info.updatePasswordSuccess');
        this.router.navigate(['/authenticate'], {
          state: {
            message: new VueServerMessage(VueServerMessageType.Success, message)
          }
        });
        return;
      }
      this.router.navigate(['/authenticate']);
    }
    /**
     * Cancel button is clicked
     */
    cancel() {
      this.backToLogin();
    }
    passwordInputFormIsValid() {
      return this.passwordInputContainer.passwordResetForm.valid && this.passwordInputContainer.passwordInput.isStrongPassword && this.passwordInputContainer.passwordsMatch;
    }
    /**
     *
     * Save button is clicked. If validation is good then
     * perform update password;
     */
    save() {
      if (this.passwordInputFormIsValid()) {
        this.updatePassword();
        return;
      }
      this.passwordInputContainer.formError.invalidFormSubmit = true;
    }
    /**
     * Make the api call to update password
     */
    updatePassword() {
      this.messages = [];
      this.passwordInputContainer.formError.invalidFormSubmit = false;
      this.accountService.updateExpiredPassword(this.credentials.username, this.passwordInputContainer.passwordInput.newPassword, this.passwordInputContainer.passwordInput.oldPassword, this.credentials.siteId).subscribe(() => this.backToLogin(true), err => this.updateFail(err));
    }
    /**
     * On failed update get error and display to user.
     * @param response HttpErrorResponse
     */
    updateFail(response) {
      const code = response.error[0].code;
      const errorMessage = this.vueAuthenticationService.getErrorMessage(code, [this.defaults.getPortalMessageBundle(), 'CAS']);
      this.messages = [new VueServerMessage({
        messageText: errorMessage,
        scrollIntoView: true,
        type: VueServerMessageType.Error
      })];
    }
    static {
      this.ɵfac = function VuePasswordExpiredComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePasswordExpiredComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueAccountManagementService), i0.ɵɵdirectiveInject(VueAuthenticationService), i0.ɵɵdirectiveInject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePasswordExpiredComponent,
        selectors: [["vue-password-expired"]],
        viewQuery: function VuePasswordExpiredComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c27, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordInputContainer = _t.first);
          }
        },
        standalone: false,
        decls: 22,
        vars: 52,
        consts: [["passwordInputContainer", ""], ["primaryVisible", "false", 3, "previousPageButtonClicked", "pageTitle", "previousPageTitle"], [3, "messages"], [3, "title"], ["inputWidthClass", "wider", 3, "oldPasswordLabel", "newPasswordLabel", "confirmPasswordLabel", "validationRequiredRules", "hasOldPassword", "autofocus"], [3, "secondaryButtonClicked", "primaryButtonClicked", "secondaryLabel", "primaryLabel"]],
        template: function VuePasswordExpiredComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "vue-page-header", 1);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵlistener("previousPageButtonClicked", function VuePasswordExpiredComponent_Template_vue_page_header_previousPageButtonClicked_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.backToLogin());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "vue-server-messages", 2);
            i0.ɵɵelementStart(6, "vue-panel", 3);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelement(9, "vue-password-strength-input", 4, 0);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵpipe(12, "async");
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵpipe(14, "async");
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵpipe(16, "async");
            i0.ɵɵelementStart(17, "vue-form-buttons", 5);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵpipe(19, "async");
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵpipe(21, "async");
            i0.ɵɵlistener("secondaryButtonClicked", function VuePasswordExpiredComponent_Template_vue_form_buttons_secondaryButtonClicked_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.cancel());
            })("primaryButtonClicked", function VuePasswordExpiredComponent_Template_vue_form_buttons_primaryButtonClicked_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.save());
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("pageTitle", i0.ɵɵpipeBind1(2, 15, i0.ɵɵpipeBind2(1, 12, "pageTitle.passwordExpired", "PortalBase")))("previousPageTitle", i0.ɵɵpipeBind1(4, 20, i0.ɵɵpipeBind2(3, 17, "title.Login", "PortalBase")));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance();
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(8, 25, i0.ɵɵpipeBind2(7, 22, "passwordExpired.panelHeading", "PortalBase")));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("oldPasswordLabel", i0.ɵɵpipeBind1(12, 30, i0.ɵɵpipeBind2(11, 27, "passwordTab.currentPasswordLabel", "PortalBase")))("newPasswordLabel", i0.ɵɵpipeBind1(14, 35, i0.ɵɵpipeBind2(13, 32, "passwordTab.newPassword", "PortalBase")))("confirmPasswordLabel", i0.ɵɵpipeBind1(16, 40, i0.ɵɵpipeBind2(15, 37, "passwordTab.reEnterNewPassword", "PortalBase")))("validationRequiredRules", ctx.requiredRules)("hasOldPassword", true)("autofocus", true);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("secondaryLabel", i0.ɵɵpipeBind1(19, 45, i0.ɵɵpipeBind2(18, 42, "button.cancel", "PortalBase")))("primaryLabel", i0.ɵɵpipeBind1(21, 50, i0.ɵɵpipeBind2(20, 47, "button.save", "PortalBase")));
          }
        },
        dependencies: [VueFormButtonsComponent, VuePageHeaderComponent, VuePanelComponent, VueServerMessagesComponent, VuePasswordStrengthInputComponent, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VuePasswordExpiredComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Provides a vertical step / wizard like interface with a counter and
 * customizable content regions that are visible depending
 * on the state of the step. Look at VueStepperComponent
 * or the online Component Tester for more information.
 *
 * Usage
 *
 ```
  <vue-stepper>
    <vue-step heading="Step A">Content A</vue-step>
    <vue-step heading="Step B">Content B</vue-step>
    <vue-step heading="Step C">Content C</vue-step>
  </vue-stepper>
  ```
 *
 * Without vue-stepper
 ```
    <section role="list">
      <vue-step
        number="1"
        heading="Step 1"
        mode="active">
        <p vueStepPendingContent>Content to show when the step is active</p>
        <p vueStepPendingContent>Content to show when the step is pending</p>
        <p vueStepCompleteContent>Content to show when the step is complete</p>
      </vue-step>
    </section>
  ```
 */
let VueStepComponent = /*#__PURE__*/(() => {
  class VueStepComponent {
    constructor() {
      /**
       * The location of this step in the list.
       * DO NOT USE when inside of `vue-stepper`
       */
      this.index = 0;
    }
    /**
     * Readonly: is the current step 'active'
     */
    get isActive() {
      return this.mode === 'active';
    }
    /**
     * Readonly: is the current step 'pending'
     */
    get isPending() {
      return this.mode === 'pending';
    }
    /**
     * Readonly: is the current step complete.
     */
    get isComplete() {
      return this.mode === 'complete';
    }
    static {
      this.ɵfac = function VueStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueStepComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueStepComponent,
        selectors: [["vue-step"]],
        inputs: {
          index: "index",
          heading: "heading",
          mode: "mode"
        },
        standalone: false,
        ngContentSelectors: _c29,
        decls: 14,
        vars: 7,
        consts: [["role", "list-item", 1, "step-header"], [1, "step-number"], [1, "step-name"], ["role", "heading", "aria-level", "2"], [1, "panel-step-content"], [1, "panel", "panel-default"], [1, "panel-body"]],
        template: function VueStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c28);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 2)(5, "span", 3);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "div", 4)(8, "div", 5)(9, "div", 6);
            i0.ɵɵprojection(10);
            i0.ɵɵtemplate(11, VueStepComponent_Conditional_11_Template, 1, 0)(12, VueStepComponent_Conditional_12_Template, 1, 0)(13, VueStepComponent_Conditional_13_Template, 1, 0);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.mode);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.index + 1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.heading);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.isPending ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isActive ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isComplete ? 13 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Provides a container for the vue-step which provides
 * a vertical step / wizard like interface with a counter and
 * customizable content regions that are visible depending
 * on the state of the step.
 *
 * check out the online Component Tester for more information.
 *
 * VF 3.0 Note: discussion should be had to replace with Angular Material
 * stepper. The functionality of the two steppers is somewhat different.
 *
 */
let VueStepperComponent = /*#__PURE__*/(() => {
  class VueStepperComponent {
    constructor() {
      /**
       * The location of the current active step.
       */
      this.activeStepIndex = 0;
    }
    /**
     * On changes we should update the children steps
     */
    ngOnChanges() {
      this.updateSteps();
    }
    /**
     * AfterViewInit we update the steps and then
     * subscribe to changes and recalculate step properties.
     */
    ngAfterViewInit() {
      this.updateSteps();
      this.steps.changes.subscribe(() => {
        this.updateSteps();
      });
    }
    /**
     * Updates the individual step properties
     * such as what number they are and their
     * status based on the activeStepIndex
     */
    updateSteps() {
      setTimeout(() => {
        this.steps.forEach((step, index) => {
          step.index = index;
          if (index < this.activeStepIndex) {
            step.mode = 'complete';
          } else if (index === this.activeStepIndex) {
            step.mode = 'active';
          } else {
            step.mode = 'pending';
          }
        });
      }, 0);
    }
    static {
      this.ɵfac = function VueStepperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueStepperComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueStepperComponent,
        selectors: [["vue-stepper"]],
        contentQueries: function VueStepperComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, VueStepComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.steps = _t);
          }
        },
        inputs: {
          activeStepIndex: "activeStepIndex"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 0,
        consts: [["role", "list", "aria-live", "polite"]],
        template: function VueStepperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return VueStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is used to display, answer and edit
 * users security questions.
 */
let VueSecurityQuestionsComponent = /*#__PURE__*/(() => {
  class VueSecurityQuestionsComponent {
    constructor() {
      /**
       * Questions that should be selected out of a group.
       * Each item in the array represents the questionId
       * of the group corresponding to its index.
       */
      this.selectedQuestions = [];
      /**
       * This is the same as selectedQuestions
       * but holds the value internally.
       */
      this.internalSelectedQuestions = [];
      /**
       * Standard vue form error
       */
      this.formError = new VueFormError();
      /**
       * i18n Bundle
       */
      this.i18nBundle = 'PortalBase';
      /**
       * When the internal form is updated we output it
       * with the selected questionsIds and form status
       */
      this.answered = new EventEmitter();
      /**
       * Answers to security questions stored in an array
       */
      this.answers = [];
      /**
       * Groups used for inputs and static display.
       * This is generated from the questionGroups
       * or questionPromptGroups depending on what is
       * passed in.
       */
      this.groups = [];
    }
    /**
     * In edit mode?
     */
    get isEdit() {
      return this.mode === 'edit';
    }
    /**
     * In view mode?
     */
    get isView() {
      return this.mode === 'view';
    }
    /**
     * In answer mode?
     */
    get isAnswer() {
      return this.mode === 'answer';
    }
    /**
     * When our inputs change we should re-setup
     * our form. If we return to edit, we should
     * clear answers
     * @param changes: Input Changes
     */
    ngOnChanges(changes) {
      this.setupForm(changes.mode && !changes.mode.firstChange && changes.mode.currentValue === 'edit' && changes.mode.previousValue !== 'edit');
    }
    /**
     * Connect to the form and check for changes
     */
    ngAfterViewInit() {
      this.formSub = this.securityQuestionsForm.form.valueChanges.subscribe(() => this.emitChanges());
    }
    ngOnDestroy() {
      this.formSub.unsubscribe();
    }
    /**
     * Emit form status and values to the parent
     */
    emitChanges() {
      setTimeout(() => {
        this.answered.emit({
          answers: this.groups.map((g, i) => {
            return {
              answer: this.answers[i],
              questionId: this.internalSelectedQuestions[i]
            };
          }),
          valid: this.securityQuestionsForm.form.valid
        });
      });
    }
    /**
     * Setup groups based on what is passed into inputs.
     * @param resetAnswers should answers reset
     */
    setupForm(resetAnswers = false) {
      if (resetAnswers) {
        this.answers = [];
      }
      this.internalSelectedQuestions = [...this.selectedQuestions];
      if (this.questionPromptGroups) {
        this.groups = this.questionPromptGroups.map((group, index) => group.questions.filter(q => !this.isEdit && this.internalSelectedQuestions[index] ? q.questionId === this.internalSelectedQuestions[index] : true).map(q => ({
          id: q.questionId,
          text: q.questionText
        })));
      } else if (this.questionGroups) {
        this.groups = this.questionGroups.map((group, index) => group.questions.filter(q => this.internalSelectedQuestions[index] ? q.id === this.internalSelectedQuestions[index] : true).map(q => ({
          id: q.id,
          text: q.question
        })));
      } else {
        this.groups = [];
      }
      /**
       * If we are answering questions and we lack a selected question,
       * it is because we were only provided one question per group and
       * we should pre-selected that
       */
      if (this.mode === 'answer' && !this.internalSelectedQuestions.length) {
        this.internalSelectedQuestions = this.groups.map(g => g[0].id);
      }
    }
    static {
      this.ɵfac = function VueSecurityQuestionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueSecurityQuestionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueSecurityQuestionsComponent,
        selectors: [["vue-security-questions"]],
        viewQuery: function VueSecurityQuestionsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c30, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.securityQuestionsForm = _t.first);
          }
        },
        inputs: {
          mode: "mode",
          questionPromptGroups: "questionPromptGroups",
          questionGroups: "questionGroups",
          selectedQuestions: "selectedQuestions",
          formError: "formError",
          i18nBundle: "i18nBundle"
        },
        outputs: {
          answered: "answered"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 0,
        consts: [["securityQuestionsForm", "ngForm"], ["inputElement", "", "questionDropdownInput", "ngModel"], ["inputElement", "", "securityQuestionInput", "ngModel"], ["novalidate", "", 1, "app-form"], ["widthClass", "widest", 3, "label", "control", "formError"], [1, "form-group", "read-only"], ["required", "", 1, "form-control", 3, "ngModelChange", "vueAutofocus", "name", "ngModel", "id"], [3, "ngValue", "disabled"], [3, "ngValue"], [1, "control-label"], [1, "input-container"], ["autocomplete", "off", "required", "", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "vueAutofocus", "name", "ngModel", "id"]],
        template: function VueSecurityQuestionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 3, 0);
            i0.ɵɵrepeaterCreate(2, VueSecurityQuestionsComponent_For_3_Template, 4, 4, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.groups);
          }
        },
        dependencies: [i6.ɵNgNoValidate, i6.NgSelectOption, i6.ɵNgSelectMultipleOption, i6.DefaultValueAccessor, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.MaxLengthValidator, i6.NgModel, i6.NgForm, VueControlGroupComponent, AutofocusDirective, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VueSecurityQuestionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Handles first time login and account reset
 */
let VueFirstTimeLoginComponent = /*#__PURE__*/(() => {
  class VueFirstTimeLoginComponent {
    constructor(router, route, accountManagementService, translationService, defaultService) {
      this.router = router;
      this.route = route;
      this.accountManagementService = accountManagementService;
      this.translationService = translationService;
      this.defaultService = defaultService;
      /**
       * Page level messages
       */
      this.messages = [];
      /**
       * This is a two step processes. Create questions then
       * create password. Start at index 0 of [0,1]
       */
      this.stepIndex = 0;
      /**
       * This holds the answers to the security questions as they
       * are edited
       */
      this.selectedQuestions = [];
      /**
       * Standard vue form error
       */
      this.formError = new VueFormError();
      /**
       * i18n Bundle
       */
      this.i18nBundle = 'PortalBase';
      /**
       * Required rules for the password strength.
       * We currently use default optional rules.
       */
      this.requiredRules = {
        rules: [{
          class: 'validation-disabled',
          label: '',
          labelKey: 'passwordRule.label.minimumLength',
          labelParams: [8],
          order: 1,
          regex: new RegExp('^.{8,}$')
        }]
      };
      /**
       * Mode for when editing security questions. We switch to
       * 'view' mode after the questions are answered
       */
      this.questionEditMode = 'edit';
      /**
       * If we are re-editing questions
       * (shows different form buttons)
       */
      this.questionsFirstEdit = true;
    }
    /**
     * Runs on initialization. Checks the email link (hash / userId)
     * and returns a list of security questions.
     */
    ngOnInit() {
      const {
        hash,
        userId
      } = this.route.snapshot.params;
      this.hash = hash;
      this.userId = userId;
      this.accountManagementService.validateNewUserEmailAndGetSecurityQuestions(userId, hash).subscribe({
        error: err => this.apiFailure(err),
        next: val => {
          this.questionPromptGroups = val;
        }
      });
    }
    /**
     * Attempts to save the new password
     */
    savePassword() {
      this.formError.invalidFormSubmit = false;
      this.messages = [];
      if (this.passwordInputContainer.checkPasswordStrong()) {
        this.accountManagementService.accountSetupActivate(this.userId, this.hash, this.passwordInputContainer.passwordInput.newPassword, this.securityQuestionAnswers).subscribe({
          error: err => this.apiFailure(err),
          next: () => this.savePasswordSuccess()
        });
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    /**
     * Runs on a successful activation
     */
    savePasswordSuccess() {
      const message = this.translationService.getTranslation(this.defaultService.getPortalMessageBundle(), 'firstTimeLogin.successMessageLoginPage');
      this.router.navigate(['/authenticate'], {
        state: {
          message: new VueServerMessage(VueServerMessageType.Success, message)
        }
      });
    }
    /**
     * Runs whenever we retrieve security questions
     * or activate the user
     * @param response HttpErrorResponse
     */
    apiFailure(response) {
      const errorMessage = this.translationService.getTranslationFromServerCode(response.error[0]);
      this.messages = [new VueServerMessage({
        messageText: errorMessage,
        scrollIntoView: true,
        type: VueServerMessageType.Error
      })];
    }
    /**
     * Runs when we get a new set of answers back from the
     * security question component
     *
     * @param response VueSecurityQuestionFormOutput
     */
    questionsAnswered(response) {
      this.formError.invalidFormSubmit = false;
      if (response.valid) {
        this.temporaryQuestionAnswers = [...response.answers];
      } else {
        this.temporaryQuestionAnswers = null;
      }
    }
    /**
     * runs when then user is done setting security
     * questions
     */
    securityQuestionSubmit() {
      this.messages = [];
      this.formError.invalidFormSubmit = false;
      if (this.temporaryQuestionAnswers) {
        this.stepIndex = 1;
        this.questionEditMode = 'view';
        this.selectedQuestions = this.temporaryQuestionAnswers.map(a => a.questionId);
        this.securityQuestionAnswers = [...this.temporaryQuestionAnswers];
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    /**
     * Used to go back and re-edit
     * questions and answers
     */
    editQuestions() {
      this.stepIndex = 0;
      this.questionEditMode = 'edit';
      this.questionsFirstEdit = false;
      this.temporaryQuestionAnswers = null;
    }
    /**
     * Used to cancel editing of
     * questions after you have gone
     * back
     */
    cancelQuestionEdit() {
      this.stepIndex = 1;
      this.questionEditMode = 'view';
      this.questionsFirstEdit = false;
    }
    static {
      this.ɵfac = function VueFirstTimeLoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueFirstTimeLoginComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(VueAccountManagementService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueFirstTimeLoginComponent,
        selectors: [["vue-first-time-login"]],
        viewQuery: function VueFirstTimeLoginComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c27, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordInputContainer = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        decls: 8,
        vars: 8,
        consts: [["passwordInputContainer", ""], ["primaryVisible", "false", 3, "pageTitle"], [1, "full-width"], [1, "row"], [1, "panel-container", "col-xs-12", "col-sm-10", "col-sm-push-1"], [3, "messages"], [3, "activeStepIndex"], [3, "heading"], [1, "edit-button-container"], [1, "btn", "btn-default", "btn-xs", "edit-questions-button"], [3, "answered", "mode", "questionPromptGroups", "formError", "selectedQuestions", "i18nBundle"], ["vueStepPendingContent", ""], [1, "password-pending-text"], ["vueStepActiveContent", ""], ["inputWidthClass", "wider", 3, "newPasswordLabel", "confirmPasswordLabel", "validationRequiredRules", "hasOldPassword", "formError", "autofocus"], [3, "primaryButtonClicked", "primaryLabel"], [1, "btn", "btn-default", "btn-xs", "edit-questions-button", 3, "click"], [3, "primaryLabel"], ["defaultPosition", "btn-left", 3, "primaryLabel", "defaultLabel"], ["defaultPosition", "btn-left", 3, "primaryButtonClicked", "defaultButtonClicked", "primaryLabel", "defaultLabel"]],
        template: function VueFirstTimeLoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "vue-page-header", 1);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "div", 4);
            i0.ɵɵelement(6, "vue-server-messages", 5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(7, VueFirstTimeLoginComponent_Conditional_7_Template, 29, 48, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("pageTitle", i0.ɵɵpipeBind1(2, 6, i0.ɵɵpipeBind2(1, 3, "label.accountSetUp", ctx.i18nBundle)));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.questionPromptGroups ? 7 : -1);
          }
        },
        dependencies: [VueFormButtonsComponent, VuePageHeaderComponent, VueServerMessagesComponent, VuePasswordStrengthInputComponent, VueStepComponent, VueStepperComponent, VueSecurityQuestionsComponent, i2.AsyncPipe, VueTranslatePipe],
        styles: [".password-pending-text[_ngcontent-%COMP%]{text-align:center}.edit-button-container[_ngcontent-%COMP%]{text-align:end}"]
      });
    }
  }
  return VueFirstTimeLoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This is the standard email regex that is currently being used across
 * pearson apps.
 */
const VUE_EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

/**
 * This component is specific to portals (Connect and Navigator)
 * to initiate and then display person username if they forget it.
 */
/** @dynamic */
let VueUsernameLookupComponent = /*#__PURE__*/(() => {
  class VueUsernameLookupComponent {
    constructor(router, accountManagementService, translationService, defaultService, forgotCreds) {
      this.router = router;
      this.accountManagementService = accountManagementService;
      this.translationService = translationService;
      this.defaultService = defaultService;
      this.forgotCreds = forgotCreds;
      /**
       * i18n Bundle
       */
      this.i18nBundle = 'PortalBase';
      /**
       * Standard vue form error
       */
      this.formError = new VueFormError();
      /**
       * This is a two step processes. Verify user
       * then answer security questions. Start index 0 of [0,1]
       */
      this.stepIndex = 0;
      /**
       * Object to hold the verify details
       */
      this.verifyDetails = {
        email: null,
        firstName: null,
        lastName: null,
        siteID: null,
        siteIDRequired: null
      };
      /**
       * Page level messages
       */
      this.messages = [];
      /**
       * Regex email validation pattern
       */
      this.emailRegex = VUE_EMAIL_REGEX;
      this.verifyDetails.siteIDRequired = this.defaultService.getLoginSiteIDRequired();
    }
    /**
     * Call the api to verify user details.
     */
    verifyUser() {
      this.formError.invalidFormSubmit = false;
      this.messages = [];
      if (this.verifyUserForm.form.valid) {
        this.accountManagementService.validateUserAndGetSecurityQuestions(this.verifyDetails.firstName, this.verifyDetails.lastName, this.verifyDetails.email, this.verifyDetails.siteID).subscribe({
          error: err => this.apiFailure(err),
          next: resp => this.verifyUserSuccess(resp)
        });
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    /**
     * Users details have been successfully verified.
     * @param resp: VueSecurityQuestionPromptGroup[]
     */
    verifyUserSuccess(resp) {
      this.questionPromptGroups = resp;
      this.stepIndex = 1;
    }
    /**
     * Calls the API to verify security question answers and
     * return the username
     */
    verifySecurityQuestions() {
      this.formError.invalidFormSubmit = false;
      this.messages = [];
      if (this.securityQuestionAnswers) {
        this.accountManagementService.forgotUsernameLookup(this.verifyDetails, this.securityQuestionAnswers).subscribe({
          error: err => this.apiFailure(err),
          next: username => this.verifySecurityQuestionsSuccess(username)
        });
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    /**
     * Called after the users successfully answered security questions
     * and redirects them to the login page showing them their
     * username
     *
     * @param username string
     */
    verifySecurityQuestionsSuccess(username) {
      const message = this.translationService.getTranslation(this.i18nBundle, 'info.usernameLookup', [username]);
      this.router.navigate(['/authenticate'], {
        state: {
          message: new VueServerMessage(VueServerMessageType.Success, message)
        }
      });
    }
    /**
     * Runs whenever we retrieve security questions
     * or activate the user
     * @param response HttpErrorResponse
     */
    apiFailure(response) {
      const code = response.error[0];
      const errorMessage = this.translationService.getTranslationFromServerCode(code);
      this.messages = [new VueServerMessage({
        messageText: errorMessage,
        scrollIntoView: true,
        type: VueServerMessageType.Error
      })];
    }
    /**
     * Return to login
     */
    backToLogin() {
      this.router.navigate(['/authenticate']);
    }
    /**
     * Runs when we get a new set of answers return from the
     * security question component
     *
     * @param response VueSecurityQuestionFormOutput
     */
    questionsAnswered(response) {
      this.formError.invalidFormSubmit = false;
      if (response.valid) {
        this.securityQuestionAnswers = response.answers;
      } else {
        this.securityQuestionAnswers = null;
      }
    }
    /**
     * Navigate to forgot password
     */
    forgotPassword() {
      this.forgotCreds.forgotPassword();
    }
    static {
      this.ɵfac = function VueUsernameLookupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueUsernameLookupComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(VueAccountManagementService), i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(VueAppDefaultsService), i0.ɵɵdirectiveInject(VueForgotCredentialsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueUsernameLookupComponent,
        selectors: [["vue-username-lookup"]],
        viewQuery: function VueUsernameLookupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.verifyUserForm = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        decls: 103,
        vars: 125,
        consts: [["verifyUserForm", "ngForm"], ["inputElement", "", "firstNameInput", "ngModel"], ["inputElement", "", "lastNameInput", "ngModel"], ["inputElement", "", "emailInput", "ngModel"], ["inputElement", "", "siteIdInput", "ngModel"], [3, "previousPageButtonClicked", "pageTitle", "previousPageTitle"], ["id", "usernameLookupMessages", 1, "full-width"], [1, "row"], [1, "panel-container", "col-xs-12", "col-sm-10", "col-sm-push-1"], [3, "messages"], [1, "full-width"], [3, "activeStepIndex"], [3, "heading"], ["vueStepActiveContent", ""], ["novalidate", "", 1, "app-form"], ["widthClass", "widest", 3, "label", "control", "formError"], ["autocomplete", "off", "vueAutofocus", "", "name", "firstNameInput", "required", "", "id", "firstNameInput", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "ngModel"], ["autocomplete", "off", "name", "lastNameInput", "required", "", "id", "lastNameInput", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "ngModel"], ["autocomplete", "off", "type", "email", "name", "emailInput", "required", "", "id", "emailInput", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "ngModel", "pattern"], ["autocomplete", "off", "name", "siteIdInput", "required", "", "id", "siteIdInput", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "ngModel"], [3, "primaryButtonClicked", "primaryLabel"], ["vueStepCompleteContent", ""], [1, "form-group", "read-only"], [1, "control-label"], [1, "input-container"], ["vueStepPendingContent", ""], [1, "empty-state"], ["mode", "answer", 3, "answered", "questionPromptGroups", "formError", "i18nBundle"], ["role", "menu"], [1, "panel-step-content"], [1, "panel", "panel-default"], [1, "panel-body"], ["standalone", "true", "defaultPosition", "btn-left", 3, "primaryButtonClicked", "secondaryButtonClicked", "defaultButtonClicked", "primaryLabel", "primaryVisible", "secondaryLabel", "defaultLabel"]],
        template: function VueUsernameLookupComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "vue-page-header", 5);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵlistener("previousPageButtonClicked", function VueUsernameLookupComponent_Template_vue_page_header_previousPageButtonClicked_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.backToLogin());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 6)(6, "div", 7)(7, "div", 8);
            i0.ɵɵelement(8, "vue-server-messages", 9);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 10)(10, "div", 7)(11, "div", 8)(12, "vue-stepper", 11)(13, "vue-step", 12);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵpipe(15, "async");
            i0.ɵɵelementContainerStart(16, 13);
            i0.ɵɵelementStart(17, "form", 14, 0)(19, "vue-control-group", 15);
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵpipe(21, "async");
            i0.ɵɵelementStart(22, "input", 16, 1);
            i0.ɵɵtwoWayListener("ngModelChange", function VueUsernameLookupComponent_Template_input_ngModelChange_22_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.verifyDetails.firstName, $event) || (ctx.verifyDetails.firstName = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "vue-control-group", 15);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵpipe(27, "async");
            i0.ɵɵelementStart(28, "input", 17, 2);
            i0.ɵɵtwoWayListener("ngModelChange", function VueUsernameLookupComponent_Template_input_ngModelChange_28_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.verifyDetails.lastName, $event) || (ctx.verifyDetails.lastName = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "vue-control-group", 15);
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵpipe(33, "async");
            i0.ɵɵelementStart(34, "input", 18, 3);
            i0.ɵɵtwoWayListener("ngModelChange", function VueUsernameLookupComponent_Template_input_ngModelChange_34_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.verifyDetails.email, $event) || (ctx.verifyDetails.email = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "vue-control-group", 15);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵpipe(39, "async");
            i0.ɵɵelementStart(40, "input", 19, 4);
            i0.ɵɵtwoWayListener("ngModelChange", function VueUsernameLookupComponent_Template_input_ngModelChange_40_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.verifyDetails.siteID, $event) || (ctx.verifyDetails.siteID = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(43, "vue-form-buttons", 20);
            i0.ɵɵpipe(44, "translate");
            i0.ɵɵpipe(45, "async");
            i0.ɵɵlistener("primaryButtonClicked", function VueUsernameLookupComponent_Template_vue_form_buttons_primaryButtonClicked_43_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.verifyUser());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(46, 21);
            i0.ɵɵelementStart(47, "div", 22)(48, "label", 23);
            i0.ɵɵtext(49);
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵpipe(51, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "div", 24)(53, "span");
            i0.ɵɵtext(54);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(55, "div", 22)(56, "label", 23);
            i0.ɵɵtext(57);
            i0.ɵɵpipe(58, "translate");
            i0.ɵɵpipe(59, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(60, "div", 24)(61, "span");
            i0.ɵɵtext(62);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(63, "div", 22)(64, "label", 23);
            i0.ɵɵtext(65);
            i0.ɵɵpipe(66, "translate");
            i0.ɵɵpipe(67, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(68, "div", 24)(69, "span");
            i0.ɵɵtext(70);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(71, "div", 22)(72, "label", 23);
            i0.ɵɵtext(73);
            i0.ɵɵpipe(74, "translate");
            i0.ɵɵpipe(75, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(76, "div", 24)(77, "span");
            i0.ɵɵtext(78);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "vue-step", 12);
            i0.ɵɵpipe(80, "translate");
            i0.ɵɵpipe(81, "async");
            i0.ɵɵelementStart(82, "div", 25)(83, "p", 26);
            i0.ɵɵtext(84);
            i0.ɵɵpipe(85, "translate");
            i0.ɵɵpipe(86, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementContainerStart(87, 13);
            i0.ɵɵelementStart(88, "vue-security-questions", 27);
            i0.ɵɵlistener("answered", function VueUsernameLookupComponent_Template_vue_security_questions_answered_88_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.questionsAnswered($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(89, "div", 10)(90, "div", 7)(91, "div", 8)(92, "section", 28)(93, "div", 29)(94, "div", 30)(95, "div", 31)(96, "vue-form-buttons", 32);
            i0.ɵɵpipe(97, "translate");
            i0.ɵɵpipe(98, "async");
            i0.ɵɵpipe(99, "translate");
            i0.ɵɵpipe(100, "async");
            i0.ɵɵpipe(101, "translate");
            i0.ɵɵpipe(102, "async");
            i0.ɵɵlistener("primaryButtonClicked", function VueUsernameLookupComponent_Template_vue_form_buttons_primaryButtonClicked_96_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.verifySecurityQuestions());
            })("secondaryButtonClicked", function VueUsernameLookupComponent_Template_vue_form_buttons_secondaryButtonClicked_96_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.forgotPassword());
            })("defaultButtonClicked", function VueUsernameLookupComponent_Template_vue_form_buttons_defaultButtonClicked_96_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.backToLogin());
            });
            i0.ɵɵelementEnd()()()()()()()()();
          }
          if (rf & 2) {
            const firstNameInput_r2 = i0.ɵɵreference(24);
            const lastNameInput_r3 = i0.ɵɵreference(30);
            const emailInput_r4 = i0.ɵɵreference(36);
            const siteIdInput_r5 = i0.ɵɵreference(42);
            i0.ɵɵproperty("pageTitle", i0.ɵɵpipeBind1(2, 43, i0.ɵɵpipeBind2(1, 40, "label.retrieveUsername", ctx.i18nBundle)))("previousPageTitle", i0.ɵɵpipeBind1(4, 48, i0.ɵɵpipeBind2(3, 45, "title.Login", ctx.i18nBundle)));
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("activeStepIndex", ctx.stepIndex);
            i0.ɵɵadvance();
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(15, 53, i0.ɵɵpipeBind2(14, 50, "usernameLookup.group1Heading", ctx.i18nBundle)));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 58, i0.ɵɵpipeBind2(20, 55, "field.firstName", ctx.i18nBundle)))("control", firstNameInput_r2)("formError", ctx.formError);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.verifyDetails.firstName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(27, 63, i0.ɵɵpipeBind2(26, 60, "field.lastName", ctx.i18nBundle)))("control", lastNameInput_r3)("formError", ctx.formError);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.verifyDetails.lastName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(33, 68, i0.ɵɵpipeBind2(32, 65, "field.email", ctx.i18nBundle)))("control", emailInput_r4)("formError", ctx.formError);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.verifyDetails.email);
            i0.ɵɵproperty("pattern", ctx.emailRegex);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(39, 73, i0.ɵɵpipeBind2(38, 70, "field.SiteID", ctx.i18nBundle)))("control", siteIdInput_r5)("formError", ctx.formError);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.verifyDetails.siteID);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(45, 78, i0.ɵɵpipeBind2(44, 75, "button.Verify", ctx.i18nBundle)));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(51, 83, i0.ɵɵpipeBind2(50, 80, "field.firstName", ctx.i18nBundle)), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.verifyDetails.firstName);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(59, 88, i0.ɵɵpipeBind2(58, 85, "field.lastName", ctx.i18nBundle)), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.verifyDetails.lastName);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(67, 93, i0.ɵɵpipeBind2(66, 90, "field.email", ctx.i18nBundle)), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.verifyDetails.email);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(75, 98, i0.ɵɵpipeBind2(74, 95, "field.SiteID", ctx.i18nBundle)), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.verifyDetails.siteID);
            i0.ɵɵadvance();
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(81, 103, i0.ɵɵpipeBind2(80, 100, "groupHeader.answerSecurityQuestions", ctx.i18nBundle)));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(86, 108, i0.ɵɵpipeBind2(85, 105, "usernameLookup.section2.emptyStateMessage", ctx.i18nBundle)), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("questionPromptGroups", ctx.questionPromptGroups)("formError", ctx.formError)("i18nBundle", ctx.i18nBundle);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("primaryLabel", i0.ɵɵpipeBind1(98, 113, i0.ɵɵpipeBind2(97, 110, "label.submit", ctx.i18nBundle)))("primaryVisible", ctx.stepIndex === 1)("secondaryLabel", i0.ɵɵpipeBind1(100, 118, i0.ɵɵpipeBind2(99, 115, "label.forgotPassword", ctx.i18nBundle)))("defaultLabel", i0.ɵɵpipeBind1(102, 123, i0.ɵɵpipeBind2(101, 120, "label.cancel", ctx.i18nBundle)));
          }
        },
        dependencies: [i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.MaxLengthValidator, i6.PatternValidator, i6.NgModel, i6.NgForm, VueControlGroupComponent, VueFormButtonsComponent, VuePageHeaderComponent, VueServerMessagesComponent, VueStepComponent, VueStepperComponent, VueSecurityQuestionsComponent, AutofocusDirective, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VueUsernameLookupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This component is for a user to change
 * their password
 *
 * It is normally placed on a route
 * path: 'changePassword/:userID/:hash'
 *
 * and it made to communicate with the login route
 * path: 'authenticate
 *
 *
 */
let VueChangePasswordComponent = /*#__PURE__*/(() => {
  class VueChangePasswordComponent {
    constructor(accountService, router, activatedRoute, vueTranslationService) {
      this.accountService = accountService;
      this.router = router;
      this.activatedRoute = activatedRoute;
      this.vueTranslationService = vueTranslationService;
      /**
       * Standard vue form error
       */
      this.formError = new VueFormError();
      /**
       * i18n Bundle
       */
      this.i18nBundle = 'PortalBase';
      /**
       * Page level messages displayed to the user
       */
      this.messages = [];
      /**
       * Required rules for the password strength.
       * We currently use default optional rules.
       */
      this.requiredRules = {
        rules: [{
          class: 'validation-disabled',
          label: '',
          labelKey: 'passwordRule.label.minimumLength',
          labelParams: [8],
          order: 1,
          regex: new RegExp('^.{8,}$')
        }]
      };
      /**
       * This holds the answers to the security questions provided
       * by the user
       */
      this.securityQuestionAnswers = [];
    }
    /**
     * Runs whenever we retrieve security questions
     * or activate the user
     * @param response HttpErrorResponse
     */
    apiFailure(response) {
      const errorMessage = this.vueTranslationService.getTranslationFromServerCode(response.error[0]);
      this.messages = [new VueServerMessage(VueServerMessageType.Error, errorMessage, false, null, false, true, true)];
    }
    isPasswordInputContainerValid() {
      return this.passwordInputContainer.passwordResetForm.valid && this.passwordInputContainer.passwordInput.isStrongPassword && this.passwordInputContainer.passwordsMatch;
    }
    /**
     * Calls service to change password once user
     * inputs a strong password
     */
    changePassword() {
      this.messages = [];
      this.formError.invalidFormSubmit = false;
      if (this.isPasswordInputContainerValid()) {
        this.accountService.forgotPasswordUpdatePassword(this.userID, this.hash, this.passwordInputContainer.passwordInput.newPassword, this.securityQuestionAnswers).subscribe({
          error: err => this.apiFailure(err),
          next: () => this.changePasswordSuccess()
        });
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    /**
     * Navigates back to the Login Page with success message
     */
    changePasswordSuccess() {
      const message = this.vueTranslationService.getTranslation(this.i18nBundle, 'changePassword.successMessageLoginPage');
      this.router.navigate(['/authenticate'], {
        state: {
          message: new VueServerMessage(VueServerMessageType.Success, message)
        }
      });
    }
    ngOnInit() {
      const {
        userID,
        hash
      } = this.activatedRoute.snapshot.params;
      this.userID = userID;
      this.hash = hash;
      this.verified = false;
      this.securityQuestionMode = 'answer';
      this.activeStepIndex = 0;
      this.securityQuestionAnswers = null;
      this.accountService.forgotPasswordGetSecurityQuestions(this.userID, this.hash).subscribe({
        error: err => {
          this.apiFailure(err);
        },
        next: data => {
          this.questionPromptGroup = data;
          this.validLink = true;
        }
      });
    }
    /**
     * Event handler for security question input
     * @param formOutput - output of form
     */
    onAnswer(formOutput) {
      this.formError.invalidFormSubmit = false;
      if (formOutput.valid && !this.verified) {
        this.securityQuestionAnswers = formOutput.answers;
      }
    }
    /**
     * Verifies security question answers
     */
    verifyQuestionAnswers() {
      this.messages = [];
      this.formError.invalidFormSubmit = false;
      if (this.securityQuestionAnswers !== null) {
        this.accountService.forgotPasswordVerifyQuestionAnswers(this.userID, this.hash, this.securityQuestionAnswers).subscribe({
          error: err => {
            this.apiFailure(err);
            this.formError.invalidFormSubmit = true;
          },
          next: () => {
            this.verified = true;
            this.activeStepIndex = 1;
            this.securityQuestionMode = 'view';
          }
        });
      } else {
        this.formError.invalidFormSubmit = true;
      }
    }
    static {
      this.ɵfac = function VueChangePasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueChangePasswordComponent)(i0.ɵɵdirectiveInject(VueAccountManagementService), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueChangePasswordComponent,
        selectors: [["vue-change-password"]],
        viewQuery: function VueChangePasswordComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c27, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordInputContainer = _t.first);
          }
        },
        inputs: {
          i18nBundle: "i18nBundle"
        },
        standalone: false,
        decls: 9,
        vars: 8,
        consts: [["passwordInputContainer", ""], [3, "pageTitle"], [1, "full-width"], [1, "row"], [1, "panel-container", "col-xs=12", "col-sm-10", "col-sm-push-1"], [3, "messages"], [3, "activeStepIndex"], [3, "heading"], [1, "empty-state"], [3, "answered", "mode", "questionPromptGroups", "formError"], [3, "primaryLabel"], [3, "primaryButtonClicked", "primaryLabel"], ["inputWidthClass", "wider", 3, "newPasswordLabel", "confirmPasswordLabel", "validationRequiredRules", "hasOldPassword", "formError", "autofocus"]],
        template: function VueChangePasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵelement(1, "vue-page-header", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "div", 4);
            i0.ɵɵelement(7, "vue-server-messages", 5);
            i0.ɵɵtemplate(8, VueChangePasswordComponent_Conditional_8_Template, 11, 16, "div");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("pageTitle", i0.ɵɵpipeBind1(3, 6, i0.ɵɵpipeBind2(2, 3, "label.passwordReset.changePassword", ctx.i18nBundle)));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("messages", ctx.messages);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.validLink ? 8 : -1);
          }
        },
        dependencies: [VueFormButtonsComponent, VuePageHeaderComponent, VueServerMessagesComponent, VuePasswordStrengthInputComponent, VueStepComponent, VueStepperComponent, VueSecurityQuestionsComponent, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VueChangePasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 *
 * This is a pure component for selecting a locale.
 * It was created to separate logic from UX because
 * the current locale selector is too tied up
 * in services to be effectively modified without
 * risking breaking other apps.
 *
 * Its use case is for Portals so it will be used
 * in the AppComponent like the following example.
 *
 ```typescript
  <vue-login-header [hideLocaleSelect]="true" [transclude]="true">
    <vue-portal-locale-selector
      [locales]="localeOptions"
      [selected]="currentlySelectedLocale"
      (localeChange)="localeChanged($event)"></vue-portal-locale-selector>
  </vue-login-header>
  <vue-navigation></vue-navigation>
  <vue-cookie-policy></vue-cookie-policy>
  <div id="main-content" class="" vueMainContent>
    <vue-loading-indicator [loadingText]="'label.loading' | translate:'PortalBase' | async "></vue-loading-indicator>
    <vue-confirm-lose-changes-dialog></vue-confirm-lose-changes-dialog>
    <vue-timeout-dialog></vue-timeout-dialog>
    <div class="app-wrapper">
      <div class="app-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <vue-footer></vue-footer>
```
 */
let VuePortalLocaleSelectorComponent = /*#__PURE__*/(() => {
  class VuePortalLocaleSelectorComponent {
    /**
     * Builds the modal component and import dependencies.
     *
     * @param vueTranslationService service in charge of translating labels.
     */
    constructor(vueTranslationService) {
      this.vueTranslationService = vueTranslationService;
      /**
       * List of options to choose from
       */
      this.locales = [];
      /**
       * Translation key for the language selection aria-label
       * Only used if `i18nLabel` is set.
       *
       * Defaults to 'label.selectLanguageAriaLabel'
       */
      this.selectLanguageAriaLabelKey = 'label.selectLanguageAriaLabel';
      /**
       * Label for the locale selection aria-label.
       *
       * Defaults to 'Select language'
       */
      this.selectLanguageAriaLabel = 'Select language';
      /**
       * Emitted when locale has changed.
       */
      this.localeChange = new EventEmitter();
      this.vueTranslationService = vueTranslationService;
    }
    /**
     * Compare function for the locale
     * selector. Used so the selector
     * knows how to identify the selected
     * value
     *
     * @param a Locale
     * @param b Locale
     * @returns boolean
     */
    compareFnc(a, b) {
      return a && b && a.code === b.code;
    }
    /**
     * Returns language selection aria-label
     *
     * @returns string value of the label.
     */
    getSelectLanguageLabel() {
      if (this.i18nBundle && this.selectLanguageAriaLabelKey) {
        return this.vueTranslationService.getTranslation(this.i18nBundle, this.selectLanguageAriaLabelKey);
      }
      return this.selectLanguageAriaLabel;
    }
    static {
      this.ɵfac = function VuePortalLocaleSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePortalLocaleSelectorComponent)(i0.ɵɵdirectiveInject(VueTranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePortalLocaleSelectorComponent,
        selectors: [["vue-portal-locale-selector"]],
        inputs: {
          locales: "locales",
          selected: "selected",
          selectLanguageAriaLabelKey: "selectLanguageAriaLabelKey",
          selectLanguageAriaLabel: "selectLanguageAriaLabel",
          i18nBundle: "i18nBundle"
        },
        outputs: {
          localeChange: "localeChange"
        },
        standalone: false,
        decls: 5,
        vars: 3,
        consts: [["icon", "globe-americas", 1, "fa", "fa-fw"], [1, "custom-dropdown"], [1, "form-control", 3, "ngModelChange", "ngModel", "compareWith"], [3, "ngValue"]],
        template: function VuePortalLocaleSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "fa-icon", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "select", 2);
            i0.ɵɵlistener("ngModelChange", function VuePortalLocaleSelectorComponent_Template_select_ngModelChange_2_listener($event) {
              return ctx.localeChange.emit($event);
            });
            i0.ɵɵrepeaterCreate(3, VuePortalLocaleSelectorComponent_For_4_Template, 2, 3, "option", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.selected)("compareWith", ctx.compareFnc);
            i0.ɵɵattribute("aria-label", ctx.getSelectLanguageLabel());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.locales);
          }
        },
        dependencies: [i6.NgSelectOption, i6.ɵNgSelectMultipleOption, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgModel, i1$2.FaIconComponent],
        styles: ["[_nghost-%COMP%]{height:50px;padding:8px 20px;display:flex;align-items:center}select[_ngcontent-%COMP%]{height:34px;width:200px;text-indent:.01px;padding:3px 7px;padding-inline-end:30px!important;line-height:20px;box-shadow:none;margin-inline-start:10px}fa-icon[_ngcontent-%COMP%]{font-size:20px;color:#333}"]
      });
    }
  }
  return VuePortalLocaleSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueExternalApplicationComponent = /*#__PURE__*/(() => {
  class VueExternalApplicationComponent {
    constructor(vueUserSessionService, vueSessionCookieService, vuePortalService, router, route) {
      this.vueUserSessionService = vueUserSessionService;
      this.vueSessionCookieService = vueSessionCookieService;
      this.vuePortalService = vuePortalService;
      this.router = router;
      this.route = route;
      /**
       * The path where the application should redirect to
       * if the targetUrl is absent for the selected application
       */
      this.pleaseSelectRoute = 'pleaseSelect';
    }
    ngOnInit() {
      this.translationBundle = this.route.snapshot.data.translationBundle;
      this.initialize();
      this.checkTargetUrl();
      this.checkTargetUrlForClientID();
    }
    /**
     * Method to redirect the user to the selected external
     * application if the user is authenticated
     */
    openApplication() {
      const ssoRequest = {
        applicationId: this.applicationId,
        clientId: this.clientId,
        refreshToken: this.vueUserSessionService.getRefreshToken(),
        targetUrl: this.targetUrl
      };
      this.vuePortalService.ssoInternalLogin(ssoRequest).subscribe({
        error: () => {
          this.router.navigateByUrl('authenticate');
        },
        next: () => {
          const target = this.application.externalAppLaunchSameTab ? '_self' : 'externalApp' + this.applicationId;
          this.win = window.open(this.targetUrl, target);
          // This is not required but implemented to maintain backward compatibility with AngularJs commons
          this.win.sessionStorage.clear();
          this.win.focus();
        }
      });
    }
    /**
     * Get the application and client details for payload construction
     */
    initialize() {
      this.clientId = this.vueUserSessionService.getClientId();
      this.application = this.vueUserSessionService.getSelectedApplication();
      if (this.application) {
        this.applicationId = this.application.id;
        this.targetUrl = this.application.externalAppLaunchURL;
      }
    }
    /**
     * Check the target url and add the client Id to the url
     */
    checkTargetUrlForClientID() {
      if (this.targetUrl) {
        if (this.targetUrl.includes(':clientID') && this.clientId) {
          this.targetUrl = this.targetUrl.replace(':clientID', this.clientId);
        }
      }
    }
    /**
     * Checks the target url and reroutes if it is null
     */
    checkTargetUrl() {
      if (!this.targetUrl) {
        this.router.navigateByUrl(this.pleaseSelectRoute);
      }
    }
    static {
      this.ɵfac = function VueExternalApplicationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueExternalApplicationComponent)(i0.ɵɵdirectiveInject(VueUserSessionService), i0.ɵɵdirectiveInject(VueSessionCookieService), i0.ɵɵdirectiveInject(VuePortalService), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueExternalApplicationComponent,
        selectors: [["vue-external-application"]],
        standalone: false,
        decls: 7,
        vars: 12,
        consts: [[2, "text-align", "center", "margin", "15px", 3, "title"], [1, "btn", "btn-primary", "btn-center", 3, "click"]],
        template: function VueExternalApplicationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "vue-panel", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementStart(3, "button", 1);
            i0.ɵɵlistener("click", function VueExternalApplicationComponent_Template_button_click_3_listener() {
              return ctx.openApplication();
            });
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "async");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind2(1, 2, "message.ExternalApp", ctx.translationBundle)));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 10, i0.ɵɵpipeBind2(5, 7, "button.ExternalApp", ctx.translationBundle)));
          }
        },
        dependencies: [VuePanelComponent, i2.AsyncPipe, VueTranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VueExternalApplicationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VueExternalApplicationLogoutComponent = /*#__PURE__*/(() => {
  class VueExternalApplicationLogoutComponent {
    constructor(vueTranslationService, route) {
      this.vueTranslationService = vueTranslationService;
      this.route = route;
    }
    ngOnInit() {
      this.translationBundle = this.route.snapshot.data.translationBundle;
      this.setDisplayMessageByEvent();
    }
    /**
     * Translates the display message based on the event
     */
    setDisplayMessageByEvent() {
      const routeParameters = this.route.snapshot.queryParams;
      if (routeParameters.event && routeParameters.event === 'logout' && routeParameters.appName) {
        this.displayMessage = this.vueTranslationService.getTranslation(this.translationBundle, 'message.ExternalAppLogout', [routeParameters.appName]);
      } else if (routeParameters.event && routeParameters.event === 'timeout' && routeParameters.appName) {
        this.displayMessage = this.vueTranslationService.getTranslation(this.translationBundle, 'message.ExternalAppTimeout', [routeParameters.appName]);
      } else {
        this.displayMessage = this.vueTranslationService.getTranslation(this.translationBundle, 'message.ExternalAppLogoutDefault');
      }
    }
    static {
      this.ɵfac = function VueExternalApplicationLogoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueExternalApplicationLogoutComponent)(i0.ɵɵdirectiveInject(VueTranslationService), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueExternalApplicationLogoutComponent,
        selectors: [["vue-external-application-logout"]],
        standalone: false,
        decls: 3,
        vars: 1,
        consts: [[1, "well", "col-lg-6", "col-lg-offset-3"]],
        template: function VueExternalApplicationLogoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.displayMessage);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueExternalApplicationLogoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any, valid-jsdoc */
/**
 * This class has a series of methods that a project can choose to use or not as their needs fit.
 * It is intended to set up everything needed for "core" application startup but a project can use one of the isolation
 * methods. In vue commons, this was effective core.js. An improvement on previous version is a project can pick and
 * choose what they want to bootstrap: for everything use `performFullBootstrap()`.
 */
let VueApplicationBootstrapService = /*#__PURE__*/(() => {
  class VueApplicationBootstrapService {
    /**
     * Constructor with all necessary services being injected.
     *
     * @param router
     * @param vueConfirmLoseChangesService
     * @param vueJavascriptUtilityService
     * @param vueNavigationService
     * @param vueSessionCookieService
     * @param vueTimeoutService
     * @param vueUserSessionService
     */
    constructor(router, vueConfirmLoseChangesService, vueJavascriptUtilityService, vueNavigationService, vueSessionCookieService, vueTimeoutService, vueUserSessionService, vueWindow) {
      this.router = router;
      this.vueConfirmLoseChangesService = vueConfirmLoseChangesService;
      this.vueJavascriptUtilityService = vueJavascriptUtilityService;
      this.vueNavigationService = vueNavigationService;
      this.vueSessionCookieService = vueSessionCookieService;
      this.vueTimeoutService = vueTimeoutService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueWindow = vueWindow;
    }
    /**
     * Called by subscription when user logs out of navigation.
     *
     * Destroys the session, and navigates to log off URL.
     */
    logoff() {
      this.sessionDestroy();
      this.vueConfirmLoseChangesService.setOverrideGuardOn();
      this.vueNavigationService.changeCurrentMenuStateClosed();
      this.navigateToLogoffURL(false, this.vueUserSessionService.getBrandingClientCode());
    }
    /**
     * Navigates to the log off URL.
     *
     * @param timeout whether the user session timed out
     * @param brandingClientCode the optional branding code for the current client
     */
    navigateToLogoffURL(timeout, brandingClientCode) {
      // strips off any query params
      const currentURL = this.vueWindow.location.href.split('?')[0];
      // null
      const logoutURL = this.vueUserSessionService.getPortalLogoutURL();
      // Only need to go to logout url if we're not already there and not already in the portal
      if (logoutURL && currentURL !== logoutURL && !this.vueJavascriptUtilityService.isURLInCurrentApp(logoutURL)) {
        this.vueWindow.location.assign(this.createLogoutUrlWithParams(logoutURL, timeout, brandingClientCode));
      } else {
        const params = this.createLogoffStateParams(timeout, brandingClientCode);
        this.router.navigate(['authenticate'], {
          queryParams: params
        });
      }
    }
    /**
     * When using all the services, sets up all listeners.
     */
    performFullBootstrap() {
      if (this.vueSessionCookieService.isHydrateSessionFromCookiesNeeded()) {
        this.vueSessionCookieService.hydrateSessionFromCookieValues(null);
      }
      this.reestablishSessionFromSessionStorageIfPossible();
      if (!this.vueUserSessionService.isUserAuthenticated()) {
        /**
         * Removed this as part of the bootstrap process.
         * So we can deep link into un-authenticated routes.
         *
         * It would be the AuthChecker guard's responsibility
         * to redirect if the user is not authenticated on
         * an authenticated route.
         */
        // this.routeUnauthenticatedUsers();
      } else {
        this.vueTimeoutService.startIdleTimer();
      }
      this.vueTimeoutService.getTimedOutState().subscribe(state => {
        if (state) {
          // User timed out
          this.timeoutLogoff();
        }
      });
      this.vueNavigationService.getLogoffState().subscribe(state => {
        if (state) {
          // User logged out
          this.logoff();
        }
      });
      this.vueNavigationService.getUnauthenticatedAccess().subscribe(state => {
        if (state) {
          // User trying to access a page without being logged in (see vue-authority-checker)
          this.routeUnauthenticatedUsers();
        }
      });
    }
    /**
     * Hydrates the memory session variables from session storage if possible.
     */
    reestablishSessionFromSessionStorageIfPossible() {
      this.vueUserSessionService.reestablishFromSessionStorage();
    }
    /**
     * Routes unauthenticated user.
     *
     * If a logoutURL is set and it's not part of the current app, redirect to URL.
     * Otherwise, route to `authenticate`.
     *
     */
    routeUnauthenticatedUsers() {
      // Unauthenticated user going to [PortalName]/ || [PortalName]/index.html.
      if (!this.vueUserSessionService.isUserAuthenticated()) {
        const logoutURL = this.vueUserSessionService.getPortalLogoutURL();
        if (logoutURL && !this.vueJavascriptUtilityService.isURLInCurrentApp(logoutURL)) {
          this.vueWindow.location.assign(logoutURL);
        } else {
          this.router.navigate(['authenticate']);
        }
      }
    }
    /**
     * Destroys session and stops idle timer.
     */
    sessionDestroy() {
      this.vueTimeoutService.stopIdleTimer();
      this.vueUserSessionService.destroy();
    }
    /**
     * Called by subscription when user times out.
     * Destroys session, and navigates to log off URL.
     */
    timeoutLogoff() {
      this.sessionDestroy();
      this.vueNavigationService.changeCurrentMenuStateClosed();
      this.vueConfirmLoseChangesService.setOverrideGuardOn();
      this.navigateToLogoffURL(true, this.vueUserSessionService.getBrandingClientCode());
    }
    /**
     * Builds the state parameters necessary for logoff.
     *
     * @param timeout whether the user session timed out.
     * @param brandingClientCode the optional branding code for the current client.
     */
    createLogoffStateParams(timeout, brandingClientCode) {
      const params = {
        brandingClientCode: null,
        timeout: null
      };
      if (timeout) {
        params.timeout = timeout;
      }
      if (brandingClientCode) {
        params.brandingClientCode = brandingClientCode;
      }
      // Remove empty keys
      Object.keys(params).forEach(key => !params[key] && delete params[key]);
      return params;
    }
    /**
     * Creates the logout URL with query parameters.
     *
     * @param logoutURL the logout URL.
     * @param timeout whether the user session timed out.
     * @param brandingClientCode the optional branding code for the current client.
     */
    createLogoutUrlWithParams(logoutURL, timeout, brandingClientCode) {
      const params = this.createLogoffStateParams(timeout, brandingClientCode);
      if (Object.keys(params).length > 0) {
        const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&').replace('brandingClientCode', 'clientCode');
        return `${logoutURL}?${queryString}`;
      }
      return logoutURL;
    }
    static {
      this.ɵfac = function VueApplicationBootstrapService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueApplicationBootstrapService)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(VueConfirmLoseChangesService), i0.ɵɵinject(VueJavascriptUtilityService), i0.ɵɵinject(VueNavigationService), i0.ɵɵinject(VueSessionCookieService), i0.ɵɵinject(VueTimeoutService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(WINDOW));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueApplicationBootstrapService,
        factory: VueApplicationBootstrapService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueApplicationBootstrapService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Component that portals can use to log
 * a user out of their current session.
 *
 * In commons framework this exists on the individual
 * portals.
 *
 */
let VueLogoutComponent = /*#__PURE__*/(() => {
  class VueLogoutComponent {
    constructor(vueBootstrapService, route) {
      this.vueBootstrapService = vueBootstrapService;
      this.route = route;
    }
    ngOnInit() {
      if (this.route.snapshot.queryParams.timeout) {
        this.vueBootstrapService.timeoutLogoff();
      } else {
        this.vueBootstrapService.logoff();
      }
    }
    static {
      this.ɵfac = function VueLogoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueLogoutComponent)(i0.ɵɵdirectiveInject(VueApplicationBootstrapService), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueLogoutComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 0,
        vars: 0,
        template: function VueLogoutComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return VueLogoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable max-len */
/**
 * NOTE: if you are exporting a TypeScript object that exists solely as an interface class,
 * it does not go here but only in public_api.ts!
 */
let VueModule = /*#__PURE__*/(() => {
  class VueModule {
    constructor(library) {
      library.addIcons(faAngleDown, faArrowDown, faArrowUp, faBars, faCalendarAlt, faCaretLeft, faCheck, faChevronDown, faChevronLeft, faChevronUp, faCopy, faExclamationTriangle, faGlobeAmericas, faQuestionCircle, faRandom, faSignOutAlt, faSortDown, faSortUp, faTimes, faTimes$1, faUser);
    }
    static forRoot() {
      return {
        ngModule: VueModule,
        providers: [{
          multi: true,
          provide: HTTP_INTERCEPTORS,
          useClass: VueOauthInterceptor
        }, WINDOW_PROVIDERS]
      };
    }
    static {
      this.ɵfac = function VueModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueModule)(i0.ɵɵinject(i1$2.FaIconLibrary));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VueModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [A11yModule, BrowserModule, CommonModule, DragDropModule, FormsModule, FontAwesomeModule, MatProgressBarModule, MatTabsModule, NgSelectModule, NgbModule, RouterModule, MatCheckboxModule, MatTooltipModule, MatDialogModule, FontAwesomeModule, MatProgressBarModule, NgSelectModule, NgbModule]
      });
    }
  }
  return VueModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Ping class that holds the values for single url request(round trip)
 */
class VuePing {
  constructor() {
    /**
     * True or False for ping.
     */
    this.success = false;
  }
}

/**
 * Network statistics for a single url that include total requests, total success and total failures and also provides
 * average jitter, average latency and packet loss values.
 */
class VueNetworkStats {
  constructor() {
    /**
     * Average jitter value.
     */
    this.averageJitter = null;
    /**
     * Total attempts to get statistic.
     */
    this.totalAttempts = 0;
    /**
     * Attempts that are just executed.
     */
    this.executedAttempts = 0;
    /**
     * Total success attempts.
     */
    this.totalSuccess = 0;
    /**
     * Total failed attempts.
     */
    this.totalFailure = 0;
  }
}

/**
 * This class is responsible for calculating the network stats using the latency and jitter values.
 * Also produces the results with full statistics of a url for given url config.
 */
class VueNetwork {
  constructor() {
    /**
     * Ping request counter.
     */
    this.pings = 0;
    /**
     * Pong response counter.
     */
    this.pongs = 0;
    /**
     * All requests (pings) with detailed information.
     */
    this.fullInfo = [];
    /**
     * Network statistics for a single url that include total requests, success and failures and also provides
     * average jitter and latency values.
     */
    this.stats = new VueNetworkStats();
    this.executionTime = 0;
    /**
     * Array of total latencies.
     */
    this.latencies = [];
    /**
     * Array of total jitters.
     */
    this.jitters = [];
    /**
     * This property holds previous latency that we require to calculate jitter value.
     */
    this.prevLatency = 0;
  }
  /**
   * Returns average value for a number array.
   * @param values are array of type number
   * @returns the average calculated from the values array
   */
  static averageIt(values) {
    return values.reduce((a, b) => a + b, 0) / values.length;
  }
  /**
   * Helper method for calculating the jitter and latencies.
   * @param vuePing Ping object that consist the one request data.
   */
  calculateStats(vuePing) {
    this.pings++;
    if (vuePing.success) {
      this.pongs++;
      this.stats.totalSuccess = this.pongs;
      if (this.prevLatency) {
        vuePing.jitter = Math.round(Math.abs(this.prevLatency - vuePing.latency));
        this.addToJitters(vuePing.jitter);
        this.stats.averageJitter = Math.round(VueNetwork.averageIt(this.jitters));
      }
    } else {
      this.stats.totalFailure++;
    }
    this.addToLatencies(vuePing.latency);
    this.stats.averageLatency = Math.round(VueNetwork.averageIt(this.latencies));
    this.stats.packetLoss = Math.round((1 - this.pongs / this.pings) * 100);
    this.prevLatency = vuePing.latency;
    this.addInfo(vuePing);
    this.stats.executedAttempts++;
    this.executionTime += vuePing.latency;
  }
  /**
   * Helper method for adding jitter value into array for each request.
   * @param jitter value for a request
   */
  addToJitters(jitter) {
    this.jitters.push(jitter);
  }
  /**
   * Helper method for adding latency into array for each request.
   * @param latency is a round-trip time for a request.
   */
  addToLatencies(latency) {
    this.latencies.push(latency);
  }
  /**
   * Helper method for adding all concurrent ping request for a given url into a list.
   * @param vuePing Ping response for a single ulr request.
   */
  addInfo(vuePing) {
    this.fullInfo.push(vuePing);
  }
}

/**
 * This class is responsible for throwing any network stats error. Basically it provides two information:
 * <ul>
 *  <li>error: Actual error occurred and wrapped into it</li>
 *  <li>statsBeforeError: All the stats that are generated just before the error occurred</li>
 */
class VueNetworkError extends Error {
  /**
   * Constructor for creating VueNetworkError object
   * @param message Actual error wrapped into it.
   * @param statsUntil: All the stats that are generated just before the error occurred
   */
  constructor(message, statsUntil) {
    super(message);
    this.statsUntil = statsUntil;
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, VueNetworkError.prototype);
  }
}

/**
 * Represents the configuration class object for generating the network statistics for given Url.
 */
class VueUrlConfig {
  /**
   * A used constructor to enforce defaults on new VueUrlConfig configs if not provided
   * @param url The URL used for ping
   * @param reference The reference for this config
   * @param needStats If stats are to be generated using attempts
   * @param timeout The timeout for each ping attempt of this url
   * @param attempts The max attempts for a ping
   * @param required If the required URL is needed to pass at least once for ping test
   * @param httpMethod The method to run ping test
   * @param body The body to send for post calls
   */
  constructor(url, reference, needStats = false, timeout = 5000, attempts = 10, required, httpMethod, body) {
    /**
     * The number of attempts to hit the Url if needStats is false, when generatingStatistic(), attempts will be 1.
     */
    this.attempts = 10;
    /**
     * Maximum timeout in millis to wait for response (default 5000ms)
     */
    this.timeout = 5000;
    /**
     * If true shows stats by using attempts otherwise only generates single stats response.
     */
    this.needStats = false;
    this.url = url;
    this.reference = reference;
    this.attempts = attempts;
    this.timeout = timeout;
    this.needStats = needStats;
    this.required = required;
    this.httpMethod = httpMethod;
    this.body = body;
  }
}

/**
 * Object used to allow the values inside the Object to be passed by reference
 * when using the @Input decorator for password values
 */
class PasswordInput {}

/**
 * This class represents a readonly form item.
 */
class VueReadOnlyFormItem {
  /**
   * Get the name of the form item.
   *
   * @returns the name of the form item.
   */
  getName() {
    return this.name;
  }
  /**
   * Get the XLIFF key for the name of the form item.
   *
   * @returns the XLIFF key for the name of the form item.
   */
  getNameKey() {
    return this.nameKey;
  }
  /**
   * Get the translated name of the form item, for display purposes.
   *
   * @returns the translated name of the form item, for display purposes.
   */
  getTranslatedName() {
    return this.translatedName;
  }
  /**
   * Get the translated value of the form item, for display purposes.
   *
   * @returns the translated value of the form item, for display purposes.
   */
  getTranslatedValue() {
    return this.translatedValue;
  }
  /**
   * Get the value of the form item.
   *
   * @returns the value of the form item.
   */
  getValue() {
    return this.value;
  }
  /**
   * Get the XLIFF key for the value of the form item.
   *
   * @returns the XLIFF key for the value of the form item.
   */
  getValueKey() {
    return this.valueKey;
  }
  /**
   * Set the name of the form item.
   *
   * @param name the name of the form item.
   * @returns the current object.
   */
  setName(name) {
    this.name = name;
    return this;
  }
  /**
   * Set the XLIFF key for the name of the form item.
   *
   * @param nameKey the XLIFF key for the name of the form item.
   * @returns the current object.
   */
  setNameKey(nameKey) {
    this.nameKey = nameKey;
    return this;
  }
  /**
   * Set the translated name of the form item, for display purposes.
   *
   * @param translatedName the translated name of the form item, for display purposes.
   * @returns the current object.
   */
  setTranslatedName(translatedName) {
    this.translatedName = translatedName;
    return this;
  }
  /**
   * Set the translated value of the form item, for display purposes.
   *
   *
   * @param translatedValue the translated value of the form item, for display purposes.
   * @returns the current object.
   */
  setTranslatedValue(translatedValue) {
    this.translatedValue = translatedValue;
    return this;
  }
  /**
   * Set the value of the form item.
   *
   * @param value the value of the form item.
   * @returns the current object.
   */
  setValue(value) {
    this.value = value;
    return this;
  }
  /**
   * Set the XLIFF key for the value of the form item.
   *
   * @param valueKey the XLIFF key for the value of the form item.
   * @returns the current object.
   */
  setValueKey(valueKey) {
    this.valueKey = valueKey;
    return this;
  }
}
class VueApplicationMenuOptions {}
class VueApplicationRoles {}

/**
This class performs a authority check on your component.  This class is known as a activation guard.  It should appear
on ALL routes as shown below - even if the route is available to all roles.
```
{ path: 'detail/:id', component: HeroDetailComponent,
   data: { authData: {menuEntryURI : "/dashboard", authorizedRoles: ['admin', 'editor'], appId = 8 },
   title : 'Hero Detail', helpURL: 'help/heroDetail.html'}, canActivate: [VueAuthorityChecker],
   canDeactivate: [VueConfirmLoseChanges], resolve: {translation: AppBundleResolve }},
```

This component will:
<li> Check if the user is authenticated and going to a page that requirements it.  It will force logging in to happen
    if required.
<li> It updates the activity time so the timeout service knows the user is doing some activity.
<li> It will then make user the has the right roles to access the page.

*/
let VueAuthorityChecker = /*#__PURE__*/(() => {
  class VueAuthorityChecker {
    constructor(router, vueNavigationService, vueUserSessionService, vueTimeoutService, vueDefaults) {
      this.router = router;
      this.vueNavigationService = vueNavigationService;
      this.vueUserSessionService = vueUserSessionService;
      this.vueTimeoutService = vueTimeoutService;
      this.vueDefaults = vueDefaults;
    }
    canActivate(route, state) {
      if (this.isRouteUnauthenticatedWhiteList(state)) {
        // This one changes the Page Title according to the menu selected.
        this.vueNavigationService.changeCurrentMenuSelectedState(route.data);
        return true;
      }
      // if the user is not authenticated, route back to the authentication page.
      if (!this.vueUserSessionService.isUserAuthenticated()) {
        this.vueNavigationService.unAuthenticatedAccessChanged(true);
        return false;
      }
      // Notify timeout service that user is not idle.
      this.vueTimeoutService.updateActivityTime();
      // check for whitelisted auth routes
      if (this.isRouteAuthenticatedWhiteList(state)) {
        this.vueNavigationService.changeCurrentMenuSelectedState(route.data);
        return true;
      }
      // Check for authorization to function and (optional) client.
      if (!this.vueUserSessionService.preCheckAuthorizationAndSetContext(route, state)) {
        this.router.navigate(['/notAuthorized']);
        return false;
      }
      if (this.vueUserSessionService.getClientsAndApplications() && this.vueUserSessionService.getClientsAndApplications().length === 0) {
        this.router.navigate(['/noApplications']);
        return false;
      }
      if (this.vueUserSessionService.getClientsAndApplications() && this.vueUserSessionService.getClientsAndApplications().length) {
        if (!this.vueUserSessionService.checkAuthorizationAndSetContext(route, state)) {
          this.router.navigate(['/notAuthorized']);
          return false;
        }
        this.vueUserSessionService.setTransientRouteAndStateInfo(route, state);
        this.vueNavigationService.changeCurrentMenuSelectedState(route.data);
        return true;
      }
      // if clients and application list is not available in session, we do store the route and state here.
      // The nav directive once it loads the client and application, then calls the checkAuthorizationAndSetContext()
      // method.
      this.vueUserSessionService.setTransientRouteAndStateInfo(route, state);
      return true;
    }
    isRouteAuthenticatedWhiteList(state) {
      /**
       * The following paths are allowed to be accessed
       * from authenticated users, but are not found in the
       * users clientsAndApplications so they need to be whitelisted.
       */
      return ['pleaseSelect', 'restricted', 'noApplications', this.vueDefaults.getAccountMaintenanceRoute()].some(path => state.url.indexOf(path) === 1);
    }
    isRouteUnauthenticatedWhiteList(state) {
      /**
       * The following paths are allowed to be accessed
       * from non-authenticated users.
       */
      return ['authenticate', 'notAuthorized', 'pageNotFound', ...this.vueDefaults.getUnAuthenticatedWhiteList()].some(path => state.url.indexOf(path) === 1);
    }
    static {
      this.ɵfac = function VueAuthorityChecker_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueAuthorityChecker)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(VueNavigationService), i0.ɵɵinject(VueUserSessionService), i0.ɵɵinject(VueTimeoutService), i0.ɵɵinject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueAuthorityChecker,
        factory: VueAuthorityChecker.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueAuthorityChecker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
This class will force the PortalBase bundle to be fetched when placed on a route.  In this example below,
the component is identifying that it requires 3 bundles to be loaded before showing it.
```
{
  path: 'proctorAdd',
  component: ProctorAddComponent,
  data: {
    authData: {
      menuEntryURI : "/proctorSearch",
      authorizedRoles: ['admin', 'editor']
    },
    pageTitle: {
      i18nBundle: "portal",
      key: "ProctorAdd"
    },
    title : 'Proctor Add',
    helpURL: 'help/proctorAdd.html'
    },
  canActivate: [VueAuthorityChecker],
  canDeactivate: [VueConfirmLoseChanges],
  resolve: {
    translation: ProctorBundleResolve,
    portaltranslation: PortalTranslationResolve,
    base: VueBaseTranslationResolve
  }
}
```
*/
let VueBaseTranslationResolve = /*#__PURE__*/(() => {
  class VueBaseTranslationResolve {
    constructor(vueTranslationService, vueAppDefaultsService) {
      this.vueTranslationService = vueTranslationService;
      this.vueAppDefaultsService = vueAppDefaultsService;
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    resolve(route) {
      return this.vueTranslationService.getTranslationBundle('PortalBase', this.vueAppDefaultsService.getPortalRESTRoot());
    }
    static {
      this.ɵfac = function VueBaseTranslationResolve_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueBaseTranslationResolve)(i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueBaseTranslationResolve,
        factory: VueBaseTranslationResolve.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueBaseTranslationResolve;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 This class will force the CAS bundle to be fetched when placed on a route.  In this example below,
 the authenticate component is identifying that it requires 3 bundles to be loaded before showing it.
 ```
 { path: '', children: [

  { path: '', redirectTo: '/pleaseSelect', pathMatch: 'full' },  // default
  { path: 'authenticate', component: VueLoginComponent,
    data: { authData: {authorizedRoles: ['*all']}, pageTitle: {key: "pageTitle.authenticate"}},
    canActivate: [VueAuthorityChecker]},
  ], resolve: {base: VueBaseTranslationResolve, cas: VueCasTranslationResolve, portal: PortalTranslationResolve }}
 ];
 ```

 */
let VueCasTranslationResolve = /*#__PURE__*/(() => {
  class VueCasTranslationResolve {
    constructor(vueTranslationService, vueAppDefaultsService) {
      this.vueTranslationService = vueTranslationService;
      this.vueAppDefaultsService = vueAppDefaultsService;
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    resolve(route) {
      return this.vueTranslationService.getTranslationBundle('CAS', this.vueAppDefaultsService.getPortalRESTRoot());
    }
    static {
      this.ɵfac = function VueCasTranslationResolve_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueCasTranslationResolve)(i0.ɵɵinject(VueTranslationService), i0.ɵɵinject(VueAppDefaultsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueCasTranslationResolve,
        factory: VueCasTranslationResolve.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueCasTranslationResolve;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This class performs a check on your component when the user is attempting to navigate away from a form where they made
changes but forgot to press save or cancel.  It should exist on ALL routes
where the user can perform a maintenance activity that needs to be persisted.
It should be placed on your route such as here.  This class is known as a deactive guard.
```
{ path: 'detail/:id', component: HeroDetailComponent,
   data: { authData: {menuEntryURI : "/dashboard", authorizedRoles: ['admin', 'editor']}, title : 'Hero Detail',
   helpURL: 'help/heroDetail.html'}, canActivate: [VueAuthorityChecker],
   canDeactivate: [VueConfirmLoseChanges], resolve: {translation: AppBundleResolve }},
```

your component should then implement the
VueCanComponentDeactivate interface.  For the most part standard functionality in your interface would test for form
changes like shown here.  A requirement then is after pressing save or cancel you would set the form to pristine.
```
canDeactivate(): boolean {
    if (this.myForm.form.dirty === false) {
      return true;
    } else {
      return false;
    }
}
```
If your component indicates it cannot deactivate, this class will interact with the vueConfirmLoseChangesService.
It tells the service the route the user was wanting to go to.  It then tells the service to show the lose change dialog.
At that point the VueConfirmLoseChangeDialog shows.  If the user decides to leave, the service will then go the the
desired route.
*/
let VueConfirmLoseChanges = /*#__PURE__*/(() => {
  class VueConfirmLoseChanges {
    constructor(vueConfirmLoseChangesService) {
      this.vueConfirmLoseChangesService = vueConfirmLoseChangesService;
      this.showConfirm = false;
    }
    canDeactivate(component, currentRoute, currentState, nextState) {
      // this happens when the user chooses to leave a page with changes
      if (this.vueConfirmLoseChangesService.getOverrideGuard()) {
        // turn it back off for next time and allow deactivation
        this.vueConfirmLoseChangesService.setOverrideGuardOff();
        return true;
      }
      if (component.canDeactivate()) {
        return true;
      }
      // here we save off the route where the user wants to go and show the lose change dialog
      // we return false because we don't want to router to navigate.  If the user chooses to
      // leave the page, the service will navigate for them (with saved route info)
      this.vueConfirmLoseChangesService.setNextRoute(nextState);
      this.vueConfirmLoseChangesService.setShowConfirm();
      this.showConfirm = true;
      return false;
    }
    static {
      this.ɵfac = function VueConfirmLoseChanges_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueConfirmLoseChanges)(i0.ɵɵinject(VueConfirmLoseChangesService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueConfirmLoseChanges,
        factory: VueConfirmLoseChanges.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueConfirmLoseChanges;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This service is use to generates a Promise of list of network statistics for given each url configs.
 * The number of statistics will generate for each url config.
 * Each object of VueNetwork will holds two set of information as follows:
 *  <ol>
 *    <li style="color: blue; font-weight: bold">Network Statistic</li>
 *      <ul>
 *        <li>Total attempts made for one url</li>
 *        <li>Total success responses</li>
 *        <li>Total failed responses</li>
 *        <li>Average jitter value</li>
 *        <li>Average latency value</li>
 *        <li>Packet loss value in percentage</li>
 *      </ul>
 *    <li style="color: blue; font-weight: bold">Ping list with following detail</li>
 *      <ul>
 *        <li>Url for the ping</li>
 *        <li>Latency</li>
 *        <li>Jitter value if not first request</li>
 *        <li>Success(true) or Fail(false)</li>
 *        <li>Error detail in case of failed request</li>
 *        <li>Date and time the ping was made</li>
 *        <li>The response status code (eg: 200, 204, 404....)</li>
 *      </ul>
 * </ol>
 */
let VueNetworkService = /*#__PURE__*/(() => {
  class VueNetworkService {
    constructor(httpClient) {
      this.httpClient = httpClient;
    }
    /**
     * The method is responsible for
     * @param urlConfigs URL Configuration list
     * @param executionTimeout Over all timeout for stopping full process.
     * @return Promise<VueNetwork> a Promise of list of network statistics for given each url configs
     * @throws VueNetworkError Error if timeout or any other error.
     */
    generateStatistics(urlConfigs, executionTimeout) {
      const completed = [];
      const promiseCallbacks = [];
      urlConfigs.forEach(config => {
        if (config.needStats && config.attempts <= 0) {
          return;
        }
        promiseCallbacks.push(() => this.generateStatistic(config, completed));
      });
      // Following promises will run as sequentially
      const threadSetQueue = [];
      while (promiseCallbacks.length) {
        const singleSetOfThreadPromises = [];
        // Here we dividing the each set of calls into as a one call as 15.
        promiseCallbacks.splice(0, 15).map(f => singleSetOfThreadPromises.push(f()));
        threadSetQueue.push(forkJoin(singleSetOfThreadPromises));
      }
      return concat(...threadSetQueue).pipe(reduce((full, newSlice) => full.concat(newSlice), []), timeout(executionTimeout), catchError(err => throwError(new VueNetworkError('Error occurred at class '.concat(this.constructor.name, ' ', err), completed))));
    }
    /**
     * Single Url request that executes the whole attempts in sequentially and generates the single VueNetwork object.
     *
     * @param urlConfig Single Url config with all configure attempts.
     * @param completed failed
     * @return Promise<VueNetwork> that has all attempts VuePings list and VueNetworkStat objects.
     */
    generateStatistic(urlConfig, completed) {
      const network = new VueNetwork();
      network.reference = urlConfig.reference;
      network.url = urlConfig.url;
      const attempts = urlConfig.needStats ? urlConfig.attempts : 1;
      network.stats.totalAttempts = attempts;
      completed.push(network);
      return range(0, attempts).pipe(concatMap(() => this.ping(urlConfig)), map(vuePing => {
        network.calculateStats(vuePing);
        return network;
      }));
    }
    /**
     * Single Url request that generates the single VuePing and attache it to VueNetwork object.
     *
     * @param urlConfig Single Url config with one attempt.
     * @return Observable<VueNetwork> that has current VuePing object.
     */
    ping(urlConfig) {
      const vuePing = new VuePing();
      vuePing.url = urlConfig.url;
      vuePing.dateTime = new Date().toLocaleString();
      const start = performance.now();
      const params = new HttpParams().set('timing', start.toString());
      return this.httpClient.get(urlConfig.url, {
        observe: 'response',
        params: params,
        responseType: 'blob'
      }).pipe(share(), first(), timeout(urlConfig.timeout), map(resp => {
        const end = performance.now();
        vuePing.latency = Math.round(end - start);
        vuePing.success = resp.ok;
        vuePing.statusCode = resp.status.toString();
        return vuePing;
      }), catchError(err => {
        const end = performance.now();
        vuePing.latency = Math.round(end - start);
        vuePing.err = err;
        vuePing.statusCode = err.status ? err.status : 'unknown';
        return of(vuePing);
      }));
    }
    static {
      this.ɵfac = function VueNetworkService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueNetworkService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueNetworkService,
        factory: VueNetworkService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VueNetworkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This bare metal component is used in unit tests when a parent or child component is needed.
 */
let EmptyComponent = /*#__PURE__*/(() => {
  class EmptyComponent {
    static {
      this.ɵfac = function EmptyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EmptyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmptyComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 0,
        vars: 0,
        template: function EmptyComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return EmptyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Mock component to stop the chain of dependencies in unit tests. `vue-control-group` is used in most components,
 * and has multiple dependencies.
 */
let VueControlGroupComponentMock = /*#__PURE__*/(() => {
  class VueControlGroupComponentMock {
    static {
      this.ɵfac = function VueControlGroupComponentMock_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueControlGroupComponentMock)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VueControlGroupComponentMock,
        selectors: [["vue-control-group"]],
        inputs: {
          control: "control",
          excludeValidationMessage: "excludeValidationMessage",
          formError: "formError",
          i18nBundle: "i18nBundle",
          isAsteriskOptional: "isAsteriskOptional",
          label: "label",
          labelKey: "labelKey",
          srLabel: "srLabel",
          srLabelKey: "srLabelKey",
          widthClass: "widthClass"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function VueControlGroupComponentMock_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VueControlGroupComponentMock;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Mock component to stop the chain of dependencies in unit tests. `vue-panel` is used in most components, and has
 * multiple dependencies.
 */
let VuePanelComponentMock = /*#__PURE__*/(() => {
  class VuePanelComponentMock {
    static {
      this.ɵfac = function VuePanelComponentMock_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VuePanelComponentMock)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VuePanelComponentMock,
        selectors: [["vue-panel"]],
        inputs: {
          titleKey: "titleKey"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function VuePanelComponentMock_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return VuePanelComponentMock;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Mock class for window and location object.
class FakeLocation {
  constructor() {
    this.href = 'http://testHost';
    this.hostname = 'testHost';
    this.protocol = 'http:';
    this.origin = 'http://testHost';
  }
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  assign(url) {
    // Do nothing
  }
}
class FakeDocument {
  constructor() {
    this.cookie = '';
  }
}
class FakeWindow {
  constructor() {
    this.location = new FakeLocation();
    this.document = new FakeDocument();
  }
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  open(url) {
    // Do nothing
  }
}
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function mockWindowFactory() {
  return new FakeWindow();
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
/**
 * NOTE: THIS IS ONE OF 3 MOCK TRANSLATION SERVICES.
 * (THEY SHOULD BE COMBINED)
 * use this one
 */
/**
 * Mock class to replace VueTranslationService in unit tests.
 */
let VueTranslationServiceMock = /*#__PURE__*/(() => {
  class VueTranslationServiceMock extends VueTranslationService {
    constructor() {
      super(null, new VueAppDefaultsService(), null, null, null, new VueUserSessionService(new VueSessionCookieService(new VueAppDefaultsService(), new FakeWindow()), new VueAppDefaultsService(), null, null));
    }
    /**
     * Get the translation for a given key in a given bundle.
     *
     * @param bundle the bundle containing the translated key.
     * @param key the key to translate.
     * @param params optional translation parameters.
     * @returns the translated label.
     */
    getTranslation(bundle, key, params) {
      return `${bundle}-${key}`;
    }
    /**
     * Gets a translation bundle by name, either from cache or from an external location.
     *
     * @param bundle the bundle to fetch.
     * @param restRoot the rest root.
     * @returns Observable which will resolve when the bundle is fetched.
     */
    getTranslationBundle(bundle, restRoot) {
      return of(bundle);
    }
    /**
     * Checks if the translations for a bundle have already been fetched.
     *
     * @param bundle bundle to check.
     * @returns whether the bundle is available.
     */
    isBundleAvailable(bundle) {
      return true;
    }
    getTranslationFromServerCode(code) {
      return code.code;
    }
    static {
      this.ɵfac = function VueTranslationServiceMock_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTranslationServiceMock)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueTranslationServiceMock,
        factory: VueTranslationServiceMock.ɵfac
      });
    }
  }
  return VueTranslationServiceMock;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Mock class to replace VueUserSessionService in unit tests.
 */
let VueUserSessionServiceMock = /*#__PURE__*/(() => {
  class VueUserSessionServiceMock {
    /**
     * Get the current client's branding code.
     *
     * @returns the branding code.
     */
    getBrandingClientCode() {
      return '';
    }
    /**
     * Returns true if user has at least one of the roles passed in as param
     *
     * @param requiredRoles: comma-delimited list of roles.
     * @returns true or false.
     */
    userHasOneRole(requiredRoles) {
      return true;
    }
    static {
      this.ɵfac = function VueUserSessionServiceMock_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueUserSessionServiceMock)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VueUserSessionServiceMock,
        factory: VueUserSessionServiceMock.ɵfac
      });
    }
  }
  return VueUserSessionServiceMock;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Imports to use with unit tests to simplify code.
 */
let VueTestingDeclarations = /*#__PURE__*/(() => {
  class VueTestingDeclarations {
    /**
     * Common imports that most unit tests will need if using the VUE Framework.
     */
    static {
      this.COMMON_DECLARATIONS = [EmptyComponent, VueControlGroupComponentMock, VuePanelComponentMock];
    }
    /**
     * Empty component to use when a wrapper is needed.
     */
    static {
      this.EMPTY_COMPONENT = [EmptyComponent];
    }
  }
  return VueTestingDeclarations;
})();
/**
 * This module is imported in unit tests for components that use FontAwesome.
 */
let FontAwesomeTestModule = /*#__PURE__*/(() => {
  class FontAwesomeTestModule {
    constructor(library) {
      library.addIcons(faAngleDown, faArrowDown, faArrowUp, faBars, faCalendarAlt, faCaretLeft, faCheck, faChevronDown, faChevronLeft, faChevronUp, faCopy, faExclamationTriangle, faGlobeAmericas, faQuestionCircle, faRandom, faSignOutAlt, faSortDown, faSortUp, faTimes, faTimes$1, faUser);
    }
    static {
      this.ɵfac = function FontAwesomeTestModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FontAwesomeTestModule)(i0.ɵɵinject(i1$2.FaIconLibrary));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FontAwesomeTestModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FontAwesomeModule, FontAwesomeModule]
      });
    }
  }
  return FontAwesomeTestModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Imports to use with unit tests to simplify code.
 */
let VueTestingImports = /*#__PURE__*/(() => {
  class VueTestingImports {
    /**
     * Common imports that most unit tests will need if using the VUE Framework.
     */
    static {
      this.COMMON_IMPORTS = [FontAwesomeTestModule, FormsModule, NgbDropdownModule, NgSelectModule, RouterTestingModule, HttpClientTestingModule];
    }
    /**
     * Font Awesome module to use in unit tests.
     */
    static {
      this.FONT_AWESOME_MODULE = [FontAwesomeTestModule];
    }
    /**
     * Common Angular Material imports.
     */
    static {
      this.MATERIAL_IMPORTS = [MatCheckboxModule, MatDatepickerModule, MatInputModule, MatListModule, MatNativeDateModule, MatRadioModule];
    }
  }
  return VueTestingImports;
})();
/**
 * Providers to use with unit tests to simplify mocks usage.
 */
let VueTestingProviders = /*#__PURE__*/(() => {
  class VueTestingProviders {
    /**
     * Common providers used in most tests.
     */
    static {
      this.COMMON_PROVIDERS = [{
        provide: VueTranslationService,
        useClass: VueTranslationServiceMock
      }, {
        provide: VueUserSessionService,
        useClass: VueUserSessionServiceMock
      }, {
        provide: WINDOW,
        useFactory: mockWindowFactory
      }];
    }
    /**
     * Provider for the VueTranslationService mock.
     */
    static {
      this.VUE_TRANSLATION_SERVICE = [{
        provide: VueTranslationService,
        useClass: VueTranslationServiceMock
      }];
    }
    /**
     * Provider for the VueUserSessionService mock.
     */
    static {
      this.VUE_USER_SESSION_SERVICE = [{
        provide: VueUserSessionService,
        useClass: VueUserSessionServiceMock
      }];
    }
  }
  return VueTestingProviders;
})();
let VueTestingModule = /*#__PURE__*/(() => {
  class VueTestingModule {
    static forRoot() {
      return {
        ngModule: VueTestingModule,
        providers: [VueTestingProviders.VUE_TRANSLATION_SERVICE, VueTestingProviders.VUE_USER_SESSION_SERVICE]
      };
    }
    static {
      this.ɵfac = function VueTestingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueTestingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VueTestingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FontAwesomeTestModule, FormsModule, NgbDropdownModule, RouterTestingModule]
      });
    }
  }
  return VueTestingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
This class performs a check on your component when the user is attempting to navigate away from a form where they made
changes but forgot to press save or cancel.  This class is known as a deactive guard. The difference between this class
and ViewConfirmLoseChanges is that VueConfirmLoseChanges only takes effect
when you navigate within a angular router. If the browser is closed or the user navigates to another link
outside of the angualr app then they will lose the changes made. This class prompts the user anytime they try to dump
out of a page with changes. This is to be used in combination with ViewConfirmLoseChanges. While ViewConfirmLoseChanges
works inside app navigation this works outside app navigation.

your component should then extend the
VueComponentCanDeactivate abstract class.
For the most part standard functionality in your interface would test for form
changes like shown here.  A requirement then is after pressing save or cancel you would set the form to pristine.
```
canDeactivate(): boolean {
    if (this.myForm.form.dirty === false) {
      return true;
    } else {
      return false;
    }
}
*/
let VueComponentCanDeactivate = /*#__PURE__*/(() => {
  class VueComponentCanDeactivate {
    unloadNotification($event) {
      if (!this.canDeactivate()) {
        $event.returnValue = true;
      }
    }
    static {
      this.ɵfac = function VueComponentCanDeactivate_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VueComponentCanDeactivate)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: VueComponentCanDeactivate,
        hostBindings: function VueComponentCanDeactivate_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("beforeunload", function VueComponentCanDeactivate_beforeunload_HostBindingHandler($event) {
              return ctx.unloadNotification($event);
            }, false, i0.ɵɵresolveWindow);
          }
        }
      });
    }
  }
  return VueComponentCanDeactivate;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of VUE Framework
 */
// Library entry point

/**
 * Generated bundle index. Do not edit.
 */

export { AutofocusDirective, BrowserWindowRef, DateLocalePipe, EmptyComponent, FontAwesomeTestModule, IDToken, Locale, PasswordInput, ProgressBarType, VUE_EMAIL_REGEX, VueA11yDragDirective, VueA11yDropListDirective, VueAccountManagementService, VueAlphaNumericCapvaDirective, VueAlphaNumericDirective, VueAppDefaultsService, VueApplication, VueApplicationBootstrapService, VueApplicationMenuOptions, VueApplicationRoles, VueArraySortPipe, VueAtlasService, VueAuthenticationComponent, VueAuthenticationService, VueAuthorityChecker, VueAuthorityRestrictedComponent, VueAuthorizationStatus, VueAuthorizedRoleComponent, VueBaseTranslationResolve, VueCapitalizeDirective, VueCasTranslationResolve, VueChangePasswordComponent, VueCheckboxComponent, VueClient, VueClientSubMenu, VueComponentCanDeactivate, VueConfirmLoseChanges, VueConfirmLoseChangesDialogComponent, VueConfirmLoseChangesService, VueControlGroupComponent, VueControlGroupComponentMock, VueCookiePolicyComponent, VueDisplaySubMenu, VueDragDropComponent, VueExternalApplicationComponent, VueExternalApplicationLogoutComponent, VueFirstTimeLoginComponent, VueFooterComponent, VueForgotCredentialsComponent, VueForgotCredentialsService, VueForgotPasswordComponent, VueFormButtonsComponent, VueFormError, VueHtmlSafePipe, VueHttpClientFactoryService, VueHttpClientService, VueHttpPaginationClientService, VueInlineValidationMessageComponent, VueIntegerDirective, VueJavascriptUtilityService, VueLabelComponent, VueLoadingIndicatorComponent, VueLoadingService, VueLocaleSelectComponent, VueLocaleService, VueLoginComponent, VueLoginHeaderComponent, VueLoginStatus, VueLogoutComponent, VueMainContentDirective, VueMaxIntegerDirective, VueMaxLengthDirective, VueMinIntegerDirective, VueModalComponent, VueModule, VueMultiSelectComponent, VueMultipartComponent, VueNavigationBreadCrumbComponent, VueNavigationComponent, VueNavigationLogoComponent, VueNavigationService, VueNavigationStdRightTopMenuComponent, VueNetwork, VueNetworkComponent, VueNetworkError, VueNetworkService, VueNetworkStats, VueNoApplicationsComponent, VueNotAuthorizedComponent, VueOAuthToken, VueOauthInterceptor, VuePageHeaderComponent, VuePageNotFoundComponent, VuePageNotificationComponent, VuePageRowsComponent, VuePaginationComponent, VuePanelComponent, VuePanelComponentMock, VuePasswordExpiredComponent, VuePasswordStrengthInputComponent, VuePing, VuePleaseSelectComponent, VuePortalLocaleSelectorComponent, VuePortalService, VueProgressBarComponent, VueReadOnlyFormComponent, VueReadOnlyFormItem, VueRequiredDirective, VueSearchComponent, VueSecurityQuestionsComponent, VueSelectedMenu, VueServerMessage, VueServerMessageType, VueServerMessagesComponent, VueSessionCookieService, VueSortComponent, VueStepComponent, VueStepperComponent, VueSubMenu, VueTabComponent, VueTabGroupComponent, VueTableActionsComponent, VueTableFilterComponent, VueTestingDeclarations, VueTestingImports, VueTestingModule, VueTestingProviders, VueTimeoutDialogComponent, VueTimeoutService, VueToggleSectionComponent, VueTranslatePipe, VueTranslationService, VueTranslationServiceMock, VueUrlConfig, VueUserSessionService, VueUserSessionServiceMock, VueUsernameLookupComponent, VueValidationMessageComponent, VueValidationRules, WINDOW, WINDOW_PROVIDERS, WindowRef, classDisabled, classFail, classNone, classSuccess, defaultOptionalValidation, defaultRequiredValidation, minValidOptionalRules, windowFactory };
